import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { fetchData } from 'gql/graphql-fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Byte: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Long: { input: any; output: any; }
  TimeSpan: { input: any; output: any; }
  UUID: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AcceptMeetingRequestError = NotFoundError | ValidationResultError;

export type AcceptMeetingRequestInput = {
  meetingId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  proposalId: Scalars['Int']['input'];
};

export type AcceptMeetingRequestPayload = {
  __typename?: 'AcceptMeetingRequestPayload';
  errors?: Maybe<Array<AcceptMeetingRequestError>>;
  meetingProposal?: Maybe<MeetingProposal>;
};

export type AccessTokenExpiredError = Error & {
  __typename?: 'AccessTokenExpiredError';
  message: Scalars['String']['output'];
};

export type AccessTokenInvalidError = Error & {
  __typename?: 'AccessTokenInvalidError';
  message: Scalars['String']['output'];
};

export enum AccessTokenPurpose {
  DocumentSignature = 'DocumentSignature',
  FormFill = 'FormFill',
  ViewDocument = 'ViewDocument',
  WorkflowSubmit = 'WorkflowSubmit'
}

export type ActionFieldValueInput = {
  fieldId: Scalars['UUID']['input'];
  serializedValue?: InputMaybe<Scalars['String']['input']>;
  variableId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddBudgetItemError = NotFoundError | ValidationResultError;

export type AddBudgetItemInput = {
  budgetedAmount: Scalars['Decimal']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type AddBudgetItemPayload = {
  __typename?: 'AddBudgetItemPayload';
  budgetItem?: Maybe<BudgetItem>;
  errors?: Maybe<Array<AddBudgetItemError>>;
};

export type AddChildActionError = NotFoundError | ValidationResultError;

export type AddChildActionInput = {
  actionConfigurationId: Scalars['Int']['input'];
  actionDefinitionId: Scalars['String']['input'];
  defaultName?: InputMaybe<Scalars['String']['input']>;
  orderIndex: Scalars['Int']['input'];
  workflowDefinitionId: Scalars['Int']['input'];
};

export type AddChildActionPayload = {
  __typename?: 'AddChildActionPayload';
  errors?: Maybe<Array<AddChildActionError>>;
  workflowActionConfiguration?: Maybe<WorkflowActionConfiguration>;
};

export type AddConditionError = NotFoundError | ValidationResultError;

export type AddConditionInput = {
  effectFieldId?: InputMaybe<Scalars['Int']['input']>;
  effectSectionId?: InputMaybe<Scalars['Int']['input']>;
  effectVisibility?: InputMaybe<ConditionEffectVisibilityInput>;
  formDefinitionId: Scalars['Int']['input'];
  triggerFieldId: Scalars['Int']['input'];
  triggerValueEquality?: InputMaybe<ConditionTriggerValueEqualityInput>;
};

export type AddConditionPayload = {
  __typename?: 'AddConditionPayload';
  errors?: Maybe<Array<AddConditionError>>;
  formCondition?: Maybe<FormCondition>;
};

export type AddCostItemError = NotFoundError | ValidationResultError;

export type AddCostItemInput = {
  budgetItemId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  plannedAmount: Scalars['Decimal']['input'];
  projectId: Scalars['Int']['input'];
};

export type AddCostItemPayload = {
  __typename?: 'AddCostItemPayload';
  costItem?: Maybe<CostItem>;
  errors?: Maybe<Array<AddCostItemError>>;
};

export type AddExpenseError = NotFoundError | ValidationResultError;

export type AddExpenseInput = {
  costItemId: Scalars['Int']['input'];
  expendedAmount: Scalars['Decimal']['input'];
  expenseDate: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  quoteId?: InputMaybe<Scalars['Int']['input']>;
  status: ExpenseStatus;
};

export type AddExpensePayload = {
  __typename?: 'AddExpensePayload';
  errors?: Maybe<Array<AddExpenseError>>;
  expense?: Maybe<Expense>;
};

export type AddExternalLinkError = ValidationResultError;

export type AddExternalLinkInput = {
  folderId: Scalars['Int']['input'];
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type AddExternalLinkPayload = {
  __typename?: 'AddExternalLinkPayload';
  errors?: Maybe<Array<AddExternalLinkError>>;
  externalLink?: Maybe<ExternalLink>;
};

export type AddExternalUserError = NotFoundError | ValidationResultError;

export type AddExternalUserInput = {
  business?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
  securityGroupId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AddExternalUserPayload = {
  __typename?: 'AddExternalUserPayload';
  applicationUser?: Maybe<ApplicationUser>;
  errors?: Maybe<Array<AddExternalUserError>>;
};

export type AddFolderError = ValidationResultError;

export type AddFolderInput = {
  name: Scalars['String']['input'];
  parentFolderId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type AddFolderPayload = {
  __typename?: 'AddFolderPayload';
  errors?: Maybe<Array<AddFolderError>>;
  folder?: Maybe<Folder>;
};

export type AddMatrixRowError = NotFoundError | ValidationResultError;

export type AddMatrixRowInput = {
  matrixFieldId: Scalars['Int']['input'];
  submissionId: Scalars['Int']['input'];
};

export type AddMatrixRowPatError = NotFoundError | ValidationResultError;

export type AddMatrixRowPatInput = {
  accessToken: Scalars['String']['input'];
  matrixFieldId: Scalars['Int']['input'];
  submissionId: Scalars['Int']['input'];
};

export type AddMatrixRowPatPayload = {
  __typename?: 'AddMatrixRowPATPayload';
  errors?: Maybe<Array<AddMatrixRowPatError>>;
  matrixRow?: Maybe<MatrixRow>;
};

export type AddMatrixRowPayload = {
  __typename?: 'AddMatrixRowPayload';
  errors?: Maybe<Array<AddMatrixRowError>>;
  matrixRow?: Maybe<MatrixRow>;
};

export type AddMeetingError = NotFoundError | ValidationResultError;

export type AddMeetingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  meetingTypeId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  proposedStartTimes: Array<Scalars['DateTime']['input']>;
  timeZone: Scalars['String']['input'];
};

export type AddMeetingPayload = {
  __typename?: 'AddMeetingPayload';
  errors?: Maybe<Array<AddMeetingError>>;
  meeting?: Maybe<Meeting>;
};

export type AddMeetingTypeError = NotFoundError | ValidationResultError;

export type AddMeetingTypeInput = {
  bookingMethod: BookingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  durationMinutes: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  principals: Array<SecurityPrincipalShimInput>;
  projectId: Scalars['Int']['input'];
};

export type AddMeetingTypePayload = {
  __typename?: 'AddMeetingTypePayload';
  errors?: Maybe<Array<AddMeetingTypeError>>;
  meetingType?: Maybe<MeetingType>;
};

export type AddProjectError = NotFoundError | ValidationResultError;

export type AddProjectFormError = ValidationResultError;

export type AddProjectFormFromTemplateError = ValidationResultError;

export type AddProjectFormFromTemplateInput = {
  formType: FormType;
  fromFormTemplateId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type AddProjectFormFromTemplatePayload = {
  __typename?: 'AddProjectFormFromTemplatePayload';
  errors?: Maybe<Array<AddProjectFormFromTemplateError>>;
  projectForm?: Maybe<ProjectForm>;
};

export type AddProjectFormInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  formType: FormType;
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type AddProjectFormPayload = {
  __typename?: 'AddProjectFormPayload';
  errors?: Maybe<Array<AddProjectFormError>>;
  projectForm?: Maybe<ProjectForm>;
};

export type AddProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type AddProjectMemberError = NotFoundError | ValidationResultError;

export type AddProjectMemberInput = {
  projectId: Scalars['Int']['input'];
  securityGroupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AddProjectMemberPayload = {
  __typename?: 'AddProjectMemberPayload';
  errors?: Maybe<Array<AddProjectMemberError>>;
  project?: Maybe<Project>;
};

export type AddProjectPayload = {
  __typename?: 'AddProjectPayload';
  errors?: Maybe<Array<AddProjectError>>;
  project?: Maybe<Project>;
};

export type AddProjectTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  hideBudgetFeature: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type AddProjectTemplatePayload = {
  __typename?: 'AddProjectTemplatePayload';
  project?: Maybe<Project>;
};

export type AddProjectWorkflowError = NotFoundError | ValidationResultError;

export type AddProjectWorkflowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type AddProjectWorkflowPayload = {
  __typename?: 'AddProjectWorkflowPayload';
  errors?: Maybe<Array<AddProjectWorkflowError>>;
  workflowDefinition?: Maybe<WorkflowDefinition>;
};

export type AddQuoteError = NotFoundError | ValidationResultError;

export type AddQuoteInput = {
  amount: Scalars['Decimal']['input'];
  costItemId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  quoteDate: Scalars['DateTime']['input'];
};

export type AddQuotePayload = {
  __typename?: 'AddQuotePayload';
  errors?: Maybe<Array<AddQuoteError>>;
  quote?: Maybe<Quote>;
};

export type AddSecurityGroupError = NotFoundError | ValidationResultError;

export type AddSecurityGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type AddSecurityGroupPayload = {
  __typename?: 'AddSecurityGroupPayload';
  errors?: Maybe<Array<AddSecurityGroupError>>;
  securityGroup?: Maybe<SecurityGroup>;
};

export type AddTaskError = NotFoundError | ValidationResultError;

export type AddTaskInput = {
  assignees: Array<SecurityPrincipalShimInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentTaskId?: InputMaybe<Scalars['Int']['input']>;
  predecessorIds: Array<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status: ProjectTaskStatus;
};

export type AddTaskPayload = {
  __typename?: 'AddTaskPayload';
  errors?: Maybe<Array<AddTaskError>>;
  projectTask?: Maybe<ProjectTask>;
};

export type AddTaskPredecessorError = ValidationResultError;

export type AddTaskPredecessorInput = {
  predecessorId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
};

export type AddTaskPredecessorPayload = {
  __typename?: 'AddTaskPredecessorPayload';
  errors?: Maybe<Array<AddTaskPredecessorError>>;
  projectTask?: Maybe<ProjectTask>;
};

export type AddWorkflowDefinitionError = NotFoundError | ValidationResultError;

export type AddWorkflowDefinitionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type AddWorkflowDefinitionPayload = {
  __typename?: 'AddWorkflowDefinitionPayload';
  errors?: Maybe<Array<AddWorkflowDefinitionError>>;
  workflowDefinition?: Maybe<WorkflowDefinition>;
};

export type AddWorkflowVariableError = NotFoundError | ValidationResultError;

export type AddWorkflowVariableInput = {
  name: Scalars['String']['input'];
  valueType: WorkflowVariableValueTypes;
  workflowDefinitionId: Scalars['Int']['input'];
};

export type AddWorkflowVariablePayload = {
  __typename?: 'AddWorkflowVariablePayload';
  errors?: Maybe<Array<AddWorkflowVariableError>>;
  workflowVariable?: Maybe<WorkflowVariable>;
};

export enum AllowedRespondents {
  AllProjectMembers = 'AllProjectMembers',
  SpecificUsersOrGroups = 'SpecificUsersOrGroups'
}

export type AllowedRespondentsOperationFilterInput = {
  eq?: InputMaybe<AllowedRespondents>;
  in?: InputMaybe<Array<AllowedRespondents>>;
  neq?: InputMaybe<AllowedRespondents>;
  nin?: InputMaybe<Array<AllowedRespondents>>;
};

export type AppSubscription = {
  __typename?: 'AppSubscription';
  asOfDate: Scalars['DateTime']['output'];
  isRegisteredWithLicenseService: Scalars['Boolean']['output'];
  products: Array<AppSubscriptionProduct>;
  referralId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SubscriptionStatus>;
  subscriptionId?: Maybe<Scalars['UUID']['output']>;
  subscriptionProvider: SubscriptionProvider;
  trialEnd?: Maybe<Scalars['DateTime']['output']>;
  trialStart?: Maybe<Scalars['DateTime']['output']>;
};

export type AppSubscriptionModel = {
  __typename?: 'AppSubscriptionModel';
  hasSubscription: Scalars['Boolean']['output'];
  subscription?: Maybe<AppSubscription>;
  trialDaysRemaining?: Maybe<Scalars['Int']['output']>;
};

export type AppSubscriptionProduct = {
  __typename?: 'AppSubscriptionProduct';
  quantity: Scalars['Long']['output'];
  sku: Scalars['String']['output'];
};

export type ApplicationRole = {
  __typename?: 'ApplicationRole';
  builtInRole: BuiltInRoles;
  concurrencyStamp?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  normalizedName?: Maybe<Scalars['String']['output']>;
  users: Array<ApplicationUser>;
};

export type ApplicationRoleFilterInput = {
  and?: InputMaybe<Array<ApplicationRoleFilterInput>>;
  builtInRole?: InputMaybe<BuiltInRolesOperationFilterInput>;
  concurrencyStamp?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationRoleFilterInput>>;
  users?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
};

export type ApplicationUser = {
  __typename?: 'ApplicationUser';
  builtInRoles: Array<BuiltInRoles>;
  business?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  groups: Array<SecurityGroup>;
  id: Scalars['String']['output'];
  language: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  optedOutOfWeeklyEmails: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  roles: Array<ApplicationRole>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ApplicationUserGroupsArgs = {
  where?: InputMaybe<SecurityGroupFilterInput>;
};

export type ApplicationUserFilterInput = {
  and?: InputMaybe<Array<ApplicationUserFilterInput>>;
  builtInRoles?: InputMaybe<ListBuiltInRolesOperationFilterInput>;
  business?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  groups?: InputMaybe<ListFilterInputTypeOfSecurityGroupFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  language?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationUserFilterInput>>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  projectAccessTokens?: InputMaybe<ListFilterInputTypeOfProjectAccessTokenFilterInput>;
  roles?: InputMaybe<ListFilterInputTypeOfApplicationRoleFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type ApplicationUserSortInput = {
  accessFailedCount?: InputMaybe<SortEnumType>;
  business?: InputMaybe<SortEnumType>;
  concurrencyStamp?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  emailConfirmed?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  hasSignedUp?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  language?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  lastWeeklyProjectUpdateSentOn?: InputMaybe<SortEnumType>;
  lockoutEnabled?: InputMaybe<SortEnumType>;
  lockoutEnd?: InputMaybe<SortEnumType>;
  normalizedEmail?: InputMaybe<SortEnumType>;
  normalizedUserName?: InputMaybe<SortEnumType>;
  optedOutOfWeeklyEmails?: InputMaybe<SortEnumType>;
  passwordHash?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  phoneNumberConfirmed?: InputMaybe<SortEnumType>;
  phoneNumberExtension?: InputMaybe<SortEnumType>;
  securityStamp?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  twoFactorEnabled?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export enum AuthenticationType {
  ExternalAccessToken = 'ExternalAccessToken',
  IdentityApplication = 'IdentityApplication'
}

export type Availabilities = {
  __typename?: 'Availabilities';
  availableStartTimes: Array<AvailabilityInfo>;
  isScheduleAvailable: Scalars['Boolean']['output'];
  isoWorkWeekDays: Array<Scalars['Int']['output']>;
  msalUIRequired: Scalars['Boolean']['output'];
};

export enum Availability {
  Busy = 'Busy',
  Free = 'Free',
  OutOfOffice = 'OutOfOffice',
  Tentative = 'Tentative',
  WorkingElsewhere = 'WorkingElsewhere'
}

export type AvailabilityInfo = {
  __typename?: 'AvailabilityInfo';
  availability: Availability;
  startTime: Scalars['DateTime']['output'];
};

export enum BookingMethod {
  DirectBooking = 'DirectBooking',
  ProposeTimes = 'ProposeTimes'
}

export type BookingMethodOperationFilterInput = {
  eq?: InputMaybe<BookingMethod>;
  in?: InputMaybe<Array<BookingMethod>>;
  neq?: InputMaybe<BookingMethod>;
  nin?: InputMaybe<Array<BookingMethod>>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BudgetAndExpensesPermission {
  Manage = 'Manage',
  NotAllowed = 'NotAllowed',
  View = 'View'
}

export type BudgetItem = {
  __typename?: 'BudgetItem';
  budgetedAmount: Scalars['Decimal']['output'];
  costItems: Array<CostItem>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
};

export type BudgetItemFilterInput = {
  and?: InputMaybe<Array<BudgetItemFilterInput>>;
  budgetedAmount?: InputMaybe<DecimalOperationFilterInput>;
  costItems?: InputMaybe<ListFilterInputTypeOfCostItemFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BudgetItemFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
};

export enum BuiltInRoles {
  BudgetAndExpensesAdmin = 'BudgetAndExpensesAdmin',
  BudgetAndExpensesReader = 'BudgetAndExpensesReader',
  Contributor = 'Contributor',
  /** @deprecated No longer supported. */
  Customer = 'Customer',
  /** @deprecated No longer supported. */
  ExpensesAdmin = 'ExpensesAdmin',
  /** @deprecated No longer supported. */
  ExpensesReader = 'ExpensesReader',
  FilesAdmin = 'FilesAdmin',
  FilesContributor = 'FilesContributor',
  FormsAdmin = 'FormsAdmin',
  LimitedAccess = 'LimitedAccess',
  MultiTenantAdministrator = 'MultiTenantAdministrator',
  ProjectAdministrator = 'ProjectAdministrator',
  Reader = 'Reader',
  TasksAdmin = 'TasksAdmin',
  TasksReader = 'TasksReader',
  TenantAdministrator = 'TenantAdministrator',
  WorkflowsAdmin = 'WorkflowsAdmin'
}

export type BuiltInRolesOperationFilterInput = {
  eq?: InputMaybe<BuiltInRoles>;
  in?: InputMaybe<Array<BuiltInRoles>>;
  neq?: InputMaybe<BuiltInRoles>;
  nin?: InputMaybe<Array<BuiltInRoles>>;
};

export type CancelSignatureRequestError = NotFoundError | ValidationResultError;

export type CancelSignatureRequestInput = {
  documentId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type CancelSignatureRequestPayload = {
  __typename?: 'CancelSignatureRequestPayload';
  document?: Maybe<Document>;
  errors?: Maybe<Array<CancelSignatureRequestError>>;
};

export type CollectFormResponsesError = ValidationResultError;

export type CollectFormResponsesInput = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  mandatoryRequestDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  projectFormId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type CollectFormResponsesPayload = {
  __typename?: 'CollectFormResponsesPayload';
  errors?: Maybe<Array<CollectFormResponsesError>>;
  projectForm?: Maybe<ProjectForm>;
};

export type CommercialProjectCalculator = {
  __typename?: 'CommercialProjectCalculator';
  id: Scalars['Int']['output'];
  jsonData: Scalars['String']['output'];
  name: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
};

export type CommercialProjectCalculatorFilterInput = {
  and?: InputMaybe<Array<CommercialProjectCalculatorFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  jsonData?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CommercialProjectCalculatorFilterInput>>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
};

export type ConditionEffect = {
  __typename?: 'ConditionEffect';
  condition?: Maybe<FormCondition>;
  conditionId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  targetField?: Maybe<FormField>;
  targetFieldId?: Maybe<Scalars['Int']['output']>;
  targetSection?: Maybe<FormSection>;
  targetSectionId?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<ConditionEffectVisibility>;
};

export type ConditionEffectFilterInput = {
  and?: InputMaybe<Array<ConditionEffectFilterInput>>;
  condition?: InputMaybe<FormConditionFilterInput>;
  conditionId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConditionEffectFilterInput>>;
  targetField?: InputMaybe<FormFieldFilterInput>;
  targetFieldId?: InputMaybe<IntOperationFilterInput>;
  targetSection?: InputMaybe<FormSectionFilterInput>;
  targetSectionId?: InputMaybe<IntOperationFilterInput>;
  visibility?: InputMaybe<ConditionEffectVisibilityFilterInput>;
};

export type ConditionEffectVisibility = {
  __typename?: 'ConditionEffectVisibility';
  visible: Scalars['Boolean']['output'];
};

export type ConditionEffectVisibilityFilterInput = {
  and?: InputMaybe<Array<ConditionEffectVisibilityFilterInput>>;
  or?: InputMaybe<Array<ConditionEffectVisibilityFilterInput>>;
  visible?: InputMaybe<BooleanOperationFilterInput>;
};

export type ConditionEffectVisibilityInput = {
  visible: Scalars['Boolean']['input'];
};

export type ConditionTrigger = {
  __typename?: 'ConditionTrigger';
  condition?: Maybe<FormCondition>;
  conditionId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  sourceField?: Maybe<FormField>;
  sourceFieldId: Scalars['Int']['output'];
  valueEquality?: Maybe<ConditionTriggerValueEquality>;
};

export type ConditionTriggerFilterInput = {
  and?: InputMaybe<Array<ConditionTriggerFilterInput>>;
  condition?: InputMaybe<FormConditionFilterInput>;
  conditionId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConditionTriggerFilterInput>>;
  sourceField?: InputMaybe<FormFieldFilterInput>;
  sourceFieldId?: InputMaybe<IntOperationFilterInput>;
  valueEquality?: InputMaybe<ConditionTriggerValueEqualityFilterInput>;
};

export type ConditionTriggerValueEquality = {
  __typename?: 'ConditionTriggerValueEquality';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type ConditionTriggerValueEqualityFilterInput = {
  and?: InputMaybe<Array<ConditionTriggerValueEqualityFilterInput>>;
  boolean?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ConditionTriggerValueEqualityFilterInput>>;
};

export type ConditionTriggerValueEqualityInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CostItem = {
  __typename?: 'CostItem';
  budgetItem?: Maybe<BudgetItem>;
  budgetItemId?: Maybe<Scalars['Int']['output']>;
  effectiveAmount: Scalars['Decimal']['output'];
  entries: Array<CostItemEntry>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  plannedAmount: Scalars['Decimal']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  status: CostItemStatus;
};

export type CostItemEntry = {
  __typename?: 'CostItemEntry';
  costItem?: Maybe<CostItem>;
  costItemId: Scalars['Int']['output'];
  expense?: Maybe<Expense>;
  expenseId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  quote?: Maybe<Quote>;
  quoteId?: Maybe<Scalars['Int']['output']>;
  type: CostItemEntryType;
};

export type CostItemEntryFilterInput = {
  and?: InputMaybe<Array<CostItemEntryFilterInput>>;
  costItem?: InputMaybe<CostItemFilterInput>;
  costItemId?: InputMaybe<IntOperationFilterInput>;
  expense?: InputMaybe<ExpenseFilterInput>;
  expenseId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CostItemEntryFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
  quote?: InputMaybe<QuoteFilterInput>;
  quoteId?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<CostItemEntryTypeOperationFilterInput>;
};

export enum CostItemEntryType {
  Expense = 'Expense',
  Quote = 'Quote'
}

export type CostItemEntryTypeOperationFilterInput = {
  eq?: InputMaybe<CostItemEntryType>;
  in?: InputMaybe<Array<CostItemEntryType>>;
  neq?: InputMaybe<CostItemEntryType>;
  nin?: InputMaybe<Array<CostItemEntryType>>;
};

export type CostItemFilterInput = {
  and?: InputMaybe<Array<CostItemFilterInput>>;
  budgetItem?: InputMaybe<BudgetItemFilterInput>;
  budgetItemId?: InputMaybe<IntOperationFilterInput>;
  entries?: InputMaybe<ListFilterInputTypeOfCostItemEntryFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CostItemFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  plannedAmount?: InputMaybe<DecimalOperationFilterInput>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<CostItemStatusOperationFilterInput>;
};

export enum CostItemStatus {
  Completed = 'Completed',
  InProgress = 'InProgress',
  Planned = 'Planned'
}

export type CostItemStatusOperationFilterInput = {
  eq?: InputMaybe<CostItemStatus>;
  in?: InputMaybe<Array<CostItemStatus>>;
  neq?: InputMaybe<CostItemStatus>;
  nin?: InputMaybe<Array<CostItemStatus>>;
};

export type CreateCommercialProjectCalculatorError = ValidationResultError;

export type CreateCommercialProjectCalculatorInput = {
  jsonData: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type CreateCommercialProjectCalculatorPayload = {
  __typename?: 'CreateCommercialProjectCalculatorPayload';
  commercialProjectCalculator?: Maybe<CommercialProjectCalculator>;
  errors?: Maybe<Array<CreateCommercialProjectCalculatorError>>;
};

export type CreateFormFieldError = NotFoundError | ValidationResultError;

export type CreateFormFieldInput = {
  documentUploadFolderId?: InputMaybe<Scalars['Int']['input']>;
  fieldType: FieldType;
  formDefinitionId: Scalars['Int']['input'];
  isMultiline: Scalars['Boolean']['input'];
  isMultiselect: Scalars['Boolean']['input'];
  isRequired: Scalars['Boolean']['input'];
  matrixInput?: InputMaybe<MatrixInput>;
  name: Scalars['String']['input'];
  options: Array<SelectionFieldOptionInput>;
  order: Scalars['Int']['input'];
  sectionId: Scalars['Int']['input'];
  shouldUploadDocumentsToFolder: Scalars['Boolean']['input'];
};

export type CreateFormFieldPayload = {
  __typename?: 'CreateFormFieldPayload';
  errors?: Maybe<Array<CreateFormFieldError>>;
  formField?: Maybe<FormField>;
};

export type CreateFormSectionError = NotFoundError | ValidationResultError;

export type CreateFormSectionInput = {
  formDefinitionId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type CreateFormSectionPayload = {
  __typename?: 'CreateFormSectionPayload';
  errors?: Maybe<Array<CreateFormSectionError>>;
  formSection?: Maybe<FormSection>;
};

export type CreateFormTemplateError = ValidationResultError;

export type CreateFormTemplateInput = {
  input: FormDefinitionInput;
};

export type CreateFormTemplatePayload = {
  __typename?: 'CreateFormTemplatePayload';
  errors?: Maybe<Array<CreateFormTemplateError>>;
  formTemplate?: Maybe<FormTemplate>;
};

export type CreateProjectAccessTokenError = NotFoundError;

export type CreateProjectAccessTokenInput = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['Int']['input'];
  forUserId: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type CreateProjectAccessTokenPayload = {
  __typename?: 'CreateProjectAccessTokenPayload';
  errors?: Maybe<Array<CreateProjectAccessTokenError>>;
  projectAccessToken?: Maybe<ProjectAccessToken>;
};

export type CreateProjectFromTemplateError = NotFoundError | ValidationResultError;

export type CreateProjectFromTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectTemplateId: Scalars['Int']['input'];
};

export type CreateProjectFromTemplatePayload = {
  __typename?: 'CreateProjectFromTemplatePayload';
  errors?: Maybe<Array<CreateProjectFromTemplateError>>;
  project?: Maybe<Project>;
};

export type CreateTemplateFromProjectFormError = ValidationResultError;

export type CreateTemplateFromProjectFormInput = {
  projectFormId: Scalars['Int']['input'];
};

export type CreateTemplateFromProjectFormPayload = {
  __typename?: 'CreateTemplateFromProjectFormPayload';
  errors?: Maybe<Array<CreateTemplateFromProjectFormError>>;
  formTemplate?: Maybe<FormTemplate>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DeclineMeetingRequestError = NotFoundError | ValidationResultError;

export type DeclineMeetingRequestInput = {
  declineReason: Scalars['String']['input'];
  meetingId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type DeclineMeetingRequestPayload = {
  __typename?: 'DeclineMeetingRequestPayload';
  errors?: Maybe<Array<DeclineMeetingRequestError>>;
  meeting?: Maybe<Meeting>;
};

export type DeleteBudgetItemError = NotFoundError | ValidationResultError;

export type DeleteBudgetItemInput = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type DeleteBudgetItemPayload = {
  __typename?: 'DeleteBudgetItemPayload';
  budgetItem?: Maybe<BudgetItem>;
  errors?: Maybe<Array<DeleteBudgetItemError>>;
};

export type DeleteConditionError = NotFoundError | ValidationResultError;

export type DeleteConditionInput = {
  formDefinitionId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type DeleteConditionPayload = {
  __typename?: 'DeleteConditionPayload';
  errors?: Maybe<Array<DeleteConditionError>>;
  formCondition?: Maybe<FormCondition>;
};

export type DeleteCostItemError = NotFoundError | ValidationResultError;

export type DeleteCostItemInput = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type DeleteCostItemPayload = {
  __typename?: 'DeleteCostItemPayload';
  costItem?: Maybe<CostItem>;
  errors?: Maybe<Array<DeleteCostItemError>>;
};

export type DeleteDocumentTemplateError = NotFoundError;

export type DeleteDocumentTemplateInput = {
  id: Scalars['Int']['input'];
};

export type DeleteDocumentTemplatePayload = {
  __typename?: 'DeleteDocumentTemplatePayload';
  documentTemplate?: Maybe<DocumentTemplate>;
  errors?: Maybe<Array<DeleteDocumentTemplateError>>;
};

export type DeleteExpenseAttachmentError = NotFoundError;

export type DeleteExpenseAttachmentInput = {
  expenseId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type DeleteExpenseAttachmentPayload = {
  __typename?: 'DeleteExpenseAttachmentPayload';
  errors?: Maybe<Array<DeleteExpenseAttachmentError>>;
  expense?: Maybe<Expense>;
};

export type DeleteExpenseError = NotFoundError | ValidationResultError;

export type DeleteExpenseInput = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type DeleteExpensePayload = {
  __typename?: 'DeleteExpensePayload';
  errors?: Maybe<Array<DeleteExpenseError>>;
  expense?: Maybe<Expense>;
};

export type DeleteExternalLinkError = ValidationResultError;

export type DeleteExternalLinkInput = {
  linkId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type DeleteExternalLinkPayload = {
  __typename?: 'DeleteExternalLinkPayload';
  errors?: Maybe<Array<DeleteExternalLinkError>>;
  externalLink?: Maybe<ExternalLink>;
};

export type DeleteFolderError = ValidationResultError;

export type DeleteFolderInput = {
  folderId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type DeleteFolderPayload = {
  __typename?: 'DeleteFolderPayload';
  errors?: Maybe<Array<DeleteFolderError>>;
  folder?: Maybe<Folder>;
};

export type DeleteFormAttachmentError = NotFoundError | ValidationResultError;

export type DeleteFormAttachmentInput = {
  attachmentId: Scalars['Int']['input'];
  fieldId: Scalars['Int']['input'];
  submissionId: Scalars['Int']['input'];
};

export type DeleteFormAttachmentPatError = NotFoundError | ValidationResultError;

export type DeleteFormAttachmentPatInput = {
  deleteFormAttachmentInput: DeleteFormAttachmentInput;
  token: Scalars['String']['input'];
};

export type DeleteFormAttachmentPatPayload = {
  __typename?: 'DeleteFormAttachmentPATPayload';
  document?: Maybe<Document>;
  errors?: Maybe<Array<DeleteFormAttachmentPatError>>;
};

export type DeleteFormAttachmentPayload = {
  __typename?: 'DeleteFormAttachmentPayload';
  document?: Maybe<Document>;
  errors?: Maybe<Array<DeleteFormAttachmentError>>;
};

export type DeleteFormFieldError = NotFoundError | ValidationResultError;

export type DeleteFormFieldInput = {
  formDefinitionId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type DeleteFormFieldPayload = {
  __typename?: 'DeleteFormFieldPayload';
  errors?: Maybe<Array<DeleteFormFieldError>>;
  formField?: Maybe<FormField>;
};

export type DeleteFormSectionError = NotFoundError | ValidationResultError;

export type DeleteFormSectionInput = {
  formDefinitionId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type DeleteFormSectionPayload = {
  __typename?: 'DeleteFormSectionPayload';
  errors?: Maybe<Array<DeleteFormSectionError>>;
  formSection?: Maybe<FormSection>;
};

export type DeleteFormSubmissionError = NotFoundError | ValidationResultError;

export type DeleteFormSubmissionInput = {
  projectId: Scalars['Int']['input'];
  submissionId: Scalars['Int']['input'];
};

export type DeleteFormSubmissionPayload = {
  __typename?: 'DeleteFormSubmissionPayload';
  errors?: Maybe<Array<DeleteFormSubmissionError>>;
  projectFormSubmission?: Maybe<ProjectFormSubmission>;
};

export type DeleteFormTemplateError = ValidationResultError;

export type DeleteFormTemplateInput = {
  id: Scalars['Int']['input'];
};

export type DeleteFormTemplatePayload = {
  __typename?: 'DeleteFormTemplatePayload';
  errors?: Maybe<Array<DeleteFormTemplateError>>;
  formTemplate?: Maybe<FormTemplate>;
};

export type DeleteMeetingError = NotFoundError | ValidationResultError;

export type DeleteMeetingInput = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type DeleteMeetingPayload = {
  __typename?: 'DeleteMeetingPayload';
  errors?: Maybe<Array<DeleteMeetingError>>;
  meeting?: Maybe<Meeting>;
};

export type DeleteMeetingTypeError = NotFoundError | ValidationResultError;

export type DeleteMeetingTypeInput = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type DeleteMeetingTypePayload = {
  __typename?: 'DeleteMeetingTypePayload';
  errors?: Maybe<Array<DeleteMeetingTypeError>>;
  meetingType?: Maybe<MeetingType>;
};

export type DeleteProjectFormError = ValidationResultError;

export type DeleteProjectFormInput = {
  formId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type DeleteProjectFormPayload = {
  __typename?: 'DeleteProjectFormPayload';
  errors?: Maybe<Array<DeleteProjectFormError>>;
  formTemplate?: Maybe<FormTemplate>;
};

export type DeleteProjectTemplateError = NotFoundError | ValidationResultError;

export type DeleteProjectTemplateInput = {
  projectId: Scalars['Int']['input'];
};

export type DeleteProjectTemplatePayload = {
  __typename?: 'DeleteProjectTemplatePayload';
  errors?: Maybe<Array<DeleteProjectTemplateError>>;
  project?: Maybe<Project>;
};

export type DeleteQuoteAttachmentError = NotFoundError;

export type DeleteQuoteAttachmentInput = {
  projectId: Scalars['Int']['input'];
  quoteId: Scalars['Int']['input'];
};

export type DeleteQuoteAttachmentPayload = {
  __typename?: 'DeleteQuoteAttachmentPayload';
  errors?: Maybe<Array<DeleteQuoteAttachmentError>>;
  quote?: Maybe<Quote>;
};

export type DeleteQuoteError = NotFoundError | ValidationResultError;

export type DeleteQuoteInput = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type DeleteQuotePayload = {
  __typename?: 'DeleteQuotePayload';
  errors?: Maybe<Array<DeleteQuoteError>>;
  quote?: Maybe<Quote>;
};

export type DeleteRequestError = NotFoundError | ValidationResultError;

export type DeleteRequestInput = {
  formId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
};

export type DeleteRequestPayload = {
  __typename?: 'DeleteRequestPayload';
  errors?: Maybe<Array<DeleteRequestError>>;
  projectTask?: Maybe<ProjectTask>;
};

export type DeleteSecurityGroupError = NotFoundError | ValidationResultError;

export type DeleteSecurityGroupInput = {
  groupId: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type DeleteSecurityGroupPayload = {
  __typename?: 'DeleteSecurityGroupPayload';
  errors?: Maybe<Array<DeleteSecurityGroupError>>;
  securityGroup?: Maybe<SecurityGroup>;
};

export type DeleteTaskError = NotFoundError | ValidationResultError;

export type DeleteTaskInput = {
  projectId: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
};

export type DeleteTaskPayload = {
  __typename?: 'DeleteTaskPayload';
  errors?: Maybe<Array<DeleteTaskError>>;
  projectTask?: Maybe<ProjectTask>;
};

export type DeleteWorkflowActionConfigurationError = NotFoundError | ValidationResultError;

export type DeleteWorkflowActionConfigurationInput = {
  actionConfigurationId: Scalars['Int']['input'];
  workflowDefinitionId: Scalars['Int']['input'];
};

export type DeleteWorkflowActionConfigurationPayload = {
  __typename?: 'DeleteWorkflowActionConfigurationPayload';
  errors?: Maybe<Array<DeleteWorkflowActionConfigurationError>>;
  workflowActionConfiguration?: Maybe<WorkflowActionConfiguration>;
};

export type DeleteWorkflowDefinitionError = NotFoundError | ValidationResultError;

export type DeleteWorkflowDefinitionInput = {
  id: Scalars['Int']['input'];
};

export type DeleteWorkflowDefinitionPayload = {
  __typename?: 'DeleteWorkflowDefinitionPayload';
  errors?: Maybe<Array<DeleteWorkflowDefinitionError>>;
  workflowDefinition?: Maybe<WorkflowDefinition>;
};

export type DeleteWorkflowVariableError = NotFoundError | ValidationResultError;

export type DeleteWorkflowVariableInput = {
  workflowVariableId: Scalars['Int']['input'];
};

export type DeleteWorkflowVariablePayload = {
  __typename?: 'DeleteWorkflowVariablePayload';
  errors?: Maybe<Array<DeleteWorkflowVariableError>>;
  workflowVariable?: Maybe<WorkflowVariable>;
};

export type Document = {
  __typename?: 'Document';
  contentType?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<ApplicationUser>;
  createdById: Scalars['String']['output'];
  createdOn: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  folderEntry?: Maybe<FolderEntry>;
  folderEntryId?: Maybe<Scalars['Int']['output']>;
  formValue?: Maybe<FormValue>;
  formValueId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  imageThumbnailUrl?: Maybe<Scalars['String']['output']>;
  isImageContentType: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  isSigned: Scalars['Boolean']['output'];
  modifiedBy?: Maybe<ApplicationUser>;
  modifiedById?: Maybe<Scalars['String']['output']>;
  modifiedOn: Scalars['DateTime']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  publicSlug?: Maybe<Scalars['String']['output']>;
  requiresSignatures: Scalars['Boolean']['output'];
  signatoryCustomer?: Maybe<ApplicationUser>;
  signatoryCustomerId?: Maybe<Scalars['String']['output']>;
  signatureRequest?: Maybe<SignatureRequest>;
  signatureTask?: Maybe<ProjectTask>;
  signedOn?: Maybe<Scalars['DateTime']['output']>;
  textualSignature?: Maybe<Scalars['String']['output']>;
  thumbnailStatus: DocumentThumbnailStatus;
  zohoActionId?: Maybe<Scalars['String']['output']>;
  zohoRequestId?: Maybe<Scalars['String']['output']>;
};

export type DocumentFilterInput = {
  and?: InputMaybe<Array<DocumentFilterInput>>;
  contentType?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  folderEntry?: InputMaybe<FolderEntryFilterInput>;
  folderEntryId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  imageThumbnailUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DocumentFilterInput>>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
  requiresSignatures?: InputMaybe<BooleanOperationFilterInput>;
  signatoryCustomerId?: InputMaybe<StringOperationFilterInput>;
  signedOn?: InputMaybe<DateTimeOperationFilterInput>;
  thumbnailStatus?: InputMaybe<DocumentThumbnailStatusOperationFilterInput>;
};

export type DocumentTemplate = {
  __typename?: 'DocumentTemplate';
  createdBy?: Maybe<ApplicationUser>;
  createdById: Scalars['String']['output'];
  createdOn: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifiedBy?: Maybe<ApplicationUser>;
  modifiedById?: Maybe<Scalars['String']['output']>;
  modifiedOn: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
};

export type DocumentTemplateFilterInput = {
  and?: InputMaybe<Array<DocumentTemplateFilterInput>>;
  createdBy?: InputMaybe<ApplicationUserFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<ApplicationUserFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DocumentTemplateFilterInput>>;
};

export enum DocumentThumbnailStatus {
  Failed = 'Failed',
  Generating = 'Generating',
  NotAnImage = 'NotAnImage',
  NotStarted = 'NotStarted',
  Ready = 'Ready'
}

export type DocumentThumbnailStatusOperationFilterInput = {
  eq?: InputMaybe<DocumentThumbnailStatus>;
  in?: InputMaybe<Array<DocumentThumbnailStatus>>;
  neq?: InputMaybe<DocumentThumbnailStatus>;
  nin?: InputMaybe<Array<DocumentThumbnailStatus>>;
};

export enum DocumentsPermission {
  Contributor = 'Contributor',
  LimitedAccess = 'LimitedAccess',
  Manage = 'Manage'
}

export enum DomainEventType {
  DocumentDeleted = 'DocumentDeleted',
  DocumentSignatureRequestDenied = 'DocumentSignatureRequestDenied',
  DocumentSignatureRequestExpired = 'DocumentSignatureRequestExpired',
  DocumentSigned = 'DocumentSigned',
  FileDownloaded = 'FileDownloaded',
  FileUploaded = 'FileUploaded',
  FormFilled = 'FormFilled',
  MeetingAccepted = 'MeetingAccepted',
  MeetingDeclined = 'MeetingDeclined',
  MeetingRequested = 'MeetingRequested',
  WorkflowActionSubmitted = 'WorkflowActionSubmitted'
}

export type DuplicateCommercialProjectCalculatorError = NotFoundError | ValidationResultError;

export type DuplicateCommercialProjectCalculatorInput = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type DuplicateCommercialProjectCalculatorPayload = {
  __typename?: 'DuplicateCommercialProjectCalculatorPayload';
  commercialProjectCalculator?: Maybe<CommercialProjectCalculator>;
  errors?: Maybe<Array<DuplicateCommercialProjectCalculatorError>>;
};

export type DuplicateFormTemplateError = ValidationResultError;

export type DuplicateFormTemplateInput = {
  templateId: Scalars['Int']['input'];
};

export type DuplicateFormTemplatePayload = {
  __typename?: 'DuplicateFormTemplatePayload';
  errors?: Maybe<Array<DuplicateFormTemplateError>>;
  formTemplate?: Maybe<FormTemplate>;
};

export type DuplicateNameError = Error & {
  __typename?: 'DuplicateNameError';
  message: Scalars['String']['output'];
};

export type DuplicateWorkflowDefinitionError = NotFoundError | ValidationResultError;

export type DuplicateWorkflowDefinitionInput = {
  workflowId: Scalars['Int']['input'];
};

export type DuplicateWorkflowDefinitionPayload = {
  __typename?: 'DuplicateWorkflowDefinitionPayload';
  errors?: Maybe<Array<DuplicateWorkflowDefinitionError>>;
  workflowDefinition?: Maybe<WorkflowDefinition>;
};

export type EditBudgetItemError = NotFoundError | ValidationResultError;

export type EditBudgetItemInput = {
  budgetedAmount: Scalars['Decimal']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type EditBudgetItemPayload = {
  __typename?: 'EditBudgetItemPayload';
  budgetItem?: Maybe<BudgetItem>;
  errors?: Maybe<Array<EditBudgetItemError>>;
};

export type EditConditionError = NotFoundError | ValidationResultError;

export type EditConditionInput = {
  conditionId: Scalars['Int']['input'];
  effectFieldId?: InputMaybe<Scalars['Int']['input']>;
  effectSectionId?: InputMaybe<Scalars['Int']['input']>;
  effectVisibility?: InputMaybe<ConditionEffectVisibilityInput>;
  formDefinitionId: Scalars['Int']['input'];
  triggerFieldId: Scalars['Int']['input'];
  triggerValueEquality?: InputMaybe<ConditionTriggerValueEqualityInput>;
};

export type EditConditionPayload = {
  __typename?: 'EditConditionPayload';
  errors?: Maybe<Array<EditConditionError>>;
  formCondition?: Maybe<FormCondition>;
};

export type EditCostItemError = NotFoundError | ValidationResultError;

export type EditCostItemInput = {
  budgetItemId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  plannedAmount: Scalars['Decimal']['input'];
  projectId: Scalars['Int']['input'];
  status: CostItemStatus;
};

export type EditCostItemPayload = {
  __typename?: 'EditCostItemPayload';
  costItem?: Maybe<CostItem>;
  errors?: Maybe<Array<EditCostItemError>>;
};

export type EditDocumentTemplateError = NotFoundError;

export type EditDocumentTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type EditDocumentTemplatePayload = {
  __typename?: 'EditDocumentTemplatePayload';
  documentTemplate?: Maybe<DocumentTemplate>;
  errors?: Maybe<Array<EditDocumentTemplateError>>;
};

export type EditExpenseError = NotFoundError | ValidationResultError;

export type EditExpenseInput = {
  costItemId: Scalars['Int']['input'];
  expendedAmount: Scalars['Decimal']['input'];
  expenseDate: Scalars['DateTime']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  quoteId?: InputMaybe<Scalars['Int']['input']>;
  status: ExpenseStatus;
};

export type EditExpensePayload = {
  __typename?: 'EditExpensePayload';
  errors?: Maybe<Array<EditExpenseError>>;
  expense?: Maybe<Expense>;
};

export type EditExternalUserError = NotFoundError | ValidationResultError;

export type EditExternalUserInput = {
  business?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type EditExternalUserPayload = {
  __typename?: 'EditExternalUserPayload';
  applicationUser?: Maybe<ApplicationUser>;
  errors?: Maybe<Array<EditExternalUserError>>;
};

export type EditFormDefinitionError = NotFoundError | ValidationResultError;

export type EditFormDefinitionInput = {
  formDefinition: FormDefinitionInput;
  formDefinitionId: Scalars['Int']['input'];
};

export type EditFormDefinitionPayload = {
  __typename?: 'EditFormDefinitionPayload';
  errors?: Maybe<Array<EditFormDefinitionError>>;
  formDefinition?: Maybe<FormDefinition>;
};

export type EditFormFieldError = NotFoundError | ValidationResultError;

export type EditFormFieldInput = {
  documentUploadFolderId?: InputMaybe<Scalars['Int']['input']>;
  fieldId: Scalars['Int']['input'];
  formDefinitionId: Scalars['Int']['input'];
  isMultiline: Scalars['Boolean']['input'];
  isMultiselect: Scalars['Boolean']['input'];
  isRequired: Scalars['Boolean']['input'];
  matrixInput?: InputMaybe<MatrixInput>;
  name: Scalars['String']['input'];
  options: Array<SelectionFieldOptionInput>;
  shouldUploadDocumentsToFolder: Scalars['Boolean']['input'];
};

export type EditFormFieldPayload = {
  __typename?: 'EditFormFieldPayload';
  errors?: Maybe<Array<EditFormFieldError>>;
  formField?: Maybe<FormField>;
};

export type EditFormSectionError = NotFoundError | ValidationResultError;

export type EditFormSectionInput = {
  formDefinitionId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type EditFormSectionPayload = {
  __typename?: 'EditFormSectionPayload';
  errors?: Maybe<Array<EditFormSectionError>>;
  formSection?: Maybe<FormSection>;
};

export type EditMeetingTypeError = NotFoundError | ValidationResultError;

export type EditMeetingTypeInput = {
  bookingMethod: BookingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  durationMinutes: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  principals: Array<SecurityPrincipalShimInput>;
  projectId: Scalars['Int']['input'];
};

export type EditMeetingTypePayload = {
  __typename?: 'EditMeetingTypePayload';
  errors?: Maybe<Array<EditMeetingTypeError>>;
  meetingType?: Maybe<MeetingType>;
};

export type EditMemberSecurityGroupError = NotFoundError | ValidationResultError;

export type EditMemberSecurityGroupInput = {
  projectId: Scalars['Int']['input'];
  securityGroupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type EditMemberSecurityGroupPayload = {
  __typename?: 'EditMemberSecurityGroupPayload';
  applicationUser?: Maybe<ApplicationUser>;
  errors?: Maybe<Array<EditMemberSecurityGroupError>>;
};

export type EditProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type EditProjectPayload = {
  __typename?: 'EditProjectPayload';
  project?: Maybe<Project>;
};

export type EditProjectProgressInput = {
  progress: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type EditProjectProgressPayload = {
  __typename?: 'EditProjectProgressPayload';
  project?: Maybe<Project>;
};

export type EditQuoteError = NotFoundError | ValidationResultError;

export type EditQuoteInput = {
  amount: Scalars['Decimal']['input'];
  costItemId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  quoteDate: Scalars['DateTime']['input'];
};

export type EditQuotePayload = {
  __typename?: 'EditQuotePayload';
  errors?: Maybe<Array<EditQuoteError>>;
  quote?: Maybe<Quote>;
};

export type EditUserError = NotFoundError | ValidationResultError;

export type EditUserInput = {
  business?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type EditUserPayload = {
  __typename?: 'EditUserPayload';
  applicationUser?: Maybe<ApplicationUser>;
  errors?: Maybe<Array<EditUserError>>;
};

export type EditUserRoleError = NotFoundError | ValidationResultError;

export type EditUserRoleInput = {
  role: BuiltInRoles;
  userId: Scalars['String']['input'];
};

export type EditUserRolePayload = {
  __typename?: 'EditUserRolePayload';
  applicationUser?: Maybe<ApplicationUser>;
  errors?: Maybe<Array<EditUserRoleError>>;
};

export type EditWorkflowDefinitionError = NotFoundError | ValidationResultError;

export type EditWorkflowDefinitionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type EditWorkflowDefinitionPayload = {
  __typename?: 'EditWorkflowDefinitionPayload';
  errors?: Maybe<Array<EditWorkflowDefinitionError>>;
  workflowDefinition?: Maybe<WorkflowDefinition>;
};

export type EditWorkflowVariableError = NotFoundError | ValidationResultError;

export type EditWorkflowVariableInput = {
  name: Scalars['String']['input'];
  workflowVariableId: Scalars['Int']['input'];
};

export type EditWorkflowVariablePayload = {
  __typename?: 'EditWorkflowVariablePayload';
  errors?: Maybe<Array<EditWorkflowVariableError>>;
  workflowVariable?: Maybe<WorkflowVariable>;
};

export type ElectronicSignatureProviderError = Error & {
  __typename?: 'ElectronicSignatureProviderError';
  errorCode?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
};

export type Error = {
  message: Scalars['String']['output'];
};

export type Expense = {
  __typename?: 'Expense';
  attachments: Array<Document>;
  entry?: Maybe<CostItemEntry>;
  expendedAmount: Scalars['Decimal']['output'];
  expenseDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  quote?: Maybe<Quote>;
  quoteId?: Maybe<Scalars['Int']['output']>;
  status: ExpenseStatus;
};

export type ExpenseFilterInput = {
  and?: InputMaybe<Array<ExpenseFilterInput>>;
  attachments?: InputMaybe<ListFilterInputTypeOfDocumentFilterInput>;
  entry?: InputMaybe<CostItemEntryFilterInput>;
  expendedAmount?: InputMaybe<DecimalOperationFilterInput>;
  expenseDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExpenseFilterInput>>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
  quote?: InputMaybe<QuoteFilterInput>;
  quoteId?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<ExpenseStatusOperationFilterInput>;
};

export enum ExpenseStatus {
  NotPaid = 'NotPaid',
  Paid = 'Paid'
}

export type ExpenseStatusOperationFilterInput = {
  eq?: InputMaybe<ExpenseStatus>;
  in?: InputMaybe<Array<ExpenseStatus>>;
  neq?: InputMaybe<ExpenseStatus>;
  nin?: InputMaybe<Array<ExpenseStatus>>;
};

export type ExternalLink = {
  __typename?: 'ExternalLink';
  createdBy?: Maybe<ApplicationUser>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['DateTime']['output'];
  folderEntry?: Maybe<FolderEntry>;
  folderEntryId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  link: Scalars['String']['output'];
  modifiedBy?: Maybe<ApplicationUser>;
  modifiedById?: Maybe<Scalars['String']['output']>;
  modifiedOn: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  roleAssignments: Array<RoleAssignment>;
};

export type ExternalLinkFilterInput = {
  and?: InputMaybe<Array<ExternalLinkFilterInput>>;
  createdBy?: InputMaybe<ApplicationUserFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  folderEntry?: InputMaybe<FolderEntryFilterInput>;
  folderEntryId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  link?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<ApplicationUserFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExternalLinkFilterInput>>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
  roleAssignments?: InputMaybe<ListFilterInputTypeOfRoleAssignmentFilterInput>;
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  documentTemplatesEnabled: Scalars['Boolean']['output'];
};

export enum FieldType {
  Boolean = 'Boolean',
  Date = 'Date',
  File = 'File',
  Matrix = 'Matrix',
  Numerical = 'Numerical',
  Selection = 'Selection',
  Text = 'Text'
}

export type FieldTypeOperationFilterInput = {
  eq?: InputMaybe<FieldType>;
  in?: InputMaybe<Array<FieldType>>;
  neq?: InputMaybe<FieldType>;
  nin?: InputMaybe<Array<FieldType>>;
};

export type FillFormError = NotFoundError | ValidationResultError;

export type FillFormInput = {
  formSubmissionId: Scalars['Int']['input'];
};

export type FillFormPayload = {
  __typename?: 'FillFormPayload';
  errors?: Maybe<Array<FillFormError>>;
  projectFormSubmission?: Maybe<ProjectFormSubmission>;
};

export type FillFormValueError = NotFoundError | ValidationResultError;

export type FillFormValueInput = {
  formValue: FormValueInput;
};

export type FillFormValuePayload = {
  __typename?: 'FillFormValuePayload';
  errors?: Maybe<Array<FillFormValueError>>;
  formValue?: Maybe<FormValue>;
};

export type FillMatrixValueError = NotFoundError | ValidationResultError;

export type FillMatrixValueInput = {
  columnId: Scalars['Int']['input'];
  matrixValueId?: InputMaybe<Scalars['Int']['input']>;
  rowId: Scalars['Int']['input'];
  submissionId: Scalars['Int']['input'];
  value: MatrixValueInput;
};

export type FillMatrixValuePatError = AccessTokenExpiredError | AccessTokenInvalidError | NotFoundError | ValidationResultError;

export type FillMatrixValuePatInput = {
  accessToken: Scalars['String']['input'];
  input: FillMatrixValueInput;
};

export type FillMatrixValuePatPayload = {
  __typename?: 'FillMatrixValuePATPayload';
  errors?: Maybe<Array<FillMatrixValuePatError>>;
  matrixValue?: Maybe<MatrixValue>;
};

export type FillMatrixValuePayload = {
  __typename?: 'FillMatrixValuePayload';
  errors?: Maybe<Array<FillMatrixValueError>>;
  matrixValue?: Maybe<MatrixValue>;
};

export type Folder = {
  __typename?: 'Folder';
  entries: Array<FolderEntry>;
  folderType: FolderType;
  id: Scalars['Int']['output'];
  modifiedBy?: Maybe<ApplicationUser>;
  modifiedById?: Maybe<Scalars['String']['output']>;
  modifiedOn: Scalars['DateTime']['output'];
  myPermissions: Array<BuiltInRoles>;
  name: Scalars['String']['output'];
  parentFolder?: Maybe<Folder>;
  parentFolderId?: Maybe<Scalars['Int']['output']>;
  path: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  rootOfProjectId?: Maybe<Scalars['Int']['output']>;
};

export type FolderEntry = {
  __typename?: 'FolderEntry';
  deletedOnUTC?: Maybe<Scalars['DateTime']['output']>;
  document?: Maybe<Document>;
  externalLink?: Maybe<ExternalLink>;
  folder?: Maybe<Folder>;
  folderId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDeleted: Scalars['Boolean']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
};

export type FolderEntryFilterInput = {
  and?: InputMaybe<Array<FolderEntryFilterInput>>;
  deletedOnUTC?: InputMaybe<DateTimeOperationFilterInput>;
  document?: InputMaybe<DocumentFilterInput>;
  externalLink?: InputMaybe<ExternalLinkFilterInput>;
  folder?: InputMaybe<FolderFilterInput>;
  folderId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FolderEntryFilterInput>>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
};

export type FolderFilterInput = {
  and?: InputMaybe<Array<FolderFilterInput>>;
  entries?: InputMaybe<ListFilterInputTypeOfFolderEntryFilterInput>;
  folderType?: InputMaybe<FolderTypeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FolderFilterInput>>;
  parentFolder?: InputMaybe<FolderFilterInput>;
  parentFolderId?: InputMaybe<IntOperationFilterInput>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
};

export type FolderSortInput = {
  folderType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isConfidentialFolder?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<ApplicationUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentFolder?: InputMaybe<FolderSortInput>;
  parentFolderId?: InputMaybe<SortEnumType>;
  path?: InputMaybe<SortEnumType>;
  project?: InputMaybe<ProjectSortInput>;
  projectId?: InputMaybe<SortEnumType>;
  rootOfProject?: InputMaybe<ProjectSortInput>;
  rootOfProjectId?: InputMaybe<SortEnumType>;
};

export enum FolderType {
  ConfidentialDocumentRoot = 'ConfidentialDocumentRoot',
  Custom = 'Custom',
  Root = 'Root',
  SharedWithAllRoot = 'SharedWithAllRoot'
}

export type FolderTypeOperationFilterInput = {
  eq?: InputMaybe<FolderType>;
  in?: InputMaybe<Array<FolderType>>;
  neq?: InputMaybe<FolderType>;
  nin?: InputMaybe<Array<FolderType>>;
};

export type FormCondition = {
  __typename?: 'FormCondition';
  effect: ConditionEffect;
  form?: Maybe<FormDefinition>;
  formId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  trigger: ConditionTrigger;
};

export type FormConditionFilterInput = {
  and?: InputMaybe<Array<FormConditionFilterInput>>;
  effect?: InputMaybe<ConditionEffectFilterInput>;
  form?: InputMaybe<FormDefinitionFilterInput>;
  formId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<FormConditionFilterInput>>;
  trigger?: InputMaybe<ConditionTriggerFilterInput>;
};

export type FormDefinition = {
  __typename?: 'FormDefinition';
  conditions: Array<FormCondition>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sections: Array<FormSection>;
};


export type FormDefinitionSectionsArgs = {
  order?: InputMaybe<Array<FormSectionSortInput>>;
};

export type FormDefinitionFilterInput = {
  and?: InputMaybe<Array<FormDefinitionFilterInput>>;
  conditions?: InputMaybe<ListFilterInputTypeOfFormConditionFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormDefinitionFilterInput>>;
  sections?: InputMaybe<ListFilterInputTypeOfFormSectionFilterInput>;
};

export type FormDefinitionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type FormDefinitionSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type FormField = {
  __typename?: 'FormField';
  affectedBy: Array<ConditionEffect>;
  documentUploadFolder?: Maybe<Folder>;
  documentUploadFolderId?: Maybe<Scalars['Int']['output']>;
  fieldType: FieldType;
  id: Scalars['Int']['output'];
  isMultiline: Scalars['Boolean']['output'];
  isMultiselect: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  matrix?: Maybe<Matrix>;
  matrixId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  options: Array<SelectionFieldOption>;
  order: Scalars['Int']['output'];
  section?: Maybe<FormSection>;
  sectionId: Scalars['Int']['output'];
  shouldUploadDocumentsToFolder: Scalars['Boolean']['output'];
  triggers: Array<ConditionTrigger>;
};

export type FormFieldFilterInput = {
  affectedBy?: InputMaybe<ListFilterInputTypeOfConditionEffectFilterInput>;
  and?: InputMaybe<Array<FormFieldFilterInput>>;
  documentUploadFolder?: InputMaybe<FolderFilterInput>;
  documentUploadFolderId?: InputMaybe<IntOperationFilterInput>;
  fieldType?: InputMaybe<FieldTypeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isMultiline?: InputMaybe<BooleanOperationFilterInput>;
  isMultiselect?: InputMaybe<BooleanOperationFilterInput>;
  isRequired?: InputMaybe<BooleanOperationFilterInput>;
  matrix?: InputMaybe<MatrixFilterInput>;
  matrixId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  options?: InputMaybe<ListFilterInputTypeOfSelectionFieldOptionFilterInput>;
  or?: InputMaybe<Array<FormFieldFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  section?: InputMaybe<FormSectionFilterInput>;
  sectionId?: InputMaybe<IntOperationFilterInput>;
  shouldUploadDocumentsToFolder?: InputMaybe<BooleanOperationFilterInput>;
  triggers?: InputMaybe<ListFilterInputTypeOfConditionTriggerFilterInput>;
};

export type FormFieldSortInput = {
  documentUploadFolder?: InputMaybe<FolderSortInput>;
  documentUploadFolderId?: InputMaybe<SortEnumType>;
  fieldType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isMultiline?: InputMaybe<SortEnumType>;
  isMultiselect?: InputMaybe<SortEnumType>;
  isRequired?: InputMaybe<SortEnumType>;
  matrix?: InputMaybe<MatrixSortInput>;
  matrixId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
  section?: InputMaybe<FormSectionSortInput>;
  sectionId?: InputMaybe<SortEnumType>;
  shouldUploadDocumentsToFolder?: InputMaybe<SortEnumType>;
};

export type FormSection = {
  __typename?: 'FormSection';
  affectedBy: Array<ConditionEffect>;
  fields: Array<FormField>;
  form?: Maybe<FormDefinition>;
  formId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};


export type FormSectionFieldsArgs = {
  order?: InputMaybe<Array<FormFieldSortInput>>;
};

export type FormSectionFilterInput = {
  affectedBy?: InputMaybe<ListFilterInputTypeOfConditionEffectFilterInput>;
  and?: InputMaybe<Array<FormSectionFilterInput>>;
  fields?: InputMaybe<ListFilterInputTypeOfFormFieldFilterInput>;
  form?: InputMaybe<FormDefinitionFilterInput>;
  formId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormSectionFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
};

export type FormSectionSortInput = {
  form?: InputMaybe<FormDefinitionSortInput>;
  formId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
};

export type FormSettings = {
  __typename?: 'FormSettings';
  allowedRespondents: AllowedRespondents;
  allowedSecurityGroupsRespondents: Array<SecurityGroup>;
  allowedUsersRespondents: Array<ApplicationUser>;
  formType: FormType;
  id: Scalars['Int']['output'];
};

export type FormSettingsFilterInput = {
  allowedRespondents?: InputMaybe<AllowedRespondentsOperationFilterInput>;
  allowedSecurityGroupsRespondents?: InputMaybe<ListFilterInputTypeOfSecurityGroupFilterInput>;
  allowedUsersRespondents?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  and?: InputMaybe<Array<FormSettingsFilterInput>>;
  formType?: InputMaybe<FormTypeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<FormSettingsFilterInput>>;
  projectForm?: InputMaybe<ProjectFormFilterInput>;
  projectFormId?: InputMaybe<IntOperationFilterInput>;
};

export enum FormStatus {
  Draft = 'Draft',
  Published = 'Published',
  /** @deprecated Form submissions now have a status indicating if it is responded. */
  Responded = 'Responded',
  Sent = 'Sent'
}

export type FormStatusOperationFilterInput = {
  eq?: InputMaybe<FormStatus>;
  in?: InputMaybe<Array<FormStatus>>;
  neq?: InputMaybe<FormStatus>;
  nin?: InputMaybe<Array<FormStatus>>;
};

export type FormTemplate = {
  __typename?: 'FormTemplate';
  createdBy?: Maybe<ApplicationUser>;
  createdById: Scalars['String']['output'];
  createdOn: Scalars['DateTime']['output'];
  formDefinition?: Maybe<FormDefinition>;
  formDefinitionId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  roleAssignments: Array<RoleAssignment>;
};

export type FormTemplateFilterInput = {
  and?: InputMaybe<Array<FormTemplateFilterInput>>;
  createdBy?: InputMaybe<ApplicationUserFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  formDefinition?: InputMaybe<FormDefinitionFilterInput>;
  formDefinitionId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<ApplicationUserFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<FormTemplateFilterInput>>;
  roleAssignments?: InputMaybe<ListFilterInputTypeOfRoleAssignmentFilterInput>;
  workflowVariables?: InputMaybe<ListFilterInputTypeOfWorkflowVariableFilterInput>;
};

export enum FormType {
  CollectResponse = 'CollectResponse',
  SelfServe = 'SelfServe'
}

export type FormTypeOperationFilterInput = {
  eq?: InputMaybe<FormType>;
  in?: InputMaybe<Array<FormType>>;
  neq?: InputMaybe<FormType>;
  nin?: InputMaybe<Array<FormType>>;
};

export type FormValue = {
  __typename?: 'FormValue';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  dateValue?: Maybe<Scalars['DateTime']['output']>;
  documents: Array<Document>;
  fieldId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  matrixRows: Array<MatrixRow>;
  number?: Maybe<Scalars['Decimal']['output']>;
  selectedOptions: Array<SelectionFieldOption>;
  text?: Maybe<Scalars['String']['output']>;
};

export type FormValueEditedEvent = {
  __typename?: 'FormValueEditedEvent';
  formValue: FormValue;
  initiatorUniqueClientId: Scalars['String']['output'];
};

export type FormValueFilterInput = {
  and?: InputMaybe<Array<FormValueFilterInput>>;
  boolean?: InputMaybe<BooleanOperationFilterInput>;
  dateValue?: InputMaybe<DateTimeOperationFilterInput>;
  documents?: InputMaybe<ListFilterInputTypeOfDocumentFilterInput>;
  field?: InputMaybe<FormFieldFilterInput>;
  fieldId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  matrixRows?: InputMaybe<ListFilterInputTypeOfMatrixRowFilterInput>;
  number?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<FormValueFilterInput>>;
  selectedOptions?: InputMaybe<ListFilterInputTypeOfSelectionFieldOptionFilterInput>;
  submission?: InputMaybe<ProjectFormSubmissionFilterInput>;
  submissionId?: InputMaybe<IntOperationFilterInput>;
  text?: InputMaybe<StringOperationFilterInput>;
};

export type FormValueInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  dateValue?: InputMaybe<Scalars['DateTime']['input']>;
  fieldId: Scalars['Int']['input'];
  number?: InputMaybe<Scalars['Decimal']['input']>;
  selectedOptionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  submissionId: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export enum FormsPermission {
  LimitedAccess = 'LimitedAccess',
  Manage = 'Manage'
}

export type GetCalendarAvailabilitiesForMeetingTypeInput = {
  endTime: Scalars['DateTime']['input'];
  meetingTypeId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  startTime: Scalars['DateTime']['input'];
  timeIntervalInMinutes: Scalars['Int']['input'];
  timeZone: Scalars['String']['input'];
};

export type GetCalendarAvailabilitiesInput = {
  endTime: Scalars['DateTime']['input'];
  memberId: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  startTime: Scalars['DateTime']['input'];
  timeIntervalInMinutes: Scalars['Int']['input'];
  timeZone: Scalars['String']['input'];
};

export type HierarchyIdFilterInput = {
  and?: InputMaybe<Array<HierarchyIdFilterInput>>;
  or?: InputMaybe<Array<HierarchyIdFilterInput>>;
};

export type ImportFoldersError = NotFoundError | ValidationResultError;

export type ImportFoldersInput = {
  currentFolderId: Scalars['Int']['input'];
  folderIds: Array<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  projectToImportFromId: Scalars['Int']['input'];
};

export type ImportFoldersPayload = {
  __typename?: 'ImportFoldersPayload';
  errors?: Maybe<Array<ImportFoldersError>>;
  project?: Maybe<Project>;
};

export type ImportTasksError = NotFoundError | ValidationResultError;

export type ImportTasksInput = {
  newStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  projectId: Scalars['Int']['input'];
  projectToImportFromId: Scalars['Int']['input'];
  taskIds: Array<Scalars['Int']['input']>;
  userMapping: Array<KeyValuePairOfStringAndStringInput>;
};

export type ImportTasksPayload = {
  __typename?: 'ImportTasksPayload';
  errors?: Maybe<Array<ImportTasksError>>;
  project?: Maybe<Project>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type InviteUserError = NotFoundError | ValidationResultError;

export type InviteUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberExtension?: InputMaybe<Scalars['Int']['input']>;
  role: BuiltInRoles;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type InviteUserPayload = {
  __typename?: 'InviteUserPayload';
  applicationUser?: Maybe<ApplicationUser>;
  errors?: Maybe<Array<InviteUserError>>;
};

export type KeyValuePairOfStringAndStringInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ListBuiltInRolesOperationFilterInput = {
  all?: InputMaybe<BuiltInRolesOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BuiltInRolesOperationFilterInput>;
  some?: InputMaybe<BuiltInRolesOperationFilterInput>;
};

export type ListFilterInputTypeOfApplicationRoleFilterInput = {
  all?: InputMaybe<ApplicationRoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ApplicationRoleFilterInput>;
  some?: InputMaybe<ApplicationRoleFilterInput>;
};

export type ListFilterInputTypeOfApplicationUserFilterInput = {
  all?: InputMaybe<ApplicationUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ApplicationUserFilterInput>;
  some?: InputMaybe<ApplicationUserFilterInput>;
};

export type ListFilterInputTypeOfBudgetItemFilterInput = {
  all?: InputMaybe<BudgetItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BudgetItemFilterInput>;
  some?: InputMaybe<BudgetItemFilterInput>;
};

export type ListFilterInputTypeOfCommercialProjectCalculatorFilterInput = {
  all?: InputMaybe<CommercialProjectCalculatorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CommercialProjectCalculatorFilterInput>;
  some?: InputMaybe<CommercialProjectCalculatorFilterInput>;
};

export type ListFilterInputTypeOfConditionEffectFilterInput = {
  all?: InputMaybe<ConditionEffectFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConditionEffectFilterInput>;
  some?: InputMaybe<ConditionEffectFilterInput>;
};

export type ListFilterInputTypeOfConditionTriggerFilterInput = {
  all?: InputMaybe<ConditionTriggerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConditionTriggerFilterInput>;
  some?: InputMaybe<ConditionTriggerFilterInput>;
};

export type ListFilterInputTypeOfCostItemEntryFilterInput = {
  all?: InputMaybe<CostItemEntryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CostItemEntryFilterInput>;
  some?: InputMaybe<CostItemEntryFilterInput>;
};

export type ListFilterInputTypeOfCostItemFilterInput = {
  all?: InputMaybe<CostItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CostItemFilterInput>;
  some?: InputMaybe<CostItemFilterInput>;
};

export type ListFilterInputTypeOfDocumentFilterInput = {
  all?: InputMaybe<DocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DocumentFilterInput>;
  some?: InputMaybe<DocumentFilterInput>;
};

export type ListFilterInputTypeOfExpenseFilterInput = {
  all?: InputMaybe<ExpenseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ExpenseFilterInput>;
  some?: InputMaybe<ExpenseFilterInput>;
};

export type ListFilterInputTypeOfFolderEntryFilterInput = {
  all?: InputMaybe<FolderEntryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FolderEntryFilterInput>;
  some?: InputMaybe<FolderEntryFilterInput>;
};

export type ListFilterInputTypeOfFolderFilterInput = {
  all?: InputMaybe<FolderFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FolderFilterInput>;
  some?: InputMaybe<FolderFilterInput>;
};

export type ListFilterInputTypeOfFormConditionFilterInput = {
  all?: InputMaybe<FormConditionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FormConditionFilterInput>;
  some?: InputMaybe<FormConditionFilterInput>;
};

export type ListFilterInputTypeOfFormFieldFilterInput = {
  all?: InputMaybe<FormFieldFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FormFieldFilterInput>;
  some?: InputMaybe<FormFieldFilterInput>;
};

export type ListFilterInputTypeOfFormSectionFilterInput = {
  all?: InputMaybe<FormSectionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FormSectionFilterInput>;
  some?: InputMaybe<FormSectionFilterInput>;
};

export type ListFilterInputTypeOfFormValueFilterInput = {
  all?: InputMaybe<FormValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FormValueFilterInput>;
  some?: InputMaybe<FormValueFilterInput>;
};

export type ListFilterInputTypeOfMatrixColumnFilterInput = {
  all?: InputMaybe<MatrixColumnFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MatrixColumnFilterInput>;
  some?: InputMaybe<MatrixColumnFilterInput>;
};

export type ListFilterInputTypeOfMatrixRowFilterInput = {
  all?: InputMaybe<MatrixRowFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MatrixRowFilterInput>;
  some?: InputMaybe<MatrixRowFilterInput>;
};

export type ListFilterInputTypeOfMatrixValueFilterInput = {
  all?: InputMaybe<MatrixValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MatrixValueFilterInput>;
  some?: InputMaybe<MatrixValueFilterInput>;
};

export type ListFilterInputTypeOfMeetingFilterInput = {
  all?: InputMaybe<MeetingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MeetingFilterInput>;
  some?: InputMaybe<MeetingFilterInput>;
};

export type ListFilterInputTypeOfMeetingProposalFilterInput = {
  all?: InputMaybe<MeetingProposalFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MeetingProposalFilterInput>;
  some?: InputMaybe<MeetingProposalFilterInput>;
};

export type ListFilterInputTypeOfMeetingTypeFilterInput = {
  all?: InputMaybe<MeetingTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MeetingTypeFilterInput>;
  some?: InputMaybe<MeetingTypeFilterInput>;
};

export type ListFilterInputTypeOfProjectAccessTokenFilterInput = {
  all?: InputMaybe<ProjectAccessTokenFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectAccessTokenFilterInput>;
  some?: InputMaybe<ProjectAccessTokenFilterInput>;
};

export type ListFilterInputTypeOfProjectEventFilterInput = {
  all?: InputMaybe<ProjectEventFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectEventFilterInput>;
  some?: InputMaybe<ProjectEventFilterInput>;
};

export type ListFilterInputTypeOfProjectFormFilterInput = {
  all?: InputMaybe<ProjectFormFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectFormFilterInput>;
  some?: InputMaybe<ProjectFormFilterInput>;
};

export type ListFilterInputTypeOfProjectTaskFilterInput = {
  all?: InputMaybe<ProjectTaskFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectTaskFilterInput>;
  some?: InputMaybe<ProjectTaskFilterInput>;
};

export type ListFilterInputTypeOfRoleAssignmentFilterInput = {
  all?: InputMaybe<RoleAssignmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RoleAssignmentFilterInput>;
  some?: InputMaybe<RoleAssignmentFilterInput>;
};

export type ListFilterInputTypeOfSecurityGroupFilterInput = {
  all?: InputMaybe<SecurityGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SecurityGroupFilterInput>;
  some?: InputMaybe<SecurityGroupFilterInput>;
};

export type ListFilterInputTypeOfSelectionFieldOptionFilterInput = {
  all?: InputMaybe<SelectionFieldOptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SelectionFieldOptionFilterInput>;
  some?: InputMaybe<SelectionFieldOptionFilterInput>;
};

export type ListFilterInputTypeOfWorkflowActionFieldValueFilterInput = {
  all?: InputMaybe<WorkflowActionFieldValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<WorkflowActionFieldValueFilterInput>;
  some?: InputMaybe<WorkflowActionFieldValueFilterInput>;
};

export type ListFilterInputTypeOfWorkflowDefinitionFilterInput = {
  all?: InputMaybe<WorkflowDefinitionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<WorkflowDefinitionFilterInput>;
  some?: InputMaybe<WorkflowDefinitionFilterInput>;
};

export type ListFilterInputTypeOfWorkflowInstanceFilterInput = {
  all?: InputMaybe<WorkflowInstanceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<WorkflowInstanceFilterInput>;
  some?: InputMaybe<WorkflowInstanceFilterInput>;
};

export type ListFilterInputTypeOfWorkflowVariableFilterInput = {
  all?: InputMaybe<WorkflowVariableFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<WorkflowVariableFilterInput>;
  some?: InputMaybe<WorkflowVariableFilterInput>;
};

export type LoginInfo = {
  __typename?: 'LoginInfo';
  hasSignedUp: Scalars['Boolean']['output'];
  isAuthenticatedWithMagicLink: Scalars['Boolean']['output'];
  isMicrosoftAccountLogin: Scalars['Boolean']['output'];
};

export enum ManagePublicFileSharingPermission {
  Allowed = 'Allowed',
  NotAllowed = 'NotAllowed'
}

export type Matrix = {
  __typename?: 'Matrix';
  columns: Array<MatrixColumn>;
  defaultRows: Array<MatrixRow>;
  id: Scalars['Int']['output'];
};


export type MatrixColumnsArgs = {
  order?: InputMaybe<Array<MatrixColumnSortInput>>;
};

export type MatrixColumn = {
  __typename?: 'MatrixColumn';
  description?: Maybe<Scalars['String']['output']>;
  fieldType: MatrixColumnType;
  id: Scalars['Int']['output'];
  isRequired: Scalars['Boolean']['output'];
  matrix?: Maybe<Matrix>;
  matrixId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  values: Array<MatrixValue>;
};

export type MatrixColumnFilterInput = {
  and?: InputMaybe<Array<MatrixColumnFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  fieldType?: InputMaybe<MatrixColumnTypeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isRequired?: InputMaybe<BooleanOperationFilterInput>;
  matrix?: InputMaybe<MatrixFilterInput>;
  matrixId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MatrixColumnFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  values?: InputMaybe<ListFilterInputTypeOfMatrixValueFilterInput>;
};

export type MatrixColumnInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  type: MatrixColumnType;
};

export type MatrixColumnSortInput = {
  description?: InputMaybe<SortEnumType>;
  fieldType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isRequired?: InputMaybe<SortEnumType>;
  matrix?: InputMaybe<MatrixSortInput>;
  matrixId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
};

export enum MatrixColumnType {
  Boolean = 'Boolean',
  Numerical = 'Numerical',
  Text = 'Text'
}

export type MatrixColumnTypeOperationFilterInput = {
  eq?: InputMaybe<MatrixColumnType>;
  in?: InputMaybe<Array<MatrixColumnType>>;
  neq?: InputMaybe<MatrixColumnType>;
  nin?: InputMaybe<Array<MatrixColumnType>>;
};

export type MatrixFilterInput = {
  and?: InputMaybe<Array<MatrixFilterInput>>;
  columns?: InputMaybe<ListFilterInputTypeOfMatrixColumnFilterInput>;
  defaultRows?: InputMaybe<ListFilterInputTypeOfMatrixRowFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<MatrixFilterInput>>;
};

export type MatrixInput = {
  columns: Array<MatrixColumnInput>;
  defaultRows: Array<MatrixRowInput>;
};

export type MatrixRow = {
  __typename?: 'MatrixRow';
  formValue?: Maybe<FormValue>;
  formValueId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isDefaultRow: Scalars['Boolean']['output'];
  matrix?: Maybe<Matrix>;
  matrixId?: Maybe<Scalars['Int']['output']>;
  values: Array<MatrixValue>;
};

export type MatrixRowEvent = {
  __typename?: 'MatrixRowEvent';
  eventType: MatrixRowEventType;
  id: Scalars['Int']['output'];
  initiatorUniqueClientId: Scalars['String']['output'];
};

export enum MatrixRowEventType {
  Added = 'Added',
  Removed = 'Removed'
}

export type MatrixRowFilterInput = {
  and?: InputMaybe<Array<MatrixRowFilterInput>>;
  formValue?: InputMaybe<FormValueFilterInput>;
  formValueId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDefaultRow?: InputMaybe<BooleanOperationFilterInput>;
  matrix?: InputMaybe<MatrixFilterInput>;
  matrixId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<MatrixRowFilterInput>>;
  values?: InputMaybe<ListFilterInputTypeOfMatrixValueFilterInput>;
};

export type MatrixRowInput = {
  values: Array<MatrixValueInput>;
};

export type MatrixSortInput = {
  id?: InputMaybe<SortEnumType>;
};

export type MatrixValue = {
  __typename?: 'MatrixValue';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  matrixColumn?: Maybe<MatrixColumn>;
  matrixColumnId: Scalars['Int']['output'];
  matrixRow?: Maybe<MatrixRow>;
  matrixRowId: Scalars['Int']['output'];
  number?: Maybe<Scalars['Decimal']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type MatrixValueEditedEvent = {
  __typename?: 'MatrixValueEditedEvent';
  initiatorUniqueClientId: Scalars['String']['output'];
  matrixValue: MatrixValue;
};

export type MatrixValueFilterInput = {
  and?: InputMaybe<Array<MatrixValueFilterInput>>;
  boolean?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  matrixColumn?: InputMaybe<MatrixColumnFilterInput>;
  matrixColumnId?: InputMaybe<IntOperationFilterInput>;
  matrixRow?: InputMaybe<MatrixRowFilterInput>;
  matrixRowId?: InputMaybe<IntOperationFilterInput>;
  number?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<MatrixValueFilterInput>>;
  text?: InputMaybe<StringOperationFilterInput>;
};

export type MatrixValueInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Decimal']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type Meeting = {
  __typename?: 'Meeting';
  cancellationReason?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<ApplicationUser>;
  createdById: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  meetingStatus: MeetingStatus;
  meetingType?: Maybe<MeetingType>;
  meetingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  participants: Array<ApplicationUser>;
  proposals: Array<MeetingProposal>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
};


export type MeetingProposalsArgs = {
  order?: InputMaybe<Array<MeetingProposalSortInput>>;
};

export type MeetingFilterInput = {
  and?: InputMaybe<Array<MeetingFilterInput>>;
  calUID?: InputMaybe<StringOperationFilterInput>;
  cancellationReason?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<ApplicationUserFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endTime?: InputMaybe<DateTimeOperationFilterInput>;
  events?: InputMaybe<ListFilterInputTypeOfProjectEventFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  meetingStatus?: InputMaybe<MeetingStatusOperationFilterInput>;
  meetingType?: InputMaybe<MeetingTypeFilterInput>;
  meetingTypeId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MeetingFilterInput>>;
  organizer?: InputMaybe<ApplicationUserFilterInput>;
  organizerId?: InputMaybe<StringOperationFilterInput>;
  outlookEventId?: InputMaybe<StringOperationFilterInput>;
  participants?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
  proposals?: InputMaybe<ListFilterInputTypeOfMeetingProposalFilterInput>;
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
  timeZone?: InputMaybe<StringOperationFilterInput>;
};

export type MeetingProposal = {
  __typename?: 'MeetingProposal';
  acceptedUsers: Array<ApplicationUser>;
  createdBy?: Maybe<ApplicationUser>;
  createdById: Scalars['String']['output'];
  createdOn: Scalars['DateTime']['output'];
  declinedUsers: Array<ApplicationUser>;
  id: Scalars['Int']['output'];
  meeting?: Maybe<Meeting>;
  meetingId: Scalars['Int']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type MeetingProposalFilterInput = {
  acceptedUsers?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  and?: InputMaybe<Array<MeetingProposalFilterInput>>;
  createdBy?: InputMaybe<ApplicationUserFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  declinedUsers?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  meeting?: InputMaybe<MeetingFilterInput>;
  meetingId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<MeetingProposalFilterInput>>;
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
};

export type MeetingProposalSortInput = {
  createdBy?: InputMaybe<ApplicationUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  meeting?: InputMaybe<MeetingSortInput>;
  meetingId?: InputMaybe<SortEnumType>;
  startTime?: InputMaybe<SortEnumType>;
};

export type MeetingSortInput = {
  calUID?: InputMaybe<SortEnumType>;
  cancellationReason?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<ApplicationUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  endTime?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  meetingStatus?: InputMaybe<SortEnumType>;
  meetingType?: InputMaybe<MeetingTypeSortInput>;
  meetingTypeId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  organizer?: InputMaybe<ApplicationUserSortInput>;
  organizerId?: InputMaybe<SortEnumType>;
  outlookEventId?: InputMaybe<SortEnumType>;
  project?: InputMaybe<ProjectSortInput>;
  projectId?: InputMaybe<SortEnumType>;
  startTime?: InputMaybe<SortEnumType>;
  timeZone?: InputMaybe<SortEnumType>;
};

export enum MeetingStatus {
  Cancelled = 'Cancelled',
  Planned = 'Planned',
  Requested = 'Requested'
}

export type MeetingStatusOperationFilterInput = {
  eq?: InputMaybe<MeetingStatus>;
  in?: InputMaybe<Array<MeetingStatus>>;
  neq?: InputMaybe<MeetingStatus>;
  nin?: InputMaybe<Array<MeetingStatus>>;
};

export type MeetingType = {
  __typename?: 'MeetingType';
  bookingMethod: BookingMethod;
  createdBy?: Maybe<ApplicationUser>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['TimeSpan']['output'];
  id: Scalars['Int']['output'];
  isDeleted: Scalars['Boolean']['output'];
  meetingRequestOwnerGroups: Array<SecurityGroup>;
  meetingRequestsOwners: Array<ApplicationUser>;
  meetings: Array<Meeting>;
  modifiedBy?: Maybe<ApplicationUser>;
  modifiedById?: Maybe<Scalars['String']['output']>;
  modifiedOn: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  workflowVariables: Array<WorkflowVariable>;
};

export type MeetingTypeFilterInput = {
  and?: InputMaybe<Array<MeetingTypeFilterInput>>;
  bookingMethod?: InputMaybe<BookingMethodOperationFilterInput>;
  createdBy?: InputMaybe<ApplicationUserFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  duration?: InputMaybe<TimeSpanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  meetingRequestOwnerGroups?: InputMaybe<ListFilterInputTypeOfSecurityGroupFilterInput>;
  meetingRequestsOwners?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  meetings?: InputMaybe<ListFilterInputTypeOfMeetingFilterInput>;
  modifiedBy?: InputMaybe<ApplicationUserFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MeetingTypeFilterInput>>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
  workflowVariables?: InputMaybe<ListFilterInputTypeOfWorkflowVariableFilterInput>;
};

export type MeetingTypeSortInput = {
  bookingMethod?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<ApplicationUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  duration?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<ApplicationUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  project?: InputMaybe<ProjectSortInput>;
  projectId?: InputMaybe<SortEnumType>;
};

export type MissingConfigurationError = Error & {
  __typename?: 'MissingConfigurationError';
  message: Scalars['String']['output'];
};

export type MoveChildActionError = NotFoundError | ValidationResultError;

export type MoveChildActionInput = {
  movedActionConfigurationId: Scalars['Int']['input'];
  orderIndex: Scalars['Int']['input'];
  parentActionConfigurationId: Scalars['Int']['input'];
  workflowDefinitionId: Scalars['Int']['input'];
};

export type MoveChildActionPayload = {
  __typename?: 'MoveChildActionPayload';
  errors?: Maybe<Array<MoveChildActionError>>;
  workflowActionConfiguration?: Maybe<WorkflowActionConfiguration>;
};

export type MoveFolderEntryError = ValidationResultError;

export type MoveFolderEntryInput = {
  destinationFolderId: Scalars['Int']['input'];
  entryId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type MoveFolderEntryPayload = {
  __typename?: 'MoveFolderEntryPayload';
  errors?: Maybe<Array<MoveFolderEntryError>>;
  folderEntry?: Maybe<FolderEntry>;
};

export type MoveFolderError = ValidationResultError;

export type MoveFolderInput = {
  destinationFolderId: Scalars['Int']['input'];
  folderId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type MoveFolderPayload = {
  __typename?: 'MoveFolderPayload';
  errors?: Maybe<Array<MoveFolderError>>;
  folder?: Maybe<Folder>;
};

export type MoveFormFieldError = NotFoundError | ValidationResultError;

export type MoveFormFieldInput = {
  destinationSectionId?: InputMaybe<Scalars['Int']['input']>;
  fieldId: Scalars['Int']['input'];
  formDefinitionId: Scalars['Int']['input'];
  newIndex: Scalars['Int']['input'];
};

export type MoveFormFieldPayload = {
  __typename?: 'MoveFormFieldPayload';
  errors?: Maybe<Array<MoveFormFieldError>>;
  formField?: Maybe<FormField>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptMeetingRequest: AcceptMeetingRequestPayload;
  addBudgetItem: AddBudgetItemPayload;
  addChildAction: AddChildActionPayload;
  addCondition: AddConditionPayload;
  addCostItem: AddCostItemPayload;
  addExpense: AddExpensePayload;
  addExternalLink: AddExternalLinkPayload;
  addExternalUser: AddExternalUserPayload;
  addFolder: AddFolderPayload;
  addMatrixRow: AddMatrixRowPayload;
  addMatrixRowPAT: AddMatrixRowPatPayload;
  addMeeting: AddMeetingPayload;
  addMeetingType: AddMeetingTypePayload;
  addProject: AddProjectPayload;
  addProjectForm: AddProjectFormPayload;
  addProjectFormFromTemplate: AddProjectFormFromTemplatePayload;
  addProjectMember: AddProjectMemberPayload;
  addProjectTemplate: AddProjectTemplatePayload;
  addProjectWorkflow: AddProjectWorkflowPayload;
  addQuote: AddQuotePayload;
  addSecurityGroup: AddSecurityGroupPayload;
  addTask: AddTaskPayload;
  addTaskPredecessor: AddTaskPredecessorPayload;
  addWorkflowDefinition: AddWorkflowDefinitionPayload;
  addWorkflowVariable: AddWorkflowVariablePayload;
  cancelSignatureRequest: CancelSignatureRequestPayload;
  collectFormResponses: CollectFormResponsesPayload;
  createCommercialProjectCalculator: CreateCommercialProjectCalculatorPayload;
  createFormField: CreateFormFieldPayload;
  createFormSection: CreateFormSectionPayload;
  createFormTemplate: CreateFormTemplatePayload;
  createProjectAccessToken: CreateProjectAccessTokenPayload;
  createProjectFromTemplate: CreateProjectFromTemplatePayload;
  createTemplateFromProjectForm: CreateTemplateFromProjectFormPayload;
  declineMeetingRequest: DeclineMeetingRequestPayload;
  deleteBudgetItem: DeleteBudgetItemPayload;
  deleteCondition: DeleteConditionPayload;
  deleteCostItem: DeleteCostItemPayload;
  deleteDocumentTemplate: DeleteDocumentTemplatePayload;
  deleteExpense: DeleteExpensePayload;
  deleteExpenseAttachment: DeleteExpenseAttachmentPayload;
  deleteExternalLink: DeleteExternalLinkPayload;
  deleteFolder: DeleteFolderPayload;
  deleteFormAttachment: DeleteFormAttachmentPayload;
  deleteFormAttachmentPAT: DeleteFormAttachmentPatPayload;
  deleteFormField: DeleteFormFieldPayload;
  deleteFormSection: DeleteFormSectionPayload;
  deleteFormSubmission: DeleteFormSubmissionPayload;
  deleteFormTemplate: DeleteFormTemplatePayload;
  deleteMeeting: DeleteMeetingPayload;
  deleteMeetingType: DeleteMeetingTypePayload;
  deleteProjectForm: DeleteProjectFormPayload;
  deleteProjectTemplate: DeleteProjectTemplatePayload;
  deleteQuote: DeleteQuotePayload;
  deleteQuoteAttachment: DeleteQuoteAttachmentPayload;
  deleteRequest: DeleteRequestPayload;
  deleteSecurityGroup: DeleteSecurityGroupPayload;
  deleteTask: DeleteTaskPayload;
  deleteWorkflowActionConfiguration: DeleteWorkflowActionConfigurationPayload;
  deleteWorkflowDefinition: DeleteWorkflowDefinitionPayload;
  deleteWorkflowVariable: DeleteWorkflowVariablePayload;
  duplicateCommercialProjectCalculator: DuplicateCommercialProjectCalculatorPayload;
  duplicateFormTemplate: DuplicateFormTemplatePayload;
  duplicateWorkflowDefinition: DuplicateWorkflowDefinitionPayload;
  editBudgetItem: EditBudgetItemPayload;
  editCondition: EditConditionPayload;
  editCostItem: EditCostItemPayload;
  editDocumentTemplate: EditDocumentTemplatePayload;
  editExpense: EditExpensePayload;
  editExternalUser: EditExternalUserPayload;
  editFormDefinition: EditFormDefinitionPayload;
  editFormField: EditFormFieldPayload;
  editFormSection: EditFormSectionPayload;
  editMeetingType: EditMeetingTypePayload;
  editMemberSecurityGroup: EditMemberSecurityGroupPayload;
  editProject: EditProjectPayload;
  editProjectProgress: EditProjectProgressPayload;
  editQuote: EditQuotePayload;
  editUser: EditUserPayload;
  editUserRole: EditUserRolePayload;
  editWorkflowDefinition: EditWorkflowDefinitionPayload;
  editWorkflowVariable: EditWorkflowVariablePayload;
  fillForm: FillFormPayload;
  fillFormValue: FillFormValuePayload;
  fillMatrixValue: FillMatrixValuePayload;
  fillMatrixValuePAT: FillMatrixValuePatPayload;
  importFolders: ImportFoldersPayload;
  importTasks: ImportTasksPayload;
  inviteUser: InviteUserPayload;
  moveChildAction: MoveChildActionPayload;
  moveFolder: MoveFolderPayload;
  moveFolderEntry: MoveFolderEntryPayload;
  moveFormField: MoveFormFieldPayload;
  publishDocument: PublishDocumentPayload;
  publishForm: PublishFormPayload;
  reSendMyWeeklyEmail: ReSendMyWeeklyEmailPayload;
  removeCommercialProjectCalculator: RemoveCommercialProjectCalculatorPayload;
  removeDocument: RemoveDocumentPayload;
  removeFormTemplateRoleAssignment: RemoveFormTemplateRoleAssignmentPayload;
  removeMatrixRow: RemoveMatrixRowPayload;
  removeMatrixRowPAT: RemoveMatrixRowPatPayload;
  /** @deprecated No longer supported. */
  removePresence: RemovePresencePayload;
  removePresencePAT: RemovePresencePatPayload;
  removeProjectMember: RemoveProjectMemberPayload;
  removeSecurityGroupMember: RemoveSecurityGroupMemberPayload;
  removeUser: RemoveUserPayload;
  renameDocument: RenameDocumentPayload;
  renameFolder: RenameFolderPayload;
  renewAccessTokenFromExpiredToken: RenewAccessTokenFromExpiredTokenPayload;
  reorderBudgetItem: ReorderBudgetItemPayload;
  reorderCostItem: ReorderCostItemPayload;
  reorderCostItemEntry: ReorderCostItemEntryPayload;
  reorderFormSections: ReorderFormSectionsPayload;
  reparentTask: ReparentTaskPayload;
  requestFormSubmission: RequestFormSubmissionPayload;
  requestFormSubmissionAnonymous: RequestFormSubmissionAnonymousPayload;
  rescheduleTask: RescheduleTaskPayload;
  resendFormInvitation: ResendFormInvitationPayload;
  sendSharingNotificationForOrganizationResource: SendSharingNotificationForOrganizationResourcePayload;
  sendSharingNotificationForProjectResource: SendSharingNotificationForProjectResourcePayload;
  sendSharingTemplateNotification: SendSharingTemplateNotificationPayload;
  sendSignatureRequest: SendSignatureRequestPayload;
  sendSignatureRequestInternal: SendSignatureRequestInternalPayload;
  shareOrganizationResource: ShareOrganizationResourcePayload;
  shareProjectResource: ShareProjectResourcePayload;
  signDocument: SignDocumentPayload;
  signDocumentAnonymously: SignDocumentAnonymouslyPayload;
  startTrial: StartTrialPayload;
  startWorkflowInstance: StartWorkflowInstancePayload;
  stopWorkflowInstance: StopWorkflowInstancePayload;
  submitWorkflowAction: SubmitWorkflowActionPayload;
  unpublishDocument: UnpublishDocumentPayload;
  unpublishForm: UnpublishFormPayload;
  unshareOrganizationResource: UnshareOrganizationResourcePayload;
  unshareProjectResource: UnshareProjectResourcePayload;
  unsubscribeFromEmails: UnsubscribeFromEmailsPayload;
  updateBrandingConfiguration: UpdateBrandingConfigurationPayload;
  updateCommercialProjectCalculator: UpdateCommercialProjectCalculatorPayload;
  updateFormSettings: UpdateFormSettingsPayload;
  updateMyPreferences: UpdateMyPreferencesPayload;
  updatePresence: UpdatePresencePayload;
  updateSecurityGroup: UpdateSecurityGroupPayload;
  updateSecurityGroupRoles: UpdateSecurityGroupRolesPayload;
  updateTask: UpdateTaskPayload;
  updateTaskStatus: UpdateTaskStatusPayload;
  updateWorkflowActionConfiguration: UpdateWorkflowActionConfigurationPayload;
};


export type MutationAcceptMeetingRequestArgs = {
  input: AcceptMeetingRequestInput;
};


export type MutationAddBudgetItemArgs = {
  input: AddBudgetItemInput;
};


export type MutationAddChildActionArgs = {
  input: AddChildActionInput;
};


export type MutationAddConditionArgs = {
  input: AddConditionInput;
};


export type MutationAddCostItemArgs = {
  input: AddCostItemInput;
};


export type MutationAddExpenseArgs = {
  input: AddExpenseInput;
};


export type MutationAddExternalLinkArgs = {
  input: AddExternalLinkInput;
};


export type MutationAddExternalUserArgs = {
  input: AddExternalUserInput;
};


export type MutationAddFolderArgs = {
  input: AddFolderInput;
};


export type MutationAddMatrixRowArgs = {
  input: AddMatrixRowInput;
};


export type MutationAddMatrixRowPatArgs = {
  input: AddMatrixRowPatInput;
};


export type MutationAddMeetingArgs = {
  input: AddMeetingInput;
};


export type MutationAddMeetingTypeArgs = {
  input: AddMeetingTypeInput;
};


export type MutationAddProjectArgs = {
  input: AddProjectInput;
};


export type MutationAddProjectFormArgs = {
  input: AddProjectFormInput;
};


export type MutationAddProjectFormFromTemplateArgs = {
  input: AddProjectFormFromTemplateInput;
};


export type MutationAddProjectMemberArgs = {
  input: AddProjectMemberInput;
};


export type MutationAddProjectTemplateArgs = {
  input: AddProjectTemplateInput;
};


export type MutationAddProjectWorkflowArgs = {
  input: AddProjectWorkflowInput;
};


export type MutationAddQuoteArgs = {
  input: AddQuoteInput;
};


export type MutationAddSecurityGroupArgs = {
  input: AddSecurityGroupInput;
};


export type MutationAddTaskArgs = {
  input: AddTaskInput;
};


export type MutationAddTaskPredecessorArgs = {
  input: AddTaskPredecessorInput;
};


export type MutationAddWorkflowDefinitionArgs = {
  input: AddWorkflowDefinitionInput;
};


export type MutationAddWorkflowVariableArgs = {
  input: AddWorkflowVariableInput;
};


export type MutationCancelSignatureRequestArgs = {
  input: CancelSignatureRequestInput;
};


export type MutationCollectFormResponsesArgs = {
  input: CollectFormResponsesInput;
};


export type MutationCreateCommercialProjectCalculatorArgs = {
  input: CreateCommercialProjectCalculatorInput;
};


export type MutationCreateFormFieldArgs = {
  input: CreateFormFieldInput;
};


export type MutationCreateFormSectionArgs = {
  input: CreateFormSectionInput;
};


export type MutationCreateFormTemplateArgs = {
  input: CreateFormTemplateInput;
};


export type MutationCreateProjectAccessTokenArgs = {
  input: CreateProjectAccessTokenInput;
};


export type MutationCreateProjectFromTemplateArgs = {
  input: CreateProjectFromTemplateInput;
};


export type MutationCreateTemplateFromProjectFormArgs = {
  input: CreateTemplateFromProjectFormInput;
};


export type MutationDeclineMeetingRequestArgs = {
  input: DeclineMeetingRequestInput;
};


export type MutationDeleteBudgetItemArgs = {
  input: DeleteBudgetItemInput;
};


export type MutationDeleteConditionArgs = {
  input: DeleteConditionInput;
};


export type MutationDeleteCostItemArgs = {
  input: DeleteCostItemInput;
};


export type MutationDeleteDocumentTemplateArgs = {
  input: DeleteDocumentTemplateInput;
};


export type MutationDeleteExpenseArgs = {
  input: DeleteExpenseInput;
};


export type MutationDeleteExpenseAttachmentArgs = {
  input: DeleteExpenseAttachmentInput;
};


export type MutationDeleteExternalLinkArgs = {
  input: DeleteExternalLinkInput;
};


export type MutationDeleteFolderArgs = {
  input: DeleteFolderInput;
};


export type MutationDeleteFormAttachmentArgs = {
  input: DeleteFormAttachmentInput;
};


export type MutationDeleteFormAttachmentPatArgs = {
  input: DeleteFormAttachmentPatInput;
};


export type MutationDeleteFormFieldArgs = {
  input: DeleteFormFieldInput;
};


export type MutationDeleteFormSectionArgs = {
  input: DeleteFormSectionInput;
};


export type MutationDeleteFormSubmissionArgs = {
  input: DeleteFormSubmissionInput;
};


export type MutationDeleteFormTemplateArgs = {
  input: DeleteFormTemplateInput;
};


export type MutationDeleteMeetingArgs = {
  input: DeleteMeetingInput;
};


export type MutationDeleteMeetingTypeArgs = {
  input: DeleteMeetingTypeInput;
};


export type MutationDeleteProjectFormArgs = {
  input: DeleteProjectFormInput;
};


export type MutationDeleteProjectTemplateArgs = {
  input: DeleteProjectTemplateInput;
};


export type MutationDeleteQuoteArgs = {
  input: DeleteQuoteInput;
};


export type MutationDeleteQuoteAttachmentArgs = {
  input: DeleteQuoteAttachmentInput;
};


export type MutationDeleteRequestArgs = {
  input: DeleteRequestInput;
};


export type MutationDeleteSecurityGroupArgs = {
  input: DeleteSecurityGroupInput;
};


export type MutationDeleteTaskArgs = {
  input: DeleteTaskInput;
};


export type MutationDeleteWorkflowActionConfigurationArgs = {
  input: DeleteWorkflowActionConfigurationInput;
};


export type MutationDeleteWorkflowDefinitionArgs = {
  input: DeleteWorkflowDefinitionInput;
};


export type MutationDeleteWorkflowVariableArgs = {
  input: DeleteWorkflowVariableInput;
};


export type MutationDuplicateCommercialProjectCalculatorArgs = {
  input: DuplicateCommercialProjectCalculatorInput;
};


export type MutationDuplicateFormTemplateArgs = {
  input: DuplicateFormTemplateInput;
};


export type MutationDuplicateWorkflowDefinitionArgs = {
  input: DuplicateWorkflowDefinitionInput;
};


export type MutationEditBudgetItemArgs = {
  input: EditBudgetItemInput;
};


export type MutationEditConditionArgs = {
  input: EditConditionInput;
};


export type MutationEditCostItemArgs = {
  input: EditCostItemInput;
};


export type MutationEditDocumentTemplateArgs = {
  input: EditDocumentTemplateInput;
};


export type MutationEditExpenseArgs = {
  input: EditExpenseInput;
};


export type MutationEditExternalUserArgs = {
  input: EditExternalUserInput;
};


export type MutationEditFormDefinitionArgs = {
  input: EditFormDefinitionInput;
};


export type MutationEditFormFieldArgs = {
  input: EditFormFieldInput;
};


export type MutationEditFormSectionArgs = {
  input: EditFormSectionInput;
};


export type MutationEditMeetingTypeArgs = {
  input: EditMeetingTypeInput;
};


export type MutationEditMemberSecurityGroupArgs = {
  input: EditMemberSecurityGroupInput;
};


export type MutationEditProjectArgs = {
  input: EditProjectInput;
};


export type MutationEditProjectProgressArgs = {
  input: EditProjectProgressInput;
};


export type MutationEditQuoteArgs = {
  input: EditQuoteInput;
};


export type MutationEditUserArgs = {
  input: EditUserInput;
};


export type MutationEditUserRoleArgs = {
  input: EditUserRoleInput;
};


export type MutationEditWorkflowDefinitionArgs = {
  input: EditWorkflowDefinitionInput;
};


export type MutationEditWorkflowVariableArgs = {
  input: EditWorkflowVariableInput;
};


export type MutationFillFormArgs = {
  input: FillFormInput;
};


export type MutationFillFormValueArgs = {
  input: FillFormValueInput;
};


export type MutationFillMatrixValueArgs = {
  input: FillMatrixValueInput;
};


export type MutationFillMatrixValuePatArgs = {
  input: FillMatrixValuePatInput;
};


export type MutationImportFoldersArgs = {
  input: ImportFoldersInput;
};


export type MutationImportTasksArgs = {
  input: ImportTasksInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationMoveChildActionArgs = {
  input: MoveChildActionInput;
};


export type MutationMoveFolderArgs = {
  input: MoveFolderInput;
};


export type MutationMoveFolderEntryArgs = {
  input: MoveFolderEntryInput;
};


export type MutationMoveFormFieldArgs = {
  input: MoveFormFieldInput;
};


export type MutationPublishDocumentArgs = {
  input: PublishDocumentInput;
};


export type MutationPublishFormArgs = {
  input: PublishFormInput;
};


export type MutationRemoveCommercialProjectCalculatorArgs = {
  input: RemoveCommercialProjectCalculatorInput;
};


export type MutationRemoveDocumentArgs = {
  input: RemoveDocumentInput;
};


export type MutationRemoveFormTemplateRoleAssignmentArgs = {
  input: RemoveFormTemplateRoleAssignmentInput;
};


export type MutationRemoveMatrixRowArgs = {
  input: RemoveMatrixRowInput;
};


export type MutationRemoveMatrixRowPatArgs = {
  input: RemoveMatrixRowPatInput;
};


export type MutationRemovePresenceArgs = {
  input: RemovePresenceInput;
};


export type MutationRemovePresencePatArgs = {
  input: RemovePresencePatInput;
};


export type MutationRemoveProjectMemberArgs = {
  input: RemoveProjectMemberInput;
};


export type MutationRemoveSecurityGroupMemberArgs = {
  input: RemoveSecurityGroupMemberInput;
};


export type MutationRemoveUserArgs = {
  input: RemoveUserInput;
};


export type MutationRenameDocumentArgs = {
  input: RenameDocumentInput;
};


export type MutationRenameFolderArgs = {
  input: RenameFolderInput;
};


export type MutationRenewAccessTokenFromExpiredTokenArgs = {
  input: RenewAccessTokenFromExpiredTokenInput;
};


export type MutationReorderBudgetItemArgs = {
  input: ReorderBudgetItemInput;
};


export type MutationReorderCostItemArgs = {
  input: ReorderCostItemInput;
};


export type MutationReorderCostItemEntryArgs = {
  input: ReorderCostItemEntryInput;
};


export type MutationReorderFormSectionsArgs = {
  input: ReorderFormSectionsInput;
};


export type MutationReparentTaskArgs = {
  input: ReparentTaskInput;
};


export type MutationRequestFormSubmissionArgs = {
  input: RequestFormSubmissionInput;
};


export type MutationRequestFormSubmissionAnonymousArgs = {
  input: RequestFormSubmissionAnonymousInput;
};


export type MutationRescheduleTaskArgs = {
  input: RescheduleTaskInput;
};


export type MutationResendFormInvitationArgs = {
  input: ResendFormInvitationInput;
};


export type MutationSendSharingNotificationForOrganizationResourceArgs = {
  input: SendSharingNotificationForOrganizationResourceInput;
};


export type MutationSendSharingNotificationForProjectResourceArgs = {
  input: SendSharingNotificationForProjectResourceInput;
};


export type MutationSendSharingTemplateNotificationArgs = {
  input: SendSharingTemplateNotificationInput;
};


export type MutationSendSignatureRequestArgs = {
  input: SendSignatureRequestInput;
};


export type MutationSendSignatureRequestInternalArgs = {
  input: SendSignatureRequestInternalInput;
};


export type MutationShareOrganizationResourceArgs = {
  input: ShareOrganizationResourceInput;
};


export type MutationShareProjectResourceArgs = {
  input: ShareProjectResourceInput;
};


export type MutationSignDocumentArgs = {
  input: SignDocumentInput;
};


export type MutationSignDocumentAnonymouslyArgs = {
  input: SignDocumentAnonymouslyInput;
};


export type MutationStartTrialArgs = {
  input: StartTrialInput;
};


export type MutationStartWorkflowInstanceArgs = {
  input: StartWorkflowInstanceInput;
};


export type MutationStopWorkflowInstanceArgs = {
  input: StopWorkflowInstanceInput;
};


export type MutationSubmitWorkflowActionArgs = {
  input: SubmitWorkflowActionInput;
};


export type MutationUnpublishDocumentArgs = {
  input: UnpublishDocumentInput;
};


export type MutationUnpublishFormArgs = {
  input: UnpublishFormInput;
};


export type MutationUnshareOrganizationResourceArgs = {
  input: UnshareOrganizationResourceInput;
};


export type MutationUnshareProjectResourceArgs = {
  input: UnshareProjectResourceInput;
};


export type MutationUnsubscribeFromEmailsArgs = {
  input: UnsubscribeFromEmailsInput;
};


export type MutationUpdateBrandingConfigurationArgs = {
  input: UpdateBrandingConfigurationInput;
};


export type MutationUpdateCommercialProjectCalculatorArgs = {
  input: UpdateCommercialProjectCalculatorInput;
};


export type MutationUpdateFormSettingsArgs = {
  input: UpdateFormSettingsInput;
};


export type MutationUpdateMyPreferencesArgs = {
  input: UpdateMyPreferencesInput;
};


export type MutationUpdatePresenceArgs = {
  input: UpdatePresenceInput;
};


export type MutationUpdateSecurityGroupArgs = {
  input: UpdateSecurityGroupInput;
};


export type MutationUpdateSecurityGroupRolesArgs = {
  input: UpdateSecurityGroupRolesInput;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateTaskStatusArgs = {
  input: UpdateTaskStatusInput;
};


export type MutationUpdateWorkflowActionConfigurationArgs = {
  input: UpdateWorkflowActionConfigurationInput;
};

export type MutationResult = {
  __typename?: 'MutationResult';
  isSuccess: Scalars['Boolean']['output'];
};

export type MyRoles = {
  __typename?: 'MyRoles';
  roles: Array<BuiltInRoles>;
};

export type NotFoundError = Error & {
  __typename?: 'NotFoundError';
  message: Scalars['String']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PermissionAssignment = {
  __typename?: 'PermissionAssignment';
  id: Scalars['String']['output'];
  permissionId: Scalars['String']['output'];
  securityGroup?: Maybe<SecurityGroup>;
  securityGroupId: Scalars['Int']['output'];
};

export enum PrincipalType {
  SecurityGroup = 'SecurityGroup',
  SharedWithAllProjectMembers = 'SharedWithAllProjectMembers',
  SharedWithAnyone = 'SharedWithAnyone',
  User = 'User'
}

export type PrincipalTypeOperationFilterInput = {
  eq?: InputMaybe<PrincipalType>;
  in?: InputMaybe<Array<PrincipalType>>;
  neq?: InputMaybe<PrincipalType>;
  nin?: InputMaybe<Array<PrincipalType>>;
};

export type Project = {
  __typename?: 'Project';
  budgetItems: Array<BudgetItem>;
  commercialProjectCalculators: Array<CommercialProjectCalculator>;
  costItems: Array<CostItem>;
  createdBy?: Maybe<ApplicationUser>;
  createdById: Scalars['String']['output'];
  createdOn: Scalars['DateTime']['output'];
  deletedOnUTC?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  entries: Array<FolderEntry>;
  expenses: Array<Expense>;
  folders: Array<Folder>;
  forms: Array<ProjectForm>;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isTemplate: Scalars['Boolean']['output'];
  meetingTypes: Array<MeetingType>;
  meetings: Array<Meeting>;
  myPermissions?: Maybe<ProjectPermissions>;
  myRoles: MyRoles;
  name: Scalars['String']['output'];
  projectEvents: Array<ProjectEvent>;
  projectProgress: Scalars['Int']['output'];
  rootFolder?: Maybe<Folder>;
  securityGroups: Array<SecurityGroup>;
  securityRoleAssignments: Array<RoleAssignment>;
  tasks: Array<ProjectTask>;
  workflowDefinitions: Array<WorkflowDefinition>;
  workflowInstances: Array<WorkflowInstance>;
};


export type ProjectSecurityGroupsArgs = {
  where?: InputMaybe<SecurityGroupFilterInput>;
};

export type ProjectAccessToken = {
  __typename?: 'ProjectAccessToken';
  createdOn: Scalars['DateTime']['output'];
  customMessage?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['Int']['output']>;
  forUser?: Maybe<ApplicationUser>;
  forUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isZohoSignEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastRenewed?: Maybe<Scalars['DateTime']['output']>;
  project?: Maybe<Project>;
  projectForm?: Maybe<ProjectForm>;
  projectFormId?: Maybe<Scalars['Int']['output']>;
  projectFormSubmission?: Maybe<ProjectFormSubmission>;
  projectFormSubmissionId?: Maybe<Scalars['Int']['output']>;
  projectId: Scalars['Int']['output'];
  purpose?: Maybe<AccessTokenPurpose>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  workflowInstance?: Maybe<WorkflowInstance>;
  workflowInstanceId?: Maybe<Scalars['Int']['output']>;
};

export type ProjectAccessTokenFilterInput = {
  and?: InputMaybe<Array<ProjectAccessTokenFilterInput>>;
  documentId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProjectAccessTokenFilterInput>>;
  projectFormId?: InputMaybe<IntOperationFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
};

export type ProjectBudget = {
  __typename?: 'ProjectBudget';
  budgetOverrun: Scalars['Decimal']['output'];
  totalBudgetedAmount: Scalars['Decimal']['output'];
  totalEffectiveAmount: Scalars['Decimal']['output'];
};

export type ProjectEvent = {
  __typename?: 'ProjectEvent';
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['Int']['output']>;
  eventDate: Scalars['DateTime']['output'];
  eventTriggeredBy?: Maybe<ApplicationUser>;
  eventTriggeredById: Scalars['String']['output'];
  eventType: DomainEventType;
  form?: Maybe<ProjectForm>;
  formId?: Maybe<Scalars['Int']['output']>;
  formSubmission?: Maybe<ProjectFormSubmission>;
  formSubmissionId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  meeting?: Maybe<Meeting>;
  meetingId?: Maybe<Scalars['Int']['output']>;
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  workflowAction?: Maybe<WorkflowActionConfiguration>;
  workflowActionId?: Maybe<Scalars['Int']['output']>;
  workflowInstance?: Maybe<WorkflowInstance>;
  workflowInstanceId?: Maybe<Scalars['Int']['output']>;
};

export type ProjectEventFilterInput = {
  and?: InputMaybe<Array<ProjectEventFilterInput>>;
  eventDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProjectEventFilterInput>>;
  projectId?: InputMaybe<IntOperationFilterInput>;
};

export type ProjectEventSortInput = {
  eventDate?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProjectEventsConnection = {
  __typename?: 'ProjectEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProjectEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProjectEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProjectEventsEdge = {
  __typename?: 'ProjectEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProjectEvent;
};

export type ProjectFilterInput = {
  and?: InputMaybe<Array<ProjectFilterInput>>;
  budgetItems?: InputMaybe<ListFilterInputTypeOfBudgetItemFilterInput>;
  commercialProjectCalculators?: InputMaybe<ListFilterInputTypeOfCommercialProjectCalculatorFilterInput>;
  costItems?: InputMaybe<ListFilterInputTypeOfCostItemFilterInput>;
  createdBy?: InputMaybe<ApplicationUserFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  deletedOnUTC?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  documents?: InputMaybe<ListFilterInputTypeOfDocumentFilterInput>;
  entries?: InputMaybe<ListFilterInputTypeOfFolderEntryFilterInput>;
  expenses?: InputMaybe<ListFilterInputTypeOfExpenseFilterInput>;
  folders?: InputMaybe<ListFilterInputTypeOfFolderFilterInput>;
  forms?: InputMaybe<ListFilterInputTypeOfProjectFormFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isTemplate?: InputMaybe<BooleanOperationFilterInput>;
  meetingTypes?: InputMaybe<ListFilterInputTypeOfMeetingTypeFilterInput>;
  meetings?: InputMaybe<ListFilterInputTypeOfMeetingFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProjectFilterInput>>;
  projectEvents?: InputMaybe<ListFilterInputTypeOfProjectEventFilterInput>;
  projectProgress?: InputMaybe<IntOperationFilterInput>;
  rootFolder?: InputMaybe<FolderFilterInput>;
  securityGroups?: InputMaybe<ListFilterInputTypeOfSecurityGroupFilterInput>;
  securityRoleAssignments?: InputMaybe<ListFilterInputTypeOfRoleAssignmentFilterInput>;
  tasks?: InputMaybe<ListFilterInputTypeOfProjectTaskFilterInput>;
  workflowDefinitions?: InputMaybe<ListFilterInputTypeOfWorkflowDefinitionFilterInput>;
  workflowInstances?: InputMaybe<ListFilterInputTypeOfWorkflowInstanceFilterInput>;
};

export type ProjectForm = {
  __typename?: 'ProjectForm';
  allowedUsers: Array<ApplicationUser>;
  createdBy?: Maybe<ApplicationUser>;
  createdById: Scalars['String']['output'];
  createdOn: Scalars['DateTime']['output'];
  formDefinition?: Maybe<FormDefinition>;
  formDefinitionId: Scalars['Int']['output'];
  formSettings: FormSettings;
  id: Scalars['Int']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  publishedBy?: Maybe<ApplicationUser>;
  publishedById?: Maybe<Scalars['String']['output']>;
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  status: FormStatus;
  submissions: Array<ProjectFormSubmission>;
};

export type ProjectFormFilterInput = {
  and?: InputMaybe<Array<ProjectFormFilterInput>>;
  createdBy?: InputMaybe<ApplicationUserFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  formDefinition?: InputMaybe<FormDefinitionFilterInput>;
  formDefinitionId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProjectFormFilterInput>>;
  projectId?: InputMaybe<IntOperationFilterInput>;
  publishedBy?: InputMaybe<ApplicationUserFilterInput>;
  publishedById?: InputMaybe<StringOperationFilterInput>;
  publishedOn?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<FormStatusOperationFilterInput>;
};

export type ProjectFormOverview = {
  __typename?: 'ProjectFormOverview';
  createdBy: Scalars['String']['output'];
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  formName: Scalars['String']['output'];
  formSettings: FormSettings;
  id: Scalars['Int']['output'];
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  status: FormStatus;
  submissionsCount: Scalars['Int']['output'];
};

export type ProjectFormPresence = {
  __typename?: 'ProjectFormPresence';
  displayName: Scalars['String']['output'];
  fieldId?: Maybe<Scalars['Int']['output']>;
  formSubmissionId: Scalars['Int']['output'];
  matrixColumnId?: Maybe<Scalars['Int']['output']>;
  matrixRowId?: Maybe<Scalars['Int']['output']>;
  uniqueClientId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ProjectFormSubmission = {
  __typename?: 'ProjectFormSubmission';
  attachments: Array<Document>;
  belongsToUser?: Maybe<ApplicationUser>;
  belongsToUserId?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['DateTime']['output'];
  events: Array<ProjectEvent>;
  formDefinition?: Maybe<FormDefinition>;
  formDefinitionId: Scalars['Int']['output'];
  formValues: Array<FormValue>;
  id: Scalars['Int']['output'];
  projectForm?: Maybe<ProjectForm>;
  projectFormId?: Maybe<Scalars['Int']['output']>;
  status: SubmissionStatus;
  submittedOn?: Maybe<Scalars['DateTime']['output']>;
  workflowAction?: Maybe<WorkflowActionConfiguration>;
  workflowActionId?: Maybe<Scalars['Int']['output']>;
  workflowInstance?: Maybe<WorkflowInstance>;
  workflowInstanceId?: Maybe<Scalars['Int']['output']>;
};

export type ProjectFormSubmissionFilterInput = {
  and?: InputMaybe<Array<ProjectFormSubmissionFilterInput>>;
  belongsToUser?: InputMaybe<ApplicationUserFilterInput>;
  belongsToUserId?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  events?: InputMaybe<ListFilterInputTypeOfProjectEventFilterInput>;
  formDefinition?: InputMaybe<FormDefinitionFilterInput>;
  formDefinitionId?: InputMaybe<IntOperationFilterInput>;
  formValues?: InputMaybe<ListFilterInputTypeOfFormValueFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProjectFormSubmissionFilterInput>>;
  projectForm?: InputMaybe<ProjectFormFilterInput>;
  projectFormId?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<SubmissionStatusOperationFilterInput>;
  submittedOn?: InputMaybe<DateTimeOperationFilterInput>;
  workflowAction?: InputMaybe<WorkflowActionConfigurationFilterInput>;
  workflowActionId?: InputMaybe<IntOperationFilterInput>;
  workflowInstance?: InputMaybe<WorkflowInstanceFilterInput>;
  workflowInstanceId?: InputMaybe<IntOperationFilterInput>;
};

export type ProjectPermissions = {
  __typename?: 'ProjectPermissions';
  budgetPermission: BudgetAndExpensesPermission;
  documentsPermission: DocumentsPermission;
  formsPermission: FormsPermission;
  managePublicFileSharingPermission: ManagePublicFileSharingPermission;
  tasksPermission: TasksPermission;
  workflowsPermission: WorkflowsPermission;
};

export type ProjectSortInput = {
  createdBy?: InputMaybe<ApplicationUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  deletedOnUTC?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isTemplate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  projectProgress?: InputMaybe<SortEnumType>;
  rootFolder?: InputMaybe<FolderSortInput>;
};

export type ProjectTask = {
  __typename?: 'ProjectTask';
  assigneeGroups: Array<SecurityGroup>;
  assignees: Array<ApplicationUser>;
  completedOn?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<ApplicationUser>;
  createdById?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['Int']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  hierarchyPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  predecessors: Array<ProjectTask>;
  project?: Maybe<Project>;
  projectForm?: Maybe<ProjectForm>;
  projectFormId?: Maybe<Scalars['Int']['output']>;
  projectId: Scalars['Int']['output'];
  roleAssignments: Array<RoleAssignment>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: ProjectTaskStatus;
  successors: Array<ProjectTask>;
  type: ProjectTaskType;
};

export type ProjectTaskFilterInput = {
  and?: InputMaybe<Array<ProjectTaskFilterInput>>;
  assigneeGroups?: InputMaybe<ListFilterInputTypeOfSecurityGroupFilterInput>;
  assignees?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  completedOn?: InputMaybe<DateTimeOperationFilterInput>;
  concurrencyTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<ApplicationUserFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  document?: InputMaybe<DocumentFilterInput>;
  documentId?: InputMaybe<IntOperationFilterInput>;
  dueDate?: InputMaybe<DateTimeOperationFilterInput>;
  hierarchyPath?: InputMaybe<HierarchyIdFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProjectTaskFilterInput>>;
  predecessors?: InputMaybe<ListFilterInputTypeOfProjectTaskFilterInput>;
  project?: InputMaybe<ProjectFilterInput>;
  projectForm?: InputMaybe<ProjectFormFilterInput>;
  projectFormId?: InputMaybe<IntOperationFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
  roleAssignments?: InputMaybe<ListFilterInputTypeOfRoleAssignmentFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<ProjectTaskStatusOperationFilterInput>;
  successors?: InputMaybe<ListFilterInputTypeOfProjectTaskFilterInput>;
  type?: InputMaybe<ProjectTaskTypeOperationFilterInput>;
};

export type ProjectTaskSortInput = {
  completedOn?: InputMaybe<SortEnumType>;
  dueDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export enum ProjectTaskStatus {
  Done = 'Done',
  Draft = 'Draft',
  InProgress = 'InProgress',
  Ready = 'Ready'
}

export type ProjectTaskStatusOperationFilterInput = {
  eq?: InputMaybe<ProjectTaskStatus>;
  in?: InputMaybe<Array<ProjectTaskStatus>>;
  neq?: InputMaybe<ProjectTaskStatus>;
  nin?: InputMaybe<Array<ProjectTaskStatus>>;
};

export enum ProjectTaskType {
  Custom = 'Custom',
  FillForm = 'FillForm',
  SignDocument = 'SignDocument'
}

export type ProjectTaskTypeOperationFilterInput = {
  eq?: InputMaybe<ProjectTaskType>;
  in?: InputMaybe<Array<ProjectTaskType>>;
  neq?: InputMaybe<ProjectTaskType>;
  nin?: InputMaybe<Array<ProjectTaskType>>;
};

export type ProjectTemplateSummary = {
  __typename?: 'ProjectTemplateSummary';
  budgetItemsCount: Scalars['Int']['output'];
  customFoldersCount: Scalars['Int']['output'];
  documentsCount: Scalars['Int']['output'];
  formsCount: Scalars['Int']['output'];
  meetingTypesCount: Scalars['Int']['output'];
  securityGroupsCount: Scalars['Int']['output'];
  tasksCount: Scalars['Int']['output'];
  workflowsCount: Scalars['Int']['output'];
};

export enum ProvisioningStatus {
  NotStarted = 'NotStarted',
  Provisioning = 'Provisioning',
  Ready = 'Ready'
}

export type PublishDocumentError = NotFoundError;

export type PublishDocumentInput = {
  documentId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type PublishDocumentPayload = {
  __typename?: 'PublishDocumentPayload';
  document?: Maybe<Document>;
  errors?: Maybe<Array<PublishDocumentError>>;
};

export type PublishFormError = ValidationResultError;

export type PublishFormInput = {
  projectFormId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type PublishFormPayload = {
  __typename?: 'PublishFormPayload';
  errors?: Maybe<Array<PublishFormError>>;
  projectForm?: Maybe<ProjectForm>;
};

export type Query = {
  __typename?: 'Query';
  budgetItems: Array<BudgetItem>;
  calendarAvailabilities: Availabilities;
  calendarAvailabilitiesForMeetingType: Availabilities;
  childFolders: Array<Folder>;
  commercialProjectCalculator?: Maybe<CommercialProjectCalculator>;
  commercialProjectCalculators: Array<CommercialProjectCalculator>;
  costItems: Array<CostItem>;
  document?: Maybe<Document>;
  documentPermissions: Array<RoleAssignment>;
  documentTemplate?: Maybe<DocumentTemplate>;
  documentTemplatePermissions: Array<RoleAssignment>;
  documentTemplates: Array<DocumentTemplate>;
  expenses: Array<Expense>;
  externalLinkPermissions: Array<RoleAssignment>;
  featureFlags: FeatureFlags;
  folder?: Maybe<Folder>;
  folderEntries: Array<FolderEntry>;
  folderEntry?: Maybe<FolderEntry>;
  folderPermissions: Array<RoleAssignment>;
  formPresences: Array<ProjectFormPresence>;
  formPresencesPAT: Array<ProjectFormPresence>;
  formTemplate?: Maybe<FormTemplate>;
  formTemplatePermissions: Array<RoleAssignment>;
  formTemplates: Array<FormTemplate>;
  loginInfo: LoginInfo;
  me?: Maybe<ApplicationUser>;
  meeting?: Maybe<Meeting>;
  meetingTypes: Array<MeetingType>;
  meetings: Array<Meeting>;
  myPermissions?: Maybe<ProjectPermissions>;
  myProjectRoles: MyRoles;
  myTasks: Array<ProjectTask>;
  organizationUsers: Array<ApplicationUser>;
  parentTask?: Maybe<ProjectTask>;
  project?: Maybe<Project>;
  projectAccessTokenFormValues: Array<FormValue>;
  projectAccessTokens: Array<ProjectAccessToken>;
  projectBudget: ProjectBudget;
  projectDocuments: Array<Document>;
  projectEvents?: Maybe<ProjectEventsConnection>;
  projectFolders: Array<Folder>;
  projectForm?: Maybe<ProjectForm>;
  projectFormOverviews: Array<ProjectFormOverview>;
  projectFormPermissions: Array<RoleAssignment>;
  projectFormSettings?: Maybe<FormSettings>;
  projectFormSubmission?: Maybe<ProjectFormSubmission>;
  projectFormSubmissions: Array<ProjectFormSubmission>;
  projectFormValues: Array<FormValue>;
  projectForms: Array<ProjectForm>;
  projectMember?: Maybe<ApplicationUser>;
  projectMembers: Array<ApplicationUser>;
  projectTask?: Maybe<ProjectTask>;
  projectTaskSubtasks: Array<ProjectTask>;
  projectTasks: Array<ProjectTask>;
  projectTemplatePermissions: Array<RoleAssignment>;
  projectTemplateSummaryInfo?: Maybe<ProjectTemplateSummary>;
  projectWorkflows: Array<WorkflowDefinition>;
  projects: Array<Project>;
  securityGroup?: Maybe<SecurityGroup>;
  securityGroupForUserInProject: Array<SecurityGroup>;
  securityGroupsForProject: Array<SecurityGroup>;
  taskPermissions: Array<RoleAssignment>;
  tasks?: Maybe<TasksConnection>;
  tenantSettings: TenantSettings;
  tenantSubscriptionDetails: AppSubscriptionModel;
  tenantTheme: TenantTheme;
  tenants: Array<Tenant>;
  tokenPurposeContext?: Maybe<TokenPurposeContextGraphQl>;
  user?: Maybe<ApplicationUser>;
  userTenants: Array<Tenant>;
  users: Array<ApplicationUser>;
  validPredecessorTasks: Array<ProjectTask>;
  validateUnsubscribeToken: ValidateUnsubscribeTokenResult;
  workflowActionConfigurationsOfWorkflow: Array<WorkflowActionConfiguration>;
  workflowActionDefinitions: Array<WorkflowActionDefinition>;
  workflowDefinition?: Maybe<WorkflowDefinition>;
  workflowInstance?: Maybe<WorkflowInstance>;
  workflowInstances: Array<WorkflowInstance>;
  workflowTemplateErrors: Array<WorkflowValidationError>;
  workflowTemplatePermissions: Array<RoleAssignment>;
  workflowTemplates: Array<WorkflowDefinition>;
  zohoEmbedUrl: Scalars['String']['output'];
};


export type QueryBudgetItemsArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryCalendarAvailabilitiesArgs = {
  input: GetCalendarAvailabilitiesInput;
};


export type QueryCalendarAvailabilitiesForMeetingTypeArgs = {
  input: GetCalendarAvailabilitiesForMeetingTypeInput;
};


export type QueryChildFoldersArgs = {
  parentFolderId: Scalars['Int']['input'];
  where?: InputMaybe<FolderFilterInput>;
};


export type QueryCommercialProjectCalculatorArgs = {
  calculatorId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<CommercialProjectCalculatorFilterInput>;
};


export type QueryCommercialProjectCalculatorsArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<CommercialProjectCalculatorFilterInput>;
};


export type QueryCostItemsArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<CostItemFilterInput>;
};


export type QueryDocumentArgs = {
  documentId: Scalars['Int']['input'];
  where?: InputMaybe<DocumentFilterInput>;
};


export type QueryDocumentPermissionsArgs = {
  documentId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};


export type QueryDocumentTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDocumentTemplatePermissionsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDocumentTemplatesArgs = {
  where?: InputMaybe<DocumentTemplateFilterInput>;
};


export type QueryExpensesArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<ExpenseFilterInput>;
};


export type QueryExternalLinkPermissionsArgs = {
  linkId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};


export type QueryFolderArgs = {
  folderId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};


export type QueryFolderEntriesArgs = {
  folderId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<FolderEntryFilterInput>;
};


export type QueryFolderEntryArgs = {
  entryId: Scalars['Int']['input'];
  where?: InputMaybe<FolderEntryFilterInput>;
};


export type QueryFolderPermissionsArgs = {
  folderId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};


export type QueryFormPresencesArgs = {
  formSubmissionId: Scalars['Int']['input'];
};


export type QueryFormPresencesPatArgs = {
  accessToken: Scalars['String']['input'];
};


export type QueryFormTemplateArgs = {
  templateId: Scalars['Int']['input'];
  where?: InputMaybe<FormTemplateFilterInput>;
};


export type QueryFormTemplatePermissionsArgs = {
  templateId: Scalars['Int']['input'];
};


export type QueryFormTemplatesArgs = {
  where?: InputMaybe<FormTemplateFilterInput>;
};


export type QueryMeetingArgs = {
  meetingId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};


export type QueryMeetingTypesArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryMeetingsArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<MeetingFilterInput>;
};


export type QueryMyTasksArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<ProjectTaskFilterInput>;
};


export type QueryOrganizationUsersArgs = {
  where?: InputMaybe<ApplicationUserFilterInput>;
};


export type QueryParentTaskArgs = {
  projectId: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
  where?: InputMaybe<ProjectTaskFilterInput>;
};


export type QueryProjectArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProjectAccessTokenFormValuesArgs = {
  token: Scalars['String']['input'];
};


export type QueryProjectAccessTokensArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<ProjectAccessTokenFilterInput>;
};


export type QueryProjectBudgetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProjectDocumentsArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<DocumentFilterInput>;
};


export type QueryProjectEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProjectEventSortInput>>;
  projectId: Scalars['Int']['input'];
};


export type QueryProjectFoldersArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<FolderFilterInput>;
};


export type QueryProjectFormArgs = {
  formId: Scalars['Int']['input'];
  where?: InputMaybe<ProjectFormFilterInput>;
};


export type QueryProjectFormOverviewsArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<ProjectFormFilterInput>;
};


export type QueryProjectFormPermissionsArgs = {
  formId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};


export type QueryProjectFormSettingsArgs = {
  formId: Scalars['Int']['input'];
  where?: InputMaybe<FormSettingsFilterInput>;
};


export type QueryProjectFormSubmissionArgs = {
  submissionId: Scalars['Int']['input'];
};


export type QueryProjectFormSubmissionsArgs = {
  formId?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<ProjectFormSubmissionFilterInput>;
};


export type QueryProjectFormValuesArgs = {
  formSubmissionId: Scalars['Int']['input'];
  where?: InputMaybe<FormValueFilterInput>;
};


export type QueryProjectFormsArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<ProjectFormFilterInput>;
};


export type QueryProjectMemberArgs = {
  projectId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
  where?: InputMaybe<ApplicationUserFilterInput>;
};


export type QueryProjectMembersArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<ApplicationUserFilterInput>;
};


export type QueryProjectTaskArgs = {
  projectId: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
  where?: InputMaybe<ProjectTaskFilterInput>;
};


export type QueryProjectTaskSubtasksArgs = {
  taskId: Scalars['Int']['input'];
  where?: InputMaybe<ProjectTaskFilterInput>;
};


export type QueryProjectTasksArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<ProjectTaskFilterInput>;
};


export type QueryProjectTemplatePermissionsArgs = {
  templateId: Scalars['Int']['input'];
};


export type QueryProjectTemplateSummaryInfoArgs = {
  projectTemplateId: Scalars['Int']['input'];
};


export type QueryProjectWorkflowsArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<WorkflowDefinitionFilterInput>;
};


export type QueryProjectsArgs = {
  where?: InputMaybe<ProjectFilterInput>;
};


export type QuerySecurityGroupArgs = {
  projectId: Scalars['Int']['input'];
  securityGroupId: Scalars['String']['input'];
  where?: InputMaybe<SecurityGroupFilterInput>;
};


export type QuerySecurityGroupForUserInProjectArgs = {
  projectId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
  where?: InputMaybe<SecurityGroupFilterInput>;
};


export type QuerySecurityGroupsForProjectArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<SecurityGroupFilterInput>;
};


export type QueryTaskPermissionsArgs = {
  projectId: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
};


export type QueryTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProjectTaskSortInput>>;
  where?: InputMaybe<ProjectTaskFilterInput>;
};


export type QueryTokenPurposeContextArgs = {
  token: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
  where?: InputMaybe<ApplicationUserFilterInput>;
};


export type QueryUsersArgs = {
  where?: InputMaybe<ApplicationUserFilterInput>;
};


export type QueryValidPredecessorTasksArgs = {
  taskId: Scalars['Int']['input'];
  where?: InputMaybe<ProjectTaskFilterInput>;
};


export type QueryValidateUnsubscribeTokenArgs = {
  input: ValidateUnsubscribeTokenInput;
};


export type QueryWorkflowActionConfigurationsOfWorkflowArgs = {
  order?: InputMaybe<Array<WorkflowActionConfigurationSortInput>>;
  workflowId: Scalars['Int']['input'];
};


export type QueryWorkflowActionDefinitionsArgs = {
  order?: InputMaybe<Array<WorkflowActionDefinitionSortInput>>;
};


export type QueryWorkflowDefinitionArgs = {
  workflowId: Scalars['Int']['input'];
};


export type QueryWorkflowInstanceArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<WorkflowInstanceFilterInput>;
  workflowId: Scalars['Int']['input'];
};


export type QueryWorkflowInstancesArgs = {
  projectId: Scalars['Int']['input'];
  where?: InputMaybe<WorkflowInstanceFilterInput>;
};


export type QueryWorkflowTemplateErrorsArgs = {
  workflowId: Scalars['Int']['input'];
};


export type QueryWorkflowTemplatePermissionsArgs = {
  templateId: Scalars['Int']['input'];
};


export type QueryWorkflowTemplatesArgs = {
  where?: InputMaybe<WorkflowDefinitionFilterInput>;
};


export type QueryZohoEmbedUrlArgs = {
  actionId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};

export type Quote = {
  __typename?: 'Quote';
  amount: Scalars['Decimal']['output'];
  attachments: Array<Document>;
  costItem?: Maybe<CostItem>;
  costItemId: Scalars['Int']['output'];
  entry?: Maybe<CostItemEntry>;
  expenses: Array<Expense>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  quoteDate: Scalars['DateTime']['output'];
};

export type QuoteFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<QuoteFilterInput>>;
  attachments?: InputMaybe<ListFilterInputTypeOfDocumentFilterInput>;
  costItem?: InputMaybe<CostItemFilterInput>;
  costItemId?: InputMaybe<IntOperationFilterInput>;
  entry?: InputMaybe<CostItemEntryFilterInput>;
  expenses?: InputMaybe<ListFilterInputTypeOfExpenseFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<QuoteFilterInput>>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
  quoteDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ReSendMyWeeklyEmailPayload = {
  __typename?: 'ReSendMyWeeklyEmailPayload';
  reSendMyWeeklyEmailResponse?: Maybe<ReSendMyWeeklyEmailResponse>;
};

export type ReSendMyWeeklyEmailResponse = {
  __typename?: 'ReSendMyWeeklyEmailResponse';
  wasEmailSent: Scalars['Boolean']['output'];
};

export type RemoveCommercialProjectCalculatorError = NotFoundError | ValidationResultError;

export type RemoveCommercialProjectCalculatorInput = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type RemoveCommercialProjectCalculatorPayload = {
  __typename?: 'RemoveCommercialProjectCalculatorPayload';
  commercialProjectCalculator?: Maybe<CommercialProjectCalculator>;
  errors?: Maybe<Array<RemoveCommercialProjectCalculatorError>>;
};

export type RemoveDocumentError = NotFoundError;

export type RemoveDocumentInput = {
  documentId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type RemoveDocumentPayload = {
  __typename?: 'RemoveDocumentPayload';
  document?: Maybe<Document>;
  errors?: Maybe<Array<RemoveDocumentError>>;
};

export type RemoveFormTemplateRoleAssignmentError = NotFoundError | ValidationResultError;

export type RemoveFormTemplateRoleAssignmentInput = {
  formTemplateId: Scalars['Int']['input'];
  roleAssignmentId: Scalars['String']['input'];
};

export type RemoveFormTemplateRoleAssignmentPayload = {
  __typename?: 'RemoveFormTemplateRoleAssignmentPayload';
  errors?: Maybe<Array<RemoveFormTemplateRoleAssignmentError>>;
  roleAssignment?: Maybe<RoleAssignment>;
};

export type RemoveMatrixRowError = NotFoundError | ValidationResultError;

export type RemoveMatrixRowInput = {
  matrixFieldId: Scalars['Int']['input'];
  rowId: Scalars['Int']['input'];
  submissionId: Scalars['Int']['input'];
};

export type RemoveMatrixRowPatError = NotFoundError | ValidationResultError;

export type RemoveMatrixRowPatInput = {
  accessToken: Scalars['String']['input'];
  matrixFieldId: Scalars['Int']['input'];
  rowId: Scalars['Int']['input'];
  submissionId: Scalars['Int']['input'];
};

export type RemoveMatrixRowPatPayload = {
  __typename?: 'RemoveMatrixRowPATPayload';
  errors?: Maybe<Array<RemoveMatrixRowPatError>>;
  matrixRow?: Maybe<MatrixRow>;
};

export type RemoveMatrixRowPayload = {
  __typename?: 'RemoveMatrixRowPayload';
  errors?: Maybe<Array<RemoveMatrixRowError>>;
  matrixRow?: Maybe<MatrixRow>;
};

export type RemovePresenceError = NotFoundError | ValidationResultError;

export type RemovePresenceInput = {
  submissionId: Scalars['Int']['input'];
  uniqueClientId: Scalars['String']['input'];
};

export type RemovePresencePatError = NotFoundError | ValidationResultError;

export type RemovePresencePatInput = {
  accessToken: Scalars['String']['input'];
  submissionId: Scalars['Int']['input'];
  uniqueClientId: Scalars['String']['input'];
};

export type RemovePresencePatPayload = {
  __typename?: 'RemovePresencePATPayload';
  errors?: Maybe<Array<RemovePresencePatError>>;
  projectFormPresence?: Maybe<ProjectFormPresence>;
};

export type RemovePresencePayload = {
  __typename?: 'RemovePresencePayload';
  errors?: Maybe<Array<RemovePresenceError>>;
  projectFormPresence?: Maybe<ProjectFormPresence>;
};

export type RemoveProjectMemberError = NotFoundError;

export type RemoveProjectMemberInput = {
  projectId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveProjectMemberPayload = {
  __typename?: 'RemoveProjectMemberPayload';
  errors?: Maybe<Array<RemoveProjectMemberError>>;
  project?: Maybe<Project>;
};

export type RemoveSecurityGroupMemberError = NotFoundError | ValidationResultError;

export type RemoveSecurityGroupMemberInput = {
  projectId: Scalars['Int']['input'];
  securityGroupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveSecurityGroupMemberPayload = {
  __typename?: 'RemoveSecurityGroupMemberPayload';
  errors?: Maybe<Array<RemoveSecurityGroupMemberError>>;
  project?: Maybe<Project>;
};

export type RemoveUserError = NotFoundError | ValidationResultError;

export type RemoveUserInput = {
  id: Scalars['String']['input'];
};

export type RemoveUserPayload = {
  __typename?: 'RemoveUserPayload';
  applicationUser?: Maybe<ApplicationUser>;
  errors?: Maybe<Array<RemoveUserError>>;
};

export type RenameDocumentError = NotFoundError;

export type RenameDocumentInput = {
  documentId: Scalars['Int']['input'];
  fileName: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type RenameDocumentPayload = {
  __typename?: 'RenameDocumentPayload';
  document?: Maybe<Document>;
  errors?: Maybe<Array<RenameDocumentError>>;
};

export type RenameFolderError = ValidationResultError;

export type RenameFolderInput = {
  folderId: Scalars['Int']['input'];
  newName: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type RenameFolderPayload = {
  __typename?: 'RenameFolderPayload';
  errors?: Maybe<Array<RenameFolderError>>;
  folder?: Maybe<Folder>;
};

export type RenewAccessTokenFromExpiredTokenError = NotFoundError | ValidationResultError;

export type RenewAccessTokenFromExpiredTokenInput = {
  token: Scalars['String']['input'];
};

export type RenewAccessTokenFromExpiredTokenPayload = {
  __typename?: 'RenewAccessTokenFromExpiredTokenPayload';
  errors?: Maybe<Array<RenewAccessTokenFromExpiredTokenError>>;
  renewAccessTokenFromExpiredTokenResult?: Maybe<RenewAccessTokenFromExpiredTokenResult>;
};

export type RenewAccessTokenFromExpiredTokenResult = {
  __typename?: 'RenewAccessTokenFromExpiredTokenResult';
  sentToEmail: Scalars['String']['output'];
};

export type ReorderBudgetItemError = NotFoundError | ValidationResultError;

export type ReorderBudgetItemInput = {
  budgetItemId: Scalars['Int']['input'];
  index: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type ReorderBudgetItemPayload = {
  __typename?: 'ReorderBudgetItemPayload';
  budgetItem?: Maybe<BudgetItem>;
  errors?: Maybe<Array<ReorderBudgetItemError>>;
};

export type ReorderCostItemEntryError = NotFoundError | ValidationResultError;

export type ReorderCostItemEntryInput = {
  costItemEntryId: Scalars['Int']['input'];
  index: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type ReorderCostItemEntryPayload = {
  __typename?: 'ReorderCostItemEntryPayload';
  costItemEntry?: Maybe<CostItemEntry>;
  errors?: Maybe<Array<ReorderCostItemEntryError>>;
};

export type ReorderCostItemError = NotFoundError | ValidationResultError;

export type ReorderCostItemInput = {
  costItemId: Scalars['Int']['input'];
  index: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type ReorderCostItemPayload = {
  __typename?: 'ReorderCostItemPayload';
  costItem?: Maybe<CostItem>;
  errors?: Maybe<Array<ReorderCostItemError>>;
};

export type ReorderFormSectionsError = NotFoundError | ValidationResultError;

export type ReorderFormSectionsInput = {
  formDefinitionId: Scalars['Int']['input'];
  sectionIdsInOrder: Array<Scalars['Int']['input']>;
};

export type ReorderFormSectionsPayload = {
  __typename?: 'ReorderFormSectionsPayload';
  errors?: Maybe<Array<ReorderFormSectionsError>>;
  formDefinition?: Maybe<FormDefinition>;
};

export type ReparentTaskError = NotFoundError;

export type ReparentTaskInput = {
  parentTaskId?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
};

export type ReparentTaskPayload = {
  __typename?: 'ReparentTaskPayload';
  errors?: Maybe<Array<ReparentTaskError>>;
  projectTask?: Maybe<ProjectTask>;
};

export type RequestFormSubmissionAnonymousError = AccessTokenExpiredError | AccessTokenInvalidError | NotFoundError | ValidationResultError;

export type RequestFormSubmissionAnonymousInput = {
  token: Scalars['String']['input'];
};

export type RequestFormSubmissionAnonymousPayload = {
  __typename?: 'RequestFormSubmissionAnonymousPayload';
  errors?: Maybe<Array<RequestFormSubmissionAnonymousError>>;
  projectFormSubmission?: Maybe<ProjectFormSubmission>;
};

export type RequestFormSubmissionError = NotFoundError | ValidationResultError;

export type RequestFormSubmissionInput = {
  formId: Scalars['Int']['input'];
};

export type RequestFormSubmissionPayload = {
  __typename?: 'RequestFormSubmissionPayload';
  errors?: Maybe<Array<RequestFormSubmissionError>>;
  projectFormSubmission?: Maybe<ProjectFormSubmission>;
};

export type RescheduleTaskError = NotFoundError | ValidationResultError;

export type RescheduleTaskInput = {
  dueDate: Scalars['DateTime']['input'];
  projectId: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  taskId: Scalars['Int']['input'];
};

export type RescheduleTaskPayload = {
  __typename?: 'RescheduleTaskPayload';
  errors?: Maybe<Array<RescheduleTaskError>>;
  projectTask?: Maybe<ProjectTask>;
};

export type ResendFormInvitationError = NotFoundError | ValidationResultError;

export type ResendFormInvitationInput = {
  formId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  recipientIds: Array<Scalars['String']['input']>;
};

export type ResendFormInvitationPayload = {
  __typename?: 'ResendFormInvitationPayload';
  errors?: Maybe<Array<ResendFormInvitationError>>;
  projectForm?: Maybe<ProjectForm>;
};

export type RoleAssignment = {
  __typename?: 'RoleAssignment';
  applicationRole?: Maybe<ApplicationRole>;
  applicationRoleId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inheritedFromFolder?: Maybe<Folder>;
  inheritedFromFolderId?: Maybe<Scalars['Int']['output']>;
  isFromFillFormTask: Scalars['Boolean']['output'];
  isFromSignDocumentTask: Scalars['Boolean']['output'];
  isInherited: Scalars['Boolean']['output'];
  isSharedWithPublicLink: Scalars['Boolean']['output'];
  principalType: PrincipalType;
  securityGroup?: Maybe<SecurityGroup>;
  securityGroupId?: Maybe<Scalars['String']['output']>;
  sharedWithAllProjectMembers: Scalars['Boolean']['output'];
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type RoleAssignmentFilterInput = {
  and?: InputMaybe<Array<RoleAssignmentFilterInput>>;
  applicationRole?: InputMaybe<ApplicationRoleFilterInput>;
  applicationRoleId?: InputMaybe<StringOperationFilterInput>;
  appliesToDocument?: InputMaybe<DocumentFilterInput>;
  appliesToDocumentId?: InputMaybe<IntOperationFilterInput>;
  appliesToFolder?: InputMaybe<FolderFilterInput>;
  appliesToFolderId?: InputMaybe<IntOperationFilterInput>;
  appliesToTask?: InputMaybe<ProjectTaskFilterInput>;
  appliesToTaskId?: InputMaybe<IntOperationFilterInput>;
  documentTemplate?: InputMaybe<DocumentTemplateFilterInput>;
  documentTemplateId?: InputMaybe<IntOperationFilterInput>;
  externalLink?: InputMaybe<ExternalLinkFilterInput>;
  externalLinkId?: InputMaybe<IntOperationFilterInput>;
  formTemplate?: InputMaybe<FormTemplateFilterInput>;
  formTemplateId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inheritedFromFolder?: InputMaybe<FolderFilterInput>;
  inheritedFromFolderId?: InputMaybe<IntOperationFilterInput>;
  isFromFillFormTask?: InputMaybe<BooleanOperationFilterInput>;
  isFromSignDocumentTask?: InputMaybe<BooleanOperationFilterInput>;
  isInherited?: InputMaybe<BooleanOperationFilterInput>;
  isSharedWithPublicLink?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<RoleAssignmentFilterInput>>;
  principalType?: InputMaybe<PrincipalTypeOperationFilterInput>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
  securityGroup?: InputMaybe<SecurityGroupFilterInput>;
  securityGroupId?: InputMaybe<StringOperationFilterInput>;
  sharedWithAllProjectMembers?: InputMaybe<BooleanOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  workflowDefinition?: InputMaybe<WorkflowDefinitionFilterInput>;
  workflowDefinitionId?: InputMaybe<IntOperationFilterInput>;
};

export type SecurityGroup = {
  __typename?: 'SecurityGroup';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefaultProjectAdminGroup: Scalars['Boolean']['output'];
  members: Array<ApplicationUser>;
  name: Scalars['String']['output'];
  permissionAssignments: Array<PermissionAssignment>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['Int']['output']>;
  projectPermissions: ProjectPermissions;
  roleAssignments: Array<RoleAssignment>;
};


export type SecurityGroupMembersArgs = {
  where?: InputMaybe<ApplicationUserFilterInput>;
};


export type SecurityGroupRoleAssignmentsArgs = {
  where?: InputMaybe<RoleAssignmentFilterInput>;
};

export type SecurityGroupFilterInput = {
  and?: InputMaybe<Array<SecurityGroupFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDefaultProjectAdminGroup?: InputMaybe<BooleanOperationFilterInput>;
  members?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SecurityGroupFilterInput>>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<IntOperationFilterInput>;
  roleAssignments?: InputMaybe<ListFilterInputTypeOfRoleAssignmentFilterInput>;
};

export type SecurityPrincipalShimInput = {
  id: Scalars['String']['input'];
  principalType: PrincipalType;
};

export type SelectionFieldOption = {
  __typename?: 'SelectionFieldOption';
  formField?: Maybe<FormField>;
  formFieldId: Scalars['Int']['output'];
  formValues: Array<FormValue>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type SelectionFieldOptionFilterInput = {
  and?: InputMaybe<Array<SelectionFieldOptionFilterInput>>;
  formField?: InputMaybe<FormFieldFilterInput>;
  formFieldId?: InputMaybe<IntOperationFilterInput>;
  formValues?: InputMaybe<ListFilterInputTypeOfFormValueFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SelectionFieldOptionFilterInput>>;
};

export type SelectionFieldOptionInput = {
  label: Scalars['String']['input'];
};

export type SendSharingNotificationForOrganizationResourceError = NotFoundError | ValidationResultError;

export type SendSharingNotificationForOrganizationResourceInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  principalId: Scalars['String']['input'];
  principalType: PrincipalType;
  resourceId: Scalars['Int']['input'];
  resourceType: ShareableResourceType;
};

export type SendSharingNotificationForOrganizationResourcePayload = {
  __typename?: 'SendSharingNotificationForOrganizationResourcePayload';
  errors?: Maybe<Array<SendSharingNotificationForOrganizationResourceError>>;
  sendSharingNotificationForResourceResponse?: Maybe<SendSharingNotificationForResourceResponse>;
};

export type SendSharingNotificationForProjectResourceError = NotFoundError | ValidationResultError;

export type SendSharingNotificationForProjectResourceInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  principalId: Scalars['String']['input'];
  principalType: PrincipalType;
  projectId: Scalars['Int']['input'];
  resourceId: Scalars['Int']['input'];
  resourceType: ShareableResourceType;
};

export type SendSharingNotificationForProjectResourcePayload = {
  __typename?: 'SendSharingNotificationForProjectResourcePayload';
  errors?: Maybe<Array<SendSharingNotificationForProjectResourceError>>;
  sendSharingNotificationForResourceResponse?: Maybe<SendSharingNotificationForResourceResponse>;
};

export type SendSharingNotificationForResourceResponse = {
  __typename?: 'SendSharingNotificationForResourceResponse';
  wasNotificationSent: Scalars['Boolean']['output'];
};

export type SendSharingTemplateNotificationError = NotFoundError | ValidationResultError;

export type SendSharingTemplateNotificationInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  principalId: Scalars['String']['input'];
  principalType: PrincipalType;
  resourceId: Scalars['Int']['input'];
  resourceType: ShareableResourceType;
};

export type SendSharingTemplateNotificationPayload = {
  __typename?: 'SendSharingTemplateNotificationPayload';
  errors?: Maybe<Array<SendSharingTemplateNotificationError>>;
  sendSharingNotificationForResourceResponse?: Maybe<SendSharingNotificationForResourceResponse>;
};

export type SendSignatureRequestError = ElectronicSignatureProviderError | NotFoundError | ValidationResultError;

export type SendSignatureRequestInput = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['Int']['input'];
  dueDate: Scalars['DateTime']['input'];
  projectId: Scalars['Int']['input'];
  signatoryCustomerId: Scalars['String']['input'];
  signatureCoordinates?: InputMaybe<ZohoSignatureCoordinatesInput>;
};

export type SendSignatureRequestInternalInput = {
  input: SendSignatureRequestInput;
  workflowInstanceId?: InputMaybe<Scalars['Int']['input']>;
};

export type SendSignatureRequestInternalPayload = {
  __typename?: 'SendSignatureRequestInternalPayload';
  document?: Maybe<Document>;
};

export type SendSignatureRequestPayload = {
  __typename?: 'SendSignatureRequestPayload';
  document?: Maybe<Document>;
  errors?: Maybe<Array<SendSignatureRequestError>>;
};

export type ShareOrganizationResourceError = NotFoundError | ValidationResultError;

export type ShareOrganizationResourceInput = {
  notificationMessage?: InputMaybe<Scalars['String']['input']>;
  principalId: Scalars['String']['input'];
  resourceId: Scalars['Int']['input'];
  resourceType: ShareableResourceType;
  sendNotification: Scalars['Boolean']['input'];
};

export type ShareOrganizationResourcePayload = {
  __typename?: 'ShareOrganizationResourcePayload';
  errors?: Maybe<Array<ShareOrganizationResourceError>>;
  roleAssignment?: Maybe<RoleAssignment>;
};

export type ShareProjectResourceError = NotFoundError | ValidationResultError;

export type ShareProjectResourceInput = {
  notificationMessage?: InputMaybe<Scalars['String']['input']>;
  principalId: Scalars['String']['input'];
  principalType: PrincipalType;
  projectId: Scalars['Int']['input'];
  resourceId: Scalars['Int']['input'];
  resourceType: ShareableResourceType;
  role?: InputMaybe<BuiltInRoles>;
  sendNotification: Scalars['Boolean']['input'];
};

export type ShareProjectResourcePayload = {
  __typename?: 'ShareProjectResourcePayload';
  errors?: Maybe<Array<ShareProjectResourceError>>;
  roleAssignment?: Maybe<RoleAssignment>;
};

export enum ShareableResourceType {
  Document = 'Document',
  DocumentTemplate = 'DocumentTemplate',
  ExternalLink = 'ExternalLink',
  Folder = 'Folder',
  Form = 'Form',
  FormTemplate = 'FormTemplate',
  Project = 'Project',
  ProjectTemplate = 'ProjectTemplate',
  Task = 'Task',
  WorkflowDefinition = 'WorkflowDefinition'
}

export type SignDocumentAnonymouslyError = AccessTokenExpiredError | AccessTokenInvalidError | NotFoundError | ValidationResultError | WorkflowExecutionFatalError;

export type SignDocumentAnonymouslyInput = {
  signatureBase64String?: InputMaybe<Scalars['String']['input']>;
  textSignature?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type SignDocumentAnonymouslyPayload = {
  __typename?: 'SignDocumentAnonymouslyPayload';
  document?: Maybe<Document>;
  errors?: Maybe<Array<SignDocumentAnonymouslyError>>;
};

export type SignDocumentError = NotFoundError | ValidationResultError | WorkflowExecutionFatalError;

export type SignDocumentInput = {
  documentId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  signatureBase64String?: InputMaybe<Scalars['String']['input']>;
  textSignature?: InputMaybe<Scalars['String']['input']>;
};

export type SignDocumentPayload = {
  __typename?: 'SignDocumentPayload';
  document?: Maybe<Document>;
  errors?: Maybe<Array<SignDocumentError>>;
};

export type SignatureRequest = {
  __typename?: 'SignatureRequest';
  expiresOn: Scalars['DateTime']['output'];
  requestId: Scalars['String']['output'];
  signatureStatus: SignatureStatus;
  tenantId: Scalars['String']['output'];
};

export enum SignatureStatus {
  Denied = 'Denied',
  Expired = 'Expired',
  Pending = 'Pending',
  Signed = 'Signed'
}

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StartTrialError = DuplicateNameError | MissingConfigurationError | ValidationResultError;

export type StartTrialInput = {
  adminInput: TenantAdminInput;
  referralId?: InputMaybe<Scalars['String']['input']>;
  tenantName: Scalars['String']['input'];
};

export type StartTrialPayload = {
  __typename?: 'StartTrialPayload';
  errors?: Maybe<Array<StartTrialError>>;
  tenant?: Maybe<Tenant>;
};

export type StartWorkflowInstanceError = NotFoundError | ValidationResultError | WorkflowConfigurationError | WorkflowExecutionFatalError;

export type StartWorkflowInstanceInput = {
  projectId: Scalars['Int']['input'];
  workflowDefinitionId: Scalars['Int']['input'];
  workflowVariables: Array<WorkflowVariableInput>;
};

export type StartWorkflowInstancePayload = {
  __typename?: 'StartWorkflowInstancePayload';
  errors?: Maybe<Array<StartWorkflowInstanceError>>;
  workflowInstance?: Maybe<WorkflowInstance>;
};

export type StopWorkflowInstanceError = NotFoundError | ValidationResultError;

export type StopWorkflowInstanceInput = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type StopWorkflowInstancePayload = {
  __typename?: 'StopWorkflowInstancePayload';
  errors?: Maybe<Array<StopWorkflowInstanceError>>;
  mutationResult?: Maybe<MutationResult>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum SubmissionStatus {
  /** @deprecated No longer supported. */
  Closed = 'Closed',
  IsResponding = 'IsResponding',
  Submitted = 'Submitted'
}

export type SubmissionStatusOperationFilterInput = {
  eq?: InputMaybe<SubmissionStatus>;
  in?: InputMaybe<Array<SubmissionStatus>>;
  neq?: InputMaybe<SubmissionStatus>;
  nin?: InputMaybe<Array<SubmissionStatus>>;
};

export type SubmitWorkflowActionError = NotFoundError | ValidationResultError | WorkflowExecutionFatalError;

export type SubmitWorkflowActionInput = {
  jsonPayload?: InputMaybe<Scalars['String']['input']>;
  workflowActionId: Scalars['Int']['input'];
  workflowInstanceId: Scalars['Int']['input'];
};

export type SubmitWorkflowActionPayload = {
  __typename?: 'SubmitWorkflowActionPayload';
  errors?: Maybe<Array<SubmitWorkflowActionError>>;
  workflowActionConfiguration?: Maybe<WorkflowActionConfiguration>;
};

export type Subscription = {
  __typename?: 'Subscription';
  formPresenceUpdated: Array<ProjectFormPresence>;
  formValueEdited: FormValueEditedEvent;
  matrixRowEvent: MatrixRowEvent;
  matrixValueEdited: MatrixValueEditedEvent;
  provisioningStatusChanged: ProvisioningStatus;
};


export type SubscriptionFormPresenceUpdatedArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  submissionId: Scalars['Int']['input'];
};


export type SubscriptionFormValueEditedArgs = {
  submissionId: Scalars['Int']['input'];
};


export type SubscriptionMatrixRowEventArgs = {
  submissionId: Scalars['Int']['input'];
};


export type SubscriptionMatrixValueEditedArgs = {
  submissionId: Scalars['Int']['input'];
};


export type SubscriptionProvisioningStatusChangedArgs = {
  tenantId: Scalars['String']['input'];
};

export enum SubscriptionProvider {
  ArivLicenseService = 'ArivLicenseService',
  AzureMarketplace = 'AzureMarketplace',
  Unknown = 'Unknown'
}

export enum SubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  InTrial = 'InTrial',
  Incomplete = 'Incomplete',
  Paused = 'Paused',
  Unpaid = 'Unpaid'
}

/** A connection to a list of items. */
export type TasksConnection = {
  __typename?: 'TasksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TasksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProjectTask>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TasksEdge = {
  __typename?: 'TasksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProjectTask;
};

export enum TasksPermission {
  LimitedAccess = 'LimitedAccess',
  Manage = 'Manage',
  ViewAll = 'ViewAll'
}

export type Tenant = {
  __typename?: 'Tenant';
  appSubscription?: Maybe<AppSubscription>;
  connectionString?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  provisioningStatus: ProvisioningStatus;
  version: Array<Scalars['Byte']['output']>;
};

export type TenantAdminInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type TenantSettings = {
  __typename?: 'TenantSettings';
  id: Scalars['Int']['output'];
  isConstructionAddonEnabled: Scalars['Boolean']['output'];
  isSignDocumentByZohoEnabled: Scalars['Boolean']['output'];
  isWhiteLabelEnabled: Scalars['Boolean']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  remainingZohoSignatureRequests: Scalars['Int']['output'];
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export type TenantTheme = {
  __typename?: 'TenantTheme';
  faviconUrl?: Maybe<Scalars['String']['output']>;
  isBrandingEnabled: Scalars['Boolean']['output'];
  loginBackgroundUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  squareLogoDarkUrl?: Maybe<Scalars['String']['output']>;
  squareLogoLightUrl?: Maybe<Scalars['String']['output']>;
  topBarLogoDarkUrl?: Maybe<Scalars['String']['output']>;
  topBarLogoLightUrl?: Maybe<Scalars['String']['output']>;
};

export type TimeSpanOperationFilterInput = {
  eq?: InputMaybe<Scalars['TimeSpan']['input']>;
  gt?: InputMaybe<Scalars['TimeSpan']['input']>;
  gte?: InputMaybe<Scalars['TimeSpan']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']['input']>>>;
  lt?: InputMaybe<Scalars['TimeSpan']['input']>;
  lte?: InputMaybe<Scalars['TimeSpan']['input']>;
  neq?: InputMaybe<Scalars['TimeSpan']['input']>;
  ngt?: InputMaybe<Scalars['TimeSpan']['input']>;
  ngte?: InputMaybe<Scalars['TimeSpan']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']['input']>>>;
  nlt?: InputMaybe<Scalars['TimeSpan']['input']>;
  nlte?: InputMaybe<Scalars['TimeSpan']['input']>;
};

export type TokenPurposeContextGraphQl = {
  __typename?: 'TokenPurposeContextGraphQL';
  actionDescription?: Maybe<Scalars['String']['output']>;
  actionUrl?: Maybe<Scalars['String']['output']>;
  customMessage?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  initiatorName?: Maybe<Scalars['String']['output']>;
  isRenewable: Scalars['Boolean']['output'];
  projectId: Scalars['Int']['output'];
  projectName?: Maybe<Scalars['String']['output']>;
  purpose: AccessTokenPurpose;
  resourceName?: Maybe<Scalars['String']['output']>;
  status: TokenStatus;
};

export enum TokenStatus {
  Completed = 'Completed',
  Expired = 'Expired',
  Invalid = 'Invalid',
  Valid = 'Valid'
}

export type UnpublishDocumentError = NotFoundError;

export type UnpublishDocumentInput = {
  documentId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type UnpublishDocumentPayload = {
  __typename?: 'UnpublishDocumentPayload';
  document?: Maybe<Document>;
  errors?: Maybe<Array<UnpublishDocumentError>>;
};

export type UnpublishFormError = ValidationResultError;

export type UnpublishFormInput = {
  projectFormId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type UnpublishFormPayload = {
  __typename?: 'UnpublishFormPayload';
  errors?: Maybe<Array<UnpublishFormError>>;
  projectForm?: Maybe<ProjectForm>;
};

export type UnshareOrganizationResourceError = NotFoundError | ValidationResultError;

export type UnshareOrganizationResourceInput = {
  roleAssignmentId: Scalars['String']['input'];
};

export type UnshareOrganizationResourcePayload = {
  __typename?: 'UnshareOrganizationResourcePayload';
  errors?: Maybe<Array<UnshareOrganizationResourceError>>;
  roleAssignment?: Maybe<RoleAssignment>;
};

export type UnshareProjectResourceError = NotFoundError | ValidationResultError;

export type UnshareProjectResourceInput = {
  projectId: Scalars['Int']['input'];
  roleAssignmentId: Scalars['String']['input'];
};

export type UnshareProjectResourcePayload = {
  __typename?: 'UnshareProjectResourcePayload';
  errors?: Maybe<Array<UnshareProjectResourceError>>;
  roleAssignment?: Maybe<RoleAssignment>;
};

export type UnsubscribeFromEmailsError = AccessTokenInvalidError;

export type UnsubscribeFromEmailsInput = {
  token: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UnsubscribeFromEmailsPayload = {
  __typename?: 'UnsubscribeFromEmailsPayload';
  errors?: Maybe<Array<UnsubscribeFromEmailsError>>;
  unsubscribeFromEmailsResponse?: Maybe<UnsubscribeFromEmailsResponse>;
};

export type UnsubscribeFromEmailsResponse = {
  __typename?: 'UnsubscribeFromEmailsResponse';
  wasUnsubscribed: Scalars['Boolean']['output'];
};

export type UpdateBrandingConfigurationError = NotFoundError | ValidationResultError;

export type UpdateBrandingConfigurationInput = {
  isWhiteLabelEnabled: Scalars['Boolean']['input'];
  primaryColor: Scalars['String']['input'];
  secondaryColor: Scalars['String']['input'];
};

export type UpdateBrandingConfigurationPayload = {
  __typename?: 'UpdateBrandingConfigurationPayload';
  errors?: Maybe<Array<UpdateBrandingConfigurationError>>;
  tenantSettings?: Maybe<TenantSettings>;
};

export type UpdateCommercialProjectCalculatorError = NotFoundError | ValidationResultError;

export type UpdateCommercialProjectCalculatorInput = {
  id: Scalars['Int']['input'];
  jsonData: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type UpdateCommercialProjectCalculatorPayload = {
  __typename?: 'UpdateCommercialProjectCalculatorPayload';
  commercialProjectCalculator?: Maybe<CommercialProjectCalculator>;
  errors?: Maybe<Array<UpdateCommercialProjectCalculatorError>>;
};

export type UpdateFormSettingsError = NotFoundError | ValidationResultError;

export type UpdateFormSettingsInput = {
  allowedRespondents: AllowedRespondents;
  allowedSecurityGroupsRespondents: Array<Scalars['String']['input']>;
  allowedUsersRespondents: Array<Scalars['String']['input']>;
  projectFormId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type UpdateFormSettingsPayload = {
  __typename?: 'UpdateFormSettingsPayload';
  errors?: Maybe<Array<UpdateFormSettingsError>>;
  formSettings?: Maybe<FormSettings>;
};

export type UpdateMyPreferencesError = NotFoundError;

export type UpdateMyPreferencesInput = {
  optOutOfWeeklyEmails: Scalars['Boolean']['input'];
  preferredLanguage: Scalars['String']['input'];
};

export type UpdateMyPreferencesPayload = {
  __typename?: 'UpdateMyPreferencesPayload';
  applicationUser?: Maybe<ApplicationUser>;
  errors?: Maybe<Array<UpdateMyPreferencesError>>;
};

export type UpdatePresenceError = NotFoundError | ValidationResultError;

export type UpdatePresenceInput = {
  fieldId?: InputMaybe<Scalars['Int']['input']>;
  matrixColumnId?: InputMaybe<Scalars['Int']['input']>;
  matrixRowId?: InputMaybe<Scalars['Int']['input']>;
  submissionId: Scalars['Int']['input'];
  uniqueClientId: Scalars['String']['input'];
};

export type UpdatePresencePayload = {
  __typename?: 'UpdatePresencePayload';
  errors?: Maybe<Array<UpdatePresenceError>>;
  projectFormPresence?: Maybe<ProjectFormPresence>;
};

export type UpdateSecurityGroupError = NotFoundError | ValidationResultError;

export type UpdateSecurityGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type UpdateSecurityGroupPayload = {
  __typename?: 'UpdateSecurityGroupPayload';
  errors?: Maybe<Array<UpdateSecurityGroupError>>;
  securityGroup?: Maybe<SecurityGroup>;
};

export type UpdateSecurityGroupRolesError = NotFoundError | ValidationResultError;

export type UpdateSecurityGroupRolesInput = {
  budgetPermission: BudgetAndExpensesPermission;
  documentsPermission: DocumentsPermission;
  formsPermission: FormsPermission;
  managePublicFileSharingPermission: ManagePublicFileSharingPermission;
  projectId: Scalars['Int']['input'];
  securityGroupId: Scalars['String']['input'];
  tasksPermission: TasksPermission;
  workflowsPermission: WorkflowsPermission;
};

export type UpdateSecurityGroupRolesPayload = {
  __typename?: 'UpdateSecurityGroupRolesPayload';
  errors?: Maybe<Array<UpdateSecurityGroupRolesError>>;
  securityGroup?: Maybe<SecurityGroup>;
};

export type UpdateTaskError = NotFoundError | ValidationResultError;

export type UpdateTaskInput = {
  assignees: Array<SecurityPrincipalShimInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentTaskId?: InputMaybe<Scalars['Int']['input']>;
  predecessorIds: Array<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status: ProjectTaskStatus;
  taskId: Scalars['Int']['input'];
};

export type UpdateTaskPayload = {
  __typename?: 'UpdateTaskPayload';
  errors?: Maybe<Array<UpdateTaskError>>;
  projectTask?: Maybe<ProjectTask>;
};

export type UpdateTaskStatusError = NotFoundError | ValidationResultError;

export type UpdateTaskStatusInput = {
  projectId: Scalars['Int']['input'];
  status: ProjectTaskStatus;
  taskId: Scalars['Int']['input'];
};

export type UpdateTaskStatusPayload = {
  __typename?: 'UpdateTaskStatusPayload';
  errors?: Maybe<Array<UpdateTaskStatusError>>;
  projectTask?: Maybe<ProjectTask>;
};

export type UpdateWorkflowActionConfigurationError = NotFoundError | ValidationResultError;

export type UpdateWorkflowActionConfigurationInput = {
  actionName: Scalars['String']['input'];
  fieldConfigurations: Array<ActionFieldValueInput>;
  workflowActionId: Scalars['Int']['input'];
  workflowDefinitionId: Scalars['Int']['input'];
};

export type UpdateWorkflowActionConfigurationPayload = {
  __typename?: 'UpdateWorkflowActionConfigurationPayload';
  errors?: Maybe<Array<UpdateWorkflowActionConfigurationError>>;
  workflowActionConfiguration?: Maybe<WorkflowActionConfiguration>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type ValidateUnsubscribeTokenInput = {
  token: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ValidateUnsubscribeTokenResult = {
  __typename?: 'ValidateUnsubscribeTokenResult';
  isValid: Scalars['Boolean']['output'];
};

export type ValidationResultError = Error & {
  __typename?: 'ValidationResultError';
  message: Scalars['String']['output'];
};

export enum WorkFlowStatus {
  Completed = 'Completed',
  Error = 'Error',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  Stopped = 'Stopped'
}

export type WorkFlowStatusOperationFilterInput = {
  eq?: InputMaybe<WorkFlowStatus>;
  in?: InputMaybe<Array<WorkFlowStatus>>;
  neq?: InputMaybe<WorkFlowStatus>;
  nin?: InputMaybe<Array<WorkFlowStatus>>;
};

export type WorkflowActionConfiguration = {
  __typename?: 'WorkflowActionConfiguration';
  belongsToWorkflowInstanceId?: Maybe<Scalars['Int']['output']>;
  canSubmit: Scalars['Boolean']['output'];
  childActions: Array<WorkflowActionConfiguration>;
  fieldValues: Array<WorkflowActionFieldValue>;
  hierarchyPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  participants: Array<ApplicationUser>;
  status: WorkflowActionStatus;
  submittedBy?: Maybe<ApplicationUser>;
  submittedById?: Maybe<Scalars['String']['output']>;
  submittedOn?: Maybe<Scalars['DateTime']['output']>;
  workflowActionDefinition?: Maybe<WorkflowActionDefinition>;
  workflowActionDefinitionId: Scalars['String']['output'];
};

export type WorkflowActionConfigurationFilterInput = {
  and?: InputMaybe<Array<WorkflowActionConfigurationFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WorkflowActionConfigurationFilterInput>>;
};

export type WorkflowActionConfigurationSortInput = {
  belongsToWorkflowDefinition?: InputMaybe<WorkflowDefinitionSortInput>;
  belongsToWorkflowDefinitionId?: InputMaybe<SortEnumType>;
  belongsToWorkflowInstance?: InputMaybe<WorkflowInstanceSortInput>;
  belongsToWorkflowInstanceId?: InputMaybe<SortEnumType>;
  hierarchyPath?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
  parentActionConfiguration?: InputMaybe<WorkflowActionConfigurationSortInput>;
  parentActionConfigurationId?: InputMaybe<SortEnumType>;
  rootOfWorkflow?: InputMaybe<WorkflowDefinitionSortInput>;
  rootOfWorkflowInstance?: InputMaybe<WorkflowInstanceSortInput>;
  status?: InputMaybe<SortEnumType>;
  submittedBy?: InputMaybe<ApplicationUserSortInput>;
  submittedById?: InputMaybe<SortEnumType>;
  submittedOn?: InputMaybe<SortEnumType>;
  workflowActionDefinition?: InputMaybe<WorkflowActionDefinitionSortInput>;
  workflowActionDefinitionId?: InputMaybe<SortEnumType>;
};

export type WorkflowActionDefinition = {
  __typename?: 'WorkflowActionDefinition';
  actionDefinitionId: Scalars['String']['output'];
  fields: Array<WorkflowActionField>;
  name: Scalars['String']['output'];
};


export type WorkflowActionDefinitionFieldsArgs = {
  order?: InputMaybe<Array<WorkflowActionFieldSortInput>>;
};

export type WorkflowActionDefinitionSortInput = {
  actionCategory?: InputMaybe<SortEnumType>;
  actionDefinitionId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type WorkflowActionField = {
  __typename?: 'WorkflowActionField';
  description?: Maybe<Scalars['String']['output']>;
  fieldType: WorkflowFieldType;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  variableType: WorkflowVariableValueTypes;
};

export type WorkflowActionFieldFilterInput = {
  and?: InputMaybe<Array<WorkflowActionFieldFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  fieldType?: InputMaybe<WorkflowFieldTypeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isParticipantField?: InputMaybe<BooleanOperationFilterInput>;
  localizedName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WorkflowActionFieldFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  required?: InputMaybe<BooleanOperationFilterInput>;
  variableType?: InputMaybe<WorkflowVariableValueTypesOperationFilterInput>;
};

export type WorkflowActionFieldSortInput = {
  description?: InputMaybe<SortEnumType>;
  fieldType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isParticipantField?: InputMaybe<SortEnumType>;
  localizedName?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
  required?: InputMaybe<SortEnumType>;
  variableType?: InputMaybe<SortEnumType>;
};

export type WorkflowActionFieldValue = {
  __typename?: 'WorkflowActionFieldValue';
  fieldId: Scalars['UUID']['output'];
  id: Scalars['Int']['output'];
  value?: Maybe<WorkflowVariable>;
  workflowActionId?: Maybe<Scalars['Int']['output']>;
};

export type WorkflowActionFieldValueFilterInput = {
  and?: InputMaybe<Array<WorkflowActionFieldValueFilterInput>>;
  field?: InputMaybe<WorkflowActionFieldFilterInput>;
  fieldId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isConfigured?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkflowActionFieldValueFilterInput>>;
  value?: InputMaybe<WorkflowVariableFilterInput>;
  valueId?: InputMaybe<IntOperationFilterInput>;
  workflowAction?: InputMaybe<WorkflowActionConfigurationFilterInput>;
  workflowActionId?: InputMaybe<IntOperationFilterInput>;
};

export enum WorkflowActionStatus {
  Completed = 'Completed',
  Error = 'Error',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  Stopped = 'Stopped'
}

export type WorkflowConfigurationError = Error & {
  __typename?: 'WorkflowConfigurationError';
  message: Scalars['String']['output'];
};

export type WorkflowDefinition = {
  __typename?: 'WorkflowDefinition';
  allActions: Array<WorkflowActionConfiguration>;
  createdBy?: Maybe<ApplicationUser>;
  createdById: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  projectId?: Maybe<Scalars['Int']['output']>;
  rootAction?: Maybe<WorkflowActionConfiguration>;
  rootActionId: Scalars['Int']['output'];
  variables: Array<WorkflowVariable>;
};

export type WorkflowDefinitionFilterInput = {
  and?: InputMaybe<Array<WorkflowDefinitionFilterInput>>;
  createdBy?: InputMaybe<ApplicationUserFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WorkflowDefinitionFilterInput>>;
};

export type WorkflowDefinitionSortInput = {
  createdBy?: InputMaybe<ApplicationUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<ApplicationUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  project?: InputMaybe<ProjectSortInput>;
  projectId?: InputMaybe<SortEnumType>;
  rootAction?: InputMaybe<WorkflowActionConfigurationSortInput>;
  rootActionId?: InputMaybe<SortEnumType>;
};

export type WorkflowExecutionFatalError = Error & {
  __typename?: 'WorkflowExecutionFatalError';
  correlationId: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  workflowInstanceId: Scalars['Int']['output'];
};

export enum WorkflowFieldType {
  Configuration = 'Configuration',
  InteractiveInput = 'InteractiveInput',
  OutputOnly = 'OutputOnly'
}

export type WorkflowFieldTypeOperationFilterInput = {
  eq?: InputMaybe<WorkflowFieldType>;
  in?: InputMaybe<Array<WorkflowFieldType>>;
  neq?: InputMaybe<WorkflowFieldType>;
  nin?: InputMaybe<Array<WorkflowFieldType>>;
};

export type WorkflowInstance = {
  __typename?: 'WorkflowInstance';
  completedOn?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<ApplicationUser>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['DateTime']['output'];
  errorCorrelationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['Int']['output'];
  rootAction?: Maybe<WorkflowActionConfiguration>;
  rootActionId: Scalars['Int']['output'];
  stoppedBy?: Maybe<ApplicationUser>;
  stoppedById?: Maybe<Scalars['String']['output']>;
  stoppedOn?: Maybe<Scalars['DateTime']['output']>;
  variables: Array<WorkflowVariable>;
  workFlowStatus: WorkFlowStatus;
  workflowDefinitionId?: Maybe<Scalars['Int']['output']>;
};

export type WorkflowInstanceFilterInput = {
  and?: InputMaybe<Array<WorkflowInstanceFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WorkflowInstanceFilterInput>>;
  projectId?: InputMaybe<IntOperationFilterInput>;
  rootAction?: InputMaybe<WorkflowActionConfigurationFilterInput>;
  rootActionId?: InputMaybe<IntOperationFilterInput>;
  workFlowStatus?: InputMaybe<WorkFlowStatusOperationFilterInput>;
};

export type WorkflowInstanceSortInput = {
  completedOn?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<ApplicationUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  errorCorrelationId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<ApplicationUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  project?: InputMaybe<ProjectSortInput>;
  projectId?: InputMaybe<SortEnumType>;
  rootAction?: InputMaybe<WorkflowActionConfigurationSortInput>;
  rootActionId?: InputMaybe<SortEnumType>;
  stoppedBy?: InputMaybe<ApplicationUserSortInput>;
  stoppedById?: InputMaybe<SortEnumType>;
  stoppedOn?: InputMaybe<SortEnumType>;
  workFlowStatus?: InputMaybe<SortEnumType>;
  workflowDefinition?: InputMaybe<WorkflowDefinitionSortInput>;
  workflowDefinitionId?: InputMaybe<SortEnumType>;
};

export type WorkflowValidationError = {
  __typename?: 'WorkflowValidationError';
  actionId: Scalars['Int']['output'];
  fieldId: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
};

export type WorkflowVariable = {
  __typename?: 'WorkflowVariable';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  serializedValue?: Maybe<Scalars['String']['output']>;
  variableType: WorkflowVariableType;
  variableValueType: WorkflowVariableValueTypes;
};

export type WorkflowVariableFilterInput = {
  actionFieldValues?: InputMaybe<ListFilterInputTypeOfWorkflowActionFieldValueFilterInput>;
  and?: InputMaybe<Array<WorkflowVariableFilterInput>>;
  documentValue?: InputMaybe<DocumentFilterInput>;
  documentValueId?: InputMaybe<IntOperationFilterInput>;
  formTemplate?: InputMaybe<FormTemplateFilterInput>;
  formTemplateId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  meetingType?: InputMaybe<MeetingTypeFilterInput>;
  meetingTypeId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WorkflowVariableFilterInput>>;
  projectForm?: InputMaybe<ProjectFormFilterInput>;
  projectFormId?: InputMaybe<IntOperationFilterInput>;
  serializedValue?: InputMaybe<StringOperationFilterInput>;
  variableType?: InputMaybe<WorkflowVariableTypeOperationFilterInput>;
  variableValueType?: InputMaybe<WorkflowVariableValueTypesOperationFilterInput>;
};

export type WorkflowVariableInput = {
  serializedValue?: InputMaybe<Scalars['String']['input']>;
  variableId: Scalars['Int']['input'];
};

export enum WorkflowVariableType {
  LocalVariable = 'LocalVariable',
  OutputVariable = 'OutputVariable',
  WorkflowVariable = 'WorkflowVariable'
}

export type WorkflowVariableTypeOperationFilterInput = {
  eq?: InputMaybe<WorkflowVariableType>;
  in?: InputMaybe<Array<WorkflowVariableType>>;
  neq?: InputMaybe<WorkflowVariableType>;
  nin?: InputMaybe<Array<WorkflowVariableType>>;
};

export enum WorkflowVariableValueTypes {
  DateAndTime = 'DateAndTime',
  DateOnly = 'DateOnly',
  Decimal = 'Decimal',
  Document = 'Document',
  DocumentSignatureCoordinates = 'DocumentSignatureCoordinates',
  FormSubmission = 'FormSubmission',
  FormTemplate = 'FormTemplate',
  Integer = 'Integer',
  MeetingType = 'MeetingType',
  SignatureRequest = 'SignatureRequest',
  SignatureRequestStatus = 'SignatureRequestStatus',
  String = 'String',
  User = 'User'
}

export type WorkflowVariableValueTypesOperationFilterInput = {
  eq?: InputMaybe<WorkflowVariableValueTypes>;
  in?: InputMaybe<Array<WorkflowVariableValueTypes>>;
  neq?: InputMaybe<WorkflowVariableValueTypes>;
  nin?: InputMaybe<Array<WorkflowVariableValueTypes>>;
};

export enum WorkflowsPermission {
  LimitedAccess = 'LimitedAccess',
  Manage = 'Manage'
}

export type ZohoSignatureCoordinatesInput = {
  page: Scalars['Int']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type FormPresenceUpdatedSubscriptionVariables = Exact<{
  submissionId: Scalars['Int']['input'];
}>;


export type FormPresenceUpdatedSubscription = { __typename?: 'Subscription', formPresenceUpdated: Array<{ __typename?: 'ProjectFormPresence', uniqueClientId: string, userId: string, displayName: string, fieldId?: number | null, matrixColumnId?: number | null, matrixRowId?: number | null }> };

export type FormValueEditedSubscriptionVariables = Exact<{
  submissionId: Scalars['Int']['input'];
}>;


export type FormValueEditedSubscription = { __typename?: 'Subscription', formValueEdited: { __typename?: 'FormValueEditedEvent', initiatorUniqueClientId: string, formValue: { __typename?: 'FormValue', id: number, fieldId: number, text?: string | null, number?: any | null, boolean?: boolean | null, dateValue?: any | null, selectedOptions: Array<{ __typename?: 'SelectionFieldOption', id: number }>, matrixRows: Array<{ __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> }>, documents: Array<{ __typename?: 'Document', id: number, fileName: string, thumbnailStatus: DocumentThumbnailStatus }> } } };

export type MatrixRowEventSubscriptionVariables = Exact<{
  submissionId: Scalars['Int']['input'];
}>;


export type MatrixRowEventSubscription = { __typename?: 'Subscription', matrixRowEvent: { __typename?: 'MatrixRowEvent', id: number, initiatorUniqueClientId: string, eventType: MatrixRowEventType } };

export type MatrixValueEditedSubscriptionVariables = Exact<{
  submissionId: Scalars['Int']['input'];
}>;


export type MatrixValueEditedSubscription = { __typename?: 'Subscription', matrixValueEdited: { __typename?: 'MatrixValueEditedEvent', initiatorUniqueClientId: string, matrixValue: { __typename?: 'MatrixValue', id: number, matrixRowId: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null } } };

export type ProvisioningStatusChangedSubscriptionVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type ProvisioningStatusChangedSubscription = { __typename?: 'Subscription', provisioningStatusChanged: ProvisioningStatus };

export type StartTrialMutationVariables = Exact<{
  input: StartTrialInput;
}>;


export type StartTrialMutation = { __typename?: 'Mutation', startTrial: { __typename?: 'StartTrialPayload', tenant?: { __typename?: 'Tenant', id: string } | null, errors?: Array<
      | { __typename?: 'DuplicateNameError', message: string }
      | { __typename?: 'MissingConfigurationError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type UpdateMyPreferencesMutationVariables = Exact<{
  input: UpdateMyPreferencesInput;
}>;


export type UpdateMyPreferencesMutation = { __typename?: 'Mutation', updateMyPreferences: { __typename?: 'UpdateMyPreferencesPayload', errors?: Array<{ __typename?: 'NotFoundError', message: string }> | null } };

export type TenantSubscriptionDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantSubscriptionDetailsQuery = { __typename?: 'Query', tenantSubscriptionDetails: { __typename?: 'AppSubscriptionModel', hasSubscription: boolean, trialDaysRemaining?: number | null, subscription?: { __typename?: 'AppSubscription', asOfDate: any, status?: SubscriptionStatus | null, trialEnd?: any | null, subscriptionProvider: SubscriptionProvider } | null } };

export type UpdateBrandingConfigurationMutationVariables = Exact<{
  input: UpdateBrandingConfigurationInput;
}>;


export type UpdateBrandingConfigurationMutation = { __typename?: 'Mutation', updateBrandingConfiguration: { __typename?: 'UpdateBrandingConfigurationPayload', tenantSettings?: { __typename?: 'TenantSettings', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type ReorderBudgetItemMutationVariables = Exact<{
  input: ReorderBudgetItemInput;
}>;


export type ReorderBudgetItemMutation = { __typename?: 'Mutation', reorderBudgetItem: { __typename?: 'ReorderBudgetItemPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type ReorderCostItemMutationVariables = Exact<{
  input: ReorderCostItemInput;
}>;


export type ReorderCostItemMutation = { __typename?: 'Mutation', reorderCostItem: { __typename?: 'ReorderCostItemPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type ReorderCostItemEntryMutationVariables = Exact<{
  input: ReorderCostItemEntryInput;
}>;


export type ReorderCostItemEntryMutation = { __typename?: 'Mutation', reorderCostItemEntry: { __typename?: 'ReorderCostItemEntryPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type CreateCommercialProjectCalculatorMutationVariables = Exact<{
  input: CreateCommercialProjectCalculatorInput;
}>;


export type CreateCommercialProjectCalculatorMutation = { __typename?: 'Mutation', createCommercialProjectCalculator: { __typename?: 'CreateCommercialProjectCalculatorPayload', commercialProjectCalculator?: { __typename?: 'CommercialProjectCalculator', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type DuplicateCommercialCalculatorMutationVariables = Exact<{
  input: DuplicateCommercialProjectCalculatorInput;
}>;


export type DuplicateCommercialCalculatorMutation = { __typename?: 'Mutation', duplicateCommercialProjectCalculator: { __typename?: 'DuplicateCommercialProjectCalculatorPayload', commercialProjectCalculator?: { __typename?: 'CommercialProjectCalculator', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type RemoveCommercialProjectCalculatorMutationVariables = Exact<{
  input: RemoveCommercialProjectCalculatorInput;
}>;


export type RemoveCommercialProjectCalculatorMutation = { __typename?: 'Mutation', removeCommercialProjectCalculator: { __typename?: 'RemoveCommercialProjectCalculatorPayload', commercialProjectCalculator?: { __typename?: 'CommercialProjectCalculator', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type UpdateCommercialProjectCalculatorMutationVariables = Exact<{
  input: UpdateCommercialProjectCalculatorInput;
}>;


export type UpdateCommercialProjectCalculatorMutation = { __typename?: 'Mutation', updateCommercialProjectCalculator: { __typename?: 'UpdateCommercialProjectCalculatorPayload', commercialProjectCalculator?: { __typename?: 'CommercialProjectCalculator', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type CommercialProjectCalculatorQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  calculatorId: Scalars['Int']['input'];
}>;


export type CommercialProjectCalculatorQuery = { __typename?: 'Query', commercialProjectCalculator?: { __typename?: 'CommercialProjectCalculator', id: number, name: string, jsonData: string } | null };

export type CommercialProjectCalculatorsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
}>;


export type CommercialProjectCalculatorsQuery = { __typename?: 'Query', commercialProjectCalculators: Array<{ __typename?: 'CommercialProjectCalculator', id: number, name: string }> };

export type TenantSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantSettingsQuery = { __typename?: 'Query', tenantSettings: { __typename?: 'TenantSettings', isConstructionAddonEnabled: boolean, isSignDocumentByZohoEnabled: boolean, remainingZohoSignatureRequests: number, isWhiteLabelEnabled: boolean, primaryColor?: string | null, secondaryColor?: string | null } };

export type TenantThemeQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantThemeQuery = { __typename?: 'Query', tenantTheme: { __typename?: 'TenantTheme', name: string, primaryColor?: string | null, secondaryColor?: string | null, isBrandingEnabled: boolean, topBarLogoLightUrl?: string | null, topBarLogoDarkUrl?: string | null, loginBackgroundUrl?: string | null, faviconUrl?: string | null, squareLogoLightUrl?: string | null, squareLogoDarkUrl?: string | null } };

export type AddBudgetItemMutationVariables = Exact<{
  input: AddBudgetItemInput;
}>;


export type AddBudgetItemMutation = { __typename?: 'Mutation', addBudgetItem: { __typename?: 'AddBudgetItemPayload', budgetItem?: { __typename?: 'BudgetItem', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteBudgetItemMutationVariables = Exact<{
  input: DeleteBudgetItemInput;
}>;


export type DeleteBudgetItemMutation = { __typename?: 'Mutation', deleteBudgetItem: { __typename?: 'DeleteBudgetItemPayload', budgetItem?: { __typename?: 'BudgetItem', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type EditBudgetItemMutationVariables = Exact<{
  input: EditBudgetItemInput;
}>;


export type EditBudgetItemMutation = { __typename?: 'Mutation', editBudgetItem: { __typename?: 'EditBudgetItemPayload', budgetItem?: { __typename?: 'BudgetItem', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type AddCostItemMutationVariables = Exact<{
  input: AddCostItemInput;
}>;


export type AddCostItemMutation = { __typename?: 'Mutation', addCostItem: { __typename?: 'AddCostItemPayload', costItem?: { __typename?: 'CostItem', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteCostItemMutationVariables = Exact<{
  input: DeleteCostItemInput;
}>;


export type DeleteCostItemMutation = { __typename?: 'Mutation', deleteCostItem: { __typename?: 'DeleteCostItemPayload', costItem?: { __typename?: 'CostItem', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type EditCostItemMutationVariables = Exact<{
  input: EditCostItemInput;
}>;


export type EditCostItemMutation = { __typename?: 'Mutation', editCostItem: { __typename?: 'EditCostItemPayload', costItem?: { __typename?: 'CostItem', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type AddExpenseMutationVariables = Exact<{
  input: AddExpenseInput;
}>;


export type AddExpenseMutation = { __typename?: 'Mutation', addExpense: { __typename?: 'AddExpensePayload', expense?: { __typename?: 'Expense', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteExpenseMutationVariables = Exact<{
  input: DeleteExpenseInput;
}>;


export type DeleteExpenseMutation = { __typename?: 'Mutation', deleteExpense: { __typename?: 'DeleteExpensePayload', expense?: { __typename?: 'Expense', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteExpenseAttachmentMutationVariables = Exact<{
  input: DeleteExpenseAttachmentInput;
}>;


export type DeleteExpenseAttachmentMutation = { __typename?: 'Mutation', deleteExpenseAttachment: { __typename?: 'DeleteExpenseAttachmentPayload', expense?: { __typename?: 'Expense', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string }> | null } };

export type EditExpenseMutationVariables = Exact<{
  input: EditExpenseInput;
}>;


export type EditExpenseMutation = { __typename?: 'Mutation', editExpense: { __typename?: 'EditExpensePayload', expense?: { __typename?: 'Expense', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteQuoteAttachmentMutationVariables = Exact<{
  input: DeleteQuoteAttachmentInput;
}>;


export type DeleteQuoteAttachmentMutation = { __typename?: 'Mutation', deleteQuoteAttachment: { __typename?: 'DeleteQuoteAttachmentPayload', quote?: { __typename?: 'Quote', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string }> | null } };

export type BudgetItemFragmentFragment = { __typename?: 'BudgetItem', id: number, name: string, budgetedAmount: any, order: number, costItems: Array<{ __typename?: 'CostItem', id: number, name: string, plannedAmount: any, status: CostItemStatus, order: number, effectiveAmount: any, budgetItem?: { __typename?: 'BudgetItem', id: number } | null, entries: Array<{ __typename?: 'CostItemEntry', id: number, type: CostItemEntryType, order: number, costItemId: number, expense?: { __typename?: 'Expense', name: string, id: number, expendedAmount: any, expenseDate: any, status: ExpenseStatus, quoteId?: number | null, attachments: Array<{ __typename?: 'Document', id: number, fileName: string, thumbnailStatus: DocumentThumbnailStatus }> } | null, quote?: { __typename?: 'Quote', id: number, name: string, amount: any, quoteDate: any, attachments: Array<{ __typename?: 'Document', id: number, fileName: string, thumbnailStatus: DocumentThumbnailStatus }>, expenses: Array<{ __typename?: 'Expense', id: number, name: string, expendedAmount: any, expenseDate: any, status: ExpenseStatus, quoteId?: number | null, attachments: Array<{ __typename?: 'Document', id: number, fileName: string, thumbnailStatus: DocumentThumbnailStatus }> }> } | null }> }> };

export type BudgetItemsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
}>;


export type BudgetItemsQuery = { __typename?: 'Query', budgetItems: Array<{ __typename?: 'BudgetItem', id: number, name: string, budgetedAmount: any, order: number, costItems: Array<{ __typename?: 'CostItem', id: number, name: string, plannedAmount: any, status: CostItemStatus, order: number, effectiveAmount: any, budgetItem?: { __typename?: 'BudgetItem', id: number } | null, entries: Array<{ __typename?: 'CostItemEntry', id: number, type: CostItemEntryType, order: number, costItemId: number, expense?: { __typename?: 'Expense', name: string, id: number, expendedAmount: any, expenseDate: any, status: ExpenseStatus, quoteId?: number | null, attachments: Array<{ __typename?: 'Document', id: number, fileName: string, thumbnailStatus: DocumentThumbnailStatus }> } | null, quote?: { __typename?: 'Quote', id: number, name: string, amount: any, quoteDate: any, attachments: Array<{ __typename?: 'Document', id: number, fileName: string, thumbnailStatus: DocumentThumbnailStatus }>, expenses: Array<{ __typename?: 'Expense', id: number, name: string, expendedAmount: any, expenseDate: any, status: ExpenseStatus, quoteId?: number | null, attachments: Array<{ __typename?: 'Document', id: number, fileName: string, thumbnailStatus: DocumentThumbnailStatus }> }> } | null }> }> }> };

export type CostItemsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  filter?: InputMaybe<CostItemFilterInput>;
}>;


export type CostItemsQuery = { __typename?: 'Query', costItems: Array<{ __typename?: 'CostItem', id: number, name: string, plannedAmount: any, budgetItem?: { __typename?: 'BudgetItem', id: number, name: string } | null, entries: Array<{ __typename?: 'CostItemEntry', quote?: { __typename?: 'Quote', id: number, amount: any, quoteDate: any, name: string } | null, expense?: { __typename?: 'Expense', id: number, expendedAmount: any, expenseDate: any, status: ExpenseStatus } | null }> }> };

export type ExpenseFragmentFragment = { __typename?: 'Expense', id: number, name: string, status: ExpenseStatus, expendedAmount: any, expenseDate: any, quoteId?: number | null, quote?: { __typename?: 'Quote', id: number, name: string, amount: any, quoteDate: any, attachments: Array<{ __typename?: 'Document', id: number, fileName: string, thumbnailStatus: DocumentThumbnailStatus }> } | null, entry?: { __typename?: 'CostItemEntry', costItem?: { __typename?: 'CostItem', id: number, name: string, status: CostItemStatus, order: number, budgetItem?: { __typename?: 'BudgetItem', id: number, name: string, order: number } | null } | null } | null, attachments: Array<{ __typename?: 'Document', id: number, fileName: string, thumbnailStatus: DocumentThumbnailStatus }> };

export type ExpensesQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  filter?: InputMaybe<ExpenseFilterInput>;
}>;


export type ExpensesQuery = { __typename?: 'Query', expenses: Array<{ __typename?: 'Expense', id: number, name: string, status: ExpenseStatus, expendedAmount: any, expenseDate: any, quoteId?: number | null, quote?: { __typename?: 'Quote', id: number, name: string, amount: any, quoteDate: any, attachments: Array<{ __typename?: 'Document', id: number, fileName: string, thumbnailStatus: DocumentThumbnailStatus }> } | null, entry?: { __typename?: 'CostItemEntry', costItem?: { __typename?: 'CostItem', id: number, name: string, status: CostItemStatus, order: number, budgetItem?: { __typename?: 'BudgetItem', id: number, name: string, order: number } | null } | null } | null, attachments: Array<{ __typename?: 'Document', id: number, fileName: string, thumbnailStatus: DocumentThumbnailStatus }> }> };

export type GetProjectBudgetQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetProjectBudgetQuery = { __typename?: 'Query', projectBudget: { __typename?: 'ProjectBudget', totalBudgetedAmount: any, totalEffectiveAmount: any, budgetOverrun: any } };

export type DeleteDocumentTemplateMutationVariables = Exact<{
  input: DeleteDocumentTemplateInput;
}>;


export type DeleteDocumentTemplateMutation = { __typename?: 'Mutation', deleteDocumentTemplate: { __typename?: 'DeleteDocumentTemplatePayload', documentTemplate?: { __typename?: 'DocumentTemplate', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string }> | null } };

export type EditDocumentTemplateMutationVariables = Exact<{
  input: EditDocumentTemplateInput;
}>;


export type EditDocumentTemplateMutation = { __typename?: 'Mutation', editDocumentTemplate: { __typename?: 'EditDocumentTemplatePayload', documentTemplate?: { __typename?: 'DocumentTemplate', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string }> | null } };

export type DocumentTemplateFragmentFragment = { __typename?: 'DocumentTemplate', id: number, name: string, description?: string | null, fileName: string, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null };

export type DocumentTemplatePermissionsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DocumentTemplatePermissionsQuery = { __typename?: 'Query', documentTemplatePermissions: Array<{ __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null }> };

export type DocumentTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<DocumentTemplateFilterInput>;
}>;


export type DocumentTemplatesQuery = { __typename?: 'Query', documentTemplates: Array<{ __typename?: 'DocumentTemplate', id: number, name: string, description?: string | null, fileName: string, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null }> };

export type SendSignatureRequestMutationVariables = Exact<{
  input: SendSignatureRequestInput;
}>;


export type SendSignatureRequestMutation = { __typename?: 'Mutation', sendSignatureRequest: { __typename?: 'SendSignatureRequestPayload', document?: { __typename?: 'Document', id: number } | null, errors?: Array<
      | { __typename?: 'ElectronicSignatureProviderError', message: string }
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type PublishDocumentMutationVariables = Exact<{
  input: PublishDocumentInput;
}>;


export type PublishDocumentMutation = { __typename?: 'Mutation', publishDocument: { __typename?: 'PublishDocumentPayload', document?: { __typename?: 'Document', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string }> | null } };

export type RemoveDocumentMutationVariables = Exact<{
  input: RemoveDocumentInput;
}>;


export type RemoveDocumentMutation = { __typename?: 'Mutation', removeDocument: { __typename?: 'RemoveDocumentPayload', errors?: Array<{ __typename?: 'NotFoundError', message: string }> | null } };

export type CancelSignatureRequestMutationVariables = Exact<{
  input: CancelSignatureRequestInput;
}>;


export type CancelSignatureRequestMutation = { __typename?: 'Mutation', cancelSignatureRequest: { __typename?: 'CancelSignatureRequestPayload', document?: { __typename?: 'Document', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type RenameDocumentMutationVariables = Exact<{
  input: RenameDocumentInput;
}>;


export type RenameDocumentMutation = { __typename?: 'Mutation', renameDocument: { __typename?: 'RenameDocumentPayload', document?: { __typename?: 'Document', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string }> | null } };

export type SignDocumentMutationVariables = Exact<{
  input: SignDocumentInput;
}>;


export type SignDocumentMutation = { __typename?: 'Mutation', signDocument: { __typename?: 'SignDocumentPayload', document?: { __typename?: 'Document', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
      | { __typename: 'WorkflowExecutionFatalError', message: string, correlationId: any }
    > | null } };

export type UnpublishDocumentMutationVariables = Exact<{
  input: UnpublishDocumentInput;
}>;


export type UnpublishDocumentMutation = { __typename?: 'Mutation', unpublishDocument: { __typename?: 'UnpublishDocumentPayload', document?: { __typename?: 'Document', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string }> | null } };

export type DocumentFragmentFragment = { __typename?: 'Document', id: number, fileName: string, projectId: number, createdOn: any, signatoryCustomerId?: string | null, signedOn?: any | null, isSigned: boolean, textualSignature?: string | null, modifiedOn: any, requiresSignatures: boolean, imageThumbnailUrl?: string | null, thumbnailStatus: DocumentThumbnailStatus, zohoRequestId?: string | null, zohoActionId?: string | null, publicSlug?: string | null, isPublic: boolean, formValueId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, signatoryCustomer?: { __typename?: 'ApplicationUser', fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string } | null } | null, signatureTask?: { __typename?: 'ProjectTask', startDate?: any | null, dueDate?: any | null } | null, signatureRequest?: { __typename?: 'SignatureRequest', signatureStatus: SignatureStatus, requestId: string, expiresOn: any } | null };

export type FilePickerDocumentFragmentFragment = { __typename?: 'Document', id: number, fileName: string, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string, name: string, folderType: FolderType } | null } | null };

export type FilePickerDocumentsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  filter?: InputMaybe<DocumentFilterInput>;
}>;


export type FilePickerDocumentsQuery = { __typename?: 'Query', projectDocuments: Array<{ __typename?: 'Document', id: number, fileName: string, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string, name: string, folderType: FolderType } | null } | null }> };

export type GetDocumentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  filter?: InputMaybe<DocumentFilterInput>;
}>;


export type GetDocumentQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: number, fileName: string, projectId: number, createdOn: any, signatoryCustomerId?: string | null, signedOn?: any | null, isSigned: boolean, textualSignature?: string | null, modifiedOn: any, requiresSignatures: boolean, imageThumbnailUrl?: string | null, thumbnailStatus: DocumentThumbnailStatus, zohoRequestId?: string | null, zohoActionId?: string | null, publicSlug?: string | null, isPublic: boolean, formValueId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, signatoryCustomer?: { __typename?: 'ApplicationUser', fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string } | null } | null, signatureTask?: { __typename?: 'ProjectTask', startDate?: any | null, dueDate?: any | null } | null, signatureRequest?: { __typename?: 'SignatureRequest', signatureStatus: SignatureStatus, requestId: string, expiresOn: any } | null } | null };

export type GetMembersWithAccessTokensByDocumentQueryVariables = Exact<{
  documentId: Scalars['Int']['input'];
}>;


export type GetMembersWithAccessTokensByDocumentQuery = { __typename?: 'Query', users: Array<{ __typename?: 'ApplicationUser', id: string }> };

export type ZohoEmbedUrlQueryVariables = Exact<{
  actionId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
}>;


export type ZohoEmbedUrlQuery = { __typename?: 'Query', zohoEmbedUrl: string };

export type ProjectDocumentsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  filter?: InputMaybe<DocumentFilterInput>;
}>;


export type ProjectDocumentsQuery = { __typename?: 'Query', projectDocuments: Array<{ __typename?: 'Document', id: number, fileName: string, projectId: number, createdOn: any, signatoryCustomerId?: string | null, signedOn?: any | null, isSigned: boolean, textualSignature?: string | null, modifiedOn: any, requiresSignatures: boolean, imageThumbnailUrl?: string | null, thumbnailStatus: DocumentThumbnailStatus, zohoRequestId?: string | null, zohoActionId?: string | null, publicSlug?: string | null, isPublic: boolean, formValueId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, signatoryCustomer?: { __typename?: 'ApplicationUser', fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string } | null } | null, signatureTask?: { __typename?: 'ProjectTask', startDate?: any | null, dueDate?: any | null } | null, signatureRequest?: { __typename?: 'SignatureRequest', signatureStatus: SignatureStatus, requestId: string, expiresOn: any } | null }> };

export type FeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagsQuery = { __typename?: 'Query', featureFlags: { __typename?: 'FeatureFlags', documentTemplatesEnabled: boolean } };

export type AddExternalLinkMutationVariables = Exact<{
  input: AddExternalLinkInput;
}>;


export type AddExternalLinkMutation = { __typename?: 'Mutation', addExternalLink: { __typename?: 'AddExternalLinkPayload', externalLink?: { __typename?: 'ExternalLink', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type AddFolderMutationVariables = Exact<{
  input: AddFolderInput;
}>;


export type AddFolderMutation = { __typename?: 'Mutation', addFolder: { __typename?: 'AddFolderPayload', folder?: { __typename?: 'Folder', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type DeleteExternalLinkMutationVariables = Exact<{
  input: DeleteExternalLinkInput;
}>;


export type DeleteExternalLinkMutation = { __typename?: 'Mutation', deleteExternalLink: { __typename?: 'DeleteExternalLinkPayload', externalLink?: { __typename?: 'ExternalLink', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type DeleteFolderMutationVariables = Exact<{
  input: DeleteFolderInput;
}>;


export type DeleteFolderMutation = { __typename?: 'Mutation', deleteFolder: { __typename?: 'DeleteFolderPayload', folder?: { __typename?: 'Folder', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type MoveFolderEntryMutationVariables = Exact<{
  input: MoveFolderEntryInput;
}>;


export type MoveFolderEntryMutation = { __typename?: 'Mutation', moveFolderEntry: { __typename?: 'MoveFolderEntryPayload', folderEntry?: { __typename?: 'FolderEntry', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type MoveFolderMutationVariables = Exact<{
  input: MoveFolderInput;
}>;


export type MoveFolderMutation = { __typename?: 'Mutation', moveFolder: { __typename?: 'MoveFolderPayload', folder?: { __typename?: 'Folder', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type RenameFolderMutationVariables = Exact<{
  input: RenameFolderInput;
}>;


export type RenameFolderMutation = { __typename?: 'Mutation', renameFolder: { __typename?: 'RenameFolderPayload', folder?: { __typename?: 'Folder', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type ExternalLinkFragmentFragment = { __typename?: 'ExternalLink', id: number, name: string, link: string, modifiedOn: any, createdOn: any, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number } | null };

export type FolderEntryFragmentFragment = { __typename?: 'FolderEntry', id: number, folderId: number, document?: { __typename?: 'Document', id: number, fileName: string, projectId: number, createdOn: any, signatoryCustomerId?: string | null, signedOn?: any | null, isSigned: boolean, textualSignature?: string | null, modifiedOn: any, requiresSignatures: boolean, imageThumbnailUrl?: string | null, thumbnailStatus: DocumentThumbnailStatus, zohoRequestId?: string | null, zohoActionId?: string | null, publicSlug?: string | null, isPublic: boolean, formValueId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, signatoryCustomer?: { __typename?: 'ApplicationUser', fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string } | null } | null, signatureTask?: { __typename?: 'ProjectTask', startDate?: any | null, dueDate?: any | null } | null, signatureRequest?: { __typename?: 'SignatureRequest', signatureStatus: SignatureStatus, requestId: string, expiresOn: any } | null } | null, externalLink?: { __typename?: 'ExternalLink', id: number, name: string, link: string, modifiedOn: any, createdOn: any, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number } | null } | null };

export type FolderFragmentFragment = { __typename?: 'Folder', id: number, name: string, parentFolderId?: number | null, projectId: number, modifiedOn: any, path: string, folderType: FolderType };

export type ChildFoldersQueryVariables = Exact<{
  parentFolderId: Scalars['Int']['input'];
}>;


export type ChildFoldersQuery = { __typename?: 'Query', childFolders: Array<{ __typename?: 'Folder', id: number, name: string, parentFolderId?: number | null, projectId: number, modifiedOn: any, path: string, folderType: FolderType }> };

export type DocumentPermissionsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  documentId: Scalars['Int']['input'];
}>;


export type DocumentPermissionsQuery = { __typename?: 'Query', documentPermissions: Array<{ __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null }> };

export type ExternalLinkPermissionsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  linkId: Scalars['Int']['input'];
}>;


export type ExternalLinkPermissionsQuery = { __typename?: 'Query', externalLinkPermissions: Array<{ __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null }> };

export type FolderEntriesQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  folderId: Scalars['Int']['input'];
  filter?: InputMaybe<FolderEntryFilterInput>;
}>;


export type FolderEntriesQuery = { __typename?: 'Query', folderEntries: Array<{ __typename?: 'FolderEntry', id: number, folderId: number, document?: { __typename?: 'Document', id: number, fileName: string, projectId: number, createdOn: any, signatoryCustomerId?: string | null, signedOn?: any | null, isSigned: boolean, textualSignature?: string | null, modifiedOn: any, requiresSignatures: boolean, imageThumbnailUrl?: string | null, thumbnailStatus: DocumentThumbnailStatus, zohoRequestId?: string | null, zohoActionId?: string | null, publicSlug?: string | null, isPublic: boolean, formValueId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, signatoryCustomer?: { __typename?: 'ApplicationUser', fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string } | null } | null, signatureTask?: { __typename?: 'ProjectTask', startDate?: any | null, dueDate?: any | null } | null, signatureRequest?: { __typename?: 'SignatureRequest', signatureStatus: SignatureStatus, requestId: string, expiresOn: any } | null } | null, externalLink?: { __typename?: 'ExternalLink', id: number, name: string, link: string, modifiedOn: any, createdOn: any, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number } | null } | null }> };

export type FolderEntryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FolderEntryQuery = { __typename?: 'Query', folderEntry?: { __typename?: 'FolderEntry', id: number, folderId: number, document?: { __typename?: 'Document', id: number, fileName: string, projectId: number, createdOn: any, signatoryCustomerId?: string | null, signedOn?: any | null, isSigned: boolean, textualSignature?: string | null, modifiedOn: any, requiresSignatures: boolean, imageThumbnailUrl?: string | null, thumbnailStatus: DocumentThumbnailStatus, zohoRequestId?: string | null, zohoActionId?: string | null, publicSlug?: string | null, isPublic: boolean, formValueId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, signatoryCustomer?: { __typename?: 'ApplicationUser', fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string } | null } | null, signatureTask?: { __typename?: 'ProjectTask', startDate?: any | null, dueDate?: any | null } | null, signatureRequest?: { __typename?: 'SignatureRequest', signatureStatus: SignatureStatus, requestId: string, expiresOn: any } | null } | null, externalLink?: { __typename?: 'ExternalLink', id: number, name: string, link: string, modifiedOn: any, createdOn: any, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number } | null } | null } | null };

export type FolderImageDocumentsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  folderId: Scalars['Int']['input'];
}>;


export type FolderImageDocumentsQuery = { __typename?: 'Query', folderEntries: Array<{ __typename?: 'FolderEntry', document?: { __typename?: 'Document', id: number, imageThumbnailUrl?: string | null, fileName: string, thumbnailStatus: DocumentThumbnailStatus } | null }> };

export type FolderPermissionsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  folderId: Scalars['Int']['input'];
}>;


export type FolderPermissionsQuery = { __typename?: 'Query', folderPermissions: Array<{ __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null }> };

export type FolderPropertiesQueryVariables = Exact<{
  folderId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
}>;


export type FolderPropertiesQuery = { __typename?: 'Query', folder?: { __typename?: 'Folder', id: number, name: string, folderType: FolderType, path: string, entries: Array<{ __typename?: 'FolderEntry', id: number }> } | null };

export type ProjectFolderMyPermissionsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  folderId: Scalars['Int']['input'];
}>;


export type ProjectFolderMyPermissionsQuery = { __typename?: 'Query', folder?: { __typename?: 'Folder', id: number, myPermissions: Array<BuiltInRoles> } | null };

export type ProjectFoldersQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  filter?: InputMaybe<FolderFilterInput>;
}>;


export type ProjectFoldersQuery = { __typename?: 'Query', projectFolders: Array<{ __typename?: 'Folder', id: number, name: string, parentFolderId?: number | null, projectId: number, modifiedOn: any, path: string, folderType: FolderType }> };

export type ProjectFormPermissionsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  formId: Scalars['Int']['input'];
}>;


export type ProjectFormPermissionsQuery = { __typename?: 'Query', projectFormPermissions: Array<{ __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null }> };

export type CollectFormResponsesMutationVariables = Exact<{
  input: CollectFormResponsesInput;
}>;


export type CollectFormResponsesMutation = { __typename?: 'Mutation', collectFormResponses: { __typename?: 'CollectFormResponsesPayload', projectForm?: { __typename?: 'ProjectForm', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type AddFormConditionMutationVariables = Exact<{
  input: AddConditionInput;
}>;


export type AddFormConditionMutation = { __typename?: 'Mutation', addCondition: { __typename?: 'AddConditionPayload', formCondition?: { __typename?: 'FormCondition', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteFormConditionMutationVariables = Exact<{
  input: DeleteConditionInput;
}>;


export type DeleteFormConditionMutation = { __typename?: 'Mutation', deleteCondition: { __typename?: 'DeleteConditionPayload', formCondition?: { __typename?: 'FormCondition', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type EditFormConditionMutationVariables = Exact<{
  input: EditConditionInput;
}>;


export type EditFormConditionMutation = { __typename?: 'Mutation', editCondition: { __typename?: 'EditConditionPayload', formCondition?: { __typename?: 'FormCondition', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type EditFormDefinitionMutationVariables = Exact<{
  input: EditFormDefinitionInput;
}>;


export type EditFormDefinitionMutation = { __typename?: 'Mutation', editFormDefinition: { __typename?: 'EditFormDefinitionPayload', formDefinition?: { __typename?: 'FormDefinition', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type CreateFormFieldMutationVariables = Exact<{
  input: CreateFormFieldInput;
}>;


export type CreateFormFieldMutation = { __typename?: 'Mutation', createFormField: { __typename?: 'CreateFormFieldPayload', formField?: { __typename?: 'FormField', id: number, name: string, fieldType: FieldType, isRequired: boolean, isMultiline: boolean, isMultiselect: boolean, shouldUploadDocumentsToFolder: boolean, documentUploadFolderId?: number | null, options: Array<{ __typename?: 'SelectionFieldOption', id: number, label: string }>, matrix?: { __typename?: 'Matrix', id: number, columns: Array<{ __typename?: 'MatrixColumn', id: number, order: number, fieldType: MatrixColumnType, name: string, description?: string | null, isRequired: boolean }>, defaultRows: Array<{ __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> }> } | null } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteFormFieldMutationVariables = Exact<{
  input: DeleteFormFieldInput;
}>;


export type DeleteFormFieldMutation = { __typename?: 'Mutation', deleteFormField: { __typename?: 'DeleteFormFieldPayload', formField?: { __typename?: 'FormField', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type EditFormFieldMutationVariables = Exact<{
  input: EditFormFieldInput;
}>;


export type EditFormFieldMutation = { __typename?: 'Mutation', editFormField: { __typename?: 'EditFormFieldPayload', formField?: { __typename?: 'FormField', id: number, name: string, fieldType: FieldType, isRequired: boolean, isMultiline: boolean, isMultiselect: boolean, shouldUploadDocumentsToFolder: boolean, documentUploadFolderId?: number | null, options: Array<{ __typename?: 'SelectionFieldOption', id: number, label: string }>, matrix?: { __typename?: 'Matrix', id: number, columns: Array<{ __typename?: 'MatrixColumn', id: number, order: number, fieldType: MatrixColumnType, name: string, description?: string | null, isRequired: boolean }>, defaultRows: Array<{ __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> }> } | null } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type MoveFormFieldMutationVariables = Exact<{
  input: MoveFormFieldInput;
}>;


export type MoveFormFieldMutation = { __typename?: 'Mutation', moveFormField: { __typename?: 'MoveFormFieldPayload', formField?: { __typename?: 'FormField', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type FillFormMutationVariables = Exact<{
  input: FillFormInput;
}>;


export type FillFormMutation = { __typename?: 'Mutation', fillForm: { __typename?: 'FillFormPayload', projectFormSubmission?: { __typename?: 'ProjectFormSubmission', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type AddMatrixRowMutationVariables = Exact<{
  input: AddMatrixRowInput;
}>;


export type AddMatrixRowMutation = { __typename?: 'Mutation', addMatrixRow: { __typename?: 'AddMatrixRowPayload', matrixRow?: { __typename?: 'MatrixRow', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type FillMatrixValueMutationVariables = Exact<{
  input: FillMatrixValueInput;
}>;


export type FillMatrixValueMutation = { __typename?: 'Mutation', fillMatrixValue: { __typename?: 'FillMatrixValuePayload', matrixValue?: { __typename?: 'MatrixValue', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type RemoveFileAttachmentMutationVariables = Exact<{
  input: DeleteFormAttachmentInput;
}>;


export type RemoveFileAttachmentMutation = { __typename?: 'Mutation', deleteFormAttachment: { __typename?: 'DeleteFormAttachmentPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type RemoveMatrixRowMutationVariables = Exact<{
  input: RemoveMatrixRowInput;
}>;


export type RemoveMatrixRowMutation = { __typename?: 'Mutation', removeMatrixRow: { __typename?: 'RemoveMatrixRowPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type RemoveFormPresenceMutationVariables = Exact<{
  input: RemovePresenceInput;
}>;


export type RemoveFormPresenceMutation = { __typename?: 'Mutation', removePresence: { __typename?: 'RemovePresencePayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type UpdateFormPresenceMutationVariables = Exact<{
  input: UpdatePresenceInput;
}>;


export type UpdateFormPresenceMutation = { __typename?: 'Mutation', updatePresence: { __typename?: 'UpdatePresencePayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteSubmissionMutationVariables = Exact<{
  input: DeleteFormSubmissionInput;
}>;


export type DeleteSubmissionMutation = { __typename?: 'Mutation', deleteFormSubmission: { __typename?: 'DeleteFormSubmissionPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteRequestMutationVariables = Exact<{
  input: DeleteRequestInput;
}>;


export type DeleteRequestMutation = { __typename?: 'Mutation', deleteRequest: { __typename?: 'DeleteRequestPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type AddProjectFormMutationVariables = Exact<{
  input: AddProjectFormInput;
}>;


export type AddProjectFormMutation = { __typename?: 'Mutation', addProjectForm: { __typename?: 'AddProjectFormPayload', projectForm?: { __typename?: 'ProjectForm', id: number, formDefinition?: { __typename?: 'FormDefinition', id: number } | null } | null } };

export type AddProjectFormFromTemplateMutationVariables = Exact<{
  input: AddProjectFormFromTemplateInput;
}>;


export type AddProjectFormFromTemplateMutation = { __typename?: 'Mutation', addProjectFormFromTemplate: { __typename?: 'AddProjectFormFromTemplatePayload', projectForm?: { __typename?: 'ProjectForm', id: number } | null } };

export type DeleteProjectFormMutationVariables = Exact<{
  input: DeleteProjectFormInput;
}>;


export type DeleteProjectFormMutation = { __typename?: 'Mutation', deleteProjectForm: { __typename?: 'DeleteProjectFormPayload', errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type FillFormValueMutationVariables = Exact<{
  input: FillFormValueInput;
}>;


export type FillFormValueMutation = { __typename?: 'Mutation', fillFormValue: { __typename?: 'FillFormValuePayload', formValue?: { __typename?: 'FormValue', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type PublishFormMutationVariables = Exact<{
  input: PublishFormInput;
}>;


export type PublishFormMutation = { __typename?: 'Mutation', publishForm: { __typename?: 'PublishFormPayload', projectForm?: { __typename?: 'ProjectForm', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type RequestFormSubmissionMutationVariables = Exact<{
  input: RequestFormSubmissionInput;
}>;


export type RequestFormSubmissionMutation = { __typename?: 'Mutation', requestFormSubmission: { __typename?: 'RequestFormSubmissionPayload', projectFormSubmission?: { __typename?: 'ProjectFormSubmission', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type RequestFormSubmissionAnonymousMutationVariables = Exact<{
  input: RequestFormSubmissionAnonymousInput;
}>;


export type RequestFormSubmissionAnonymousMutation = { __typename?: 'Mutation', requestFormSubmissionAnonymous: { __typename?: 'RequestFormSubmissionAnonymousPayload', projectFormSubmission?: { __typename?: 'ProjectFormSubmission', id: number } | null, errors?: Array<
      | { __typename?: 'AccessTokenExpiredError', message: string }
      | { __typename?: 'AccessTokenInvalidError', message: string }
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type CreateFormSectionMutationVariables = Exact<{
  input: CreateFormSectionInput;
}>;


export type CreateFormSectionMutation = { __typename?: 'Mutation', createFormSection: { __typename?: 'CreateFormSectionPayload', formSection?: { __typename?: 'FormSection', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteFormSectionMutationVariables = Exact<{
  input: DeleteFormSectionInput;
}>;


export type DeleteFormSectionMutation = { __typename?: 'Mutation', deleteFormSection: { __typename?: 'DeleteFormSectionPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type EditFormSectionMutationVariables = Exact<{
  input: EditFormSectionInput;
}>;


export type EditFormSectionMutation = { __typename?: 'Mutation', editFormSection: { __typename?: 'EditFormSectionPayload', formSection?: { __typename?: 'FormSection', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type ReorderFormSectionsMutationVariables = Exact<{
  input: ReorderFormSectionsInput;
}>;


export type ReorderFormSectionsMutation = { __typename?: 'Mutation', reorderFormSections: { __typename?: 'ReorderFormSectionsPayload', formDefinition?: { __typename?: 'FormDefinition', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type CreateFormTemplateMutationVariables = Exact<{
  input: FormDefinitionInput;
}>;


export type CreateFormTemplateMutation = { __typename?: 'Mutation', createFormTemplate: { __typename?: 'CreateFormTemplatePayload', formTemplate?: { __typename?: 'FormTemplate', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type CreateTemplateFromProjectFormMutationVariables = Exact<{
  input: CreateTemplateFromProjectFormInput;
}>;


export type CreateTemplateFromProjectFormMutation = { __typename?: 'Mutation', createTemplateFromProjectForm: { __typename?: 'CreateTemplateFromProjectFormPayload', formTemplate?: { __typename?: 'FormTemplate', id: number } | null } };

export type DeleteFormTemplateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFormTemplateMutation = { __typename?: 'Mutation', deleteFormTemplate: { __typename?: 'DeleteFormTemplatePayload', formTemplate?: { __typename?: 'FormTemplate', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type DuplicateFormTemplateMutationVariables = Exact<{
  input: DuplicateFormTemplateInput;
}>;


export type DuplicateFormTemplateMutation = { __typename?: 'Mutation', duplicateFormTemplate: { __typename?: 'DuplicateFormTemplatePayload', formTemplate?: { __typename?: 'FormTemplate', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type RemoveTemplateRoleAssignmentMutationVariables = Exact<{
  input: RemoveFormTemplateRoleAssignmentInput;
}>;


export type RemoveTemplateRoleAssignmentMutation = { __typename?: 'Mutation', removeFormTemplateRoleAssignment: { __typename?: 'RemoveFormTemplateRoleAssignmentPayload', roleAssignment?: { __typename?: 'RoleAssignment', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type SendSharingTemplateNotificationMutationVariables = Exact<{
  input: SendSharingTemplateNotificationInput;
}>;


export type SendSharingTemplateNotificationMutation = { __typename?: 'Mutation', sendSharingTemplateNotification: { __typename?: 'SendSharingTemplateNotificationPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type UnpublishFormMutationVariables = Exact<{
  input: UnpublishFormInput;
}>;


export type UnpublishFormMutation = { __typename?: 'Mutation', unpublishForm: { __typename?: 'UnpublishFormPayload', projectForm?: { __typename?: 'ProjectForm', id: number } | null, errors?: Array<{ __typename?: 'ValidationResultError', message: string }> | null } };

export type UpdateFormSettingsMutationVariables = Exact<{
  input: UpdateFormSettingsInput;
}>;


export type UpdateFormSettingsMutation = { __typename?: 'Mutation', updateFormSettings: { __typename?: 'UpdateFormSettingsPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type FormAllowedUsersFragmentFragment = { __typename?: 'ProjectForm', allowedUsers: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, formSettings: { __typename?: 'FormSettings', allowedUsersRespondents: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, allowedSecurityGroupsRespondents: Array<{ __typename?: 'SecurityGroup', members: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> } };

export type PreviewProjectFormQueryVariables = Exact<{
  projectFormId: Scalars['Int']['input'];
}>;


export type PreviewProjectFormQuery = { __typename?: 'Query', projectForm?: { __typename?: 'ProjectForm', formDefinition?: { __typename?: 'FormDefinition', id: number, name: string, description?: string | null, sections: Array<{ __typename?: 'FormSection', id: number, name: string, fields: Array<{ __typename?: 'FormField', id: number, name: string, fieldType: FieldType, isRequired: boolean, isMultiline: boolean, isMultiselect: boolean, shouldUploadDocumentsToFolder: boolean, documentUploadFolderId?: number | null, options: Array<{ __typename?: 'SelectionFieldOption', id: number, label: string }>, matrix?: { __typename?: 'Matrix', id: number, columns: Array<{ __typename?: 'MatrixColumn', id: number, order: number, fieldType: MatrixColumnType, name: string, description?: string | null, isRequired: boolean }>, defaultRows: Array<{ __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> }> } | null }> }>, conditions: Array<{ __typename?: 'FormCondition', id: number, formId: number, trigger: { __typename?: 'ConditionTrigger', id: number, sourceFieldId: number, valueEquality?: { __typename?: 'ConditionTriggerValueEquality', boolean?: boolean | null } | null }, effect: { __typename?: 'ConditionEffect', targetFieldId?: number | null, targetSectionId?: number | null, visibility?: { __typename?: 'ConditionEffectVisibility', visible: boolean } | null } }> } | null } | null };

export type ProjectFormQueryVariables = Exact<{
  formId: Scalars['Int']['input'];
  filter?: InputMaybe<ProjectFormFilterInput>;
}>;


export type ProjectFormQuery = { __typename?: 'Query', projectForm?: { __typename?: 'ProjectForm', id: number, projectId: number, status: FormStatus, publishedOn?: any | null, createdOn: any, createdBy?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string } | null, formSettings: { __typename?: 'FormSettings', id: number, allowedRespondents: AllowedRespondents, formType: FormType, allowedUsersRespondents: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string, business?: string | null, title?: string | null, email: string }>, allowedSecurityGroupsRespondents: Array<{ __typename?: 'SecurityGroup', id: string, name: string, members: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> }, formDefinition?: { __typename?: 'FormDefinition', name: string } | null, project?: { __typename?: 'Project', name: string, isArchived: boolean } | null, allowedUsers: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null };

export type ProjectFormDefinitionQueryVariables = Exact<{
  formId: Scalars['Int']['input'];
  filter?: InputMaybe<ProjectFormFilterInput>;
}>;


export type ProjectFormDefinitionQuery = { __typename?: 'Query', projectForm?: { __typename?: 'ProjectForm', formDefinition?: { __typename?: 'FormDefinition', id: number, name: string, description?: string | null, sections: Array<{ __typename?: 'FormSection', id: number, name: string, fields: Array<{ __typename?: 'FormField', id: number, name: string, fieldType: FieldType, isRequired: boolean, isMultiline: boolean, isMultiselect: boolean, shouldUploadDocumentsToFolder: boolean, documentUploadFolderId?: number | null, options: Array<{ __typename?: 'SelectionFieldOption', id: number, label: string }>, matrix?: { __typename?: 'Matrix', id: number, columns: Array<{ __typename?: 'MatrixColumn', id: number, order: number, fieldType: MatrixColumnType, name: string, description?: string | null, isRequired: boolean }>, defaultRows: Array<{ __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> }> } | null }> }>, conditions: Array<{ __typename?: 'FormCondition', id: number, formId: number, trigger: { __typename?: 'ConditionTrigger', id: number, sourceFieldId: number, valueEquality?: { __typename?: 'ConditionTriggerValueEquality', boolean?: boolean | null } | null }, effect: { __typename?: 'ConditionEffect', targetFieldId?: number | null, targetSectionId?: number | null, visibility?: { __typename?: 'ConditionEffectVisibility', visible: boolean } | null } }> } | null } | null };

export type ProjectFormOverviewsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  filter?: InputMaybe<ProjectFormFilterInput>;
}>;


export type ProjectFormOverviewsQuery = { __typename?: 'Query', projectFormOverviews: Array<{ __typename?: 'ProjectFormOverview', id: number, formName: string, status: FormStatus, publishedOn?: any | null, createdOn?: any | null, createdBy: string, submissionsCount: number, formSettings: { __typename?: 'FormSettings', formType: FormType, allowedRespondents: AllowedRespondents, allowedUsersRespondents: Array<{ __typename?: 'ApplicationUser', id: string }>, allowedSecurityGroupsRespondents: Array<{ __typename?: 'SecurityGroup', members: Array<{ __typename?: 'ApplicationUser', id: string }> }> } }> };

export type ProjectFormSettingsQueryVariables = Exact<{
  formId: Scalars['Int']['input'];
}>;


export type ProjectFormSettingsQuery = { __typename?: 'Query', projectFormSettings?: { __typename?: 'FormSettings', id: number, allowedRespondents: AllowedRespondents, formType: FormType, allowedSecurityGroupsRespondents: Array<{ __typename?: 'SecurityGroup', id: string, name: string }>, allowedUsersRespondents: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string, business?: string | null, title?: string | null, email: string }> } | null };

export type ProjectFormSettingsFragmentFragment = { __typename?: 'FormSettings', id: number, allowedRespondents: AllowedRespondents, formType: FormType, allowedSecurityGroupsRespondents: Array<{ __typename?: 'SecurityGroup', id: string, name: string }>, allowedUsersRespondents: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string, business?: string | null, title?: string | null, email: string }> };

export type ProjectFormsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  filter?: InputMaybe<ProjectFormFilterInput>;
}>;


export type ProjectFormsQuery = { __typename?: 'Query', projectForms: Array<{ __typename?: 'ProjectForm', id: number, projectId: number, status: FormStatus, publishedOn?: any | null, createdOn: any, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, formSettings: { __typename?: 'FormSettings', id: number, allowedRespondents: AllowedRespondents, formType: FormType, allowedSecurityGroupsRespondents: Array<{ __typename?: 'SecurityGroup', id: string, name: string }>, allowedUsersRespondents: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string, business?: string | null, title?: string | null, email: string }> }, formDefinition?: { __typename?: 'FormDefinition', id: number, name: string, description?: string | null } | null, project?: { __typename?: 'Project', isArchived: boolean } | null }> };

export type FormDefinitionFragmentFragment = { __typename?: 'FormDefinition', id: number, name: string, description?: string | null, sections: Array<{ __typename?: 'FormSection', id: number, name: string, fields: Array<{ __typename?: 'FormField', id: number, name: string, fieldType: FieldType, isRequired: boolean, isMultiline: boolean, isMultiselect: boolean, shouldUploadDocumentsToFolder: boolean, documentUploadFolderId?: number | null, options: Array<{ __typename?: 'SelectionFieldOption', id: number, label: string }>, matrix?: { __typename?: 'Matrix', id: number, columns: Array<{ __typename?: 'MatrixColumn', id: number, order: number, fieldType: MatrixColumnType, name: string, description?: string | null, isRequired: boolean }>, defaultRows: Array<{ __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> }> } | null }> }>, conditions: Array<{ __typename?: 'FormCondition', id: number, formId: number, trigger: { __typename?: 'ConditionTrigger', id: number, sourceFieldId: number, valueEquality?: { __typename?: 'ConditionTriggerValueEquality', boolean?: boolean | null } | null }, effect: { __typename?: 'ConditionEffect', targetFieldId?: number | null, targetSectionId?: number | null, visibility?: { __typename?: 'ConditionEffectVisibility', visible: boolean } | null } }> };

export type FormFieldFragmentFragment = { __typename?: 'FormField', id: number, name: string, fieldType: FieldType, isRequired: boolean, isMultiline: boolean, isMultiselect: boolean, shouldUploadDocumentsToFolder: boolean, documentUploadFolderId?: number | null, options: Array<{ __typename?: 'SelectionFieldOption', id: number, label: string }>, matrix?: { __typename?: 'Matrix', id: number, columns: Array<{ __typename?: 'MatrixColumn', id: number, order: number, fieldType: MatrixColumnType, name: string, description?: string | null, isRequired: boolean }>, defaultRows: Array<{ __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> }> } | null };

export type FormValueFragmentFragment = { __typename?: 'FormValue', id: number, fieldId: number, text?: string | null, number?: any | null, boolean?: boolean | null, dateValue?: any | null, selectedOptions: Array<{ __typename?: 'SelectionFieldOption', id: number }>, matrixRows: Array<{ __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> }>, documents: Array<{ __typename?: 'Document', id: number, fileName: string, thumbnailStatus: DocumentThumbnailStatus }> };

export type GetMembersWithAccessTokensByFormQueryVariables = Exact<{
  projectFormId: Scalars['Int']['input'];
}>;


export type GetMembersWithAccessTokensByFormQuery = { __typename?: 'Query', users: Array<{ __typename?: 'ApplicationUser', id: string }> };

export type MatrixFragmentFragment = { __typename?: 'Matrix', id: number, columns: Array<{ __typename?: 'MatrixColumn', id: number, order: number, fieldType: MatrixColumnType, name: string, description?: string | null, isRequired: boolean }>, defaultRows: Array<{ __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> }> };

export type MatrixRowFragmentFragment = { __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> };

export type FormFillerPresenceQueryVariables = Exact<{
  formSubmissionId: Scalars['Int']['input'];
}>;


export type FormFillerPresenceQuery = { __typename?: 'Query', formPresences: Array<{ __typename?: 'ProjectFormPresence', uniqueClientId: string, userId: string, displayName: string, fieldId?: number | null, matrixRowId?: number | null, matrixColumnId?: number | null }> };

export type ProjectFormSubmissionQueryVariables = Exact<{
  submissionId: Scalars['Int']['input'];
}>;


export type ProjectFormSubmissionQuery = { __typename?: 'Query', projectFormSubmission?: { __typename?: 'ProjectFormSubmission', id: number, projectFormId?: number | null, belongsToUserId?: string | null, submittedOn?: any | null, status: SubmissionStatus, formValues: Array<{ __typename?: 'FormValue', id: number, fieldId: number, text?: string | null, number?: any | null, boolean?: boolean | null, dateValue?: any | null, selectedOptions: Array<{ __typename?: 'SelectionFieldOption', id: number }>, matrixRows: Array<{ __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> }>, documents: Array<{ __typename?: 'Document', id: number, fileName: string, thumbnailStatus: DocumentThumbnailStatus }> }>, formDefinition?: { __typename?: 'FormDefinition', name: string, id: number, description?: string | null, sections: Array<{ __typename?: 'FormSection', id: number, name: string, fields: Array<{ __typename?: 'FormField', id: number, name: string, fieldType: FieldType, isRequired: boolean, isMultiline: boolean, isMultiselect: boolean, shouldUploadDocumentsToFolder: boolean, documentUploadFolderId?: number | null, options: Array<{ __typename?: 'SelectionFieldOption', id: number, label: string }>, matrix?: { __typename?: 'Matrix', id: number, columns: Array<{ __typename?: 'MatrixColumn', id: number, order: number, fieldType: MatrixColumnType, name: string, description?: string | null, isRequired: boolean }>, defaultRows: Array<{ __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> }> } | null }> }>, conditions: Array<{ __typename?: 'FormCondition', id: number, formId: number, trigger: { __typename?: 'ConditionTrigger', id: number, sourceFieldId: number, valueEquality?: { __typename?: 'ConditionTriggerValueEquality', boolean?: boolean | null } | null }, effect: { __typename?: 'ConditionEffect', targetFieldId?: number | null, targetSectionId?: number | null, visibility?: { __typename?: 'ConditionEffectVisibility', visible: boolean } | null } }> } | null, belongsToUser?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, projectForm?: { __typename?: 'ProjectForm', formDefinition?: { __typename?: 'FormDefinition', name: string } | null } | null } | null };

export type ProjectFormSubmissionFragmentFragment = { __typename?: 'ProjectFormSubmission', id: number, projectFormId?: number | null, belongsToUserId?: string | null, submittedOn?: any | null, status: SubmissionStatus, belongsToUser?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, projectForm?: { __typename?: 'ProjectForm', formDefinition?: { __typename?: 'FormDefinition', name: string } | null } | null, formDefinition?: { __typename?: 'FormDefinition', name: string } | null };

export type ProjectFormSubmissionsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  formId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProjectFormSubmissionFilterInput>;
}>;


export type ProjectFormSubmissionsQuery = { __typename?: 'Query', projectFormSubmissions: Array<{ __typename?: 'ProjectFormSubmission', id: number, projectFormId?: number | null, belongsToUserId?: string | null, submittedOn?: any | null, status: SubmissionStatus, attachments: Array<{ __typename?: 'Document', id: number, fileName: string }>, belongsToUser?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, projectForm?: { __typename?: 'ProjectForm', formDefinition?: { __typename?: 'FormDefinition', name: string } | null } | null, formDefinition?: { __typename?: 'FormDefinition', name: string } | null }> };

export type FormTemplateQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FormTemplateQuery = { __typename?: 'Query', formTemplate?: { __typename?: 'FormTemplate', id: number, createdOn: any, createdById: string, formDefinition?: { __typename?: 'FormDefinition', name: string, id: number, description?: string | null, sections: Array<{ __typename?: 'FormSection', id: number, name: string, fields: Array<{ __typename?: 'FormField', id: number, name: string, fieldType: FieldType, isRequired: boolean, isMultiline: boolean, isMultiselect: boolean, shouldUploadDocumentsToFolder: boolean, documentUploadFolderId?: number | null, options: Array<{ __typename?: 'SelectionFieldOption', id: number, label: string }>, matrix?: { __typename?: 'Matrix', id: number, columns: Array<{ __typename?: 'MatrixColumn', id: number, order: number, fieldType: MatrixColumnType, name: string, description?: string | null, isRequired: boolean }>, defaultRows: Array<{ __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> }> } | null }> }>, conditions: Array<{ __typename?: 'FormCondition', id: number, formId: number, trigger: { __typename?: 'ConditionTrigger', id: number, sourceFieldId: number, valueEquality?: { __typename?: 'ConditionTriggerValueEquality', boolean?: boolean | null } | null }, effect: { __typename?: 'ConditionEffect', targetFieldId?: number | null, targetSectionId?: number | null, visibility?: { __typename?: 'ConditionEffectVisibility', visible: boolean } | null } }> } | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, roleAssignments: Array<{ __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null }> } | null };

export type FormTemplateForEditorQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FormTemplateForEditorQuery = { __typename?: 'Query', formTemplate?: { __typename?: 'FormTemplate', id: number, createdOn: any, createdById: string, formDefinition?: { __typename?: 'FormDefinition', name: string, id: number, description?: string | null, sections: Array<{ __typename?: 'FormSection', id: number, name: string, fields: Array<{ __typename?: 'FormField', id: number, name: string, fieldType: FieldType, isRequired: boolean, isMultiline: boolean, isMultiselect: boolean, shouldUploadDocumentsToFolder: boolean, documentUploadFolderId?: number | null, options: Array<{ __typename?: 'SelectionFieldOption', id: number, label: string }>, matrix?: { __typename?: 'Matrix', id: number, columns: Array<{ __typename?: 'MatrixColumn', id: number, order: number, fieldType: MatrixColumnType, name: string, description?: string | null, isRequired: boolean }>, defaultRows: Array<{ __typename?: 'MatrixRow', id: number, isDefaultRow: boolean, values: Array<{ __typename?: 'MatrixValue', id: number, matrixColumnId: number, text?: string | null, number?: any | null, boolean?: boolean | null }> }> } | null }> }>, conditions: Array<{ __typename?: 'FormCondition', id: number, formId: number, trigger: { __typename?: 'ConditionTrigger', id: number, sourceFieldId: number, valueEquality?: { __typename?: 'ConditionTriggerValueEquality', boolean?: boolean | null } | null }, effect: { __typename?: 'ConditionEffect', targetFieldId?: number | null, targetSectionId?: number | null, visibility?: { __typename?: 'ConditionEffectVisibility', visible: boolean } | null } }> } | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, roleAssignments: Array<{ __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null }> } | null };

export type FormTemplateFragmentFragment = { __typename?: 'FormTemplate', id: number, createdOn: any, createdById: string, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, formDefinition?: { __typename?: 'FormDefinition', name: string, description?: string | null } | null, roleAssignments: Array<{ __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null }> };

export type TemplatePermissionsQueryVariables = Exact<{
  formTemplateId: Scalars['Int']['input'];
}>;


export type TemplatePermissionsQuery = { __typename?: 'Query', formTemplatePermissions: Array<{ __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null }> };

export type FormTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<FormTemplateFilterInput>;
}>;


export type FormTemplatesQuery = { __typename?: 'Query', formTemplates: Array<{ __typename?: 'FormTemplate', id: number, createdOn: any, createdById: string, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, formDefinition?: { __typename?: 'FormDefinition', name: string, description?: string | null } | null, roleAssignments: Array<{ __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null }> }> };

export type AcceptMeetingRequestMutationVariables = Exact<{
  input: AcceptMeetingRequestInput;
}>;


export type AcceptMeetingRequestMutation = { __typename?: 'Mutation', acceptMeetingRequest: { __typename?: 'AcceptMeetingRequestPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type AddMeetingMutationVariables = Exact<{
  input: AddMeetingInput;
}>;


export type AddMeetingMutation = { __typename?: 'Mutation', addMeeting: { __typename?: 'AddMeetingPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type AddMeetingTypeMutationVariables = Exact<{
  input: AddMeetingTypeInput;
}>;


export type AddMeetingTypeMutation = { __typename?: 'Mutation', addMeetingType: { __typename?: 'AddMeetingTypePayload', meetingType?: { __typename?: 'MeetingType', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeclineMeetingRequestMutationVariables = Exact<{
  input: DeclineMeetingRequestInput;
}>;


export type DeclineMeetingRequestMutation = { __typename?: 'Mutation', declineMeetingRequest: { __typename?: 'DeclineMeetingRequestPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteMeetingMutationVariables = Exact<{
  input: DeleteMeetingInput;
}>;


export type DeleteMeetingMutation = { __typename?: 'Mutation', deleteMeeting: { __typename?: 'DeleteMeetingPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteMeetingTypeMutationVariables = Exact<{
  input: DeleteMeetingTypeInput;
}>;


export type DeleteMeetingTypeMutation = { __typename?: 'Mutation', deleteMeetingType: { __typename?: 'DeleteMeetingTypePayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type EditMeetingTypeMutationVariables = Exact<{
  input: EditMeetingTypeInput;
}>;


export type EditMeetingTypeMutation = { __typename?: 'Mutation', editMeetingType: { __typename?: 'EditMeetingTypePayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type MeetingFragmentFragment = { __typename?: 'Meeting', id: number, name: string, description?: string | null, startTime?: any | null, endTime?: any | null, meetingStatus: MeetingStatus, cancellationReason?: string | null, createdById: string, meetingType?: { __typename?: 'MeetingType', duration: any, bookingMethod: BookingMethod, meetingRequestsOwners: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, meetingRequestOwnerGroups: Array<{ __typename?: 'SecurityGroup', id: string, members: Array<{ __typename?: 'ApplicationUser', id: string }> }> } | null, proposals: Array<{ __typename?: 'MeetingProposal', startTime: any }>, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> };

export type CalendarAvailabilitiesQueryVariables = Exact<{
  input: GetCalendarAvailabilitiesInput;
}>;


export type CalendarAvailabilitiesQuery = { __typename?: 'Query', calendarAvailabilities: { __typename?: 'Availabilities', msalUIRequired: boolean, isScheduleAvailable: boolean, isoWorkWeekDays: Array<number>, availableStartTimes: Array<{ __typename?: 'AvailabilityInfo', startTime: any, availability: Availability }> } };

export type MeetingQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  meetingId: Scalars['Int']['input'];
}>;


export type MeetingQuery = { __typename?: 'Query', meeting?: { __typename?: 'Meeting', id: number, name: string, description?: string | null, startTime?: any | null, endTime?: any | null, meetingStatus: MeetingStatus, cancellationReason?: string | null, createdById: string, meetingType?: { __typename?: 'MeetingType', id: number, name: string, description?: string | null, createdOn: any, duration: any, bookingMethod: BookingMethod, meetingRequestsOwners: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, meetingRequestOwnerGroups: Array<{ __typename?: 'SecurityGroup', id: string, members: Array<{ __typename?: 'ApplicationUser', id: string }> }> } | null, proposals: Array<{ __typename?: 'MeetingProposal', id: number, startTime: any, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, acceptedUsers: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, declinedUsers: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }>, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null };

export type MeetingTypeOwnersAvailabilitiesQueryVariables = Exact<{
  input: GetCalendarAvailabilitiesForMeetingTypeInput;
}>;


export type MeetingTypeOwnersAvailabilitiesQuery = { __typename?: 'Query', calendarAvailabilitiesForMeetingType: { __typename?: 'Availabilities', isScheduleAvailable: boolean, msalUIRequired: boolean, isoWorkWeekDays: Array<number>, availableStartTimes: Array<{ __typename?: 'AvailabilityInfo', startTime: any, availability: Availability }> } };

export type MeetingTypesQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
}>;


export type MeetingTypesQuery = { __typename?: 'Query', meetingTypes: Array<{ __typename?: 'MeetingType', id: number, name: string, description?: string | null, duration: any, bookingMethod: BookingMethod, createdOn: any, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, meetingRequestsOwners: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, meetingRequestOwnerGroups: Array<{ __typename?: 'SecurityGroup', id: string, name: string }> }> };

export type MeetingsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  filter?: InputMaybe<MeetingFilterInput>;
}>;


export type MeetingsQuery = { __typename?: 'Query', meetings: Array<{ __typename?: 'Meeting', id: number, name: string, description?: string | null, startTime?: any | null, endTime?: any | null, meetingStatus: MeetingStatus, cancellationReason?: string | null, createdById: string, meetingType?: { __typename?: 'MeetingType', duration: any, bookingMethod: BookingMethod, meetingRequestsOwners: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, meetingRequestOwnerGroups: Array<{ __typename?: 'SecurityGroup', id: string, members: Array<{ __typename?: 'ApplicationUser', id: string }> }> } | null, proposals: Array<{ __typename?: 'MeetingProposal', startTime: any }>, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> };

export type RenewAccessTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type RenewAccessTokenMutation = { __typename?: 'Mutation', renewAccessTokenFromExpiredToken: { __typename?: 'RenewAccessTokenFromExpiredTokenPayload', renewAccessTokenFromExpiredTokenResult?: { __typename?: 'RenewAccessTokenFromExpiredTokenResult', sentToEmail: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type GetTokenPurposeContextQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetTokenPurposeContextQuery = { __typename?: 'Query', tokenPurposeContext?: { __typename?: 'TokenPurposeContextGraphQL', purpose: AccessTokenPurpose, status: TokenStatus, isRenewable: boolean, errorMessage?: string | null, initiatorName?: string | null, actionDescription?: string | null, resourceName?: string | null, customMessage?: string | null, actionUrl?: string | null, projectId: number, projectName?: string | null, documentId?: number | null } | null };

export type AddProjectMutationVariables = Exact<{
  input: AddProjectInput;
}>;


export type AddProjectMutation = { __typename?: 'Mutation', addProject: { __typename?: 'AddProjectPayload', project?: { __typename?: 'Project', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type AddProjectMemberMutationVariables = Exact<{
  input: AddProjectMemberInput;
}>;


export type AddProjectMemberMutation = { __typename?: 'Mutation', addProjectMember: { __typename?: 'AddProjectMemberPayload', project?: { __typename?: 'Project', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type AddProjectTemplateMutationVariables = Exact<{
  input: AddProjectTemplateInput;
}>;


export type AddProjectTemplateMutation = { __typename?: 'Mutation', addProjectTemplate: { __typename?: 'AddProjectTemplatePayload', project?: { __typename?: 'Project', id: number } | null } };

export type CreateProjectFromTemplateMutationVariables = Exact<{
  input: CreateProjectFromTemplateInput;
}>;


export type CreateProjectFromTemplateMutation = { __typename?: 'Mutation', createProjectFromTemplate: { __typename?: 'CreateProjectFromTemplatePayload', project?: { __typename?: 'Project', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteProjectTemplateMutationVariables = Exact<{
  input: DeleteProjectTemplateInput;
}>;


export type DeleteProjectTemplateMutation = { __typename?: 'Mutation', deleteProjectTemplate: { __typename?: 'DeleteProjectTemplatePayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type EditMemberSecurityGroupMutationVariables = Exact<{
  input: EditMemberSecurityGroupInput;
}>;


export type EditMemberSecurityGroupMutation = { __typename?: 'Mutation', editMemberSecurityGroup: { __typename?: 'EditMemberSecurityGroupPayload', applicationUser?: { __typename?: 'ApplicationUser', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type EditProjectMutationVariables = Exact<{
  input: EditProjectInput;
}>;


export type EditProjectMutation = { __typename?: 'Mutation', editProject: { __typename?: 'EditProjectPayload', project?: { __typename?: 'Project', id: number } | null } };

export type EditProjectProgressMutationVariables = Exact<{
  input: EditProjectProgressInput;
}>;


export type EditProjectProgressMutation = { __typename?: 'Mutation', editProjectProgress: { __typename?: 'EditProjectProgressPayload', project?: { __typename?: 'Project', id: number } | null } };

export type ImportFoldersMutationVariables = Exact<{
  input: ImportFoldersInput;
}>;


export type ImportFoldersMutation = { __typename?: 'Mutation', importFolders: { __typename?: 'ImportFoldersPayload', project?: { __typename?: 'Project', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type ImportTasksMutationVariables = Exact<{
  input: ImportTasksInput;
}>;


export type ImportTasksMutation = { __typename?: 'Mutation', importTasks: { __typename?: 'ImportTasksPayload', project?: { __typename?: 'Project', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type AddExternalUserMutationVariables = Exact<{
  input: AddExternalUserInput;
}>;


export type AddExternalUserMutation = { __typename?: 'Mutation', addExternalUser: { __typename?: 'AddExternalUserPayload', applicationUser?: { __typename?: 'ApplicationUser', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type RemoveProjectMemberMutationVariables = Exact<{
  input: RemoveProjectMemberInput;
}>;


export type RemoveProjectMemberMutation = { __typename?: 'Mutation', removeProjectMember: { __typename?: 'RemoveProjectMemberPayload', project?: { __typename?: 'Project', id: number } | null, errors?: Array<{ __typename?: 'NotFoundError', message: string }> | null } };

export type GetMyProjectRolesQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
}>;


export type GetMyProjectRolesQuery = { __typename?: 'Query', project?: { __typename?: 'Project', myRoles: { __typename?: 'MyRoles', roles: Array<BuiltInRoles> }, myPermissions?: { __typename?: 'ProjectPermissions', budgetPermission: BudgetAndExpensesPermission, tasksPermission: TasksPermission, formsPermission: FormsPermission, documentsPermission: DocumentsPermission, managePublicFileSharingPermission: ManagePublicFileSharingPermission, workflowsPermission: WorkflowsPermission } | null } | null };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, name: string, description?: string | null, isArchived: boolean, isTemplate: boolean, createdOn: any, projectProgress: number, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, rootFolder?: { __typename?: 'Folder', id: number, name: string, folderType: FolderType, path: string } | null, securityGroups: Array<{ __typename?: 'SecurityGroup', members: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string, business?: string | null, title?: string | null, email: string }> }> } | null };

export type GetProjectMembersQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  filter?: InputMaybe<ApplicationUserFilterInput>;
}>;


export type GetProjectMembersQuery = { __typename?: 'Query', projectMembers: Array<{ __typename?: 'ApplicationUser', id: string, email: string, title?: string | null, phoneNumber?: string | null, firstName: string, lastName: string, fullName: string, business?: string | null, builtInRoles: Array<BuiltInRoles>, roles: Array<{ __typename?: 'ApplicationRole', name: string }> }> };

export type GetProjectTemplateSummaryInfoQueryVariables = Exact<{
  projectTemplateId: Scalars['Int']['input'];
}>;


export type GetProjectTemplateSummaryInfoQuery = { __typename?: 'Query', projectTemplateSummaryInfo?: { __typename?: 'ProjectTemplateSummary', budgetItemsCount: number, customFoldersCount: number, documentsCount: number, tasksCount: number, meetingTypesCount: number, formsCount: number, securityGroupsCount: number, workflowsCount: number } | null };

export type ProjectMemberFragmentFragment = { __typename?: 'ApplicationUser', id: string, email: string, title?: string | null, phoneNumber?: string | null, firstName: string, lastName: string, fullName: string, business?: string | null, builtInRoles: Array<BuiltInRoles>, roles: Array<{ __typename?: 'ApplicationRole', name: string }> };

export type ProjectTemplatePermissionsQueryVariables = Exact<{
  templateId: Scalars['Int']['input'];
}>;


export type ProjectTemplatePermissionsQuery = { __typename?: 'Query', projectTemplatePermissions: Array<{ __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null }> };

export type GetProjectsQueryVariables = Exact<{
  filter?: InputMaybe<ProjectFilterInput>;
}>;


export type GetProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', id: number, name: string, description?: string | null, isArchived: boolean, isTemplate: boolean, createdById: string, createdOn: any, securityGroups: Array<{ __typename?: 'SecurityGroup', id: string, name: string, members: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> }> };

export type RecentProjectEventsQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Array<ProjectEventSortInput> | ProjectEventSortInput>;
}>;


export type RecentProjectEventsQuery = { __typename?: 'Query', projectEvents?: { __typename?: 'ProjectEventsConnection', edges?: Array<{ __typename?: 'ProjectEventsEdge', cursor: string, node: { __typename?: 'ProjectEvent', id: number, projectId: number, eventType: DomainEventType, eventDate: any, eventTriggeredById: string, formSubmissionId?: number | null, workflowInstanceId?: number | null, workflowActionId?: number | null, meetingId?: number | null, eventTriggeredBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, document?: { __typename?: 'Document', fileName: string, id: number, folderEntry?: { __typename?: 'FolderEntry', folder?: { __typename?: 'Folder', id: number, path: string, name: string } | null } | null } | null, form?: { __typename?: 'ProjectForm', id: number, formDefinition?: { __typename?: 'FormDefinition', name: string } | null } | null, formSubmission?: { __typename?: 'ProjectFormSubmission', formDefinition?: { __typename?: 'FormDefinition', name: string } | null } | null, workflowInstance?: { __typename?: 'WorkflowInstance', id: number, name: string } | null, workflowAction?: { __typename?: 'WorkflowActionConfiguration', id: number, name: string } | null, meeting?: { __typename?: 'Meeting', id: number, name: string, description?: string | null, startTime?: any | null, endTime?: any | null, meetingStatus: MeetingStatus, cancellationReason?: string | null, createdById: string, meetingType?: { __typename?: 'MeetingType', duration: any, bookingMethod: BookingMethod, meetingRequestsOwners: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, meetingRequestOwnerGroups: Array<{ __typename?: 'SecurityGroup', id: string, members: Array<{ __typename?: 'ApplicationUser', id: string }> }> } | null, proposals: Array<{ __typename?: 'MeetingProposal', startTime: any }>, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type AddSecurityGroupMutationVariables = Exact<{
  input: AddSecurityGroupInput;
}>;


export type AddSecurityGroupMutation = { __typename?: 'Mutation', addSecurityGroup: { __typename?: 'AddSecurityGroupPayload', securityGroup?: { __typename?: 'SecurityGroup', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteSecurityGroupMutationVariables = Exact<{
  input: DeleteSecurityGroupInput;
}>;


export type DeleteSecurityGroupMutation = { __typename?: 'Mutation', deleteSecurityGroup: { __typename?: 'DeleteSecurityGroupPayload', securityGroup?: { __typename?: 'SecurityGroup', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type RemoveSecurityGroupMemberMutationVariables = Exact<{
  input: RemoveSecurityGroupMemberInput;
}>;


export type RemoveSecurityGroupMemberMutation = { __typename?: 'Mutation', removeSecurityGroupMember: { __typename?: 'RemoveSecurityGroupMemberPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type SendSharingNotificationForOrganizationResourceMutationVariables = Exact<{
  input: SendSharingNotificationForOrganizationResourceInput;
}>;


export type SendSharingNotificationForOrganizationResourceMutation = { __typename?: 'Mutation', sendSharingNotificationForOrganizationResource: { __typename?: 'SendSharingNotificationForOrganizationResourcePayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type SendSharingNotificationForProjectResourceMutationVariables = Exact<{
  input: SendSharingNotificationForProjectResourceInput;
}>;


export type SendSharingNotificationForProjectResourceMutation = { __typename?: 'Mutation', sendSharingNotificationForProjectResource: { __typename?: 'SendSharingNotificationForProjectResourcePayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type ShareOrganizationResourceMutationVariables = Exact<{
  input: ShareOrganizationResourceInput;
}>;


export type ShareOrganizationResourceMutation = { __typename?: 'Mutation', shareOrganizationResource: { __typename?: 'ShareOrganizationResourcePayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type ShareProjectResourceMutationVariables = Exact<{
  input: ShareProjectResourceInput;
}>;


export type ShareProjectResourceMutation = { __typename?: 'Mutation', shareProjectResource: { __typename?: 'ShareProjectResourcePayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type UnshareOrganizationResourceMutationVariables = Exact<{
  input: UnshareOrganizationResourceInput;
}>;


export type UnshareOrganizationResourceMutation = { __typename?: 'Mutation', unshareOrganizationResource: { __typename?: 'UnshareOrganizationResourcePayload', roleAssignment?: { __typename?: 'RoleAssignment', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type UnshareProjectResourceMutationVariables = Exact<{
  input: UnshareProjectResourceInput;
}>;


export type UnshareProjectResourceMutation = { __typename?: 'Mutation', unshareProjectResource: { __typename?: 'UnshareProjectResourcePayload', roleAssignment?: { __typename?: 'RoleAssignment', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type UpdateSecurityGroupMutationVariables = Exact<{
  input: UpdateSecurityGroupInput;
}>;


export type UpdateSecurityGroupMutation = { __typename?: 'Mutation', updateSecurityGroup: { __typename?: 'UpdateSecurityGroupPayload', securityGroup?: { __typename?: 'SecurityGroup', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type UpdateSecurityGroupRolesMutationVariables = Exact<{
  input: UpdateSecurityGroupRolesInput;
}>;


export type UpdateSecurityGroupRolesMutation = { __typename?: 'Mutation', updateSecurityGroupRoles: { __typename?: 'UpdateSecurityGroupRolesPayload', securityGroup?: { __typename?: 'SecurityGroup', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type SecurityGroupFragmentFragment = { __typename?: 'SecurityGroup', id: string, name: string, description?: string | null, isDefaultProjectAdminGroup: boolean, members: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, business?: string | null, title?: string | null, email: string, builtInRoles: Array<BuiltInRoles>, roles: Array<{ __typename?: 'ApplicationRole', name: string }> }>, permissionAssignments: Array<{ __typename?: 'PermissionAssignment', permissionId: string }>, projectPermissions: { __typename?: 'ProjectPermissions', budgetPermission: BudgetAndExpensesPermission, tasksPermission: TasksPermission, formsPermission: FormsPermission, documentsPermission: DocumentsPermission, workflowsPermission: WorkflowsPermission, managePublicFileSharingPermission: ManagePublicFileSharingPermission } };

export type RoleAssignmentFragmentFragment = { __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null };

export type SecurityGroupQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  securityGroupId: Scalars['String']['input'];
}>;


export type SecurityGroupQuery = { __typename?: 'Query', securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string, description?: string | null, isDefaultProjectAdminGroup: boolean, members: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, business?: string | null, title?: string | null, email: string, builtInRoles: Array<BuiltInRoles>, roles: Array<{ __typename?: 'ApplicationRole', name: string }> }>, permissionAssignments: Array<{ __typename?: 'PermissionAssignment', permissionId: string }>, projectPermissions: { __typename?: 'ProjectPermissions', budgetPermission: BudgetAndExpensesPermission, tasksPermission: TasksPermission, formsPermission: FormsPermission, documentsPermission: DocumentsPermission, workflowsPermission: WorkflowsPermission, managePublicFileSharingPermission: ManagePublicFileSharingPermission } } | null };

export type SecurityGroupForUserInProjectQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
}>;


export type SecurityGroupForUserInProjectQuery = { __typename?: 'Query', securityGroupForUserInProject: Array<{ __typename?: 'SecurityGroup', id: string, name: string, description?: string | null, isDefaultProjectAdminGroup: boolean, members: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, business?: string | null, title?: string | null, email: string, builtInRoles: Array<BuiltInRoles>, roles: Array<{ __typename?: 'ApplicationRole', name: string }> }>, permissionAssignments: Array<{ __typename?: 'PermissionAssignment', permissionId: string }>, projectPermissions: { __typename?: 'ProjectPermissions', budgetPermission: BudgetAndExpensesPermission, tasksPermission: TasksPermission, formsPermission: FormsPermission, documentsPermission: DocumentsPermission, workflowsPermission: WorkflowsPermission, managePublicFileSharingPermission: ManagePublicFileSharingPermission } }> };

export type SecurityGroupsForProjectQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
}>;


export type SecurityGroupsForProjectQuery = { __typename?: 'Query', securityGroupsForProject: Array<{ __typename?: 'SecurityGroup', id: string, name: string, description?: string | null, isDefaultProjectAdminGroup: boolean, members: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, business?: string | null, title?: string | null, email: string, builtInRoles: Array<BuiltInRoles>, roles: Array<{ __typename?: 'ApplicationRole', name: string }> }>, permissionAssignments: Array<{ __typename?: 'PermissionAssignment', permissionId: string }>, projectPermissions: { __typename?: 'ProjectPermissions', budgetPermission: BudgetAndExpensesPermission, tasksPermission: TasksPermission, formsPermission: FormsPermission, documentsPermission: DocumentsPermission, workflowsPermission: WorkflowsPermission, managePublicFileSharingPermission: ManagePublicFileSharingPermission } }> };

export type AllTasksPageQueryQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProjectTaskFilterInput>;
  order?: InputMaybe<Array<ProjectTaskSortInput> | ProjectTaskSortInput>;
}>;


export type AllTasksPageQueryQuery = { __typename?: 'Query', tasks?: { __typename?: 'TasksConnection', totalCount: number, edges?: Array<{ __typename?: 'TasksEdge', cursor: string, node: { __typename?: 'ProjectTask', id: number, startDate?: any | null, dueDate?: any | null, completedOn?: any | null, status: ProjectTaskStatus, type: ProjectTaskType, name?: string | null, description?: string | null, hierarchyPath?: string | null, projectId: number, project?: { __typename?: 'Project', id: number, name: string } | null, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, predecessors: Array<{ __typename?: 'ProjectTask', id: number }>, assignees: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, assigneeGroups: Array<{ __typename?: 'SecurityGroup', id: string, name: string }>, projectForm?: { __typename?: 'ProjectForm', id: number, publishedOn?: any | null, createdOn: any, status: FormStatus, formSettings: { __typename?: 'FormSettings', id: number, allowedRespondents: AllowedRespondents, formType: FormType, allowedUsersRespondents: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string, business?: string | null, title?: string | null, email: string }>, allowedSecurityGroupsRespondents: Array<{ __typename?: 'SecurityGroup', id: string, name: string, members: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> }, formDefinition?: { __typename?: 'FormDefinition', name: string } | null, allowedUsers: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null, document?: { __typename?: 'Document', fileName: string, id: number, projectId: number, createdOn: any, signatoryCustomerId?: string | null, signedOn?: any | null, isSigned: boolean, textualSignature?: string | null, modifiedOn: any, requiresSignatures: boolean, imageThumbnailUrl?: string | null, thumbnailStatus: DocumentThumbnailStatus, zohoRequestId?: string | null, zohoActionId?: string | null, publicSlug?: string | null, isPublic: boolean, formValueId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, signatoryCustomer?: { __typename?: 'ApplicationUser', fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string } | null } | null, signatureTask?: { __typename?: 'ProjectTask', startDate?: any | null, dueDate?: any | null } | null, signatureRequest?: { __typename?: 'SignatureRequest', signatureStatus: SignatureStatus, requestId: string, expiresOn: any } | null } | null } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ProjectPickerProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectPickerProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', id: number, name: string, isTemplate: boolean, isArchived: boolean, myPermissions?: { __typename?: 'ProjectPermissions', tasksPermission: TasksPermission } | null }> };

export type AddTaskMutationVariables = Exact<{
  input: AddTaskInput;
}>;


export type AddTaskMutation = { __typename?: 'Mutation', addTask: { __typename?: 'AddTaskPayload', projectTask?: { __typename?: 'ProjectTask', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteTaskMutationVariables = Exact<{
  projectId: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask: { __typename?: 'DeleteTaskPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type RescheduleTaskMutationVariables = Exact<{
  input: RescheduleTaskInput;
}>;


export type RescheduleTaskMutation = { __typename?: 'Mutation', rescheduleTask: { __typename?: 'RescheduleTaskPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type UpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'UpdateTaskPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type UpdateTaskStatusMutationVariables = Exact<{
  input: UpdateTaskStatusInput;
}>;


export type UpdateTaskStatusMutation = { __typename?: 'Mutation', updateTaskStatus: { __typename?: 'UpdateTaskStatusPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type ProjectTaskFragmentFragment = { __typename?: 'ProjectTask', id: number, startDate?: any | null, dueDate?: any | null, completedOn?: any | null, status: ProjectTaskStatus, type: ProjectTaskType, name?: string | null, description?: string | null, hierarchyPath?: string | null, projectId: number, project?: { __typename?: 'Project', id: number, name: string } | null, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, predecessors: Array<{ __typename?: 'ProjectTask', id: number }>, assignees: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, assigneeGroups: Array<{ __typename?: 'SecurityGroup', id: string, name: string }>, projectForm?: { __typename?: 'ProjectForm', id: number, publishedOn?: any | null, createdOn: any, status: FormStatus, formSettings: { __typename?: 'FormSettings', id: number, allowedRespondents: AllowedRespondents, formType: FormType, allowedUsersRespondents: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string, business?: string | null, title?: string | null, email: string }>, allowedSecurityGroupsRespondents: Array<{ __typename?: 'SecurityGroup', id: string, name: string, members: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> }, formDefinition?: { __typename?: 'FormDefinition', name: string } | null, allowedUsers: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null, document?: { __typename?: 'Document', fileName: string, id: number, projectId: number, createdOn: any, signatoryCustomerId?: string | null, signedOn?: any | null, isSigned: boolean, textualSignature?: string | null, modifiedOn: any, requiresSignatures: boolean, imageThumbnailUrl?: string | null, thumbnailStatus: DocumentThumbnailStatus, zohoRequestId?: string | null, zohoActionId?: string | null, publicSlug?: string | null, isPublic: boolean, formValueId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, signatoryCustomer?: { __typename?: 'ApplicationUser', fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string } | null } | null, signatureTask?: { __typename?: 'ProjectTask', startDate?: any | null, dueDate?: any | null } | null, signatureRequest?: { __typename?: 'SignatureRequest', signatureStatus: SignatureStatus, requestId: string, expiresOn: any } | null } | null };

export type GetTaskNameFragmentFragment = { __typename?: 'ProjectTask', id: number, type: ProjectTaskType, name?: string | null, projectForm?: { __typename?: 'ProjectForm', formDefinition?: { __typename?: 'FormDefinition', name: string } | null } | null, document?: { __typename?: 'Document', fileName: string } | null };

export type MyTasksQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
}>;


export type MyTasksQuery = { __typename?: 'Query', myTasks: Array<{ __typename?: 'ProjectTask', id: number, startDate?: any | null, dueDate?: any | null, completedOn?: any | null, status: ProjectTaskStatus, type: ProjectTaskType, name?: string | null, description?: string | null, hierarchyPath?: string | null, projectId: number, project?: { __typename?: 'Project', id: number, name: string } | null, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, predecessors: Array<{ __typename?: 'ProjectTask', id: number }>, assignees: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, assigneeGroups: Array<{ __typename?: 'SecurityGroup', id: string, name: string }>, projectForm?: { __typename?: 'ProjectForm', id: number, publishedOn?: any | null, createdOn: any, status: FormStatus, formSettings: { __typename?: 'FormSettings', id: number, allowedRespondents: AllowedRespondents, formType: FormType, allowedUsersRespondents: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string, business?: string | null, title?: string | null, email: string }>, allowedSecurityGroupsRespondents: Array<{ __typename?: 'SecurityGroup', id: string, name: string, members: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> }, formDefinition?: { __typename?: 'FormDefinition', name: string } | null, allowedUsers: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null, document?: { __typename?: 'Document', fileName: string, id: number, projectId: number, createdOn: any, signatoryCustomerId?: string | null, signedOn?: any | null, isSigned: boolean, textualSignature?: string | null, modifiedOn: any, requiresSignatures: boolean, imageThumbnailUrl?: string | null, thumbnailStatus: DocumentThumbnailStatus, zohoRequestId?: string | null, zohoActionId?: string | null, publicSlug?: string | null, isPublic: boolean, formValueId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, signatoryCustomer?: { __typename?: 'ApplicationUser', fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string } | null } | null, signatureTask?: { __typename?: 'ProjectTask', startDate?: any | null, dueDate?: any | null } | null, signatureRequest?: { __typename?: 'SignatureRequest', signatureStatus: SignatureStatus, requestId: string, expiresOn: any } | null } | null }> };

export type ParentTaskQueryVariables = Exact<{
  taskId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
}>;


export type ParentTaskQuery = { __typename?: 'Query', parentTask?: { __typename?: 'ProjectTask', id: number, type: ProjectTaskType, name?: string | null, projectForm?: { __typename?: 'ProjectForm', formDefinition?: { __typename?: 'FormDefinition', name: string } | null } | null, document?: { __typename?: 'Document', fileName: string } | null } | null };

export type ProjectTaskQueryVariables = Exact<{
  taskId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
}>;


export type ProjectTaskQuery = { __typename?: 'Query', projectTask?: { __typename?: 'ProjectTask', id: number, startDate?: any | null, dueDate?: any | null, completedOn?: any | null, status: ProjectTaskStatus, type: ProjectTaskType, name?: string | null, description?: string | null, hierarchyPath?: string | null, projectId: number, project?: { __typename?: 'Project', id: number, name: string } | null, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, predecessors: Array<{ __typename?: 'ProjectTask', id: number }>, assignees: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, assigneeGroups: Array<{ __typename?: 'SecurityGroup', id: string, name: string }>, projectForm?: { __typename?: 'ProjectForm', id: number, publishedOn?: any | null, createdOn: any, status: FormStatus, formSettings: { __typename?: 'FormSettings', id: number, allowedRespondents: AllowedRespondents, formType: FormType, allowedUsersRespondents: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string, business?: string | null, title?: string | null, email: string }>, allowedSecurityGroupsRespondents: Array<{ __typename?: 'SecurityGroup', id: string, name: string, members: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> }, formDefinition?: { __typename?: 'FormDefinition', name: string } | null, allowedUsers: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null, document?: { __typename?: 'Document', fileName: string, id: number, projectId: number, createdOn: any, signatoryCustomerId?: string | null, signedOn?: any | null, isSigned: boolean, textualSignature?: string | null, modifiedOn: any, requiresSignatures: boolean, imageThumbnailUrl?: string | null, thumbnailStatus: DocumentThumbnailStatus, zohoRequestId?: string | null, zohoActionId?: string | null, publicSlug?: string | null, isPublic: boolean, formValueId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, signatoryCustomer?: { __typename?: 'ApplicationUser', fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string } | null } | null, signatureTask?: { __typename?: 'ProjectTask', startDate?: any | null, dueDate?: any | null } | null, signatureRequest?: { __typename?: 'SignatureRequest', signatureStatus: SignatureStatus, requestId: string, expiresOn: any } | null } | null } | null };

export type ProjectTaskPermissionsQueryVariables = Exact<{
  taskId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
}>;


export type ProjectTaskPermissionsQuery = { __typename?: 'Query', taskPermissions: Array<{ __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null }> };

export type ProjectTaskSubtasksQueryVariables = Exact<{
  taskId: Scalars['Int']['input'];
  filter?: InputMaybe<ProjectTaskFilterInput>;
}>;


export type ProjectTaskSubtasksQuery = { __typename?: 'Query', projectTaskSubtasks: Array<{ __typename?: 'ProjectTask', id: number, startDate?: any | null, dueDate?: any | null, completedOn?: any | null, status: ProjectTaskStatus, type: ProjectTaskType, name?: string | null, description?: string | null, hierarchyPath?: string | null, projectId: number, project?: { __typename?: 'Project', id: number, name: string } | null, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, predecessors: Array<{ __typename?: 'ProjectTask', id: number }>, assignees: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, assigneeGroups: Array<{ __typename?: 'SecurityGroup', id: string, name: string }>, projectForm?: { __typename?: 'ProjectForm', id: number, publishedOn?: any | null, createdOn: any, status: FormStatus, formSettings: { __typename?: 'FormSettings', id: number, allowedRespondents: AllowedRespondents, formType: FormType, allowedUsersRespondents: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string, business?: string | null, title?: string | null, email: string }>, allowedSecurityGroupsRespondents: Array<{ __typename?: 'SecurityGroup', id: string, name: string, members: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> }, formDefinition?: { __typename?: 'FormDefinition', name: string } | null, allowedUsers: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null, document?: { __typename?: 'Document', fileName: string, id: number, projectId: number, createdOn: any, signatoryCustomerId?: string | null, signedOn?: any | null, isSigned: boolean, textualSignature?: string | null, modifiedOn: any, requiresSignatures: boolean, imageThumbnailUrl?: string | null, thumbnailStatus: DocumentThumbnailStatus, zohoRequestId?: string | null, zohoActionId?: string | null, publicSlug?: string | null, isPublic: boolean, formValueId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, signatoryCustomer?: { __typename?: 'ApplicationUser', fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string } | null } | null, signatureTask?: { __typename?: 'ProjectTask', startDate?: any | null, dueDate?: any | null } | null, signatureRequest?: { __typename?: 'SignatureRequest', signatureStatus: SignatureStatus, requestId: string, expiresOn: any } | null } | null }> };

export type ProjectTasksQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  filter?: InputMaybe<ProjectTaskFilterInput>;
}>;


export type ProjectTasksQuery = { __typename?: 'Query', projectTasks: Array<{ __typename?: 'ProjectTask', id: number, startDate?: any | null, dueDate?: any | null, completedOn?: any | null, status: ProjectTaskStatus, type: ProjectTaskType, name?: string | null, description?: string | null, hierarchyPath?: string | null, projectId: number, predecessors: Array<{ __typename?: 'ProjectTask', id: number }>, project?: { __typename?: 'Project', id: number, name: string } | null, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, assignees: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, assigneeGroups: Array<{ __typename?: 'SecurityGroup', id: string, name: string }>, projectForm?: { __typename?: 'ProjectForm', id: number, publishedOn?: any | null, createdOn: any, status: FormStatus, formSettings: { __typename?: 'FormSettings', id: number, allowedRespondents: AllowedRespondents, formType: FormType, allowedUsersRespondents: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string, business?: string | null, title?: string | null, email: string }>, allowedSecurityGroupsRespondents: Array<{ __typename?: 'SecurityGroup', id: string, name: string, members: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> }, formDefinition?: { __typename?: 'FormDefinition', name: string } | null, allowedUsers: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null, document?: { __typename?: 'Document', fileName: string, id: number, projectId: number, createdOn: any, signatoryCustomerId?: string | null, signedOn?: any | null, isSigned: boolean, textualSignature?: string | null, modifiedOn: any, requiresSignatures: boolean, imageThumbnailUrl?: string | null, thumbnailStatus: DocumentThumbnailStatus, zohoRequestId?: string | null, zohoActionId?: string | null, publicSlug?: string | null, isPublic: boolean, formValueId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, signatoryCustomer?: { __typename?: 'ApplicationUser', fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string } | null } | null, signatureTask?: { __typename?: 'ProjectTask', startDate?: any | null, dueDate?: any | null } | null, signatureRequest?: { __typename?: 'SignatureRequest', signatureStatus: SignatureStatus, requestId: string, expiresOn: any } | null } | null }> };

export type ValidTaskPredecessorsQueryVariables = Exact<{
  taskId: Scalars['Int']['input'];
}>;


export type ValidTaskPredecessorsQuery = { __typename?: 'Query', validPredecessorTasks: Array<{ __typename?: 'ProjectTask', id: number, startDate?: any | null, dueDate?: any | null, completedOn?: any | null, status: ProjectTaskStatus, type: ProjectTaskType, name?: string | null, description?: string | null, hierarchyPath?: string | null, projectId: number, project?: { __typename?: 'Project', id: number, name: string } | null, createdBy?: { __typename?: 'ApplicationUser', id: string, fullName: string } | null, predecessors: Array<{ __typename?: 'ProjectTask', id: number }>, assignees: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }>, assigneeGroups: Array<{ __typename?: 'SecurityGroup', id: string, name: string }>, projectForm?: { __typename?: 'ProjectForm', id: number, publishedOn?: any | null, createdOn: any, status: FormStatus, formSettings: { __typename?: 'FormSettings', id: number, allowedRespondents: AllowedRespondents, formType: FormType, allowedUsersRespondents: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string, business?: string | null, title?: string | null, email: string }>, allowedSecurityGroupsRespondents: Array<{ __typename?: 'SecurityGroup', id: string, name: string, members: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> }, formDefinition?: { __typename?: 'FormDefinition', name: string } | null, allowedUsers: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null, document?: { __typename?: 'Document', fileName: string, id: number, projectId: number, createdOn: any, signatoryCustomerId?: string | null, signedOn?: any | null, isSigned: boolean, textualSignature?: string | null, modifiedOn: any, requiresSignatures: boolean, imageThumbnailUrl?: string | null, thumbnailStatus: DocumentThumbnailStatus, zohoRequestId?: string | null, zohoActionId?: string | null, publicSlug?: string | null, isPublic: boolean, formValueId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string } | null, signatoryCustomer?: { __typename?: 'ApplicationUser', fullName: string } | null, folderEntry?: { __typename?: 'FolderEntry', folderId: number, folder?: { __typename?: 'Folder', path: string } | null } | null, signatureTask?: { __typename?: 'ProjectTask', startDate?: any | null, dueDate?: any | null } | null, signatureRequest?: { __typename?: 'SignatureRequest', signatureStatus: SignatureStatus, requestId: string, expiresOn: any } | null } | null }> };

export type GetTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantsQuery = { __typename?: 'Query', tenants: Array<{ __typename?: 'Tenant', id: string, name?: string | null, identifier: string, provisioningStatus: ProvisioningStatus }> };

export type UserTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTenantsQuery = { __typename?: 'Query', userTenants: Array<{ __typename?: 'Tenant', name?: string | null, identifier: string }> };

export type EditUserRoleMutationVariables = Exact<{
  input: EditUserRoleInput;
}>;


export type EditUserRoleMutation = { __typename?: 'Mutation', editUserRole: { __typename?: 'EditUserRolePayload', applicationUser?: { __typename?: 'ApplicationUser', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type EditExternalUserMutationVariables = Exact<{
  input: EditExternalUserInput;
}>;


export type EditExternalUserMutation = { __typename?: 'Mutation', editExternalUser: { __typename?: 'EditExternalUserPayload', applicationUser?: { __typename?: 'ApplicationUser', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type EditUserMutationVariables = Exact<{
  input: EditUserInput;
}>;


export type EditUserMutation = { __typename?: 'Mutation', editUser: { __typename?: 'EditUserPayload', applicationUser?: { __typename?: 'ApplicationUser', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser: { __typename?: 'InviteUserPayload', applicationUser?: { __typename?: 'ApplicationUser', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type RemoveUserMutationVariables = Exact<{
  input: RemoveUserInput;
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser: { __typename?: 'RemoveUserPayload', applicationUser?: { __typename?: 'ApplicationUser', id: string } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type UnsubscribeFromEmailsMutationVariables = Exact<{
  input: UnsubscribeFromEmailsInput;
}>;


export type UnsubscribeFromEmailsMutation = { __typename?: 'Mutation', unsubscribeFromEmails: { __typename?: 'UnsubscribeFromEmailsPayload', errors?: Array<{ __typename?: 'AccessTokenInvalidError', message: string }> | null } };

export type GetLoginInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoginInfoQuery = { __typename?: 'Query', loginInfo: { __typename?: 'LoginInfo', isAuthenticatedWithMagicLink: boolean, isMicrosoftAccountLogin: boolean, hasSignedUp: boolean } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, language: string, optedOutOfWeeklyEmails: boolean, builtInRoles: Array<BuiltInRoles>, roles: Array<{ __typename?: 'ApplicationRole', name: string }> } | null };

export type OrganizationUsersQueryVariables = Exact<{
  filter?: InputMaybe<ApplicationUserFilterInput>;
}>;


export type OrganizationUsersQuery = { __typename?: 'Query', organizationUsers: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, business?: string | null, title?: string | null, email: string }> };

export type GetUserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, title?: string | null, business?: string | null, builtInRoles: Array<BuiltInRoles>, email: string, phoneNumber?: string | null, roles: Array<{ __typename?: 'ApplicationRole', name: string }> } | null };

export type GetUsersQueryVariables = Exact<{
  filter?: InputMaybe<ApplicationUserFilterInput>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, business?: string | null, title?: string | null, email: string }> };

export type GetUsersFullQueryVariables = Exact<{
  filter?: InputMaybe<ApplicationUserFilterInput>;
}>;


export type GetUsersFullQuery = { __typename?: 'Query', users: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string, email: string, phoneNumber?: string | null, business?: string | null, title?: string | null, builtInRoles: Array<BuiltInRoles>, roles: Array<{ __typename?: 'ApplicationRole', name: string }> }> };

export type IsEmailsUnsubscribeTokenValidQueryVariables = Exact<{
  input: ValidateUnsubscribeTokenInput;
}>;


export type IsEmailsUnsubscribeTokenValidQuery = { __typename?: 'Query', validateUnsubscribeToken: { __typename?: 'ValidateUnsubscribeTokenResult', isValid: boolean } };

export type StartWorkflowMutationVariables = Exact<{
  input: StartWorkflowInstanceInput;
}>;


export type StartWorkflowMutation = { __typename?: 'Mutation', startWorkflowInstance: { __typename?: 'StartWorkflowInstancePayload', workflowInstance?: { __typename?: 'WorkflowInstance', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
      | { __typename: 'WorkflowConfigurationError', message: string }
      | { __typename: 'WorkflowExecutionFatalError', message: string, workflowInstanceId: number }
    > | null } };

export type AddChildActionMutationVariables = Exact<{
  input: AddChildActionInput;
}>;


export type AddChildActionMutation = { __typename?: 'Mutation', addChildAction: { __typename?: 'AddChildActionPayload', workflowActionConfiguration?: { __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type AddProjectWorkflowMutationVariables = Exact<{
  input: AddProjectWorkflowInput;
}>;


export type AddProjectWorkflowMutation = { __typename?: 'Mutation', addProjectWorkflow: { __typename?: 'AddProjectWorkflowPayload', workflowDefinition?: { __typename?: 'WorkflowDefinition', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type AddWorkflowMutationVariables = Exact<{
  input: AddWorkflowDefinitionInput;
}>;


export type AddWorkflowMutation = { __typename?: 'Mutation', addWorkflowDefinition: { __typename?: 'AddWorkflowDefinitionPayload', workflowDefinition?: { __typename?: 'WorkflowDefinition', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteWorkflowActionMutationVariables = Exact<{
  input: DeleteWorkflowActionConfigurationInput;
}>;


export type DeleteWorkflowActionMutation = { __typename?: 'Mutation', deleteWorkflowActionConfiguration: { __typename?: 'DeleteWorkflowActionConfigurationPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type StopWorkflowInstanceMutationVariables = Exact<{
  input: StopWorkflowInstanceInput;
}>;


export type StopWorkflowInstanceMutation = { __typename?: 'Mutation', stopWorkflowInstance: { __typename?: 'StopWorkflowInstancePayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteWorkflowTemplateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteWorkflowTemplateMutation = { __typename?: 'Mutation', deleteWorkflowDefinition: { __typename?: 'DeleteWorkflowDefinitionPayload', workflowDefinition?: { __typename?: 'WorkflowDefinition', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DuplicateWorkflowDefinitionMutationVariables = Exact<{
  input: DuplicateWorkflowDefinitionInput;
}>;


export type DuplicateWorkflowDefinitionMutation = { __typename?: 'Mutation', duplicateWorkflowDefinition: { __typename?: 'DuplicateWorkflowDefinitionPayload', workflowDefinition?: { __typename?: 'WorkflowDefinition', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type EditWorkflowMutationVariables = Exact<{
  input: EditWorkflowDefinitionInput;
}>;


export type EditWorkflowMutation = { __typename?: 'Mutation', editWorkflowDefinition: { __typename?: 'EditWorkflowDefinitionPayload', workflowDefinition?: { __typename?: 'WorkflowDefinition', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type MoveChildActionMutationVariables = Exact<{
  input: MoveChildActionInput;
}>;


export type MoveChildActionMutation = { __typename?: 'Mutation', moveChildAction: { __typename?: 'MoveChildActionPayload', errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type UpdateWorkflowActionConfigurationMutationVariables = Exact<{
  input: UpdateWorkflowActionConfigurationInput;
}>;


export type UpdateWorkflowActionConfigurationMutation = { __typename?: 'Mutation', updateWorkflowActionConfiguration: { __typename?: 'UpdateWorkflowActionConfigurationPayload', workflowActionConfiguration?: { __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type SubmitWorkflowActionMutationVariables = Exact<{
  input: SubmitWorkflowActionInput;
}>;


export type SubmitWorkflowActionMutation = { __typename?: 'Mutation', submitWorkflowAction: { __typename?: 'SubmitWorkflowActionPayload', workflowActionConfiguration?: { __typename?: 'WorkflowActionConfiguration', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
      | { __typename?: 'WorkflowExecutionFatalError', message: string }
    > | null } };

export type AddWorkflowVariableMutationVariables = Exact<{
  input: AddWorkflowVariableInput;
}>;


export type AddWorkflowVariableMutation = { __typename?: 'Mutation', addWorkflowVariable: { __typename?: 'AddWorkflowVariablePayload', workflowVariable?: { __typename?: 'WorkflowVariable', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type DeleteWorkflowVariableMutationVariables = Exact<{
  input: DeleteWorkflowVariableInput;
}>;


export type DeleteWorkflowVariableMutation = { __typename?: 'Mutation', deleteWorkflowVariable: { __typename?: 'DeleteWorkflowVariablePayload', workflowVariable?: { __typename?: 'WorkflowVariable', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type EditWorkflowVariableMutationVariables = Exact<{
  input: EditWorkflowVariableInput;
}>;


export type EditWorkflowVariableMutation = { __typename?: 'Mutation', editWorkflowVariable: { __typename?: 'EditWorkflowVariablePayload', workflowVariable?: { __typename?: 'WorkflowVariable', id: number } | null, errors?: Array<
      | { __typename?: 'NotFoundError', message: string }
      | { __typename?: 'ValidationResultError', message: string }
    > | null } };

export type ActionsOfWorkflowInstanceQueryVariables = Exact<{
  workflowId: Scalars['Int']['input'];
}>;


export type ActionsOfWorkflowInstanceQuery = { __typename?: 'Query', workflowActionConfigurationsOfWorkflow: Array<{ __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, canSubmit: boolean, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> };

export type WorkflowInstanceQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  workflowId: Scalars['Int']['input'];
}>;


export type WorkflowInstanceQuery = { __typename?: 'Query', workflowInstance?: { __typename?: 'WorkflowInstance', id: number, name: string, workFlowStatus: WorkFlowStatus, errorCorrelationId?: string | null, stoppedBy?: { __typename?: 'ApplicationUser', fullName: string } | null, rootAction?: { __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null } | null };

export type WorkflowInstancesQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  filter?: InputMaybe<WorkflowInstanceFilterInput>;
}>;


export type WorkflowInstancesQuery = { __typename?: 'Query', workflowInstances: Array<{ __typename?: 'WorkflowInstance', id: number, name: string, workFlowStatus: WorkFlowStatus, createdOn: any, stoppedOn?: any | null, completedOn?: any | null, variables: Array<{ __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes }> }> };

export type WorkflowActionForExecutionFragmentFragment = { __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, canSubmit: boolean, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> };

export type WorkflowActionConfigurationFragmentFragment = { __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> };

export type WorkflowActionDefinitionFragmentFragment = { __typename?: 'WorkflowActionDefinition', actionDefinitionId: string, name: string, fields: Array<{ __typename?: 'WorkflowActionField', id: any, name: string, description?: string | null, variableType: WorkflowVariableValueTypes, fieldType: WorkflowFieldType, required: boolean }> };

export type WorkflowActionFieldFragmentFragment = { __typename?: 'WorkflowActionField', id: any, name: string, description?: string | null, variableType: WorkflowVariableValueTypes, fieldType: WorkflowFieldType, required: boolean };

export type WorkflowActionFieldValueFragmentFragment = { __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null };

export type WorkflowDefinitionFragmentFragment = { __typename?: 'WorkflowDefinition', id: number, name: string, description?: string | null, projectId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string, id: string } | null, allActions: Array<{ __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> };

export type WorkflowDefinitionFullFragmentFragment = { __typename?: 'WorkflowDefinition', id: number, name: string, description?: string | null, projectId?: number | null, variables: Array<{ __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes }>, rootAction?: { __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, childActions: Array<{ __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }>, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string, id: string } | null, allActions: Array<{ __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> };

export type WorkflowInstanceFragmentFragment = { __typename?: 'WorkflowInstance', id: number, name: string, workFlowStatus: WorkFlowStatus, errorCorrelationId?: string | null, stoppedBy?: { __typename?: 'ApplicationUser', fullName: string } | null, rootAction?: { __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null };

export type WorkflowVariableFragmentFragment = { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes };

export type ProjectWorkflowsQueryVariables = Exact<{
  filter?: InputMaybe<WorkflowDefinitionFilterInput>;
  projectId: Scalars['Int']['input'];
}>;


export type ProjectWorkflowsQuery = { __typename?: 'Query', projectWorkflows: Array<{ __typename?: 'WorkflowDefinition', id: number, name: string, description?: string | null, projectId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string, id: string } | null, allActions: Array<{ __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> }> };

export type WorkflowQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type WorkflowQuery = { __typename?: 'Query', workflowDefinition?: { __typename?: 'WorkflowDefinition', id: number, name: string, description?: string | null, projectId?: number | null, variables: Array<{ __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes }>, rootAction?: { __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, childActions: Array<{ __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }>, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> } | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string, id: string } | null, allActions: Array<{ __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> } | null };

export type WorkflowActionDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkflowActionDefinitionsQuery = { __typename?: 'Query', workflowActionDefinitions: Array<{ __typename?: 'WorkflowActionDefinition', actionDefinitionId: string, name: string, fields: Array<{ __typename?: 'WorkflowActionField', id: any, name: string, description?: string | null, variableType: WorkflowVariableValueTypes, fieldType: WorkflowFieldType, required: boolean }> }> };

export type WorkflowTemplateErrorsQueryVariables = Exact<{
  workflowId: Scalars['Int']['input'];
}>;


export type WorkflowTemplateErrorsQuery = { __typename?: 'Query', workflowTemplateErrors: Array<{ __typename?: 'WorkflowValidationError', actionId: number, fieldId: any, message: string }> };

export type WorkflowTemplatePermissionsQueryVariables = Exact<{
  templateId: Scalars['Int']['input'];
}>;


export type WorkflowTemplatePermissionsQuery = { __typename?: 'Query', workflowTemplatePermissions: Array<{ __typename?: 'RoleAssignment', id: string, isInherited: boolean, isFromFillFormTask: boolean, isFromSignDocumentTask: boolean, principalType: PrincipalType, sharedWithAllProjectMembers: boolean, isSharedWithPublicLink: boolean, applicationRole?: { __typename?: 'ApplicationRole', name: string, builtInRole: BuiltInRoles } | null, user?: { __typename?: 'ApplicationUser', id: string, firstName: string, lastName: string, fullName: string, email: string, business?: string | null, title?: string | null } | null, securityGroup?: { __typename?: 'SecurityGroup', id: string, name: string } | null, inheritedFromFolder?: { __typename?: 'Folder', id: number, name: string, path: string, folderType: FolderType } | null }> };

export type WorkflowTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<WorkflowDefinitionFilterInput>;
}>;


export type WorkflowTemplatesQuery = { __typename?: 'Query', workflowTemplates: Array<{ __typename?: 'WorkflowDefinition', id: number, name: string, description?: string | null, projectId?: number | null, createdBy?: { __typename?: 'ApplicationUser', fullName: string, id: string } | null, allActions: Array<{ __typename?: 'WorkflowActionConfiguration', id: number, workflowActionDefinitionId: string, name: string, order: number, status: WorkflowActionStatus, hierarchyPath?: string | null, submittedById?: string | null, submittedOn?: any | null, submittedBy?: { __typename?: 'ApplicationUser', firstName: string, lastName: string, fullName: string } | null, fieldValues: Array<{ __typename?: 'WorkflowActionFieldValue', id: number, fieldId: any, value?: { __typename?: 'WorkflowVariable', id: number, name?: string | null, serializedValue?: string | null, variableType: WorkflowVariableType, variableValueType: WorkflowVariableValueTypes } | null }>, participants: Array<{ __typename?: 'ApplicationUser', id: string, fullName: string }> }> }> };


export const BudgetItemFragmentFragmentDoc = `
    fragment BudgetItemFragment on BudgetItem {
  id
  name
  budgetedAmount
  order
  costItems {
    id
    name
    plannedAmount
    status
    order
    effectiveAmount
    budgetItem {
      id
    }
    entries {
      id
      type
      order
      costItemId
      expense {
        name
        id
        expendedAmount
        expenseDate
        status
        quoteId
        attachments {
          id
          fileName
          thumbnailStatus
        }
      }
      quote {
        id
        name
        amount
        quoteDate
        attachments {
          id
          fileName
          thumbnailStatus
        }
        expenses {
          id
          name
          expendedAmount
          expenseDate
          status
          quoteId
          attachments {
            id
            fileName
            thumbnailStatus
          }
        }
      }
    }
  }
}
    `;
export const ExpenseFragmentFragmentDoc = `
    fragment ExpenseFragment on Expense {
  id
  name
  status
  expendedAmount
  expenseDate
  quoteId
  quote {
    id
    name
    amount
    quoteDate
    attachments {
      id
      fileName
      thumbnailStatus
    }
  }
  entry {
    costItem {
      id
      name
      status
      order
      budgetItem {
        id
        name
        order
      }
    }
  }
  attachments {
    id
    fileName
    thumbnailStatus
  }
}
    `;
export const DocumentTemplateFragmentFragmentDoc = `
    fragment DocumentTemplateFragment on DocumentTemplate {
  id
  name
  description
  fileName
  createdBy {
    id
    fullName
  }
}
    `;
export const FilePickerDocumentFragmentFragmentDoc = `
    fragment FilePickerDocumentFragment on Document {
  id
  fileName
  folderEntry {
    folderId
    folder {
      path
      name
      folderType
    }
  }
}
    `;
export const DocumentFragmentFragmentDoc = `
    fragment DocumentFragment on Document {
  id
  fileName
  projectId
  createdOn
  createdBy {
    fullName
  }
  signatoryCustomerId
  signatoryCustomer {
    fullName
  }
  signedOn
  isSigned
  textualSignature
  folderEntry {
    folderId
    folder {
      path
    }
  }
  modifiedOn
  requiresSignatures
  imageThumbnailUrl
  thumbnailStatus
  zohoRequestId
  zohoActionId
  signatureTask {
    startDate
    dueDate
  }
  signatureRequest {
    signatureStatus
    requestId
    expiresOn
  }
  publicSlug
  isPublic
  formValueId
}
    `;
export const ExternalLinkFragmentFragmentDoc = `
    fragment ExternalLinkFragment on ExternalLink {
  id
  name
  link
  modifiedOn
  createdOn
  createdBy {
    id
    fullName
  }
  folderEntry {
    folderId
  }
}
    `;
export const FolderEntryFragmentFragmentDoc = `
    fragment FolderEntryFragment on FolderEntry {
  id
  folderId
  document {
    ...DocumentFragment
  }
  externalLink {
    ...ExternalLinkFragment
  }
}
    `;
export const FolderFragmentFragmentDoc = `
    fragment FolderFragment on Folder {
  id
  name
  parentFolderId
  projectId
  modifiedOn
  path
  folderType
}
    `;
export const MatrixRowFragmentFragmentDoc = `
    fragment MatrixRowFragment on MatrixRow {
  id
  isDefaultRow
  values {
    id
    matrixColumnId
    text
    number
    boolean
  }
}
    `;
export const MatrixFragmentFragmentDoc = `
    fragment MatrixFragment on Matrix {
  id
  columns(order: {order: ASC}) {
    id
    order
    fieldType
    name
    description
    isRequired
  }
  defaultRows {
    ...MatrixRowFragment
  }
}
    `;
export const FormFieldFragmentFragmentDoc = `
    fragment FormFieldFragment on FormField {
  id
  name
  fieldType
  isRequired
  isMultiline
  isMultiselect
  shouldUploadDocumentsToFolder
  documentUploadFolderId
  options {
    id
    label
  }
  matrix {
    ...MatrixFragment
  }
}
    `;
export const FormDefinitionFragmentFragmentDoc = `
    fragment FormDefinitionFragment on FormDefinition {
  id
  name
  description
  sections(order: {order: ASC}) {
    id
    name
    fields(order: {order: ASC}) {
      ...FormFieldFragment
    }
  }
  conditions {
    id
    formId
    trigger {
      id
      sourceFieldId
      valueEquality {
        boolean
      }
    }
    effect {
      targetFieldId
      targetSectionId
      visibility {
        visible
      }
    }
  }
}
    `;
export const FormValueFragmentFragmentDoc = `
    fragment FormValueFragment on FormValue {
  id
  fieldId
  text
  number
  boolean
  dateValue
  selectedOptions {
    id
  }
  matrixRows {
    ...MatrixRowFragment
  }
  documents {
    id
    fileName
    thumbnailStatus
  }
}
    `;
export const ProjectFormSubmissionFragmentFragmentDoc = `
    fragment ProjectFormSubmissionFragment on ProjectFormSubmission {
  id
  projectFormId
  belongsToUser {
    id
    fullName
  }
  belongsToUserId
  submittedOn
  status
  projectForm {
    formDefinition {
      name
    }
  }
  formDefinition {
    name
  }
}
    `;
export const RoleAssignmentFragmentFragmentDoc = `
    fragment RoleAssignmentFragment on RoleAssignment {
  id
  isInherited
  isFromFillFormTask
  isFromSignDocumentTask
  principalType
  sharedWithAllProjectMembers
  isSharedWithPublicLink
  applicationRole {
    name
    builtInRole
  }
  user {
    id
    firstName
    lastName
    fullName
    email
    business
    title
  }
  securityGroup {
    id
    name
  }
  inheritedFromFolder {
    id
    name
    path
    folderType
  }
}
    `;
export const FormTemplateFragmentFragmentDoc = `
    fragment FormTemplateFragment on FormTemplate {
  id
  createdOn
  createdById
  createdBy {
    fullName
  }
  formDefinition {
    name
    description
  }
  roleAssignments {
    ...RoleAssignmentFragment
  }
}
    `;
export const MeetingFragmentFragmentDoc = `
    fragment MeetingFragment on Meeting {
  id
  name
  description
  startTime
  endTime
  meetingStatus
  cancellationReason
  meetingType {
    duration
    bookingMethod
    meetingRequestsOwners {
      id
      fullName
    }
    meetingRequestOwnerGroups {
      id
      members {
        id
      }
    }
  }
  proposals(order: {startTime: ASC}) {
    startTime
  }
  createdById
  createdBy {
    id
    fullName
  }
  participants {
    id
    fullName
  }
}
    `;
export const ProjectMemberFragmentFragmentDoc = `
    fragment ProjectMemberFragment on ApplicationUser {
  id
  email
  title
  phoneNumber
  firstName
  lastName
  fullName
  business
  roles {
    name
  }
  builtInRoles
}
    `;
export const SecurityGroupFragmentFragmentDoc = `
    fragment SecurityGroupFragment on SecurityGroup {
  id
  name
  description
  isDefaultProjectAdminGroup
  members {
    id
    firstName
    lastName
    fullName
    business
    title
    email
    roles {
      name
    }
    builtInRoles
  }
  permissionAssignments {
    permissionId
  }
  projectPermissions {
    budgetPermission
    tasksPermission
    formsPermission
    documentsPermission
    workflowsPermission
    managePublicFileSharingPermission
  }
}
    `;
export const GetTaskNameFragmentFragmentDoc = `
    fragment GetTaskNameFragment on ProjectTask {
  id
  type
  name
  projectForm {
    formDefinition {
      name
    }
  }
  document {
    fileName
  }
}
    `;
export const FormAllowedUsersFragmentFragmentDoc = `
    fragment FormAllowedUsersFragment on ProjectForm {
  allowedUsers {
    id
    fullName
  }
  formSettings {
    allowedUsersRespondents {
      id
      fullName
    }
    allowedSecurityGroupsRespondents {
      members {
        id
        fullName
      }
    }
  }
}
    `;
export const ProjectFormSettingsFragmentFragmentDoc = `
    fragment ProjectFormSettingsFragment on FormSettings {
  id
  allowedRespondents
  formType
  allowedSecurityGroupsRespondents {
    id
    name
  }
  allowedUsersRespondents {
    id
    fullName
    business
    fullName
    title
    email
  }
}
    `;
export const ProjectTaskFragmentFragmentDoc = `
    fragment ProjectTaskFragment on ProjectTask {
  id
  startDate
  dueDate
  completedOn
  status
  type
  name
  description
  hierarchyPath
  projectId
  ...GetTaskNameFragment
  project {
    id
    name
  }
  createdBy {
    id
    fullName
  }
  predecessors {
    id
  }
  assignees {
    id
    fullName
  }
  assigneeGroups {
    id
    name
  }
  projectForm {
    id
    publishedOn
    createdOn
    status
    ...FormAllowedUsersFragment
    formSettings {
      ...ProjectFormSettingsFragment
    }
    formDefinition {
      name
    }
  }
  document {
    ...DocumentFragment
  }
}
    `;
export const WorkflowVariableFragmentFragmentDoc = `
    fragment WorkflowVariableFragment on WorkflowVariable {
  id
  name
  serializedValue
  variableType
  variableValueType
}
    `;
export const WorkflowActionFieldValueFragmentFragmentDoc = `
    fragment WorkflowActionFieldValueFragment on WorkflowActionFieldValue {
  id
  fieldId
  value {
    ...WorkflowVariableFragment
  }
}
    `;
export const WorkflowActionForExecutionFragmentFragmentDoc = `
    fragment WorkflowActionForExecutionFragment on WorkflowActionConfiguration {
  id
  workflowActionDefinitionId
  name
  order
  status
  hierarchyPath
  canSubmit
  submittedById
  submittedBy {
    firstName
    lastName
    fullName
  }
  submittedOn
  fieldValues {
    ...WorkflowActionFieldValueFragment
  }
  participants {
    id
    fullName
  }
}
    `;
export const WorkflowActionFieldFragmentFragmentDoc = `
    fragment WorkflowActionFieldFragment on WorkflowActionField {
  id
  name
  description
  variableType
  fieldType
  required
}
    `;
export const WorkflowActionDefinitionFragmentFragmentDoc = `
    fragment WorkflowActionDefinitionFragment on WorkflowActionDefinition {
  actionDefinitionId
  name
  fields(order: {order: ASC}) {
    ...WorkflowActionFieldFragment
  }
}
    `;
export const WorkflowActionConfigurationFragmentFragmentDoc = `
    fragment WorkflowActionConfigurationFragment on WorkflowActionConfiguration {
  id
  workflowActionDefinitionId
  name
  order
  status
  hierarchyPath
  submittedById
  submittedBy {
    firstName
    lastName
    fullName
  }
  submittedOn
  fieldValues {
    ...WorkflowActionFieldValueFragment
  }
  participants {
    id
    fullName
  }
}
    `;
export const WorkflowDefinitionFragmentFragmentDoc = `
    fragment WorkflowDefinitionFragment on WorkflowDefinition {
  id
  name
  description
  projectId
  createdBy {
    fullName
    id
  }
  allActions {
    ...WorkflowActionConfigurationFragment
  }
}
    `;
export const WorkflowDefinitionFullFragmentFragmentDoc = `
    fragment WorkflowDefinitionFullFragment on WorkflowDefinition {
  ...WorkflowDefinitionFragment
  variables {
    ...WorkflowVariableFragment
  }
  rootAction {
    ...WorkflowActionConfigurationFragment
    childActions {
      ...WorkflowActionConfigurationFragment
    }
  }
}
    `;
export const WorkflowInstanceFragmentFragmentDoc = `
    fragment WorkflowInstanceFragment on WorkflowInstance {
  id
  name
  workFlowStatus
  stoppedBy {
    fullName
  }
  errorCorrelationId
  rootAction {
    ...WorkflowActionConfigurationFragment
  }
}
    `;
export const FormPresenceUpdatedDocument = `
    subscription formPresenceUpdated($submissionId: Int!) {
  formPresenceUpdated(submissionId: $submissionId) {
    uniqueClientId
    userId
    displayName
    fieldId
    matrixColumnId
    matrixRowId
  }
}
    `;
export const FormValueEditedDocument = `
    subscription formValueEdited($submissionId: Int!) {
  formValueEdited(submissionId: $submissionId) {
    initiatorUniqueClientId
    formValue {
      id
      fieldId
      text
      number
      boolean
      dateValue
      selectedOptions {
        id
      }
      matrixRows {
        id
        isDefaultRow
        values {
          id
          matrixColumnId
          text
          number
          boolean
        }
      }
      documents {
        id
        fileName
        thumbnailStatus
      }
    }
  }
}
    `;
export const MatrixRowEventDocument = `
    subscription matrixRowEvent($submissionId: Int!) {
  matrixRowEvent(submissionId: $submissionId) {
    id
    initiatorUniqueClientId
    eventType
  }
}
    `;
export const MatrixValueEditedDocument = `
    subscription matrixValueEdited($submissionId: Int!) {
  matrixValueEdited(submissionId: $submissionId) {
    initiatorUniqueClientId
    matrixValue {
      id
      matrixRowId
      matrixColumnId
      text
      number
      boolean
    }
  }
}
    `;
export const ProvisioningStatusChangedDocument = `
    subscription provisioningStatusChanged($tenantId: String!) {
  provisioningStatusChanged(tenantId: $tenantId)
}
    `;
export const StartTrialDocument = `
    mutation startTrial($input: StartTrialInput!) {
  startTrial(input: $input) {
    tenant {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useStartTrialMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartTrialMutation, TError, StartTrialMutationVariables, TContext>) => {
    
    return useMutation<StartTrialMutation, TError, StartTrialMutationVariables, TContext>(
      {
    mutationKey: ['startTrial'],
    mutationFn: (variables?: StartTrialMutationVariables) => fetchData<StartTrialMutation, StartTrialMutationVariables>(StartTrialDocument, variables)(),
    ...options
  }
    )};

export const UpdateMyPreferencesDocument = `
    mutation updateMyPreferences($input: UpdateMyPreferencesInput!) {
  updateMyPreferences(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUpdateMyPreferencesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMyPreferencesMutation, TError, UpdateMyPreferencesMutationVariables, TContext>) => {
    
    return useMutation<UpdateMyPreferencesMutation, TError, UpdateMyPreferencesMutationVariables, TContext>(
      {
    mutationKey: ['updateMyPreferences'],
    mutationFn: (variables?: UpdateMyPreferencesMutationVariables) => fetchData<UpdateMyPreferencesMutation, UpdateMyPreferencesMutationVariables>(UpdateMyPreferencesDocument, variables)(),
    ...options
  }
    )};

export const TenantSubscriptionDetailsDocument = `
    query tenantSubscriptionDetails {
  tenantSubscriptionDetails {
    hasSubscription
    trialDaysRemaining
    subscription {
      asOfDate
      status
      trialEnd
      subscriptionProvider
    }
  }
}
    `;

export const useTenantSubscriptionDetailsQuery = <
      TData = TenantSubscriptionDetailsQuery,
      TError = unknown
    >(
      variables?: TenantSubscriptionDetailsQueryVariables,
      options?: Omit<UseQueryOptions<TenantSubscriptionDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TenantSubscriptionDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TenantSubscriptionDetailsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['tenantSubscriptionDetails'] : ['tenantSubscriptionDetails', variables],
    queryFn: fetchData<TenantSubscriptionDetailsQuery, TenantSubscriptionDetailsQueryVariables>(TenantSubscriptionDetailsDocument, variables),
    ...options
  }
    )};

useTenantSubscriptionDetailsQuery.document = TenantSubscriptionDetailsDocument;

useTenantSubscriptionDetailsQuery.getKey = (variables?: TenantSubscriptionDetailsQueryVariables) => variables === undefined ? ['tenantSubscriptionDetails'] : ['tenantSubscriptionDetails', variables];

export const UpdateBrandingConfigurationDocument = `
    mutation updateBrandingConfiguration($input: UpdateBrandingConfigurationInput!) {
  updateBrandingConfiguration(input: $input) {
    tenantSettings {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUpdateBrandingConfigurationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBrandingConfigurationMutation, TError, UpdateBrandingConfigurationMutationVariables, TContext>) => {
    
    return useMutation<UpdateBrandingConfigurationMutation, TError, UpdateBrandingConfigurationMutationVariables, TContext>(
      {
    mutationKey: ['updateBrandingConfiguration'],
    mutationFn: (variables?: UpdateBrandingConfigurationMutationVariables) => fetchData<UpdateBrandingConfigurationMutation, UpdateBrandingConfigurationMutationVariables>(UpdateBrandingConfigurationDocument, variables)(),
    ...options
  }
    )};

export const ReorderBudgetItemDocument = `
    mutation reorderBudgetItem($input: ReorderBudgetItemInput!) {
  reorderBudgetItem(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useReorderBudgetItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderBudgetItemMutation, TError, ReorderBudgetItemMutationVariables, TContext>) => {
    
    return useMutation<ReorderBudgetItemMutation, TError, ReorderBudgetItemMutationVariables, TContext>(
      {
    mutationKey: ['reorderBudgetItem'],
    mutationFn: (variables?: ReorderBudgetItemMutationVariables) => fetchData<ReorderBudgetItemMutation, ReorderBudgetItemMutationVariables>(ReorderBudgetItemDocument, variables)(),
    ...options
  }
    )};

export const ReorderCostItemDocument = `
    mutation reorderCostItem($input: ReorderCostItemInput!) {
  reorderCostItem(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useReorderCostItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderCostItemMutation, TError, ReorderCostItemMutationVariables, TContext>) => {
    
    return useMutation<ReorderCostItemMutation, TError, ReorderCostItemMutationVariables, TContext>(
      {
    mutationKey: ['reorderCostItem'],
    mutationFn: (variables?: ReorderCostItemMutationVariables) => fetchData<ReorderCostItemMutation, ReorderCostItemMutationVariables>(ReorderCostItemDocument, variables)(),
    ...options
  }
    )};

export const ReorderCostItemEntryDocument = `
    mutation reorderCostItemEntry($input: ReorderCostItemEntryInput!) {
  reorderCostItemEntry(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useReorderCostItemEntryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderCostItemEntryMutation, TError, ReorderCostItemEntryMutationVariables, TContext>) => {
    
    return useMutation<ReorderCostItemEntryMutation, TError, ReorderCostItemEntryMutationVariables, TContext>(
      {
    mutationKey: ['reorderCostItemEntry'],
    mutationFn: (variables?: ReorderCostItemEntryMutationVariables) => fetchData<ReorderCostItemEntryMutation, ReorderCostItemEntryMutationVariables>(ReorderCostItemEntryDocument, variables)(),
    ...options
  }
    )};

export const CreateCommercialProjectCalculatorDocument = `
    mutation createCommercialProjectCalculator($input: CreateCommercialProjectCalculatorInput!) {
  createCommercialProjectCalculator(input: $input) {
    commercialProjectCalculator {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useCreateCommercialProjectCalculatorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCommercialProjectCalculatorMutation, TError, CreateCommercialProjectCalculatorMutationVariables, TContext>) => {
    
    return useMutation<CreateCommercialProjectCalculatorMutation, TError, CreateCommercialProjectCalculatorMutationVariables, TContext>(
      {
    mutationKey: ['createCommercialProjectCalculator'],
    mutationFn: (variables?: CreateCommercialProjectCalculatorMutationVariables) => fetchData<CreateCommercialProjectCalculatorMutation, CreateCommercialProjectCalculatorMutationVariables>(CreateCommercialProjectCalculatorDocument, variables)(),
    ...options
  }
    )};

export const DuplicateCommercialCalculatorDocument = `
    mutation duplicateCommercialCalculator($input: DuplicateCommercialProjectCalculatorInput!) {
  duplicateCommercialProjectCalculator(input: $input) {
    commercialProjectCalculator {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDuplicateCommercialCalculatorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DuplicateCommercialCalculatorMutation, TError, DuplicateCommercialCalculatorMutationVariables, TContext>) => {
    
    return useMutation<DuplicateCommercialCalculatorMutation, TError, DuplicateCommercialCalculatorMutationVariables, TContext>(
      {
    mutationKey: ['duplicateCommercialCalculator'],
    mutationFn: (variables?: DuplicateCommercialCalculatorMutationVariables) => fetchData<DuplicateCommercialCalculatorMutation, DuplicateCommercialCalculatorMutationVariables>(DuplicateCommercialCalculatorDocument, variables)(),
    ...options
  }
    )};

export const RemoveCommercialProjectCalculatorDocument = `
    mutation removeCommercialProjectCalculator($input: RemoveCommercialProjectCalculatorInput!) {
  removeCommercialProjectCalculator(input: $input) {
    commercialProjectCalculator {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRemoveCommercialProjectCalculatorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCommercialProjectCalculatorMutation, TError, RemoveCommercialProjectCalculatorMutationVariables, TContext>) => {
    
    return useMutation<RemoveCommercialProjectCalculatorMutation, TError, RemoveCommercialProjectCalculatorMutationVariables, TContext>(
      {
    mutationKey: ['removeCommercialProjectCalculator'],
    mutationFn: (variables?: RemoveCommercialProjectCalculatorMutationVariables) => fetchData<RemoveCommercialProjectCalculatorMutation, RemoveCommercialProjectCalculatorMutationVariables>(RemoveCommercialProjectCalculatorDocument, variables)(),
    ...options
  }
    )};

export const UpdateCommercialProjectCalculatorDocument = `
    mutation updateCommercialProjectCalculator($input: UpdateCommercialProjectCalculatorInput!) {
  updateCommercialProjectCalculator(input: $input) {
    commercialProjectCalculator {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUpdateCommercialProjectCalculatorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCommercialProjectCalculatorMutation, TError, UpdateCommercialProjectCalculatorMutationVariables, TContext>) => {
    
    return useMutation<UpdateCommercialProjectCalculatorMutation, TError, UpdateCommercialProjectCalculatorMutationVariables, TContext>(
      {
    mutationKey: ['updateCommercialProjectCalculator'],
    mutationFn: (variables?: UpdateCommercialProjectCalculatorMutationVariables) => fetchData<UpdateCommercialProjectCalculatorMutation, UpdateCommercialProjectCalculatorMutationVariables>(UpdateCommercialProjectCalculatorDocument, variables)(),
    ...options
  }
    )};

export const CommercialProjectCalculatorDocument = `
    query commercialProjectCalculator($projectId: Int!, $calculatorId: Int!) {
  commercialProjectCalculator(projectId: $projectId, calculatorId: $calculatorId) {
    id
    name
    jsonData
  }
}
    `;

export const useCommercialProjectCalculatorQuery = <
      TData = CommercialProjectCalculatorQuery,
      TError = unknown
    >(
      variables: CommercialProjectCalculatorQueryVariables,
      options?: Omit<UseQueryOptions<CommercialProjectCalculatorQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CommercialProjectCalculatorQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CommercialProjectCalculatorQuery, TError, TData>(
      {
    queryKey: ['commercialProjectCalculator', variables],
    queryFn: fetchData<CommercialProjectCalculatorQuery, CommercialProjectCalculatorQueryVariables>(CommercialProjectCalculatorDocument, variables),
    ...options
  }
    )};

useCommercialProjectCalculatorQuery.document = CommercialProjectCalculatorDocument;

useCommercialProjectCalculatorQuery.getKey = (variables: CommercialProjectCalculatorQueryVariables) => ['commercialProjectCalculator', variables];

export const CommercialProjectCalculatorsDocument = `
    query commercialProjectCalculators($projectId: Int!) {
  commercialProjectCalculators(projectId: $projectId) {
    id
    name
  }
}
    `;

export const useCommercialProjectCalculatorsQuery = <
      TData = CommercialProjectCalculatorsQuery,
      TError = unknown
    >(
      variables: CommercialProjectCalculatorsQueryVariables,
      options?: Omit<UseQueryOptions<CommercialProjectCalculatorsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CommercialProjectCalculatorsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CommercialProjectCalculatorsQuery, TError, TData>(
      {
    queryKey: ['commercialProjectCalculators', variables],
    queryFn: fetchData<CommercialProjectCalculatorsQuery, CommercialProjectCalculatorsQueryVariables>(CommercialProjectCalculatorsDocument, variables),
    ...options
  }
    )};

useCommercialProjectCalculatorsQuery.document = CommercialProjectCalculatorsDocument;

useCommercialProjectCalculatorsQuery.getKey = (variables: CommercialProjectCalculatorsQueryVariables) => ['commercialProjectCalculators', variables];

export const TenantSettingsDocument = `
    query tenantSettings {
  tenantSettings {
    isConstructionAddonEnabled
    isSignDocumentByZohoEnabled
    remainingZohoSignatureRequests
    isWhiteLabelEnabled
    primaryColor
    secondaryColor
  }
}
    `;

export const useTenantSettingsQuery = <
      TData = TenantSettingsQuery,
      TError = unknown
    >(
      variables?: TenantSettingsQueryVariables,
      options?: Omit<UseQueryOptions<TenantSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TenantSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TenantSettingsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['tenantSettings'] : ['tenantSettings', variables],
    queryFn: fetchData<TenantSettingsQuery, TenantSettingsQueryVariables>(TenantSettingsDocument, variables),
    ...options
  }
    )};

useTenantSettingsQuery.document = TenantSettingsDocument;

useTenantSettingsQuery.getKey = (variables?: TenantSettingsQueryVariables) => variables === undefined ? ['tenantSettings'] : ['tenantSettings', variables];

export const TenantThemeDocument = `
    query tenantTheme {
  tenantTheme {
    name
    primaryColor
    secondaryColor
    isBrandingEnabled
    topBarLogoLightUrl
    topBarLogoDarkUrl
    loginBackgroundUrl
    faviconUrl
    squareLogoLightUrl
    squareLogoDarkUrl
  }
}
    `;

export const useTenantThemeQuery = <
      TData = TenantThemeQuery,
      TError = unknown
    >(
      variables?: TenantThemeQueryVariables,
      options?: Omit<UseQueryOptions<TenantThemeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TenantThemeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TenantThemeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['tenantTheme'] : ['tenantTheme', variables],
    queryFn: fetchData<TenantThemeQuery, TenantThemeQueryVariables>(TenantThemeDocument, variables),
    ...options
  }
    )};

useTenantThemeQuery.document = TenantThemeDocument;

useTenantThemeQuery.getKey = (variables?: TenantThemeQueryVariables) => variables === undefined ? ['tenantTheme'] : ['tenantTheme', variables];

export const AddBudgetItemDocument = `
    mutation addBudgetItem($input: AddBudgetItemInput!) {
  addBudgetItem(input: $input) {
    budgetItem {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddBudgetItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddBudgetItemMutation, TError, AddBudgetItemMutationVariables, TContext>) => {
    
    return useMutation<AddBudgetItemMutation, TError, AddBudgetItemMutationVariables, TContext>(
      {
    mutationKey: ['addBudgetItem'],
    mutationFn: (variables?: AddBudgetItemMutationVariables) => fetchData<AddBudgetItemMutation, AddBudgetItemMutationVariables>(AddBudgetItemDocument, variables)(),
    ...options
  }
    )};

export const DeleteBudgetItemDocument = `
    mutation deleteBudgetItem($input: DeleteBudgetItemInput!) {
  deleteBudgetItem(input: $input) {
    budgetItem {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteBudgetItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteBudgetItemMutation, TError, DeleteBudgetItemMutationVariables, TContext>) => {
    
    return useMutation<DeleteBudgetItemMutation, TError, DeleteBudgetItemMutationVariables, TContext>(
      {
    mutationKey: ['deleteBudgetItem'],
    mutationFn: (variables?: DeleteBudgetItemMutationVariables) => fetchData<DeleteBudgetItemMutation, DeleteBudgetItemMutationVariables>(DeleteBudgetItemDocument, variables)(),
    ...options
  }
    )};

export const EditBudgetItemDocument = `
    mutation editBudgetItem($input: EditBudgetItemInput!) {
  editBudgetItem(input: $input) {
    budgetItem {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditBudgetItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditBudgetItemMutation, TError, EditBudgetItemMutationVariables, TContext>) => {
    
    return useMutation<EditBudgetItemMutation, TError, EditBudgetItemMutationVariables, TContext>(
      {
    mutationKey: ['editBudgetItem'],
    mutationFn: (variables?: EditBudgetItemMutationVariables) => fetchData<EditBudgetItemMutation, EditBudgetItemMutationVariables>(EditBudgetItemDocument, variables)(),
    ...options
  }
    )};

export const AddCostItemDocument = `
    mutation addCostItem($input: AddCostItemInput!) {
  addCostItem(input: $input) {
    costItem {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddCostItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddCostItemMutation, TError, AddCostItemMutationVariables, TContext>) => {
    
    return useMutation<AddCostItemMutation, TError, AddCostItemMutationVariables, TContext>(
      {
    mutationKey: ['addCostItem'],
    mutationFn: (variables?: AddCostItemMutationVariables) => fetchData<AddCostItemMutation, AddCostItemMutationVariables>(AddCostItemDocument, variables)(),
    ...options
  }
    )};

export const DeleteCostItemDocument = `
    mutation deleteCostItem($input: DeleteCostItemInput!) {
  deleteCostItem(input: $input) {
    costItem {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteCostItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCostItemMutation, TError, DeleteCostItemMutationVariables, TContext>) => {
    
    return useMutation<DeleteCostItemMutation, TError, DeleteCostItemMutationVariables, TContext>(
      {
    mutationKey: ['deleteCostItem'],
    mutationFn: (variables?: DeleteCostItemMutationVariables) => fetchData<DeleteCostItemMutation, DeleteCostItemMutationVariables>(DeleteCostItemDocument, variables)(),
    ...options
  }
    )};

export const EditCostItemDocument = `
    mutation editCostItem($input: EditCostItemInput!) {
  editCostItem(input: $input) {
    costItem {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditCostItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditCostItemMutation, TError, EditCostItemMutationVariables, TContext>) => {
    
    return useMutation<EditCostItemMutation, TError, EditCostItemMutationVariables, TContext>(
      {
    mutationKey: ['editCostItem'],
    mutationFn: (variables?: EditCostItemMutationVariables) => fetchData<EditCostItemMutation, EditCostItemMutationVariables>(EditCostItemDocument, variables)(),
    ...options
  }
    )};

export const AddExpenseDocument = `
    mutation addExpense($input: AddExpenseInput!) {
  addExpense(input: $input) {
    expense {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddExpenseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddExpenseMutation, TError, AddExpenseMutationVariables, TContext>) => {
    
    return useMutation<AddExpenseMutation, TError, AddExpenseMutationVariables, TContext>(
      {
    mutationKey: ['addExpense'],
    mutationFn: (variables?: AddExpenseMutationVariables) => fetchData<AddExpenseMutation, AddExpenseMutationVariables>(AddExpenseDocument, variables)(),
    ...options
  }
    )};

export const DeleteExpenseDocument = `
    mutation deleteExpense($input: DeleteExpenseInput!) {
  deleteExpense(input: $input) {
    expense {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteExpenseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteExpenseMutation, TError, DeleteExpenseMutationVariables, TContext>) => {
    
    return useMutation<DeleteExpenseMutation, TError, DeleteExpenseMutationVariables, TContext>(
      {
    mutationKey: ['deleteExpense'],
    mutationFn: (variables?: DeleteExpenseMutationVariables) => fetchData<DeleteExpenseMutation, DeleteExpenseMutationVariables>(DeleteExpenseDocument, variables)(),
    ...options
  }
    )};

export const DeleteExpenseAttachmentDocument = `
    mutation deleteExpenseAttachment($input: DeleteExpenseAttachmentInput!) {
  deleteExpenseAttachment(input: $input) {
    expense {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteExpenseAttachmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteExpenseAttachmentMutation, TError, DeleteExpenseAttachmentMutationVariables, TContext>) => {
    
    return useMutation<DeleteExpenseAttachmentMutation, TError, DeleteExpenseAttachmentMutationVariables, TContext>(
      {
    mutationKey: ['deleteExpenseAttachment'],
    mutationFn: (variables?: DeleteExpenseAttachmentMutationVariables) => fetchData<DeleteExpenseAttachmentMutation, DeleteExpenseAttachmentMutationVariables>(DeleteExpenseAttachmentDocument, variables)(),
    ...options
  }
    )};

export const EditExpenseDocument = `
    mutation editExpense($input: EditExpenseInput!) {
  editExpense(input: $input) {
    expense {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditExpenseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditExpenseMutation, TError, EditExpenseMutationVariables, TContext>) => {
    
    return useMutation<EditExpenseMutation, TError, EditExpenseMutationVariables, TContext>(
      {
    mutationKey: ['editExpense'],
    mutationFn: (variables?: EditExpenseMutationVariables) => fetchData<EditExpenseMutation, EditExpenseMutationVariables>(EditExpenseDocument, variables)(),
    ...options
  }
    )};

export const DeleteQuoteAttachmentDocument = `
    mutation deleteQuoteAttachment($input: DeleteQuoteAttachmentInput!) {
  deleteQuoteAttachment(input: $input) {
    quote {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteQuoteAttachmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteQuoteAttachmentMutation, TError, DeleteQuoteAttachmentMutationVariables, TContext>) => {
    
    return useMutation<DeleteQuoteAttachmentMutation, TError, DeleteQuoteAttachmentMutationVariables, TContext>(
      {
    mutationKey: ['deleteQuoteAttachment'],
    mutationFn: (variables?: DeleteQuoteAttachmentMutationVariables) => fetchData<DeleteQuoteAttachmentMutation, DeleteQuoteAttachmentMutationVariables>(DeleteQuoteAttachmentDocument, variables)(),
    ...options
  }
    )};

export const BudgetItemsDocument = `
    query budgetItems($projectId: Int!) {
  budgetItems(projectId: $projectId) {
    ...BudgetItemFragment
  }
}
    ${BudgetItemFragmentFragmentDoc}`;

export const useBudgetItemsQuery = <
      TData = BudgetItemsQuery,
      TError = unknown
    >(
      variables: BudgetItemsQueryVariables,
      options?: Omit<UseQueryOptions<BudgetItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BudgetItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BudgetItemsQuery, TError, TData>(
      {
    queryKey: ['budgetItems', variables],
    queryFn: fetchData<BudgetItemsQuery, BudgetItemsQueryVariables>(BudgetItemsDocument, variables),
    ...options
  }
    )};

useBudgetItemsQuery.document = BudgetItemsDocument;

useBudgetItemsQuery.getKey = (variables: BudgetItemsQueryVariables) => ['budgetItems', variables];

export const CostItemsDocument = `
    query costItems($projectId: Int!, $filter: CostItemFilterInput) {
  costItems(projectId: $projectId, where: $filter) {
    id
    name
    plannedAmount
    budgetItem {
      id
      name
    }
    entries {
      quote {
        id
        amount
        quoteDate
        name
      }
      expense {
        id
        expendedAmount
        expenseDate
        status
      }
    }
  }
}
    `;

export const useCostItemsQuery = <
      TData = CostItemsQuery,
      TError = unknown
    >(
      variables: CostItemsQueryVariables,
      options?: Omit<UseQueryOptions<CostItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CostItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CostItemsQuery, TError, TData>(
      {
    queryKey: ['costItems', variables],
    queryFn: fetchData<CostItemsQuery, CostItemsQueryVariables>(CostItemsDocument, variables),
    ...options
  }
    )};

useCostItemsQuery.document = CostItemsDocument;

useCostItemsQuery.getKey = (variables: CostItemsQueryVariables) => ['costItems', variables];

export const ExpensesDocument = `
    query expenses($projectId: Int!, $filter: ExpenseFilterInput) {
  expenses(projectId: $projectId, where: $filter) {
    ...ExpenseFragment
  }
}
    ${ExpenseFragmentFragmentDoc}`;

export const useExpensesQuery = <
      TData = ExpensesQuery,
      TError = unknown
    >(
      variables: ExpensesQueryVariables,
      options?: Omit<UseQueryOptions<ExpensesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ExpensesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ExpensesQuery, TError, TData>(
      {
    queryKey: ['expenses', variables],
    queryFn: fetchData<ExpensesQuery, ExpensesQueryVariables>(ExpensesDocument, variables),
    ...options
  }
    )};

useExpensesQuery.document = ExpensesDocument;

useExpensesQuery.getKey = (variables: ExpensesQueryVariables) => ['expenses', variables];

export const GetProjectBudgetDocument = `
    query getProjectBudget($id: Int!) {
  projectBudget(id: $id) {
    totalBudgetedAmount
    totalEffectiveAmount
    budgetOverrun
  }
}
    `;

export const useGetProjectBudgetQuery = <
      TData = GetProjectBudgetQuery,
      TError = unknown
    >(
      variables: GetProjectBudgetQueryVariables,
      options?: Omit<UseQueryOptions<GetProjectBudgetQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProjectBudgetQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProjectBudgetQuery, TError, TData>(
      {
    queryKey: ['getProjectBudget', variables],
    queryFn: fetchData<GetProjectBudgetQuery, GetProjectBudgetQueryVariables>(GetProjectBudgetDocument, variables),
    ...options
  }
    )};

useGetProjectBudgetQuery.document = GetProjectBudgetDocument;

useGetProjectBudgetQuery.getKey = (variables: GetProjectBudgetQueryVariables) => ['getProjectBudget', variables];

export const DeleteDocumentTemplateDocument = `
    mutation deleteDocumentTemplate($input: DeleteDocumentTemplateInput!) {
  deleteDocumentTemplate(input: $input) {
    documentTemplate {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteDocumentTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDocumentTemplateMutation, TError, DeleteDocumentTemplateMutationVariables, TContext>) => {
    
    return useMutation<DeleteDocumentTemplateMutation, TError, DeleteDocumentTemplateMutationVariables, TContext>(
      {
    mutationKey: ['deleteDocumentTemplate'],
    mutationFn: (variables?: DeleteDocumentTemplateMutationVariables) => fetchData<DeleteDocumentTemplateMutation, DeleteDocumentTemplateMutationVariables>(DeleteDocumentTemplateDocument, variables)(),
    ...options
  }
    )};

export const EditDocumentTemplateDocument = `
    mutation editDocumentTemplate($input: EditDocumentTemplateInput!) {
  editDocumentTemplate(input: $input) {
    documentTemplate {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditDocumentTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditDocumentTemplateMutation, TError, EditDocumentTemplateMutationVariables, TContext>) => {
    
    return useMutation<EditDocumentTemplateMutation, TError, EditDocumentTemplateMutationVariables, TContext>(
      {
    mutationKey: ['editDocumentTemplate'],
    mutationFn: (variables?: EditDocumentTemplateMutationVariables) => fetchData<EditDocumentTemplateMutation, EditDocumentTemplateMutationVariables>(EditDocumentTemplateDocument, variables)(),
    ...options
  }
    )};

export const DocumentTemplatePermissionsDocument = `
    query documentTemplatePermissions($id: Int!) {
  documentTemplatePermissions(id: $id) {
    ...RoleAssignmentFragment
  }
}
    ${RoleAssignmentFragmentFragmentDoc}`;

export const useDocumentTemplatePermissionsQuery = <
      TData = DocumentTemplatePermissionsQuery,
      TError = unknown
    >(
      variables: DocumentTemplatePermissionsQueryVariables,
      options?: Omit<UseQueryOptions<DocumentTemplatePermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DocumentTemplatePermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DocumentTemplatePermissionsQuery, TError, TData>(
      {
    queryKey: ['documentTemplatePermissions', variables],
    queryFn: fetchData<DocumentTemplatePermissionsQuery, DocumentTemplatePermissionsQueryVariables>(DocumentTemplatePermissionsDocument, variables),
    ...options
  }
    )};

useDocumentTemplatePermissionsQuery.document = DocumentTemplatePermissionsDocument;

useDocumentTemplatePermissionsQuery.getKey = (variables: DocumentTemplatePermissionsQueryVariables) => ['documentTemplatePermissions', variables];

export const DocumentTemplatesDocument = `
    query documentTemplates($filter: DocumentTemplateFilterInput) {
  documentTemplates(where: $filter) {
    ...DocumentTemplateFragment
  }
}
    ${DocumentTemplateFragmentFragmentDoc}`;

export const useDocumentTemplatesQuery = <
      TData = DocumentTemplatesQuery,
      TError = unknown
    >(
      variables?: DocumentTemplatesQueryVariables,
      options?: Omit<UseQueryOptions<DocumentTemplatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DocumentTemplatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DocumentTemplatesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['documentTemplates'] : ['documentTemplates', variables],
    queryFn: fetchData<DocumentTemplatesQuery, DocumentTemplatesQueryVariables>(DocumentTemplatesDocument, variables),
    ...options
  }
    )};

useDocumentTemplatesQuery.document = DocumentTemplatesDocument;

useDocumentTemplatesQuery.getKey = (variables?: DocumentTemplatesQueryVariables) => variables === undefined ? ['documentTemplates'] : ['documentTemplates', variables];

export const SendSignatureRequestDocument = `
    mutation sendSignatureRequest($input: SendSignatureRequestInput!) {
  sendSignatureRequest(input: $input) {
    document {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useSendSignatureRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendSignatureRequestMutation, TError, SendSignatureRequestMutationVariables, TContext>) => {
    
    return useMutation<SendSignatureRequestMutation, TError, SendSignatureRequestMutationVariables, TContext>(
      {
    mutationKey: ['sendSignatureRequest'],
    mutationFn: (variables?: SendSignatureRequestMutationVariables) => fetchData<SendSignatureRequestMutation, SendSignatureRequestMutationVariables>(SendSignatureRequestDocument, variables)(),
    ...options
  }
    )};

export const PublishDocumentDocument = `
    mutation publishDocument($input: PublishDocumentInput!) {
  publishDocument(input: $input) {
    document {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const usePublishDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PublishDocumentMutation, TError, PublishDocumentMutationVariables, TContext>) => {
    
    return useMutation<PublishDocumentMutation, TError, PublishDocumentMutationVariables, TContext>(
      {
    mutationKey: ['publishDocument'],
    mutationFn: (variables?: PublishDocumentMutationVariables) => fetchData<PublishDocumentMutation, PublishDocumentMutationVariables>(PublishDocumentDocument, variables)(),
    ...options
  }
    )};

export const RemoveDocumentDocument = `
    mutation removeDocument($input: RemoveDocumentInput!) {
  removeDocument(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRemoveDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveDocumentMutation, TError, RemoveDocumentMutationVariables, TContext>) => {
    
    return useMutation<RemoveDocumentMutation, TError, RemoveDocumentMutationVariables, TContext>(
      {
    mutationKey: ['removeDocument'],
    mutationFn: (variables?: RemoveDocumentMutationVariables) => fetchData<RemoveDocumentMutation, RemoveDocumentMutationVariables>(RemoveDocumentDocument, variables)(),
    ...options
  }
    )};

export const CancelSignatureRequestDocument = `
    mutation cancelSignatureRequest($input: CancelSignatureRequestInput!) {
  cancelSignatureRequest(input: $input) {
    document {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useCancelSignatureRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CancelSignatureRequestMutation, TError, CancelSignatureRequestMutationVariables, TContext>) => {
    
    return useMutation<CancelSignatureRequestMutation, TError, CancelSignatureRequestMutationVariables, TContext>(
      {
    mutationKey: ['cancelSignatureRequest'],
    mutationFn: (variables?: CancelSignatureRequestMutationVariables) => fetchData<CancelSignatureRequestMutation, CancelSignatureRequestMutationVariables>(CancelSignatureRequestDocument, variables)(),
    ...options
  }
    )};

export const RenameDocumentDocument = `
    mutation renameDocument($input: RenameDocumentInput!) {
  renameDocument(input: $input) {
    document {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRenameDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RenameDocumentMutation, TError, RenameDocumentMutationVariables, TContext>) => {
    
    return useMutation<RenameDocumentMutation, TError, RenameDocumentMutationVariables, TContext>(
      {
    mutationKey: ['renameDocument'],
    mutationFn: (variables?: RenameDocumentMutationVariables) => fetchData<RenameDocumentMutation, RenameDocumentMutationVariables>(RenameDocumentDocument, variables)(),
    ...options
  }
    )};

export const SignDocumentDocument = `
    mutation signDocument($input: SignDocumentInput!) {
  signDocument(input: $input) {
    document {
      id
    }
    errors {
      ... on WorkflowExecutionFatalError {
        message
        correlationId
        __typename
      }
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useSignDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SignDocumentMutation, TError, SignDocumentMutationVariables, TContext>) => {
    
    return useMutation<SignDocumentMutation, TError, SignDocumentMutationVariables, TContext>(
      {
    mutationKey: ['signDocument'],
    mutationFn: (variables?: SignDocumentMutationVariables) => fetchData<SignDocumentMutation, SignDocumentMutationVariables>(SignDocumentDocument, variables)(),
    ...options
  }
    )};

export const UnpublishDocumentDocument = `
    mutation unpublishDocument($input: UnpublishDocumentInput!) {
  unpublishDocument(input: $input) {
    document {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUnpublishDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnpublishDocumentMutation, TError, UnpublishDocumentMutationVariables, TContext>) => {
    
    return useMutation<UnpublishDocumentMutation, TError, UnpublishDocumentMutationVariables, TContext>(
      {
    mutationKey: ['unpublishDocument'],
    mutationFn: (variables?: UnpublishDocumentMutationVariables) => fetchData<UnpublishDocumentMutation, UnpublishDocumentMutationVariables>(UnpublishDocumentDocument, variables)(),
    ...options
  }
    )};

export const FilePickerDocumentsDocument = `
    query filePickerDocuments($projectId: Int!, $filter: DocumentFilterInput) {
  projectDocuments(projectId: $projectId, where: $filter) {
    ...FilePickerDocumentFragment
  }
}
    ${FilePickerDocumentFragmentFragmentDoc}`;

export const useFilePickerDocumentsQuery = <
      TData = FilePickerDocumentsQuery,
      TError = unknown
    >(
      variables: FilePickerDocumentsQueryVariables,
      options?: Omit<UseQueryOptions<FilePickerDocumentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FilePickerDocumentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FilePickerDocumentsQuery, TError, TData>(
      {
    queryKey: ['filePickerDocuments', variables],
    queryFn: fetchData<FilePickerDocumentsQuery, FilePickerDocumentsQueryVariables>(FilePickerDocumentsDocument, variables),
    ...options
  }
    )};

useFilePickerDocumentsQuery.document = FilePickerDocumentsDocument;

useFilePickerDocumentsQuery.getKey = (variables: FilePickerDocumentsQueryVariables) => ['filePickerDocuments', variables];

export const GetDocumentDocument = `
    query getDocument($id: Int!, $filter: DocumentFilterInput) {
  document(documentId: $id, where: $filter) {
    ...DocumentFragment
  }
}
    ${DocumentFragmentFragmentDoc}`;

export const useGetDocumentQuery = <
      TData = GetDocumentQuery,
      TError = unknown
    >(
      variables: GetDocumentQueryVariables,
      options?: Omit<UseQueryOptions<GetDocumentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetDocumentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetDocumentQuery, TError, TData>(
      {
    queryKey: ['getDocument', variables],
    queryFn: fetchData<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, variables),
    ...options
  }
    )};

useGetDocumentQuery.document = GetDocumentDocument;

useGetDocumentQuery.getKey = (variables: GetDocumentQueryVariables) => ['getDocument', variables];

export const GetMembersWithAccessTokensByDocumentDocument = `
    query getMembersWithAccessTokensByDocument($documentId: Int!) {
  users(where: {projectAccessTokens: {some: {documentId: {eq: $documentId}}}}) {
    id
  }
}
    `;

export const useGetMembersWithAccessTokensByDocumentQuery = <
      TData = GetMembersWithAccessTokensByDocumentQuery,
      TError = unknown
    >(
      variables: GetMembersWithAccessTokensByDocumentQueryVariables,
      options?: Omit<UseQueryOptions<GetMembersWithAccessTokensByDocumentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMembersWithAccessTokensByDocumentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMembersWithAccessTokensByDocumentQuery, TError, TData>(
      {
    queryKey: ['getMembersWithAccessTokensByDocument', variables],
    queryFn: fetchData<GetMembersWithAccessTokensByDocumentQuery, GetMembersWithAccessTokensByDocumentQueryVariables>(GetMembersWithAccessTokensByDocumentDocument, variables),
    ...options
  }
    )};

useGetMembersWithAccessTokensByDocumentQuery.document = GetMembersWithAccessTokensByDocumentDocument;

useGetMembersWithAccessTokensByDocumentQuery.getKey = (variables: GetMembersWithAccessTokensByDocumentQueryVariables) => ['getMembersWithAccessTokensByDocument', variables];

export const ZohoEmbedUrlDocument = `
    query zohoEmbedUrl($actionId: String!, $requestId: String!) {
  zohoEmbedUrl(actionId: $actionId, requestId: $requestId)
}
    `;

export const useZohoEmbedUrlQuery = <
      TData = ZohoEmbedUrlQuery,
      TError = unknown
    >(
      variables: ZohoEmbedUrlQueryVariables,
      options?: Omit<UseQueryOptions<ZohoEmbedUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ZohoEmbedUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ZohoEmbedUrlQuery, TError, TData>(
      {
    queryKey: ['zohoEmbedUrl', variables],
    queryFn: fetchData<ZohoEmbedUrlQuery, ZohoEmbedUrlQueryVariables>(ZohoEmbedUrlDocument, variables),
    ...options
  }
    )};

useZohoEmbedUrlQuery.document = ZohoEmbedUrlDocument;

useZohoEmbedUrlQuery.getKey = (variables: ZohoEmbedUrlQueryVariables) => ['zohoEmbedUrl', variables];

export const ProjectDocumentsDocument = `
    query projectDocuments($projectId: Int!, $filter: DocumentFilterInput) {
  projectDocuments(projectId: $projectId, where: $filter) {
    ...DocumentFragment
  }
}
    ${DocumentFragmentFragmentDoc}`;

export const useProjectDocumentsQuery = <
      TData = ProjectDocumentsQuery,
      TError = unknown
    >(
      variables: ProjectDocumentsQueryVariables,
      options?: Omit<UseQueryOptions<ProjectDocumentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectDocumentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectDocumentsQuery, TError, TData>(
      {
    queryKey: ['projectDocuments', variables],
    queryFn: fetchData<ProjectDocumentsQuery, ProjectDocumentsQueryVariables>(ProjectDocumentsDocument, variables),
    ...options
  }
    )};

useProjectDocumentsQuery.document = ProjectDocumentsDocument;

useProjectDocumentsQuery.getKey = (variables: ProjectDocumentsQueryVariables) => ['projectDocuments', variables];

export const FeatureFlagsDocument = `
    query featureFlags {
  featureFlags {
    documentTemplatesEnabled
  }
}
    `;

export const useFeatureFlagsQuery = <
      TData = FeatureFlagsQuery,
      TError = unknown
    >(
      variables?: FeatureFlagsQueryVariables,
      options?: Omit<UseQueryOptions<FeatureFlagsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeatureFlagsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FeatureFlagsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['featureFlags'] : ['featureFlags', variables],
    queryFn: fetchData<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, variables),
    ...options
  }
    )};

useFeatureFlagsQuery.document = FeatureFlagsDocument;

useFeatureFlagsQuery.getKey = (variables?: FeatureFlagsQueryVariables) => variables === undefined ? ['featureFlags'] : ['featureFlags', variables];

export const AddExternalLinkDocument = `
    mutation addExternalLink($input: AddExternalLinkInput!) {
  addExternalLink(input: $input) {
    externalLink {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddExternalLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddExternalLinkMutation, TError, AddExternalLinkMutationVariables, TContext>) => {
    
    return useMutation<AddExternalLinkMutation, TError, AddExternalLinkMutationVariables, TContext>(
      {
    mutationKey: ['addExternalLink'],
    mutationFn: (variables?: AddExternalLinkMutationVariables) => fetchData<AddExternalLinkMutation, AddExternalLinkMutationVariables>(AddExternalLinkDocument, variables)(),
    ...options
  }
    )};

export const AddFolderDocument = `
    mutation addFolder($input: AddFolderInput!) {
  addFolder(input: $input) {
    folder {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddFolderMutation, TError, AddFolderMutationVariables, TContext>) => {
    
    return useMutation<AddFolderMutation, TError, AddFolderMutationVariables, TContext>(
      {
    mutationKey: ['addFolder'],
    mutationFn: (variables?: AddFolderMutationVariables) => fetchData<AddFolderMutation, AddFolderMutationVariables>(AddFolderDocument, variables)(),
    ...options
  }
    )};

export const DeleteExternalLinkDocument = `
    mutation deleteExternalLink($input: DeleteExternalLinkInput!) {
  deleteExternalLink(input: $input) {
    externalLink {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteExternalLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteExternalLinkMutation, TError, DeleteExternalLinkMutationVariables, TContext>) => {
    
    return useMutation<DeleteExternalLinkMutation, TError, DeleteExternalLinkMutationVariables, TContext>(
      {
    mutationKey: ['deleteExternalLink'],
    mutationFn: (variables?: DeleteExternalLinkMutationVariables) => fetchData<DeleteExternalLinkMutation, DeleteExternalLinkMutationVariables>(DeleteExternalLinkDocument, variables)(),
    ...options
  }
    )};

export const DeleteFolderDocument = `
    mutation deleteFolder($input: DeleteFolderInput!) {
  deleteFolder(input: $input) {
    folder {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteFolderMutation, TError, DeleteFolderMutationVariables, TContext>) => {
    
    return useMutation<DeleteFolderMutation, TError, DeleteFolderMutationVariables, TContext>(
      {
    mutationKey: ['deleteFolder'],
    mutationFn: (variables?: DeleteFolderMutationVariables) => fetchData<DeleteFolderMutation, DeleteFolderMutationVariables>(DeleteFolderDocument, variables)(),
    ...options
  }
    )};

export const MoveFolderEntryDocument = `
    mutation moveFolderEntry($input: MoveFolderEntryInput!) {
  moveFolderEntry(input: $input) {
    folderEntry {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useMoveFolderEntryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveFolderEntryMutation, TError, MoveFolderEntryMutationVariables, TContext>) => {
    
    return useMutation<MoveFolderEntryMutation, TError, MoveFolderEntryMutationVariables, TContext>(
      {
    mutationKey: ['moveFolderEntry'],
    mutationFn: (variables?: MoveFolderEntryMutationVariables) => fetchData<MoveFolderEntryMutation, MoveFolderEntryMutationVariables>(MoveFolderEntryDocument, variables)(),
    ...options
  }
    )};

export const MoveFolderDocument = `
    mutation moveFolder($input: MoveFolderInput!) {
  moveFolder(input: $input) {
    folder {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useMoveFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveFolderMutation, TError, MoveFolderMutationVariables, TContext>) => {
    
    return useMutation<MoveFolderMutation, TError, MoveFolderMutationVariables, TContext>(
      {
    mutationKey: ['moveFolder'],
    mutationFn: (variables?: MoveFolderMutationVariables) => fetchData<MoveFolderMutation, MoveFolderMutationVariables>(MoveFolderDocument, variables)(),
    ...options
  }
    )};

export const RenameFolderDocument = `
    mutation renameFolder($input: RenameFolderInput!) {
  renameFolder(input: $input) {
    folder {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRenameFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RenameFolderMutation, TError, RenameFolderMutationVariables, TContext>) => {
    
    return useMutation<RenameFolderMutation, TError, RenameFolderMutationVariables, TContext>(
      {
    mutationKey: ['renameFolder'],
    mutationFn: (variables?: RenameFolderMutationVariables) => fetchData<RenameFolderMutation, RenameFolderMutationVariables>(RenameFolderDocument, variables)(),
    ...options
  }
    )};

export const ChildFoldersDocument = `
    query childFolders($parentFolderId: Int!) {
  childFolders(parentFolderId: $parentFolderId) {
    ...FolderFragment
  }
}
    ${FolderFragmentFragmentDoc}`;

export const useChildFoldersQuery = <
      TData = ChildFoldersQuery,
      TError = unknown
    >(
      variables: ChildFoldersQueryVariables,
      options?: Omit<UseQueryOptions<ChildFoldersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ChildFoldersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ChildFoldersQuery, TError, TData>(
      {
    queryKey: ['childFolders', variables],
    queryFn: fetchData<ChildFoldersQuery, ChildFoldersQueryVariables>(ChildFoldersDocument, variables),
    ...options
  }
    )};

useChildFoldersQuery.document = ChildFoldersDocument;

useChildFoldersQuery.getKey = (variables: ChildFoldersQueryVariables) => ['childFolders', variables];

export const DocumentPermissionsDocument = `
    query documentPermissions($projectId: Int!, $documentId: Int!) {
  documentPermissions(projectId: $projectId, documentId: $documentId) {
    ...RoleAssignmentFragment
  }
}
    ${RoleAssignmentFragmentFragmentDoc}`;

export const useDocumentPermissionsQuery = <
      TData = DocumentPermissionsQuery,
      TError = unknown
    >(
      variables: DocumentPermissionsQueryVariables,
      options?: Omit<UseQueryOptions<DocumentPermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DocumentPermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DocumentPermissionsQuery, TError, TData>(
      {
    queryKey: ['documentPermissions', variables],
    queryFn: fetchData<DocumentPermissionsQuery, DocumentPermissionsQueryVariables>(DocumentPermissionsDocument, variables),
    ...options
  }
    )};

useDocumentPermissionsQuery.document = DocumentPermissionsDocument;

useDocumentPermissionsQuery.getKey = (variables: DocumentPermissionsQueryVariables) => ['documentPermissions', variables];

export const ExternalLinkPermissionsDocument = `
    query externalLinkPermissions($projectId: Int!, $linkId: Int!) {
  externalLinkPermissions(projectId: $projectId, linkId: $linkId) {
    ...RoleAssignmentFragment
  }
}
    ${RoleAssignmentFragmentFragmentDoc}`;

export const useExternalLinkPermissionsQuery = <
      TData = ExternalLinkPermissionsQuery,
      TError = unknown
    >(
      variables: ExternalLinkPermissionsQueryVariables,
      options?: Omit<UseQueryOptions<ExternalLinkPermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ExternalLinkPermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ExternalLinkPermissionsQuery, TError, TData>(
      {
    queryKey: ['externalLinkPermissions', variables],
    queryFn: fetchData<ExternalLinkPermissionsQuery, ExternalLinkPermissionsQueryVariables>(ExternalLinkPermissionsDocument, variables),
    ...options
  }
    )};

useExternalLinkPermissionsQuery.document = ExternalLinkPermissionsDocument;

useExternalLinkPermissionsQuery.getKey = (variables: ExternalLinkPermissionsQueryVariables) => ['externalLinkPermissions', variables];

export const FolderEntriesDocument = `
    query folderEntries($projectId: Int!, $folderId: Int!, $filter: FolderEntryFilterInput) {
  folderEntries(projectId: $projectId, folderId: $folderId, where: $filter) {
    ...FolderEntryFragment
  }
}
    ${FolderEntryFragmentFragmentDoc}
${DocumentFragmentFragmentDoc}
${ExternalLinkFragmentFragmentDoc}`;

export const useFolderEntriesQuery = <
      TData = FolderEntriesQuery,
      TError = unknown
    >(
      variables: FolderEntriesQueryVariables,
      options?: Omit<UseQueryOptions<FolderEntriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FolderEntriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FolderEntriesQuery, TError, TData>(
      {
    queryKey: ['folderEntries', variables],
    queryFn: fetchData<FolderEntriesQuery, FolderEntriesQueryVariables>(FolderEntriesDocument, variables),
    ...options
  }
    )};

useFolderEntriesQuery.document = FolderEntriesDocument;

useFolderEntriesQuery.getKey = (variables: FolderEntriesQueryVariables) => ['folderEntries', variables];

export const FolderEntryDocument = `
    query folderEntry($id: Int!) {
  folderEntry(entryId: $id) {
    ...FolderEntryFragment
  }
}
    ${FolderEntryFragmentFragmentDoc}
${DocumentFragmentFragmentDoc}
${ExternalLinkFragmentFragmentDoc}`;

export const useFolderEntryQuery = <
      TData = FolderEntryQuery,
      TError = unknown
    >(
      variables: FolderEntryQueryVariables,
      options?: Omit<UseQueryOptions<FolderEntryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FolderEntryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FolderEntryQuery, TError, TData>(
      {
    queryKey: ['folderEntry', variables],
    queryFn: fetchData<FolderEntryQuery, FolderEntryQueryVariables>(FolderEntryDocument, variables),
    ...options
  }
    )};

useFolderEntryQuery.document = FolderEntryDocument;

useFolderEntryQuery.getKey = (variables: FolderEntryQueryVariables) => ['folderEntry', variables];

export const FolderImageDocumentsDocument = `
    query folderImageDocuments($projectId: Int!, $folderId: Int!) {
  folderEntries(
    projectId: $projectId
    folderId: $folderId
    where: {document: {thumbnailStatus: {neq: NotAnImage}}}
  ) {
    document {
      id
      imageThumbnailUrl
      fileName
      thumbnailStatus
    }
  }
}
    `;

export const useFolderImageDocumentsQuery = <
      TData = FolderImageDocumentsQuery,
      TError = unknown
    >(
      variables: FolderImageDocumentsQueryVariables,
      options?: Omit<UseQueryOptions<FolderImageDocumentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FolderImageDocumentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FolderImageDocumentsQuery, TError, TData>(
      {
    queryKey: ['folderImageDocuments', variables],
    queryFn: fetchData<FolderImageDocumentsQuery, FolderImageDocumentsQueryVariables>(FolderImageDocumentsDocument, variables),
    ...options
  }
    )};

useFolderImageDocumentsQuery.document = FolderImageDocumentsDocument;

useFolderImageDocumentsQuery.getKey = (variables: FolderImageDocumentsQueryVariables) => ['folderImageDocuments', variables];

export const FolderPermissionsDocument = `
    query folderPermissions($projectId: Int!, $folderId: Int!) {
  folderPermissions(projectId: $projectId, folderId: $folderId) {
    ...RoleAssignmentFragment
  }
}
    ${RoleAssignmentFragmentFragmentDoc}`;

export const useFolderPermissionsQuery = <
      TData = FolderPermissionsQuery,
      TError = unknown
    >(
      variables: FolderPermissionsQueryVariables,
      options?: Omit<UseQueryOptions<FolderPermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FolderPermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FolderPermissionsQuery, TError, TData>(
      {
    queryKey: ['folderPermissions', variables],
    queryFn: fetchData<FolderPermissionsQuery, FolderPermissionsQueryVariables>(FolderPermissionsDocument, variables),
    ...options
  }
    )};

useFolderPermissionsQuery.document = FolderPermissionsDocument;

useFolderPermissionsQuery.getKey = (variables: FolderPermissionsQueryVariables) => ['folderPermissions', variables];

export const FolderPropertiesDocument = `
    query folderProperties($folderId: Int!, $projectId: Int!) {
  folder(folderId: $folderId, projectId: $projectId) {
    id
    name
    folderType
    path
    entries {
      id
    }
  }
}
    `;

export const useFolderPropertiesQuery = <
      TData = FolderPropertiesQuery,
      TError = unknown
    >(
      variables: FolderPropertiesQueryVariables,
      options?: Omit<UseQueryOptions<FolderPropertiesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FolderPropertiesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FolderPropertiesQuery, TError, TData>(
      {
    queryKey: ['folderProperties', variables],
    queryFn: fetchData<FolderPropertiesQuery, FolderPropertiesQueryVariables>(FolderPropertiesDocument, variables),
    ...options
  }
    )};

useFolderPropertiesQuery.document = FolderPropertiesDocument;

useFolderPropertiesQuery.getKey = (variables: FolderPropertiesQueryVariables) => ['folderProperties', variables];

export const ProjectFolderMyPermissionsDocument = `
    query projectFolderMyPermissions($projectId: Int!, $folderId: Int!) {
  folder(projectId: $projectId, folderId: $folderId) {
    id
    myPermissions
  }
}
    `;

export const useProjectFolderMyPermissionsQuery = <
      TData = ProjectFolderMyPermissionsQuery,
      TError = unknown
    >(
      variables: ProjectFolderMyPermissionsQueryVariables,
      options?: Omit<UseQueryOptions<ProjectFolderMyPermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectFolderMyPermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectFolderMyPermissionsQuery, TError, TData>(
      {
    queryKey: ['projectFolderMyPermissions', variables],
    queryFn: fetchData<ProjectFolderMyPermissionsQuery, ProjectFolderMyPermissionsQueryVariables>(ProjectFolderMyPermissionsDocument, variables),
    ...options
  }
    )};

useProjectFolderMyPermissionsQuery.document = ProjectFolderMyPermissionsDocument;

useProjectFolderMyPermissionsQuery.getKey = (variables: ProjectFolderMyPermissionsQueryVariables) => ['projectFolderMyPermissions', variables];

export const ProjectFoldersDocument = `
    query projectFolders($projectId: Int!, $filter: FolderFilterInput) {
  projectFolders(projectId: $projectId, where: $filter) {
    ...FolderFragment
  }
}
    ${FolderFragmentFragmentDoc}`;

export const useProjectFoldersQuery = <
      TData = ProjectFoldersQuery,
      TError = unknown
    >(
      variables: ProjectFoldersQueryVariables,
      options?: Omit<UseQueryOptions<ProjectFoldersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectFoldersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectFoldersQuery, TError, TData>(
      {
    queryKey: ['projectFolders', variables],
    queryFn: fetchData<ProjectFoldersQuery, ProjectFoldersQueryVariables>(ProjectFoldersDocument, variables),
    ...options
  }
    )};

useProjectFoldersQuery.document = ProjectFoldersDocument;

useProjectFoldersQuery.getKey = (variables: ProjectFoldersQueryVariables) => ['projectFolders', variables];

export const ProjectFormPermissionsDocument = `
    query projectFormPermissions($projectId: Int!, $formId: Int!) {
  projectFormPermissions(projectId: $projectId, formId: $formId) {
    ...RoleAssignmentFragment
  }
}
    ${RoleAssignmentFragmentFragmentDoc}`;

export const useProjectFormPermissionsQuery = <
      TData = ProjectFormPermissionsQuery,
      TError = unknown
    >(
      variables: ProjectFormPermissionsQueryVariables,
      options?: Omit<UseQueryOptions<ProjectFormPermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectFormPermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectFormPermissionsQuery, TError, TData>(
      {
    queryKey: ['projectFormPermissions', variables],
    queryFn: fetchData<ProjectFormPermissionsQuery, ProjectFormPermissionsQueryVariables>(ProjectFormPermissionsDocument, variables),
    ...options
  }
    )};

useProjectFormPermissionsQuery.document = ProjectFormPermissionsDocument;

useProjectFormPermissionsQuery.getKey = (variables: ProjectFormPermissionsQueryVariables) => ['projectFormPermissions', variables];

export const CollectFormResponsesDocument = `
    mutation collectFormResponses($input: CollectFormResponsesInput!) {
  collectFormResponses(input: $input) {
    projectForm {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useCollectFormResponsesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CollectFormResponsesMutation, TError, CollectFormResponsesMutationVariables, TContext>) => {
    
    return useMutation<CollectFormResponsesMutation, TError, CollectFormResponsesMutationVariables, TContext>(
      {
    mutationKey: ['collectFormResponses'],
    mutationFn: (variables?: CollectFormResponsesMutationVariables) => fetchData<CollectFormResponsesMutation, CollectFormResponsesMutationVariables>(CollectFormResponsesDocument, variables)(),
    ...options
  }
    )};

export const AddFormConditionDocument = `
    mutation addFormCondition($input: AddConditionInput!) {
  addCondition(input: $input) {
    formCondition {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddFormConditionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddFormConditionMutation, TError, AddFormConditionMutationVariables, TContext>) => {
    
    return useMutation<AddFormConditionMutation, TError, AddFormConditionMutationVariables, TContext>(
      {
    mutationKey: ['addFormCondition'],
    mutationFn: (variables?: AddFormConditionMutationVariables) => fetchData<AddFormConditionMutation, AddFormConditionMutationVariables>(AddFormConditionDocument, variables)(),
    ...options
  }
    )};

export const DeleteFormConditionDocument = `
    mutation deleteFormCondition($input: DeleteConditionInput!) {
  deleteCondition(input: $input) {
    formCondition {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteFormConditionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteFormConditionMutation, TError, DeleteFormConditionMutationVariables, TContext>) => {
    
    return useMutation<DeleteFormConditionMutation, TError, DeleteFormConditionMutationVariables, TContext>(
      {
    mutationKey: ['deleteFormCondition'],
    mutationFn: (variables?: DeleteFormConditionMutationVariables) => fetchData<DeleteFormConditionMutation, DeleteFormConditionMutationVariables>(DeleteFormConditionDocument, variables)(),
    ...options
  }
    )};

export const EditFormConditionDocument = `
    mutation editFormCondition($input: EditConditionInput!) {
  editCondition(input: $input) {
    formCondition {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditFormConditionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditFormConditionMutation, TError, EditFormConditionMutationVariables, TContext>) => {
    
    return useMutation<EditFormConditionMutation, TError, EditFormConditionMutationVariables, TContext>(
      {
    mutationKey: ['editFormCondition'],
    mutationFn: (variables?: EditFormConditionMutationVariables) => fetchData<EditFormConditionMutation, EditFormConditionMutationVariables>(EditFormConditionDocument, variables)(),
    ...options
  }
    )};

export const EditFormDefinitionDocument = `
    mutation editFormDefinition($input: EditFormDefinitionInput!) {
  editFormDefinition(input: $input) {
    formDefinition {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditFormDefinitionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditFormDefinitionMutation, TError, EditFormDefinitionMutationVariables, TContext>) => {
    
    return useMutation<EditFormDefinitionMutation, TError, EditFormDefinitionMutationVariables, TContext>(
      {
    mutationKey: ['editFormDefinition'],
    mutationFn: (variables?: EditFormDefinitionMutationVariables) => fetchData<EditFormDefinitionMutation, EditFormDefinitionMutationVariables>(EditFormDefinitionDocument, variables)(),
    ...options
  }
    )};

export const CreateFormFieldDocument = `
    mutation createFormField($input: CreateFormFieldInput!) {
  createFormField(input: $input) {
    formField {
      ...FormFieldFragment
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    ${FormFieldFragmentFragmentDoc}
${MatrixFragmentFragmentDoc}
${MatrixRowFragmentFragmentDoc}`;

export const useCreateFormFieldMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFormFieldMutation, TError, CreateFormFieldMutationVariables, TContext>) => {
    
    return useMutation<CreateFormFieldMutation, TError, CreateFormFieldMutationVariables, TContext>(
      {
    mutationKey: ['createFormField'],
    mutationFn: (variables?: CreateFormFieldMutationVariables) => fetchData<CreateFormFieldMutation, CreateFormFieldMutationVariables>(CreateFormFieldDocument, variables)(),
    ...options
  }
    )};

export const DeleteFormFieldDocument = `
    mutation deleteFormField($input: DeleteFormFieldInput!) {
  deleteFormField(input: $input) {
    formField {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteFormFieldMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteFormFieldMutation, TError, DeleteFormFieldMutationVariables, TContext>) => {
    
    return useMutation<DeleteFormFieldMutation, TError, DeleteFormFieldMutationVariables, TContext>(
      {
    mutationKey: ['deleteFormField'],
    mutationFn: (variables?: DeleteFormFieldMutationVariables) => fetchData<DeleteFormFieldMutation, DeleteFormFieldMutationVariables>(DeleteFormFieldDocument, variables)(),
    ...options
  }
    )};

export const EditFormFieldDocument = `
    mutation editFormField($input: EditFormFieldInput!) {
  editFormField(input: $input) {
    formField {
      ...FormFieldFragment
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    ${FormFieldFragmentFragmentDoc}
${MatrixFragmentFragmentDoc}
${MatrixRowFragmentFragmentDoc}`;

export const useEditFormFieldMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditFormFieldMutation, TError, EditFormFieldMutationVariables, TContext>) => {
    
    return useMutation<EditFormFieldMutation, TError, EditFormFieldMutationVariables, TContext>(
      {
    mutationKey: ['editFormField'],
    mutationFn: (variables?: EditFormFieldMutationVariables) => fetchData<EditFormFieldMutation, EditFormFieldMutationVariables>(EditFormFieldDocument, variables)(),
    ...options
  }
    )};

export const MoveFormFieldDocument = `
    mutation moveFormField($input: MoveFormFieldInput!) {
  moveFormField(input: $input) {
    formField {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useMoveFormFieldMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveFormFieldMutation, TError, MoveFormFieldMutationVariables, TContext>) => {
    
    return useMutation<MoveFormFieldMutation, TError, MoveFormFieldMutationVariables, TContext>(
      {
    mutationKey: ['moveFormField'],
    mutationFn: (variables?: MoveFormFieldMutationVariables) => fetchData<MoveFormFieldMutation, MoveFormFieldMutationVariables>(MoveFormFieldDocument, variables)(),
    ...options
  }
    )};

export const FillFormDocument = `
    mutation fillForm($input: FillFormInput!) {
  fillForm(input: $input) {
    projectFormSubmission {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useFillFormMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FillFormMutation, TError, FillFormMutationVariables, TContext>) => {
    
    return useMutation<FillFormMutation, TError, FillFormMutationVariables, TContext>(
      {
    mutationKey: ['fillForm'],
    mutationFn: (variables?: FillFormMutationVariables) => fetchData<FillFormMutation, FillFormMutationVariables>(FillFormDocument, variables)(),
    ...options
  }
    )};

export const AddMatrixRowDocument = `
    mutation addMatrixRow($input: AddMatrixRowInput!) {
  addMatrixRow(input: $input) {
    matrixRow {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddMatrixRowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddMatrixRowMutation, TError, AddMatrixRowMutationVariables, TContext>) => {
    
    return useMutation<AddMatrixRowMutation, TError, AddMatrixRowMutationVariables, TContext>(
      {
    mutationKey: ['addMatrixRow'],
    mutationFn: (variables?: AddMatrixRowMutationVariables) => fetchData<AddMatrixRowMutation, AddMatrixRowMutationVariables>(AddMatrixRowDocument, variables)(),
    ...options
  }
    )};

export const FillMatrixValueDocument = `
    mutation fillMatrixValue($input: FillMatrixValueInput!) {
  fillMatrixValue(input: $input) {
    matrixValue {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useFillMatrixValueMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FillMatrixValueMutation, TError, FillMatrixValueMutationVariables, TContext>) => {
    
    return useMutation<FillMatrixValueMutation, TError, FillMatrixValueMutationVariables, TContext>(
      {
    mutationKey: ['fillMatrixValue'],
    mutationFn: (variables?: FillMatrixValueMutationVariables) => fetchData<FillMatrixValueMutation, FillMatrixValueMutationVariables>(FillMatrixValueDocument, variables)(),
    ...options
  }
    )};

export const RemoveFileAttachmentDocument = `
    mutation removeFileAttachment($input: DeleteFormAttachmentInput!) {
  deleteFormAttachment(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRemoveFileAttachmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveFileAttachmentMutation, TError, RemoveFileAttachmentMutationVariables, TContext>) => {
    
    return useMutation<RemoveFileAttachmentMutation, TError, RemoveFileAttachmentMutationVariables, TContext>(
      {
    mutationKey: ['removeFileAttachment'],
    mutationFn: (variables?: RemoveFileAttachmentMutationVariables) => fetchData<RemoveFileAttachmentMutation, RemoveFileAttachmentMutationVariables>(RemoveFileAttachmentDocument, variables)(),
    ...options
  }
    )};

export const RemoveMatrixRowDocument = `
    mutation removeMatrixRow($input: RemoveMatrixRowInput!) {
  removeMatrixRow(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRemoveMatrixRowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveMatrixRowMutation, TError, RemoveMatrixRowMutationVariables, TContext>) => {
    
    return useMutation<RemoveMatrixRowMutation, TError, RemoveMatrixRowMutationVariables, TContext>(
      {
    mutationKey: ['removeMatrixRow'],
    mutationFn: (variables?: RemoveMatrixRowMutationVariables) => fetchData<RemoveMatrixRowMutation, RemoveMatrixRowMutationVariables>(RemoveMatrixRowDocument, variables)(),
    ...options
  }
    )};

export const RemoveFormPresenceDocument = `
    mutation RemoveFormPresence($input: RemovePresenceInput!) {
  removePresence(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRemoveFormPresenceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveFormPresenceMutation, TError, RemoveFormPresenceMutationVariables, TContext>) => {
    
    return useMutation<RemoveFormPresenceMutation, TError, RemoveFormPresenceMutationVariables, TContext>(
      {
    mutationKey: ['RemoveFormPresence'],
    mutationFn: (variables?: RemoveFormPresenceMutationVariables) => fetchData<RemoveFormPresenceMutation, RemoveFormPresenceMutationVariables>(RemoveFormPresenceDocument, variables)(),
    ...options
  }
    )};

export const UpdateFormPresenceDocument = `
    mutation UpdateFormPresence($input: UpdatePresenceInput!) {
  updatePresence(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUpdateFormPresenceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateFormPresenceMutation, TError, UpdateFormPresenceMutationVariables, TContext>) => {
    
    return useMutation<UpdateFormPresenceMutation, TError, UpdateFormPresenceMutationVariables, TContext>(
      {
    mutationKey: ['UpdateFormPresence'],
    mutationFn: (variables?: UpdateFormPresenceMutationVariables) => fetchData<UpdateFormPresenceMutation, UpdateFormPresenceMutationVariables>(UpdateFormPresenceDocument, variables)(),
    ...options
  }
    )};

export const DeleteSubmissionDocument = `
    mutation deleteSubmission($input: DeleteFormSubmissionInput!) {
  deleteFormSubmission(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteSubmissionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSubmissionMutation, TError, DeleteSubmissionMutationVariables, TContext>) => {
    
    return useMutation<DeleteSubmissionMutation, TError, DeleteSubmissionMutationVariables, TContext>(
      {
    mutationKey: ['deleteSubmission'],
    mutationFn: (variables?: DeleteSubmissionMutationVariables) => fetchData<DeleteSubmissionMutation, DeleteSubmissionMutationVariables>(DeleteSubmissionDocument, variables)(),
    ...options
  }
    )};

export const DeleteRequestDocument = `
    mutation deleteRequest($input: DeleteRequestInput!) {
  deleteRequest(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteRequestMutation, TError, DeleteRequestMutationVariables, TContext>) => {
    
    return useMutation<DeleteRequestMutation, TError, DeleteRequestMutationVariables, TContext>(
      {
    mutationKey: ['deleteRequest'],
    mutationFn: (variables?: DeleteRequestMutationVariables) => fetchData<DeleteRequestMutation, DeleteRequestMutationVariables>(DeleteRequestDocument, variables)(),
    ...options
  }
    )};

export const AddProjectFormDocument = `
    mutation addProjectForm($input: AddProjectFormInput!) {
  addProjectForm(input: $input) {
    projectForm {
      id
      formDefinition {
        id
      }
    }
  }
}
    `;

export const useAddProjectFormMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddProjectFormMutation, TError, AddProjectFormMutationVariables, TContext>) => {
    
    return useMutation<AddProjectFormMutation, TError, AddProjectFormMutationVariables, TContext>(
      {
    mutationKey: ['addProjectForm'],
    mutationFn: (variables?: AddProjectFormMutationVariables) => fetchData<AddProjectFormMutation, AddProjectFormMutationVariables>(AddProjectFormDocument, variables)(),
    ...options
  }
    )};

export const AddProjectFormFromTemplateDocument = `
    mutation addProjectFormFromTemplate($input: AddProjectFormFromTemplateInput!) {
  addProjectFormFromTemplate(input: $input) {
    projectForm {
      id
    }
  }
}
    `;

export const useAddProjectFormFromTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddProjectFormFromTemplateMutation, TError, AddProjectFormFromTemplateMutationVariables, TContext>) => {
    
    return useMutation<AddProjectFormFromTemplateMutation, TError, AddProjectFormFromTemplateMutationVariables, TContext>(
      {
    mutationKey: ['addProjectFormFromTemplate'],
    mutationFn: (variables?: AddProjectFormFromTemplateMutationVariables) => fetchData<AddProjectFormFromTemplateMutation, AddProjectFormFromTemplateMutationVariables>(AddProjectFormFromTemplateDocument, variables)(),
    ...options
  }
    )};

export const DeleteProjectFormDocument = `
    mutation deleteProjectForm($input: DeleteProjectFormInput!) {
  deleteProjectForm(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteProjectFormMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteProjectFormMutation, TError, DeleteProjectFormMutationVariables, TContext>) => {
    
    return useMutation<DeleteProjectFormMutation, TError, DeleteProjectFormMutationVariables, TContext>(
      {
    mutationKey: ['deleteProjectForm'],
    mutationFn: (variables?: DeleteProjectFormMutationVariables) => fetchData<DeleteProjectFormMutation, DeleteProjectFormMutationVariables>(DeleteProjectFormDocument, variables)(),
    ...options
  }
    )};

export const FillFormValueDocument = `
    mutation fillFormValue($input: FillFormValueInput!) {
  fillFormValue(input: $input) {
    formValue {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useFillFormValueMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FillFormValueMutation, TError, FillFormValueMutationVariables, TContext>) => {
    
    return useMutation<FillFormValueMutation, TError, FillFormValueMutationVariables, TContext>(
      {
    mutationKey: ['fillFormValue'],
    mutationFn: (variables?: FillFormValueMutationVariables) => fetchData<FillFormValueMutation, FillFormValueMutationVariables>(FillFormValueDocument, variables)(),
    ...options
  }
    )};

export const PublishFormDocument = `
    mutation publishForm($input: PublishFormInput!) {
  publishForm(input: $input) {
    projectForm {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const usePublishFormMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PublishFormMutation, TError, PublishFormMutationVariables, TContext>) => {
    
    return useMutation<PublishFormMutation, TError, PublishFormMutationVariables, TContext>(
      {
    mutationKey: ['publishForm'],
    mutationFn: (variables?: PublishFormMutationVariables) => fetchData<PublishFormMutation, PublishFormMutationVariables>(PublishFormDocument, variables)(),
    ...options
  }
    )};

export const RequestFormSubmissionDocument = `
    mutation requestFormSubmission($input: RequestFormSubmissionInput!) {
  requestFormSubmission(input: $input) {
    projectFormSubmission {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRequestFormSubmissionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RequestFormSubmissionMutation, TError, RequestFormSubmissionMutationVariables, TContext>) => {
    
    return useMutation<RequestFormSubmissionMutation, TError, RequestFormSubmissionMutationVariables, TContext>(
      {
    mutationKey: ['requestFormSubmission'],
    mutationFn: (variables?: RequestFormSubmissionMutationVariables) => fetchData<RequestFormSubmissionMutation, RequestFormSubmissionMutationVariables>(RequestFormSubmissionDocument, variables)(),
    ...options
  }
    )};

export const RequestFormSubmissionAnonymousDocument = `
    mutation requestFormSubmissionAnonymous($input: RequestFormSubmissionAnonymousInput!) {
  requestFormSubmissionAnonymous(input: $input) {
    projectFormSubmission {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRequestFormSubmissionAnonymousMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RequestFormSubmissionAnonymousMutation, TError, RequestFormSubmissionAnonymousMutationVariables, TContext>) => {
    
    return useMutation<RequestFormSubmissionAnonymousMutation, TError, RequestFormSubmissionAnonymousMutationVariables, TContext>(
      {
    mutationKey: ['requestFormSubmissionAnonymous'],
    mutationFn: (variables?: RequestFormSubmissionAnonymousMutationVariables) => fetchData<RequestFormSubmissionAnonymousMutation, RequestFormSubmissionAnonymousMutationVariables>(RequestFormSubmissionAnonymousDocument, variables)(),
    ...options
  }
    )};

export const CreateFormSectionDocument = `
    mutation createFormSection($input: CreateFormSectionInput!) {
  createFormSection(input: $input) {
    formSection {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useCreateFormSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFormSectionMutation, TError, CreateFormSectionMutationVariables, TContext>) => {
    
    return useMutation<CreateFormSectionMutation, TError, CreateFormSectionMutationVariables, TContext>(
      {
    mutationKey: ['createFormSection'],
    mutationFn: (variables?: CreateFormSectionMutationVariables) => fetchData<CreateFormSectionMutation, CreateFormSectionMutationVariables>(CreateFormSectionDocument, variables)(),
    ...options
  }
    )};

export const DeleteFormSectionDocument = `
    mutation deleteFormSection($input: DeleteFormSectionInput!) {
  deleteFormSection(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteFormSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteFormSectionMutation, TError, DeleteFormSectionMutationVariables, TContext>) => {
    
    return useMutation<DeleteFormSectionMutation, TError, DeleteFormSectionMutationVariables, TContext>(
      {
    mutationKey: ['deleteFormSection'],
    mutationFn: (variables?: DeleteFormSectionMutationVariables) => fetchData<DeleteFormSectionMutation, DeleteFormSectionMutationVariables>(DeleteFormSectionDocument, variables)(),
    ...options
  }
    )};

export const EditFormSectionDocument = `
    mutation editFormSection($input: EditFormSectionInput!) {
  editFormSection(input: $input) {
    formSection {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditFormSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditFormSectionMutation, TError, EditFormSectionMutationVariables, TContext>) => {
    
    return useMutation<EditFormSectionMutation, TError, EditFormSectionMutationVariables, TContext>(
      {
    mutationKey: ['editFormSection'],
    mutationFn: (variables?: EditFormSectionMutationVariables) => fetchData<EditFormSectionMutation, EditFormSectionMutationVariables>(EditFormSectionDocument, variables)(),
    ...options
  }
    )};

export const ReorderFormSectionsDocument = `
    mutation reorderFormSections($input: ReorderFormSectionsInput!) {
  reorderFormSections(input: $input) {
    formDefinition {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useReorderFormSectionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderFormSectionsMutation, TError, ReorderFormSectionsMutationVariables, TContext>) => {
    
    return useMutation<ReorderFormSectionsMutation, TError, ReorderFormSectionsMutationVariables, TContext>(
      {
    mutationKey: ['reorderFormSections'],
    mutationFn: (variables?: ReorderFormSectionsMutationVariables) => fetchData<ReorderFormSectionsMutation, ReorderFormSectionsMutationVariables>(ReorderFormSectionsDocument, variables)(),
    ...options
  }
    )};

export const CreateFormTemplateDocument = `
    mutation createFormTemplate($input: FormDefinitionInput!) {
  createFormTemplate(input: {input: $input}) {
    formTemplate {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useCreateFormTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFormTemplateMutation, TError, CreateFormTemplateMutationVariables, TContext>) => {
    
    return useMutation<CreateFormTemplateMutation, TError, CreateFormTemplateMutationVariables, TContext>(
      {
    mutationKey: ['createFormTemplate'],
    mutationFn: (variables?: CreateFormTemplateMutationVariables) => fetchData<CreateFormTemplateMutation, CreateFormTemplateMutationVariables>(CreateFormTemplateDocument, variables)(),
    ...options
  }
    )};

export const CreateTemplateFromProjectFormDocument = `
    mutation createTemplateFromProjectForm($input: CreateTemplateFromProjectFormInput!) {
  createTemplateFromProjectForm(input: $input) {
    formTemplate {
      id
    }
  }
}
    `;

export const useCreateTemplateFromProjectFormMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTemplateFromProjectFormMutation, TError, CreateTemplateFromProjectFormMutationVariables, TContext>) => {
    
    return useMutation<CreateTemplateFromProjectFormMutation, TError, CreateTemplateFromProjectFormMutationVariables, TContext>(
      {
    mutationKey: ['createTemplateFromProjectForm'],
    mutationFn: (variables?: CreateTemplateFromProjectFormMutationVariables) => fetchData<CreateTemplateFromProjectFormMutation, CreateTemplateFromProjectFormMutationVariables>(CreateTemplateFromProjectFormDocument, variables)(),
    ...options
  }
    )};

export const DeleteFormTemplateDocument = `
    mutation deleteFormTemplate($id: Int!) {
  deleteFormTemplate(input: {id: $id}) {
    formTemplate {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteFormTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteFormTemplateMutation, TError, DeleteFormTemplateMutationVariables, TContext>) => {
    
    return useMutation<DeleteFormTemplateMutation, TError, DeleteFormTemplateMutationVariables, TContext>(
      {
    mutationKey: ['deleteFormTemplate'],
    mutationFn: (variables?: DeleteFormTemplateMutationVariables) => fetchData<DeleteFormTemplateMutation, DeleteFormTemplateMutationVariables>(DeleteFormTemplateDocument, variables)(),
    ...options
  }
    )};

export const DuplicateFormTemplateDocument = `
    mutation duplicateFormTemplate($input: DuplicateFormTemplateInput!) {
  duplicateFormTemplate(input: $input) {
    formTemplate {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDuplicateFormTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DuplicateFormTemplateMutation, TError, DuplicateFormTemplateMutationVariables, TContext>) => {
    
    return useMutation<DuplicateFormTemplateMutation, TError, DuplicateFormTemplateMutationVariables, TContext>(
      {
    mutationKey: ['duplicateFormTemplate'],
    mutationFn: (variables?: DuplicateFormTemplateMutationVariables) => fetchData<DuplicateFormTemplateMutation, DuplicateFormTemplateMutationVariables>(DuplicateFormTemplateDocument, variables)(),
    ...options
  }
    )};

export const RemoveTemplateRoleAssignmentDocument = `
    mutation removeTemplateRoleAssignment($input: RemoveFormTemplateRoleAssignmentInput!) {
  removeFormTemplateRoleAssignment(input: $input) {
    roleAssignment {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRemoveTemplateRoleAssignmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTemplateRoleAssignmentMutation, TError, RemoveTemplateRoleAssignmentMutationVariables, TContext>) => {
    
    return useMutation<RemoveTemplateRoleAssignmentMutation, TError, RemoveTemplateRoleAssignmentMutationVariables, TContext>(
      {
    mutationKey: ['removeTemplateRoleAssignment'],
    mutationFn: (variables?: RemoveTemplateRoleAssignmentMutationVariables) => fetchData<RemoveTemplateRoleAssignmentMutation, RemoveTemplateRoleAssignmentMutationVariables>(RemoveTemplateRoleAssignmentDocument, variables)(),
    ...options
  }
    )};

export const SendSharingTemplateNotificationDocument = `
    mutation sendSharingTemplateNotification($input: SendSharingTemplateNotificationInput!) {
  sendSharingTemplateNotification(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useSendSharingTemplateNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendSharingTemplateNotificationMutation, TError, SendSharingTemplateNotificationMutationVariables, TContext>) => {
    
    return useMutation<SendSharingTemplateNotificationMutation, TError, SendSharingTemplateNotificationMutationVariables, TContext>(
      {
    mutationKey: ['sendSharingTemplateNotification'],
    mutationFn: (variables?: SendSharingTemplateNotificationMutationVariables) => fetchData<SendSharingTemplateNotificationMutation, SendSharingTemplateNotificationMutationVariables>(SendSharingTemplateNotificationDocument, variables)(),
    ...options
  }
    )};

export const UnpublishFormDocument = `
    mutation unpublishForm($input: UnpublishFormInput!) {
  unpublishForm(input: $input) {
    projectForm {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUnpublishFormMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnpublishFormMutation, TError, UnpublishFormMutationVariables, TContext>) => {
    
    return useMutation<UnpublishFormMutation, TError, UnpublishFormMutationVariables, TContext>(
      {
    mutationKey: ['unpublishForm'],
    mutationFn: (variables?: UnpublishFormMutationVariables) => fetchData<UnpublishFormMutation, UnpublishFormMutationVariables>(UnpublishFormDocument, variables)(),
    ...options
  }
    )};

export const UpdateFormSettingsDocument = `
    mutation UpdateFormSettings($input: UpdateFormSettingsInput!) {
  updateFormSettings(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUpdateFormSettingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateFormSettingsMutation, TError, UpdateFormSettingsMutationVariables, TContext>) => {
    
    return useMutation<UpdateFormSettingsMutation, TError, UpdateFormSettingsMutationVariables, TContext>(
      {
    mutationKey: ['UpdateFormSettings'],
    mutationFn: (variables?: UpdateFormSettingsMutationVariables) => fetchData<UpdateFormSettingsMutation, UpdateFormSettingsMutationVariables>(UpdateFormSettingsDocument, variables)(),
    ...options
  }
    )};

export const PreviewProjectFormDocument = `
    query previewProjectForm($projectFormId: Int!) {
  projectForm(formId: $projectFormId) {
    formDefinition {
      ...FormDefinitionFragment
    }
  }
}
    ${FormDefinitionFragmentFragmentDoc}
${FormFieldFragmentFragmentDoc}
${MatrixFragmentFragmentDoc}
${MatrixRowFragmentFragmentDoc}`;

export const usePreviewProjectFormQuery = <
      TData = PreviewProjectFormQuery,
      TError = unknown
    >(
      variables: PreviewProjectFormQueryVariables,
      options?: Omit<UseQueryOptions<PreviewProjectFormQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PreviewProjectFormQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PreviewProjectFormQuery, TError, TData>(
      {
    queryKey: ['previewProjectForm', variables],
    queryFn: fetchData<PreviewProjectFormQuery, PreviewProjectFormQueryVariables>(PreviewProjectFormDocument, variables),
    ...options
  }
    )};

usePreviewProjectFormQuery.document = PreviewProjectFormDocument;

usePreviewProjectFormQuery.getKey = (variables: PreviewProjectFormQueryVariables) => ['previewProjectForm', variables];

export const ProjectFormDocument = `
    query projectForm($formId: Int!, $filter: ProjectFormFilterInput) {
  projectForm(formId: $formId, where: $filter) {
    id
    projectId
    status
    publishedOn
    createdOn
    createdBy {
      id
      firstName
      lastName
      fullName
    }
    ...FormAllowedUsersFragment
    formSettings {
      ...ProjectFormSettingsFragment
    }
    formDefinition {
      name
    }
    project {
      name
      isArchived
    }
  }
}
    ${FormAllowedUsersFragmentFragmentDoc}
${ProjectFormSettingsFragmentFragmentDoc}`;

export const useProjectFormQuery = <
      TData = ProjectFormQuery,
      TError = unknown
    >(
      variables: ProjectFormQueryVariables,
      options?: Omit<UseQueryOptions<ProjectFormQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectFormQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectFormQuery, TError, TData>(
      {
    queryKey: ['projectForm', variables],
    queryFn: fetchData<ProjectFormQuery, ProjectFormQueryVariables>(ProjectFormDocument, variables),
    ...options
  }
    )};

useProjectFormQuery.document = ProjectFormDocument;

useProjectFormQuery.getKey = (variables: ProjectFormQueryVariables) => ['projectForm', variables];

export const ProjectFormDefinitionDocument = `
    query projectFormDefinition($formId: Int!, $filter: ProjectFormFilterInput) {
  projectForm(formId: $formId, where: $filter) {
    formDefinition {
      ...FormDefinitionFragment
    }
  }
}
    ${FormDefinitionFragmentFragmentDoc}
${FormFieldFragmentFragmentDoc}
${MatrixFragmentFragmentDoc}
${MatrixRowFragmentFragmentDoc}`;

export const useProjectFormDefinitionQuery = <
      TData = ProjectFormDefinitionQuery,
      TError = unknown
    >(
      variables: ProjectFormDefinitionQueryVariables,
      options?: Omit<UseQueryOptions<ProjectFormDefinitionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectFormDefinitionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectFormDefinitionQuery, TError, TData>(
      {
    queryKey: ['projectFormDefinition', variables],
    queryFn: fetchData<ProjectFormDefinitionQuery, ProjectFormDefinitionQueryVariables>(ProjectFormDefinitionDocument, variables),
    ...options
  }
    )};

useProjectFormDefinitionQuery.document = ProjectFormDefinitionDocument;

useProjectFormDefinitionQuery.getKey = (variables: ProjectFormDefinitionQueryVariables) => ['projectFormDefinition', variables];

export const ProjectFormOverviewsDocument = `
    query projectFormOverviews($projectId: Int!, $filter: ProjectFormFilterInput) {
  projectFormOverviews(projectId: $projectId, where: $filter) {
    id
    formName
    status
    publishedOn
    createdOn
    createdBy
    submissionsCount
    formSettings {
      formType
      allowedRespondents
      allowedUsersRespondents {
        id
      }
      allowedSecurityGroupsRespondents {
        members {
          id
        }
      }
    }
  }
}
    `;

export const useProjectFormOverviewsQuery = <
      TData = ProjectFormOverviewsQuery,
      TError = unknown
    >(
      variables: ProjectFormOverviewsQueryVariables,
      options?: Omit<UseQueryOptions<ProjectFormOverviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectFormOverviewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectFormOverviewsQuery, TError, TData>(
      {
    queryKey: ['projectFormOverviews', variables],
    queryFn: fetchData<ProjectFormOverviewsQuery, ProjectFormOverviewsQueryVariables>(ProjectFormOverviewsDocument, variables),
    ...options
  }
    )};

useProjectFormOverviewsQuery.document = ProjectFormOverviewsDocument;

useProjectFormOverviewsQuery.getKey = (variables: ProjectFormOverviewsQueryVariables) => ['projectFormOverviews', variables];

export const ProjectFormSettingsDocument = `
    query projectFormSettings($formId: Int!) {
  projectFormSettings(formId: $formId) {
    ...ProjectFormSettingsFragment
  }
}
    ${ProjectFormSettingsFragmentFragmentDoc}`;

export const useProjectFormSettingsQuery = <
      TData = ProjectFormSettingsQuery,
      TError = unknown
    >(
      variables: ProjectFormSettingsQueryVariables,
      options?: Omit<UseQueryOptions<ProjectFormSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectFormSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectFormSettingsQuery, TError, TData>(
      {
    queryKey: ['projectFormSettings', variables],
    queryFn: fetchData<ProjectFormSettingsQuery, ProjectFormSettingsQueryVariables>(ProjectFormSettingsDocument, variables),
    ...options
  }
    )};

useProjectFormSettingsQuery.document = ProjectFormSettingsDocument;

useProjectFormSettingsQuery.getKey = (variables: ProjectFormSettingsQueryVariables) => ['projectFormSettings', variables];

export const ProjectFormsDocument = `
    query projectForms($projectId: Int!, $filter: ProjectFormFilterInput) {
  projectForms(projectId: $projectId, where: $filter) {
    id
    projectId
    status
    publishedOn
    createdOn
    createdBy {
      fullName
    }
    formSettings {
      ...ProjectFormSettingsFragment
    }
    formDefinition {
      id
      name
      description
    }
    project {
      isArchived
    }
  }
}
    ${ProjectFormSettingsFragmentFragmentDoc}`;

export const useProjectFormsQuery = <
      TData = ProjectFormsQuery,
      TError = unknown
    >(
      variables: ProjectFormsQueryVariables,
      options?: Omit<UseQueryOptions<ProjectFormsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectFormsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectFormsQuery, TError, TData>(
      {
    queryKey: ['projectForms', variables],
    queryFn: fetchData<ProjectFormsQuery, ProjectFormsQueryVariables>(ProjectFormsDocument, variables),
    ...options
  }
    )};

useProjectFormsQuery.document = ProjectFormsDocument;

useProjectFormsQuery.getKey = (variables: ProjectFormsQueryVariables) => ['projectForms', variables];

export const GetMembersWithAccessTokensByFormDocument = `
    query getMembersWithAccessTokensByForm($projectFormId: Int!) {
  users(
    where: {projectAccessTokens: {some: {projectFormId: {eq: $projectFormId}}}}
  ) {
    id
  }
}
    `;

export const useGetMembersWithAccessTokensByFormQuery = <
      TData = GetMembersWithAccessTokensByFormQuery,
      TError = unknown
    >(
      variables: GetMembersWithAccessTokensByFormQueryVariables,
      options?: Omit<UseQueryOptions<GetMembersWithAccessTokensByFormQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMembersWithAccessTokensByFormQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMembersWithAccessTokensByFormQuery, TError, TData>(
      {
    queryKey: ['getMembersWithAccessTokensByForm', variables],
    queryFn: fetchData<GetMembersWithAccessTokensByFormQuery, GetMembersWithAccessTokensByFormQueryVariables>(GetMembersWithAccessTokensByFormDocument, variables),
    ...options
  }
    )};

useGetMembersWithAccessTokensByFormQuery.document = GetMembersWithAccessTokensByFormDocument;

useGetMembersWithAccessTokensByFormQuery.getKey = (variables: GetMembersWithAccessTokensByFormQueryVariables) => ['getMembersWithAccessTokensByForm', variables];

export const FormFillerPresenceDocument = `
    query FormFillerPresence($formSubmissionId: Int!) {
  formPresences(formSubmissionId: $formSubmissionId) {
    uniqueClientId
    userId
    displayName
    fieldId
    matrixRowId
    matrixColumnId
  }
}
    `;

export const useFormFillerPresenceQuery = <
      TData = FormFillerPresenceQuery,
      TError = unknown
    >(
      variables: FormFillerPresenceQueryVariables,
      options?: Omit<UseQueryOptions<FormFillerPresenceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FormFillerPresenceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FormFillerPresenceQuery, TError, TData>(
      {
    queryKey: ['FormFillerPresence', variables],
    queryFn: fetchData<FormFillerPresenceQuery, FormFillerPresenceQueryVariables>(FormFillerPresenceDocument, variables),
    ...options
  }
    )};

useFormFillerPresenceQuery.document = FormFillerPresenceDocument;

useFormFillerPresenceQuery.getKey = (variables: FormFillerPresenceQueryVariables) => ['FormFillerPresence', variables];

export const ProjectFormSubmissionDocument = `
    query projectFormSubmission($submissionId: Int!) {
  projectFormSubmission(submissionId: $submissionId) {
    ...ProjectFormSubmissionFragment
    formValues {
      ...FormValueFragment
    }
    formDefinition {
      ...FormDefinitionFragment
    }
  }
}
    ${ProjectFormSubmissionFragmentFragmentDoc}
${FormValueFragmentFragmentDoc}
${MatrixRowFragmentFragmentDoc}
${FormDefinitionFragmentFragmentDoc}
${FormFieldFragmentFragmentDoc}
${MatrixFragmentFragmentDoc}`;

export const useProjectFormSubmissionQuery = <
      TData = ProjectFormSubmissionQuery,
      TError = unknown
    >(
      variables: ProjectFormSubmissionQueryVariables,
      options?: Omit<UseQueryOptions<ProjectFormSubmissionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectFormSubmissionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectFormSubmissionQuery, TError, TData>(
      {
    queryKey: ['projectFormSubmission', variables],
    queryFn: fetchData<ProjectFormSubmissionQuery, ProjectFormSubmissionQueryVariables>(ProjectFormSubmissionDocument, variables),
    ...options
  }
    )};

useProjectFormSubmissionQuery.document = ProjectFormSubmissionDocument;

useProjectFormSubmissionQuery.getKey = (variables: ProjectFormSubmissionQueryVariables) => ['projectFormSubmission', variables];

export const ProjectFormSubmissionsDocument = `
    query projectFormSubmissions($projectId: Int!, $formId: Int, $filter: ProjectFormSubmissionFilterInput) {
  projectFormSubmissions(projectId: $projectId, formId: $formId, where: $filter) {
    ...ProjectFormSubmissionFragment
    attachments {
      id
      fileName
    }
  }
}
    ${ProjectFormSubmissionFragmentFragmentDoc}`;

export const useProjectFormSubmissionsQuery = <
      TData = ProjectFormSubmissionsQuery,
      TError = unknown
    >(
      variables: ProjectFormSubmissionsQueryVariables,
      options?: Omit<UseQueryOptions<ProjectFormSubmissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectFormSubmissionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectFormSubmissionsQuery, TError, TData>(
      {
    queryKey: ['projectFormSubmissions', variables],
    queryFn: fetchData<ProjectFormSubmissionsQuery, ProjectFormSubmissionsQueryVariables>(ProjectFormSubmissionsDocument, variables),
    ...options
  }
    )};

useProjectFormSubmissionsQuery.document = ProjectFormSubmissionsDocument;

useProjectFormSubmissionsQuery.getKey = (variables: ProjectFormSubmissionsQueryVariables) => ['projectFormSubmissions', variables];

export const FormTemplateDocument = `
    query formTemplate($id: Int!) {
  formTemplate(templateId: $id) {
    ...FormTemplateFragment
    formDefinition {
      ...FormDefinitionFragment
    }
  }
}
    ${FormTemplateFragmentFragmentDoc}
${RoleAssignmentFragmentFragmentDoc}
${FormDefinitionFragmentFragmentDoc}
${FormFieldFragmentFragmentDoc}
${MatrixFragmentFragmentDoc}
${MatrixRowFragmentFragmentDoc}`;

export const useFormTemplateQuery = <
      TData = FormTemplateQuery,
      TError = unknown
    >(
      variables: FormTemplateQueryVariables,
      options?: Omit<UseQueryOptions<FormTemplateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FormTemplateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FormTemplateQuery, TError, TData>(
      {
    queryKey: ['formTemplate', variables],
    queryFn: fetchData<FormTemplateQuery, FormTemplateQueryVariables>(FormTemplateDocument, variables),
    ...options
  }
    )};

useFormTemplateQuery.document = FormTemplateDocument;

useFormTemplateQuery.getKey = (variables: FormTemplateQueryVariables) => ['formTemplate', variables];

export const FormTemplateForEditorDocument = `
    query formTemplateForEditor($id: Int!) {
  formTemplate(templateId: $id) {
    ...FormTemplateFragment
    formDefinition {
      ...FormDefinitionFragment
    }
  }
}
    ${FormTemplateFragmentFragmentDoc}
${RoleAssignmentFragmentFragmentDoc}
${FormDefinitionFragmentFragmentDoc}
${FormFieldFragmentFragmentDoc}
${MatrixFragmentFragmentDoc}
${MatrixRowFragmentFragmentDoc}`;

export const useFormTemplateForEditorQuery = <
      TData = FormTemplateForEditorQuery,
      TError = unknown
    >(
      variables: FormTemplateForEditorQueryVariables,
      options?: Omit<UseQueryOptions<FormTemplateForEditorQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FormTemplateForEditorQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FormTemplateForEditorQuery, TError, TData>(
      {
    queryKey: ['formTemplateForEditor', variables],
    queryFn: fetchData<FormTemplateForEditorQuery, FormTemplateForEditorQueryVariables>(FormTemplateForEditorDocument, variables),
    ...options
  }
    )};

useFormTemplateForEditorQuery.document = FormTemplateForEditorDocument;

useFormTemplateForEditorQuery.getKey = (variables: FormTemplateForEditorQueryVariables) => ['formTemplateForEditor', variables];

export const TemplatePermissionsDocument = `
    query templatePermissions($formTemplateId: Int!) {
  formTemplatePermissions(templateId: $formTemplateId) {
    ...RoleAssignmentFragment
  }
}
    ${RoleAssignmentFragmentFragmentDoc}`;

export const useTemplatePermissionsQuery = <
      TData = TemplatePermissionsQuery,
      TError = unknown
    >(
      variables: TemplatePermissionsQueryVariables,
      options?: Omit<UseQueryOptions<TemplatePermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TemplatePermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TemplatePermissionsQuery, TError, TData>(
      {
    queryKey: ['templatePermissions', variables],
    queryFn: fetchData<TemplatePermissionsQuery, TemplatePermissionsQueryVariables>(TemplatePermissionsDocument, variables),
    ...options
  }
    )};

useTemplatePermissionsQuery.document = TemplatePermissionsDocument;

useTemplatePermissionsQuery.getKey = (variables: TemplatePermissionsQueryVariables) => ['templatePermissions', variables];

export const FormTemplatesDocument = `
    query formTemplates($filter: FormTemplateFilterInput) {
  formTemplates(where: $filter) {
    ...FormTemplateFragment
  }
}
    ${FormTemplateFragmentFragmentDoc}
${RoleAssignmentFragmentFragmentDoc}`;

export const useFormTemplatesQuery = <
      TData = FormTemplatesQuery,
      TError = unknown
    >(
      variables?: FormTemplatesQueryVariables,
      options?: Omit<UseQueryOptions<FormTemplatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FormTemplatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FormTemplatesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['formTemplates'] : ['formTemplates', variables],
    queryFn: fetchData<FormTemplatesQuery, FormTemplatesQueryVariables>(FormTemplatesDocument, variables),
    ...options
  }
    )};

useFormTemplatesQuery.document = FormTemplatesDocument;

useFormTemplatesQuery.getKey = (variables?: FormTemplatesQueryVariables) => variables === undefined ? ['formTemplates'] : ['formTemplates', variables];

export const AcceptMeetingRequestDocument = `
    mutation acceptMeetingRequest($input: AcceptMeetingRequestInput!) {
  acceptMeetingRequest(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAcceptMeetingRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AcceptMeetingRequestMutation, TError, AcceptMeetingRequestMutationVariables, TContext>) => {
    
    return useMutation<AcceptMeetingRequestMutation, TError, AcceptMeetingRequestMutationVariables, TContext>(
      {
    mutationKey: ['acceptMeetingRequest'],
    mutationFn: (variables?: AcceptMeetingRequestMutationVariables) => fetchData<AcceptMeetingRequestMutation, AcceptMeetingRequestMutationVariables>(AcceptMeetingRequestDocument, variables)(),
    ...options
  }
    )};

export const AddMeetingDocument = `
    mutation addMeeting($input: AddMeetingInput!) {
  addMeeting(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddMeetingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddMeetingMutation, TError, AddMeetingMutationVariables, TContext>) => {
    
    return useMutation<AddMeetingMutation, TError, AddMeetingMutationVariables, TContext>(
      {
    mutationKey: ['addMeeting'],
    mutationFn: (variables?: AddMeetingMutationVariables) => fetchData<AddMeetingMutation, AddMeetingMutationVariables>(AddMeetingDocument, variables)(),
    ...options
  }
    )};

export const AddMeetingTypeDocument = `
    mutation addMeetingType($input: AddMeetingTypeInput!) {
  addMeetingType(input: $input) {
    meetingType {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddMeetingTypeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddMeetingTypeMutation, TError, AddMeetingTypeMutationVariables, TContext>) => {
    
    return useMutation<AddMeetingTypeMutation, TError, AddMeetingTypeMutationVariables, TContext>(
      {
    mutationKey: ['addMeetingType'],
    mutationFn: (variables?: AddMeetingTypeMutationVariables) => fetchData<AddMeetingTypeMutation, AddMeetingTypeMutationVariables>(AddMeetingTypeDocument, variables)(),
    ...options
  }
    )};

export const DeclineMeetingRequestDocument = `
    mutation declineMeetingRequest($input: DeclineMeetingRequestInput!) {
  declineMeetingRequest(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeclineMeetingRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeclineMeetingRequestMutation, TError, DeclineMeetingRequestMutationVariables, TContext>) => {
    
    return useMutation<DeclineMeetingRequestMutation, TError, DeclineMeetingRequestMutationVariables, TContext>(
      {
    mutationKey: ['declineMeetingRequest'],
    mutationFn: (variables?: DeclineMeetingRequestMutationVariables) => fetchData<DeclineMeetingRequestMutation, DeclineMeetingRequestMutationVariables>(DeclineMeetingRequestDocument, variables)(),
    ...options
  }
    )};

export const DeleteMeetingDocument = `
    mutation deleteMeeting($input: DeleteMeetingInput!) {
  deleteMeeting(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteMeetingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMeetingMutation, TError, DeleteMeetingMutationVariables, TContext>) => {
    
    return useMutation<DeleteMeetingMutation, TError, DeleteMeetingMutationVariables, TContext>(
      {
    mutationKey: ['deleteMeeting'],
    mutationFn: (variables?: DeleteMeetingMutationVariables) => fetchData<DeleteMeetingMutation, DeleteMeetingMutationVariables>(DeleteMeetingDocument, variables)(),
    ...options
  }
    )};

export const DeleteMeetingTypeDocument = `
    mutation deleteMeetingType($input: DeleteMeetingTypeInput!) {
  deleteMeetingType(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteMeetingTypeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMeetingTypeMutation, TError, DeleteMeetingTypeMutationVariables, TContext>) => {
    
    return useMutation<DeleteMeetingTypeMutation, TError, DeleteMeetingTypeMutationVariables, TContext>(
      {
    mutationKey: ['deleteMeetingType'],
    mutationFn: (variables?: DeleteMeetingTypeMutationVariables) => fetchData<DeleteMeetingTypeMutation, DeleteMeetingTypeMutationVariables>(DeleteMeetingTypeDocument, variables)(),
    ...options
  }
    )};

export const EditMeetingTypeDocument = `
    mutation editMeetingType($input: EditMeetingTypeInput!) {
  editMeetingType(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditMeetingTypeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditMeetingTypeMutation, TError, EditMeetingTypeMutationVariables, TContext>) => {
    
    return useMutation<EditMeetingTypeMutation, TError, EditMeetingTypeMutationVariables, TContext>(
      {
    mutationKey: ['editMeetingType'],
    mutationFn: (variables?: EditMeetingTypeMutationVariables) => fetchData<EditMeetingTypeMutation, EditMeetingTypeMutationVariables>(EditMeetingTypeDocument, variables)(),
    ...options
  }
    )};

export const CalendarAvailabilitiesDocument = `
    query calendarAvailabilities($input: GetCalendarAvailabilitiesInput!) {
  calendarAvailabilities(input: $input) {
    msalUIRequired
    isScheduleAvailable
    isoWorkWeekDays
    availableStartTimes {
      startTime
      availability
    }
  }
}
    `;

export const useCalendarAvailabilitiesQuery = <
      TData = CalendarAvailabilitiesQuery,
      TError = unknown
    >(
      variables: CalendarAvailabilitiesQueryVariables,
      options?: Omit<UseQueryOptions<CalendarAvailabilitiesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CalendarAvailabilitiesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CalendarAvailabilitiesQuery, TError, TData>(
      {
    queryKey: ['calendarAvailabilities', variables],
    queryFn: fetchData<CalendarAvailabilitiesQuery, CalendarAvailabilitiesQueryVariables>(CalendarAvailabilitiesDocument, variables),
    ...options
  }
    )};

useCalendarAvailabilitiesQuery.document = CalendarAvailabilitiesDocument;

useCalendarAvailabilitiesQuery.getKey = (variables: CalendarAvailabilitiesQueryVariables) => ['calendarAvailabilities', variables];

export const MeetingDocument = `
    query meeting($projectId: Int!, $meetingId: Int!) {
  meeting(projectId: $projectId, meetingId: $meetingId) {
    ...MeetingFragment
    meetingType {
      id
      name
      description
      createdOn
      meetingRequestsOwners {
        id
        fullName
      }
    }
    proposals(order: {startTime: ASC}) {
      id
      startTime
      createdBy {
        fullName
      }
      acceptedUsers {
        id
        fullName
      }
      declinedUsers {
        id
        fullName
      }
    }
  }
}
    ${MeetingFragmentFragmentDoc}`;

export const useMeetingQuery = <
      TData = MeetingQuery,
      TError = unknown
    >(
      variables: MeetingQueryVariables,
      options?: Omit<UseQueryOptions<MeetingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MeetingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MeetingQuery, TError, TData>(
      {
    queryKey: ['meeting', variables],
    queryFn: fetchData<MeetingQuery, MeetingQueryVariables>(MeetingDocument, variables),
    ...options
  }
    )};

useMeetingQuery.document = MeetingDocument;

useMeetingQuery.getKey = (variables: MeetingQueryVariables) => ['meeting', variables];

export const MeetingTypeOwnersAvailabilitiesDocument = `
    query meetingTypeOwnersAvailabilities($input: GetCalendarAvailabilitiesForMeetingTypeInput!) {
  calendarAvailabilitiesForMeetingType(input: $input) {
    isScheduleAvailable
    msalUIRequired
    isoWorkWeekDays
    availableStartTimes {
      startTime
      availability
    }
  }
}
    `;

export const useMeetingTypeOwnersAvailabilitiesQuery = <
      TData = MeetingTypeOwnersAvailabilitiesQuery,
      TError = unknown
    >(
      variables: MeetingTypeOwnersAvailabilitiesQueryVariables,
      options?: Omit<UseQueryOptions<MeetingTypeOwnersAvailabilitiesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MeetingTypeOwnersAvailabilitiesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MeetingTypeOwnersAvailabilitiesQuery, TError, TData>(
      {
    queryKey: ['meetingTypeOwnersAvailabilities', variables],
    queryFn: fetchData<MeetingTypeOwnersAvailabilitiesQuery, MeetingTypeOwnersAvailabilitiesQueryVariables>(MeetingTypeOwnersAvailabilitiesDocument, variables),
    ...options
  }
    )};

useMeetingTypeOwnersAvailabilitiesQuery.document = MeetingTypeOwnersAvailabilitiesDocument;

useMeetingTypeOwnersAvailabilitiesQuery.getKey = (variables: MeetingTypeOwnersAvailabilitiesQueryVariables) => ['meetingTypeOwnersAvailabilities', variables];

export const MeetingTypesDocument = `
    query meetingTypes($projectId: Int!) {
  meetingTypes(projectId: $projectId) {
    id
    name
    description
    duration
    bookingMethod
    createdOn
    createdBy {
      fullName
    }
    meetingRequestsOwners {
      id
      fullName
    }
    meetingRequestOwnerGroups {
      id
      name
    }
  }
}
    `;

export const useMeetingTypesQuery = <
      TData = MeetingTypesQuery,
      TError = unknown
    >(
      variables: MeetingTypesQueryVariables,
      options?: Omit<UseQueryOptions<MeetingTypesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MeetingTypesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MeetingTypesQuery, TError, TData>(
      {
    queryKey: ['meetingTypes', variables],
    queryFn: fetchData<MeetingTypesQuery, MeetingTypesQueryVariables>(MeetingTypesDocument, variables),
    ...options
  }
    )};

useMeetingTypesQuery.document = MeetingTypesDocument;

useMeetingTypesQuery.getKey = (variables: MeetingTypesQueryVariables) => ['meetingTypes', variables];

export const MeetingsDocument = `
    query meetings($projectId: Int!, $filter: MeetingFilterInput) {
  meetings(projectId: $projectId, where: $filter) {
    ...MeetingFragment
  }
}
    ${MeetingFragmentFragmentDoc}`;

export const useMeetingsQuery = <
      TData = MeetingsQuery,
      TError = unknown
    >(
      variables: MeetingsQueryVariables,
      options?: Omit<UseQueryOptions<MeetingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MeetingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MeetingsQuery, TError, TData>(
      {
    queryKey: ['meetings', variables],
    queryFn: fetchData<MeetingsQuery, MeetingsQueryVariables>(MeetingsDocument, variables),
    ...options
  }
    )};

useMeetingsQuery.document = MeetingsDocument;

useMeetingsQuery.getKey = (variables: MeetingsQueryVariables) => ['meetings', variables];

export const RenewAccessTokenDocument = `
    mutation renewAccessToken($token: String!) {
  renewAccessTokenFromExpiredToken(input: {token: $token}) {
    renewAccessTokenFromExpiredTokenResult {
      sentToEmail
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRenewAccessTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RenewAccessTokenMutation, TError, RenewAccessTokenMutationVariables, TContext>) => {
    
    return useMutation<RenewAccessTokenMutation, TError, RenewAccessTokenMutationVariables, TContext>(
      {
    mutationKey: ['renewAccessToken'],
    mutationFn: (variables?: RenewAccessTokenMutationVariables) => fetchData<RenewAccessTokenMutation, RenewAccessTokenMutationVariables>(RenewAccessTokenDocument, variables)(),
    ...options
  }
    )};

export const GetTokenPurposeContextDocument = `
    query getTokenPurposeContext($token: String!) {
  tokenPurposeContext(token: $token) {
    purpose
    status
    isRenewable
    errorMessage
    initiatorName
    actionDescription
    resourceName
    customMessage
    actionUrl
    projectId
    projectName
    documentId
  }
}
    `;

export const useGetTokenPurposeContextQuery = <
      TData = GetTokenPurposeContextQuery,
      TError = unknown
    >(
      variables: GetTokenPurposeContextQueryVariables,
      options?: Omit<UseQueryOptions<GetTokenPurposeContextQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTokenPurposeContextQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetTokenPurposeContextQuery, TError, TData>(
      {
    queryKey: ['getTokenPurposeContext', variables],
    queryFn: fetchData<GetTokenPurposeContextQuery, GetTokenPurposeContextQueryVariables>(GetTokenPurposeContextDocument, variables),
    ...options
  }
    )};

useGetTokenPurposeContextQuery.document = GetTokenPurposeContextDocument;

useGetTokenPurposeContextQuery.getKey = (variables: GetTokenPurposeContextQueryVariables) => ['getTokenPurposeContext', variables];

export const AddProjectDocument = `
    mutation addProject($input: AddProjectInput!) {
  addProject(input: $input) {
    project {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddProjectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddProjectMutation, TError, AddProjectMutationVariables, TContext>) => {
    
    return useMutation<AddProjectMutation, TError, AddProjectMutationVariables, TContext>(
      {
    mutationKey: ['addProject'],
    mutationFn: (variables?: AddProjectMutationVariables) => fetchData<AddProjectMutation, AddProjectMutationVariables>(AddProjectDocument, variables)(),
    ...options
  }
    )};

export const AddProjectMemberDocument = `
    mutation addProjectMember($input: AddProjectMemberInput!) {
  addProjectMember(input: $input) {
    project {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddProjectMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddProjectMemberMutation, TError, AddProjectMemberMutationVariables, TContext>) => {
    
    return useMutation<AddProjectMemberMutation, TError, AddProjectMemberMutationVariables, TContext>(
      {
    mutationKey: ['addProjectMember'],
    mutationFn: (variables?: AddProjectMemberMutationVariables) => fetchData<AddProjectMemberMutation, AddProjectMemberMutationVariables>(AddProjectMemberDocument, variables)(),
    ...options
  }
    )};

export const AddProjectTemplateDocument = `
    mutation addProjectTemplate($input: AddProjectTemplateInput!) {
  addProjectTemplate(input: $input) {
    project {
      id
    }
  }
}
    `;

export const useAddProjectTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddProjectTemplateMutation, TError, AddProjectTemplateMutationVariables, TContext>) => {
    
    return useMutation<AddProjectTemplateMutation, TError, AddProjectTemplateMutationVariables, TContext>(
      {
    mutationKey: ['addProjectTemplate'],
    mutationFn: (variables?: AddProjectTemplateMutationVariables) => fetchData<AddProjectTemplateMutation, AddProjectTemplateMutationVariables>(AddProjectTemplateDocument, variables)(),
    ...options
  }
    )};

export const CreateProjectFromTemplateDocument = `
    mutation createProjectFromTemplate($input: CreateProjectFromTemplateInput!) {
  createProjectFromTemplate(input: $input) {
    project {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useCreateProjectFromTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProjectFromTemplateMutation, TError, CreateProjectFromTemplateMutationVariables, TContext>) => {
    
    return useMutation<CreateProjectFromTemplateMutation, TError, CreateProjectFromTemplateMutationVariables, TContext>(
      {
    mutationKey: ['createProjectFromTemplate'],
    mutationFn: (variables?: CreateProjectFromTemplateMutationVariables) => fetchData<CreateProjectFromTemplateMutation, CreateProjectFromTemplateMutationVariables>(CreateProjectFromTemplateDocument, variables)(),
    ...options
  }
    )};

export const DeleteProjectTemplateDocument = `
    mutation deleteProjectTemplate($input: DeleteProjectTemplateInput!) {
  deleteProjectTemplate(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteProjectTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteProjectTemplateMutation, TError, DeleteProjectTemplateMutationVariables, TContext>) => {
    
    return useMutation<DeleteProjectTemplateMutation, TError, DeleteProjectTemplateMutationVariables, TContext>(
      {
    mutationKey: ['deleteProjectTemplate'],
    mutationFn: (variables?: DeleteProjectTemplateMutationVariables) => fetchData<DeleteProjectTemplateMutation, DeleteProjectTemplateMutationVariables>(DeleteProjectTemplateDocument, variables)(),
    ...options
  }
    )};

export const EditMemberSecurityGroupDocument = `
    mutation editMemberSecurityGroup($input: EditMemberSecurityGroupInput!) {
  editMemberSecurityGroup(input: $input) {
    applicationUser {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditMemberSecurityGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditMemberSecurityGroupMutation, TError, EditMemberSecurityGroupMutationVariables, TContext>) => {
    
    return useMutation<EditMemberSecurityGroupMutation, TError, EditMemberSecurityGroupMutationVariables, TContext>(
      {
    mutationKey: ['editMemberSecurityGroup'],
    mutationFn: (variables?: EditMemberSecurityGroupMutationVariables) => fetchData<EditMemberSecurityGroupMutation, EditMemberSecurityGroupMutationVariables>(EditMemberSecurityGroupDocument, variables)(),
    ...options
  }
    )};

export const EditProjectDocument = `
    mutation editProject($input: EditProjectInput!) {
  editProject(input: $input) {
    project {
      id
    }
  }
}
    `;

export const useEditProjectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditProjectMutation, TError, EditProjectMutationVariables, TContext>) => {
    
    return useMutation<EditProjectMutation, TError, EditProjectMutationVariables, TContext>(
      {
    mutationKey: ['editProject'],
    mutationFn: (variables?: EditProjectMutationVariables) => fetchData<EditProjectMutation, EditProjectMutationVariables>(EditProjectDocument, variables)(),
    ...options
  }
    )};

export const EditProjectProgressDocument = `
    mutation editProjectProgress($input: EditProjectProgressInput!) {
  editProjectProgress(input: $input) {
    project {
      id
    }
  }
}
    `;

export const useEditProjectProgressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditProjectProgressMutation, TError, EditProjectProgressMutationVariables, TContext>) => {
    
    return useMutation<EditProjectProgressMutation, TError, EditProjectProgressMutationVariables, TContext>(
      {
    mutationKey: ['editProjectProgress'],
    mutationFn: (variables?: EditProjectProgressMutationVariables) => fetchData<EditProjectProgressMutation, EditProjectProgressMutationVariables>(EditProjectProgressDocument, variables)(),
    ...options
  }
    )};

export const ImportFoldersDocument = `
    mutation importFolders($input: ImportFoldersInput!) {
  importFolders(input: $input) {
    project {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useImportFoldersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportFoldersMutation, TError, ImportFoldersMutationVariables, TContext>) => {
    
    return useMutation<ImportFoldersMutation, TError, ImportFoldersMutationVariables, TContext>(
      {
    mutationKey: ['importFolders'],
    mutationFn: (variables?: ImportFoldersMutationVariables) => fetchData<ImportFoldersMutation, ImportFoldersMutationVariables>(ImportFoldersDocument, variables)(),
    ...options
  }
    )};

export const ImportTasksDocument = `
    mutation importTasks($input: ImportTasksInput!) {
  importTasks(input: $input) {
    project {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useImportTasksMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportTasksMutation, TError, ImportTasksMutationVariables, TContext>) => {
    
    return useMutation<ImportTasksMutation, TError, ImportTasksMutationVariables, TContext>(
      {
    mutationKey: ['importTasks'],
    mutationFn: (variables?: ImportTasksMutationVariables) => fetchData<ImportTasksMutation, ImportTasksMutationVariables>(ImportTasksDocument, variables)(),
    ...options
  }
    )};

export const AddExternalUserDocument = `
    mutation addExternalUser($input: AddExternalUserInput!) {
  addExternalUser(input: $input) {
    applicationUser {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddExternalUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddExternalUserMutation, TError, AddExternalUserMutationVariables, TContext>) => {
    
    return useMutation<AddExternalUserMutation, TError, AddExternalUserMutationVariables, TContext>(
      {
    mutationKey: ['addExternalUser'],
    mutationFn: (variables?: AddExternalUserMutationVariables) => fetchData<AddExternalUserMutation, AddExternalUserMutationVariables>(AddExternalUserDocument, variables)(),
    ...options
  }
    )};

export const RemoveProjectMemberDocument = `
    mutation removeProjectMember($input: RemoveProjectMemberInput!) {
  removeProjectMember(input: $input) {
    project {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRemoveProjectMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProjectMemberMutation, TError, RemoveProjectMemberMutationVariables, TContext>) => {
    
    return useMutation<RemoveProjectMemberMutation, TError, RemoveProjectMemberMutationVariables, TContext>(
      {
    mutationKey: ['removeProjectMember'],
    mutationFn: (variables?: RemoveProjectMemberMutationVariables) => fetchData<RemoveProjectMemberMutation, RemoveProjectMemberMutationVariables>(RemoveProjectMemberDocument, variables)(),
    ...options
  }
    )};

export const GetMyProjectRolesDocument = `
    query getMyProjectRoles($projectId: Int!) {
  project(id: $projectId) {
    myRoles {
      roles
    }
    myPermissions {
      budgetPermission
      tasksPermission
      formsPermission
      documentsPermission
      managePublicFileSharingPermission
      workflowsPermission
    }
  }
}
    `;

export const useGetMyProjectRolesQuery = <
      TData = GetMyProjectRolesQuery,
      TError = unknown
    >(
      variables: GetMyProjectRolesQueryVariables,
      options?: Omit<UseQueryOptions<GetMyProjectRolesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMyProjectRolesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMyProjectRolesQuery, TError, TData>(
      {
    queryKey: ['getMyProjectRoles', variables],
    queryFn: fetchData<GetMyProjectRolesQuery, GetMyProjectRolesQueryVariables>(GetMyProjectRolesDocument, variables),
    ...options
  }
    )};

useGetMyProjectRolesQuery.document = GetMyProjectRolesDocument;

useGetMyProjectRolesQuery.getKey = (variables: GetMyProjectRolesQueryVariables) => ['getMyProjectRoles', variables];

export const GetProjectDocument = `
    query getProject($id: Int!) {
  project(id: $id) {
    id
    name
    description
    isArchived
    isTemplate
    createdOn
    projectProgress
    createdBy {
      fullName
    }
    rootFolder {
      id
      name
      folderType
      path
    }
    securityGroups {
      members {
        id
        fullName
        business
        title
        email
      }
    }
  }
}
    `;

export const useGetProjectQuery = <
      TData = GetProjectQuery,
      TError = unknown
    >(
      variables: GetProjectQueryVariables,
      options?: Omit<UseQueryOptions<GetProjectQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProjectQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProjectQuery, TError, TData>(
      {
    queryKey: ['getProject', variables],
    queryFn: fetchData<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, variables),
    ...options
  }
    )};

useGetProjectQuery.document = GetProjectDocument;

useGetProjectQuery.getKey = (variables: GetProjectQueryVariables) => ['getProject', variables];

export const GetProjectMembersDocument = `
    query getProjectMembers($projectId: Int!, $filter: ApplicationUserFilterInput) {
  projectMembers(projectId: $projectId, where: $filter) {
    ...ProjectMemberFragment
  }
}
    ${ProjectMemberFragmentFragmentDoc}`;

export const useGetProjectMembersQuery = <
      TData = GetProjectMembersQuery,
      TError = unknown
    >(
      variables: GetProjectMembersQueryVariables,
      options?: Omit<UseQueryOptions<GetProjectMembersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProjectMembersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProjectMembersQuery, TError, TData>(
      {
    queryKey: ['getProjectMembers', variables],
    queryFn: fetchData<GetProjectMembersQuery, GetProjectMembersQueryVariables>(GetProjectMembersDocument, variables),
    ...options
  }
    )};

useGetProjectMembersQuery.document = GetProjectMembersDocument;

useGetProjectMembersQuery.getKey = (variables: GetProjectMembersQueryVariables) => ['getProjectMembers', variables];

export const GetProjectTemplateSummaryInfoDocument = `
    query getProjectTemplateSummaryInfo($projectTemplateId: Int!) {
  projectTemplateSummaryInfo(projectTemplateId: $projectTemplateId) {
    budgetItemsCount
    customFoldersCount
    documentsCount
    tasksCount
    meetingTypesCount
    formsCount
    securityGroupsCount
    workflowsCount
  }
}
    `;

export const useGetProjectTemplateSummaryInfoQuery = <
      TData = GetProjectTemplateSummaryInfoQuery,
      TError = unknown
    >(
      variables: GetProjectTemplateSummaryInfoQueryVariables,
      options?: Omit<UseQueryOptions<GetProjectTemplateSummaryInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProjectTemplateSummaryInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProjectTemplateSummaryInfoQuery, TError, TData>(
      {
    queryKey: ['getProjectTemplateSummaryInfo', variables],
    queryFn: fetchData<GetProjectTemplateSummaryInfoQuery, GetProjectTemplateSummaryInfoQueryVariables>(GetProjectTemplateSummaryInfoDocument, variables),
    ...options
  }
    )};

useGetProjectTemplateSummaryInfoQuery.document = GetProjectTemplateSummaryInfoDocument;

useGetProjectTemplateSummaryInfoQuery.getKey = (variables: GetProjectTemplateSummaryInfoQueryVariables) => ['getProjectTemplateSummaryInfo', variables];

export const ProjectTemplatePermissionsDocument = `
    query projectTemplatePermissions($templateId: Int!) {
  projectTemplatePermissions(templateId: $templateId) {
    ...RoleAssignmentFragment
  }
}
    ${RoleAssignmentFragmentFragmentDoc}`;

export const useProjectTemplatePermissionsQuery = <
      TData = ProjectTemplatePermissionsQuery,
      TError = unknown
    >(
      variables: ProjectTemplatePermissionsQueryVariables,
      options?: Omit<UseQueryOptions<ProjectTemplatePermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectTemplatePermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectTemplatePermissionsQuery, TError, TData>(
      {
    queryKey: ['projectTemplatePermissions', variables],
    queryFn: fetchData<ProjectTemplatePermissionsQuery, ProjectTemplatePermissionsQueryVariables>(ProjectTemplatePermissionsDocument, variables),
    ...options
  }
    )};

useProjectTemplatePermissionsQuery.document = ProjectTemplatePermissionsDocument;

useProjectTemplatePermissionsQuery.getKey = (variables: ProjectTemplatePermissionsQueryVariables) => ['projectTemplatePermissions', variables];

export const GetProjectsDocument = `
    query getProjects($filter: ProjectFilterInput) {
  projects(where: $filter) {
    id
    name
    description
    isArchived
    isTemplate
    createdById
    createdOn
    securityGroups {
      id
      name
      members {
        id
        fullName
      }
    }
  }
}
    `;

export const useGetProjectsQuery = <
      TData = GetProjectsQuery,
      TError = unknown
    >(
      variables?: GetProjectsQueryVariables,
      options?: Omit<UseQueryOptions<GetProjectsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProjectsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProjectsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getProjects'] : ['getProjects', variables],
    queryFn: fetchData<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, variables),
    ...options
  }
    )};

useGetProjectsQuery.document = GetProjectsDocument;

useGetProjectsQuery.getKey = (variables?: GetProjectsQueryVariables) => variables === undefined ? ['getProjects'] : ['getProjects', variables];

export const RecentProjectEventsDocument = `
    query recentProjectEvents($projectId: Int!, $first: Int!, $after: String, $asOfDate: DateTime, $order: [ProjectEventSortInput!]) {
  projectEvents(
    projectId: $projectId
    first: $first
    after: $after
    asOfDate: $asOfDate
    order: $order
  ) {
    edges {
      cursor
      node {
        id
        projectId
        eventType
        eventDate
        eventTriggeredById
        eventTriggeredBy {
          firstName
          lastName
          fullName
        }
        document {
          fileName
          id
          folderEntry {
            folder {
              id
              path
              name
            }
          }
        }
        form {
          id
          formDefinition {
            name
          }
        }
        formSubmissionId
        formSubmission {
          formDefinition {
            name
          }
        }
        workflowInstanceId
        workflowInstance {
          id
          name
        }
        workflowActionId
        workflowAction {
          id
          name
        }
        meetingId
        meeting {
          ...MeetingFragment
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${MeetingFragmentFragmentDoc}`;

export const useRecentProjectEventsQuery = <
      TData = RecentProjectEventsQuery,
      TError = unknown
    >(
      variables: RecentProjectEventsQueryVariables,
      options?: Omit<UseQueryOptions<RecentProjectEventsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RecentProjectEventsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<RecentProjectEventsQuery, TError, TData>(
      {
    queryKey: ['recentProjectEvents', variables],
    queryFn: fetchData<RecentProjectEventsQuery, RecentProjectEventsQueryVariables>(RecentProjectEventsDocument, variables),
    ...options
  }
    )};

useRecentProjectEventsQuery.document = RecentProjectEventsDocument;

useRecentProjectEventsQuery.getKey = (variables: RecentProjectEventsQueryVariables) => ['recentProjectEvents', variables];

export const AddSecurityGroupDocument = `
    mutation addSecurityGroup($input: AddSecurityGroupInput!) {
  addSecurityGroup(input: $input) {
    securityGroup {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddSecurityGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddSecurityGroupMutation, TError, AddSecurityGroupMutationVariables, TContext>) => {
    
    return useMutation<AddSecurityGroupMutation, TError, AddSecurityGroupMutationVariables, TContext>(
      {
    mutationKey: ['addSecurityGroup'],
    mutationFn: (variables?: AddSecurityGroupMutationVariables) => fetchData<AddSecurityGroupMutation, AddSecurityGroupMutationVariables>(AddSecurityGroupDocument, variables)(),
    ...options
  }
    )};

export const DeleteSecurityGroupDocument = `
    mutation deleteSecurityGroup($input: DeleteSecurityGroupInput!) {
  deleteSecurityGroup(input: $input) {
    securityGroup {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteSecurityGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSecurityGroupMutation, TError, DeleteSecurityGroupMutationVariables, TContext>) => {
    
    return useMutation<DeleteSecurityGroupMutation, TError, DeleteSecurityGroupMutationVariables, TContext>(
      {
    mutationKey: ['deleteSecurityGroup'],
    mutationFn: (variables?: DeleteSecurityGroupMutationVariables) => fetchData<DeleteSecurityGroupMutation, DeleteSecurityGroupMutationVariables>(DeleteSecurityGroupDocument, variables)(),
    ...options
  }
    )};

export const RemoveSecurityGroupMemberDocument = `
    mutation removeSecurityGroupMember($input: RemoveSecurityGroupMemberInput!) {
  removeSecurityGroupMember(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRemoveSecurityGroupMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSecurityGroupMemberMutation, TError, RemoveSecurityGroupMemberMutationVariables, TContext>) => {
    
    return useMutation<RemoveSecurityGroupMemberMutation, TError, RemoveSecurityGroupMemberMutationVariables, TContext>(
      {
    mutationKey: ['removeSecurityGroupMember'],
    mutationFn: (variables?: RemoveSecurityGroupMemberMutationVariables) => fetchData<RemoveSecurityGroupMemberMutation, RemoveSecurityGroupMemberMutationVariables>(RemoveSecurityGroupMemberDocument, variables)(),
    ...options
  }
    )};

export const SendSharingNotificationForOrganizationResourceDocument = `
    mutation sendSharingNotificationForOrganizationResource($input: SendSharingNotificationForOrganizationResourceInput!) {
  sendSharingNotificationForOrganizationResource(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useSendSharingNotificationForOrganizationResourceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendSharingNotificationForOrganizationResourceMutation, TError, SendSharingNotificationForOrganizationResourceMutationVariables, TContext>) => {
    
    return useMutation<SendSharingNotificationForOrganizationResourceMutation, TError, SendSharingNotificationForOrganizationResourceMutationVariables, TContext>(
      {
    mutationKey: ['sendSharingNotificationForOrganizationResource'],
    mutationFn: (variables?: SendSharingNotificationForOrganizationResourceMutationVariables) => fetchData<SendSharingNotificationForOrganizationResourceMutation, SendSharingNotificationForOrganizationResourceMutationVariables>(SendSharingNotificationForOrganizationResourceDocument, variables)(),
    ...options
  }
    )};

export const SendSharingNotificationForProjectResourceDocument = `
    mutation sendSharingNotificationForProjectResource($input: SendSharingNotificationForProjectResourceInput!) {
  sendSharingNotificationForProjectResource(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useSendSharingNotificationForProjectResourceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendSharingNotificationForProjectResourceMutation, TError, SendSharingNotificationForProjectResourceMutationVariables, TContext>) => {
    
    return useMutation<SendSharingNotificationForProjectResourceMutation, TError, SendSharingNotificationForProjectResourceMutationVariables, TContext>(
      {
    mutationKey: ['sendSharingNotificationForProjectResource'],
    mutationFn: (variables?: SendSharingNotificationForProjectResourceMutationVariables) => fetchData<SendSharingNotificationForProjectResourceMutation, SendSharingNotificationForProjectResourceMutationVariables>(SendSharingNotificationForProjectResourceDocument, variables)(),
    ...options
  }
    )};

export const ShareOrganizationResourceDocument = `
    mutation shareOrganizationResource($input: ShareOrganizationResourceInput!) {
  shareOrganizationResource(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useShareOrganizationResourceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ShareOrganizationResourceMutation, TError, ShareOrganizationResourceMutationVariables, TContext>) => {
    
    return useMutation<ShareOrganizationResourceMutation, TError, ShareOrganizationResourceMutationVariables, TContext>(
      {
    mutationKey: ['shareOrganizationResource'],
    mutationFn: (variables?: ShareOrganizationResourceMutationVariables) => fetchData<ShareOrganizationResourceMutation, ShareOrganizationResourceMutationVariables>(ShareOrganizationResourceDocument, variables)(),
    ...options
  }
    )};

export const ShareProjectResourceDocument = `
    mutation shareProjectResource($input: ShareProjectResourceInput!) {
  shareProjectResource(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useShareProjectResourceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ShareProjectResourceMutation, TError, ShareProjectResourceMutationVariables, TContext>) => {
    
    return useMutation<ShareProjectResourceMutation, TError, ShareProjectResourceMutationVariables, TContext>(
      {
    mutationKey: ['shareProjectResource'],
    mutationFn: (variables?: ShareProjectResourceMutationVariables) => fetchData<ShareProjectResourceMutation, ShareProjectResourceMutationVariables>(ShareProjectResourceDocument, variables)(),
    ...options
  }
    )};

export const UnshareOrganizationResourceDocument = `
    mutation unshareOrganizationResource($input: UnshareOrganizationResourceInput!) {
  unshareOrganizationResource(input: $input) {
    roleAssignment {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUnshareOrganizationResourceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnshareOrganizationResourceMutation, TError, UnshareOrganizationResourceMutationVariables, TContext>) => {
    
    return useMutation<UnshareOrganizationResourceMutation, TError, UnshareOrganizationResourceMutationVariables, TContext>(
      {
    mutationKey: ['unshareOrganizationResource'],
    mutationFn: (variables?: UnshareOrganizationResourceMutationVariables) => fetchData<UnshareOrganizationResourceMutation, UnshareOrganizationResourceMutationVariables>(UnshareOrganizationResourceDocument, variables)(),
    ...options
  }
    )};

export const UnshareProjectResourceDocument = `
    mutation unshareProjectResource($input: UnshareProjectResourceInput!) {
  unshareProjectResource(input: $input) {
    roleAssignment {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUnshareProjectResourceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnshareProjectResourceMutation, TError, UnshareProjectResourceMutationVariables, TContext>) => {
    
    return useMutation<UnshareProjectResourceMutation, TError, UnshareProjectResourceMutationVariables, TContext>(
      {
    mutationKey: ['unshareProjectResource'],
    mutationFn: (variables?: UnshareProjectResourceMutationVariables) => fetchData<UnshareProjectResourceMutation, UnshareProjectResourceMutationVariables>(UnshareProjectResourceDocument, variables)(),
    ...options
  }
    )};

export const UpdateSecurityGroupDocument = `
    mutation updateSecurityGroup($input: UpdateSecurityGroupInput!) {
  updateSecurityGroup(input: $input) {
    securityGroup {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUpdateSecurityGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSecurityGroupMutation, TError, UpdateSecurityGroupMutationVariables, TContext>) => {
    
    return useMutation<UpdateSecurityGroupMutation, TError, UpdateSecurityGroupMutationVariables, TContext>(
      {
    mutationKey: ['updateSecurityGroup'],
    mutationFn: (variables?: UpdateSecurityGroupMutationVariables) => fetchData<UpdateSecurityGroupMutation, UpdateSecurityGroupMutationVariables>(UpdateSecurityGroupDocument, variables)(),
    ...options
  }
    )};

export const UpdateSecurityGroupRolesDocument = `
    mutation updateSecurityGroupRoles($input: UpdateSecurityGroupRolesInput!) {
  updateSecurityGroupRoles(input: $input) {
    securityGroup {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUpdateSecurityGroupRolesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSecurityGroupRolesMutation, TError, UpdateSecurityGroupRolesMutationVariables, TContext>) => {
    
    return useMutation<UpdateSecurityGroupRolesMutation, TError, UpdateSecurityGroupRolesMutationVariables, TContext>(
      {
    mutationKey: ['updateSecurityGroupRoles'],
    mutationFn: (variables?: UpdateSecurityGroupRolesMutationVariables) => fetchData<UpdateSecurityGroupRolesMutation, UpdateSecurityGroupRolesMutationVariables>(UpdateSecurityGroupRolesDocument, variables)(),
    ...options
  }
    )};

export const SecurityGroupDocument = `
    query securityGroup($projectId: Int!, $securityGroupId: String!) {
  securityGroup(projectId: $projectId, securityGroupId: $securityGroupId) {
    ...SecurityGroupFragment
  }
}
    ${SecurityGroupFragmentFragmentDoc}`;

export const useSecurityGroupQuery = <
      TData = SecurityGroupQuery,
      TError = unknown
    >(
      variables: SecurityGroupQueryVariables,
      options?: Omit<UseQueryOptions<SecurityGroupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SecurityGroupQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SecurityGroupQuery, TError, TData>(
      {
    queryKey: ['securityGroup', variables],
    queryFn: fetchData<SecurityGroupQuery, SecurityGroupQueryVariables>(SecurityGroupDocument, variables),
    ...options
  }
    )};

useSecurityGroupQuery.document = SecurityGroupDocument;

useSecurityGroupQuery.getKey = (variables: SecurityGroupQueryVariables) => ['securityGroup', variables];

export const SecurityGroupForUserInProjectDocument = `
    query securityGroupForUserInProject($projectId: Int!, $userId: String!) {
  securityGroupForUserInProject(projectId: $projectId, userId: $userId) {
    ...SecurityGroupFragment
  }
}
    ${SecurityGroupFragmentFragmentDoc}`;

export const useSecurityGroupForUserInProjectQuery = <
      TData = SecurityGroupForUserInProjectQuery,
      TError = unknown
    >(
      variables: SecurityGroupForUserInProjectQueryVariables,
      options?: Omit<UseQueryOptions<SecurityGroupForUserInProjectQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SecurityGroupForUserInProjectQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SecurityGroupForUserInProjectQuery, TError, TData>(
      {
    queryKey: ['securityGroupForUserInProject', variables],
    queryFn: fetchData<SecurityGroupForUserInProjectQuery, SecurityGroupForUserInProjectQueryVariables>(SecurityGroupForUserInProjectDocument, variables),
    ...options
  }
    )};

useSecurityGroupForUserInProjectQuery.document = SecurityGroupForUserInProjectDocument;

useSecurityGroupForUserInProjectQuery.getKey = (variables: SecurityGroupForUserInProjectQueryVariables) => ['securityGroupForUserInProject', variables];

export const SecurityGroupsForProjectDocument = `
    query securityGroupsForProject($projectId: Int!) {
  securityGroupsForProject(projectId: $projectId) {
    ...SecurityGroupFragment
  }
}
    ${SecurityGroupFragmentFragmentDoc}`;

export const useSecurityGroupsForProjectQuery = <
      TData = SecurityGroupsForProjectQuery,
      TError = unknown
    >(
      variables: SecurityGroupsForProjectQueryVariables,
      options?: Omit<UseQueryOptions<SecurityGroupsForProjectQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SecurityGroupsForProjectQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SecurityGroupsForProjectQuery, TError, TData>(
      {
    queryKey: ['securityGroupsForProject', variables],
    queryFn: fetchData<SecurityGroupsForProjectQuery, SecurityGroupsForProjectQueryVariables>(SecurityGroupsForProjectDocument, variables),
    ...options
  }
    )};

useSecurityGroupsForProjectQuery.document = SecurityGroupsForProjectDocument;

useSecurityGroupsForProjectQuery.getKey = (variables: SecurityGroupsForProjectQueryVariables) => ['securityGroupsForProject', variables];

export const AllTasksPageQueryDocument = `
    query allTasksPageQuery($first: Int!, $after: String, $where: ProjectTaskFilterInput, $order: [ProjectTaskSortInput!]) {
  tasks(first: $first, after: $after, where: $where, order: $order) {
    edges {
      cursor
      node {
        ...ProjectTaskFragment
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${ProjectTaskFragmentFragmentDoc}
${GetTaskNameFragmentFragmentDoc}
${FormAllowedUsersFragmentFragmentDoc}
${ProjectFormSettingsFragmentFragmentDoc}
${DocumentFragmentFragmentDoc}`;

export const useAllTasksPageQueryQuery = <
      TData = AllTasksPageQueryQuery,
      TError = unknown
    >(
      variables: AllTasksPageQueryQueryVariables,
      options?: Omit<UseQueryOptions<AllTasksPageQueryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AllTasksPageQueryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AllTasksPageQueryQuery, TError, TData>(
      {
    queryKey: ['allTasksPageQuery', variables],
    queryFn: fetchData<AllTasksPageQueryQuery, AllTasksPageQueryQueryVariables>(AllTasksPageQueryDocument, variables),
    ...options
  }
    )};

useAllTasksPageQueryQuery.document = AllTasksPageQueryDocument;

useAllTasksPageQueryQuery.getKey = (variables: AllTasksPageQueryQueryVariables) => ['allTasksPageQuery', variables];

export const ProjectPickerProjectsDocument = `
    query projectPickerProjects {
  projects {
    id
    name
    isTemplate
    isArchived
    myPermissions {
      tasksPermission
    }
  }
}
    `;

export const useProjectPickerProjectsQuery = <
      TData = ProjectPickerProjectsQuery,
      TError = unknown
    >(
      variables?: ProjectPickerProjectsQueryVariables,
      options?: Omit<UseQueryOptions<ProjectPickerProjectsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectPickerProjectsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectPickerProjectsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['projectPickerProjects'] : ['projectPickerProjects', variables],
    queryFn: fetchData<ProjectPickerProjectsQuery, ProjectPickerProjectsQueryVariables>(ProjectPickerProjectsDocument, variables),
    ...options
  }
    )};

useProjectPickerProjectsQuery.document = ProjectPickerProjectsDocument;

useProjectPickerProjectsQuery.getKey = (variables?: ProjectPickerProjectsQueryVariables) => variables === undefined ? ['projectPickerProjects'] : ['projectPickerProjects', variables];

export const AddTaskDocument = `
    mutation addTask($input: AddTaskInput!) {
  addTask(input: $input) {
    projectTask {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddTaskMutation, TError, AddTaskMutationVariables, TContext>) => {
    
    return useMutation<AddTaskMutation, TError, AddTaskMutationVariables, TContext>(
      {
    mutationKey: ['addTask'],
    mutationFn: (variables?: AddTaskMutationVariables) => fetchData<AddTaskMutation, AddTaskMutationVariables>(AddTaskDocument, variables)(),
    ...options
  }
    )};

export const DeleteTaskDocument = `
    mutation deleteTask($projectId: Int!, $taskId: Int!) {
  deleteTask(input: {projectId: $projectId, taskId: $taskId}) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTaskMutation, TError, DeleteTaskMutationVariables, TContext>) => {
    
    return useMutation<DeleteTaskMutation, TError, DeleteTaskMutationVariables, TContext>(
      {
    mutationKey: ['deleteTask'],
    mutationFn: (variables?: DeleteTaskMutationVariables) => fetchData<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, variables)(),
    ...options
  }
    )};

export const RescheduleTaskDocument = `
    mutation rescheduleTask($input: RescheduleTaskInput!) {
  rescheduleTask(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRescheduleTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RescheduleTaskMutation, TError, RescheduleTaskMutationVariables, TContext>) => {
    
    return useMutation<RescheduleTaskMutation, TError, RescheduleTaskMutationVariables, TContext>(
      {
    mutationKey: ['rescheduleTask'],
    mutationFn: (variables?: RescheduleTaskMutationVariables) => fetchData<RescheduleTaskMutation, RescheduleTaskMutationVariables>(RescheduleTaskDocument, variables)(),
    ...options
  }
    )};

export const UpdateTaskDocument = `
    mutation updateTask($input: UpdateTaskInput!) {
  updateTask(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUpdateTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTaskMutation, TError, UpdateTaskMutationVariables, TContext>) => {
    
    return useMutation<UpdateTaskMutation, TError, UpdateTaskMutationVariables, TContext>(
      {
    mutationKey: ['updateTask'],
    mutationFn: (variables?: UpdateTaskMutationVariables) => fetchData<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, variables)(),
    ...options
  }
    )};

export const UpdateTaskStatusDocument = `
    mutation updateTaskStatus($input: UpdateTaskStatusInput!) {
  updateTaskStatus(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUpdateTaskStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTaskStatusMutation, TError, UpdateTaskStatusMutationVariables, TContext>) => {
    
    return useMutation<UpdateTaskStatusMutation, TError, UpdateTaskStatusMutationVariables, TContext>(
      {
    mutationKey: ['updateTaskStatus'],
    mutationFn: (variables?: UpdateTaskStatusMutationVariables) => fetchData<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>(UpdateTaskStatusDocument, variables)(),
    ...options
  }
    )};

export const MyTasksDocument = `
    query myTasks($projectId: Int!) {
  myTasks(projectId: $projectId) {
    ...ProjectTaskFragment
  }
}
    ${ProjectTaskFragmentFragmentDoc}
${GetTaskNameFragmentFragmentDoc}
${FormAllowedUsersFragmentFragmentDoc}
${ProjectFormSettingsFragmentFragmentDoc}
${DocumentFragmentFragmentDoc}`;

export const useMyTasksQuery = <
      TData = MyTasksQuery,
      TError = unknown
    >(
      variables: MyTasksQueryVariables,
      options?: Omit<UseQueryOptions<MyTasksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MyTasksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MyTasksQuery, TError, TData>(
      {
    queryKey: ['myTasks', variables],
    queryFn: fetchData<MyTasksQuery, MyTasksQueryVariables>(MyTasksDocument, variables),
    ...options
  }
    )};

useMyTasksQuery.document = MyTasksDocument;

useMyTasksQuery.getKey = (variables: MyTasksQueryVariables) => ['myTasks', variables];

export const ParentTaskDocument = `
    query parentTask($taskId: Int!, $projectId: Int!) {
  parentTask(taskId: $taskId, projectId: $projectId) {
    ...GetTaskNameFragment
  }
}
    ${GetTaskNameFragmentFragmentDoc}`;

export const useParentTaskQuery = <
      TData = ParentTaskQuery,
      TError = unknown
    >(
      variables: ParentTaskQueryVariables,
      options?: Omit<UseQueryOptions<ParentTaskQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ParentTaskQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ParentTaskQuery, TError, TData>(
      {
    queryKey: ['parentTask', variables],
    queryFn: fetchData<ParentTaskQuery, ParentTaskQueryVariables>(ParentTaskDocument, variables),
    ...options
  }
    )};

useParentTaskQuery.document = ParentTaskDocument;

useParentTaskQuery.getKey = (variables: ParentTaskQueryVariables) => ['parentTask', variables];

export const ProjectTaskDocument = `
    query projectTask($taskId: Int!, $projectId: Int!) {
  projectTask(taskId: $taskId, projectId: $projectId) {
    ...ProjectTaskFragment
  }
}
    ${ProjectTaskFragmentFragmentDoc}
${GetTaskNameFragmentFragmentDoc}
${FormAllowedUsersFragmentFragmentDoc}
${ProjectFormSettingsFragmentFragmentDoc}
${DocumentFragmentFragmentDoc}`;

export const useProjectTaskQuery = <
      TData = ProjectTaskQuery,
      TError = unknown
    >(
      variables: ProjectTaskQueryVariables,
      options?: Omit<UseQueryOptions<ProjectTaskQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectTaskQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectTaskQuery, TError, TData>(
      {
    queryKey: ['projectTask', variables],
    queryFn: fetchData<ProjectTaskQuery, ProjectTaskQueryVariables>(ProjectTaskDocument, variables),
    ...options
  }
    )};

useProjectTaskQuery.document = ProjectTaskDocument;

useProjectTaskQuery.getKey = (variables: ProjectTaskQueryVariables) => ['projectTask', variables];

export const ProjectTaskPermissionsDocument = `
    query projectTaskPermissions($taskId: Int!, $projectId: Int!) {
  taskPermissions(taskId: $taskId, projectId: $projectId) {
    ...RoleAssignmentFragment
  }
}
    ${RoleAssignmentFragmentFragmentDoc}`;

export const useProjectTaskPermissionsQuery = <
      TData = ProjectTaskPermissionsQuery,
      TError = unknown
    >(
      variables: ProjectTaskPermissionsQueryVariables,
      options?: Omit<UseQueryOptions<ProjectTaskPermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectTaskPermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectTaskPermissionsQuery, TError, TData>(
      {
    queryKey: ['projectTaskPermissions', variables],
    queryFn: fetchData<ProjectTaskPermissionsQuery, ProjectTaskPermissionsQueryVariables>(ProjectTaskPermissionsDocument, variables),
    ...options
  }
    )};

useProjectTaskPermissionsQuery.document = ProjectTaskPermissionsDocument;

useProjectTaskPermissionsQuery.getKey = (variables: ProjectTaskPermissionsQueryVariables) => ['projectTaskPermissions', variables];

export const ProjectTaskSubtasksDocument = `
    query ProjectTaskSubtasks($taskId: Int!, $filter: ProjectTaskFilterInput) {
  projectTaskSubtasks(taskId: $taskId, where: $filter) {
    ...ProjectTaskFragment
  }
}
    ${ProjectTaskFragmentFragmentDoc}
${GetTaskNameFragmentFragmentDoc}
${FormAllowedUsersFragmentFragmentDoc}
${ProjectFormSettingsFragmentFragmentDoc}
${DocumentFragmentFragmentDoc}`;

export const useProjectTaskSubtasksQuery = <
      TData = ProjectTaskSubtasksQuery,
      TError = unknown
    >(
      variables: ProjectTaskSubtasksQueryVariables,
      options?: Omit<UseQueryOptions<ProjectTaskSubtasksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectTaskSubtasksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectTaskSubtasksQuery, TError, TData>(
      {
    queryKey: ['ProjectTaskSubtasks', variables],
    queryFn: fetchData<ProjectTaskSubtasksQuery, ProjectTaskSubtasksQueryVariables>(ProjectTaskSubtasksDocument, variables),
    ...options
  }
    )};

useProjectTaskSubtasksQuery.document = ProjectTaskSubtasksDocument;

useProjectTaskSubtasksQuery.getKey = (variables: ProjectTaskSubtasksQueryVariables) => ['ProjectTaskSubtasks', variables];

export const ProjectTasksDocument = `
    query projectTasks($projectId: Int!, $filter: ProjectTaskFilterInput) {
  projectTasks(projectId: $projectId, where: $filter) {
    predecessors {
      id
    }
    ...ProjectTaskFragment
  }
}
    ${ProjectTaskFragmentFragmentDoc}
${GetTaskNameFragmentFragmentDoc}
${FormAllowedUsersFragmentFragmentDoc}
${ProjectFormSettingsFragmentFragmentDoc}
${DocumentFragmentFragmentDoc}`;

export const useProjectTasksQuery = <
      TData = ProjectTasksQuery,
      TError = unknown
    >(
      variables: ProjectTasksQueryVariables,
      options?: Omit<UseQueryOptions<ProjectTasksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectTasksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectTasksQuery, TError, TData>(
      {
    queryKey: ['projectTasks', variables],
    queryFn: fetchData<ProjectTasksQuery, ProjectTasksQueryVariables>(ProjectTasksDocument, variables),
    ...options
  }
    )};

useProjectTasksQuery.document = ProjectTasksDocument;

useProjectTasksQuery.getKey = (variables: ProjectTasksQueryVariables) => ['projectTasks', variables];

export const ValidTaskPredecessorsDocument = `
    query validTaskPredecessors($taskId: Int!) {
  validPredecessorTasks(taskId: $taskId) {
    ...ProjectTaskFragment
  }
}
    ${ProjectTaskFragmentFragmentDoc}
${GetTaskNameFragmentFragmentDoc}
${FormAllowedUsersFragmentFragmentDoc}
${ProjectFormSettingsFragmentFragmentDoc}
${DocumentFragmentFragmentDoc}`;

export const useValidTaskPredecessorsQuery = <
      TData = ValidTaskPredecessorsQuery,
      TError = unknown
    >(
      variables: ValidTaskPredecessorsQueryVariables,
      options?: Omit<UseQueryOptions<ValidTaskPredecessorsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ValidTaskPredecessorsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ValidTaskPredecessorsQuery, TError, TData>(
      {
    queryKey: ['validTaskPredecessors', variables],
    queryFn: fetchData<ValidTaskPredecessorsQuery, ValidTaskPredecessorsQueryVariables>(ValidTaskPredecessorsDocument, variables),
    ...options
  }
    )};

useValidTaskPredecessorsQuery.document = ValidTaskPredecessorsDocument;

useValidTaskPredecessorsQuery.getKey = (variables: ValidTaskPredecessorsQueryVariables) => ['validTaskPredecessors', variables];

export const GetTenantsDocument = `
    query getTenants {
  tenants {
    id
    name
    identifier
    provisioningStatus
  }
}
    `;

export const useGetTenantsQuery = <
      TData = GetTenantsQuery,
      TError = unknown
    >(
      variables?: GetTenantsQueryVariables,
      options?: Omit<UseQueryOptions<GetTenantsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTenantsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetTenantsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getTenants'] : ['getTenants', variables],
    queryFn: fetchData<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, variables),
    ...options
  }
    )};

useGetTenantsQuery.document = GetTenantsDocument;

useGetTenantsQuery.getKey = (variables?: GetTenantsQueryVariables) => variables === undefined ? ['getTenants'] : ['getTenants', variables];

export const UserTenantsDocument = `
    query userTenants {
  userTenants {
    name
    identifier
  }
}
    `;

export const useUserTenantsQuery = <
      TData = UserTenantsQuery,
      TError = unknown
    >(
      variables?: UserTenantsQueryVariables,
      options?: Omit<UseQueryOptions<UserTenantsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserTenantsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UserTenantsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userTenants'] : ['userTenants', variables],
    queryFn: fetchData<UserTenantsQuery, UserTenantsQueryVariables>(UserTenantsDocument, variables),
    ...options
  }
    )};

useUserTenantsQuery.document = UserTenantsDocument;

useUserTenantsQuery.getKey = (variables?: UserTenantsQueryVariables) => variables === undefined ? ['userTenants'] : ['userTenants', variables];

export const EditUserRoleDocument = `
    mutation editUserRole($input: EditUserRoleInput!) {
  editUserRole(input: $input) {
    applicationUser {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditUserRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditUserRoleMutation, TError, EditUserRoleMutationVariables, TContext>) => {
    
    return useMutation<EditUserRoleMutation, TError, EditUserRoleMutationVariables, TContext>(
      {
    mutationKey: ['editUserRole'],
    mutationFn: (variables?: EditUserRoleMutationVariables) => fetchData<EditUserRoleMutation, EditUserRoleMutationVariables>(EditUserRoleDocument, variables)(),
    ...options
  }
    )};

export const EditExternalUserDocument = `
    mutation editExternalUser($input: EditExternalUserInput!) {
  editExternalUser(input: $input) {
    applicationUser {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditExternalUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditExternalUserMutation, TError, EditExternalUserMutationVariables, TContext>) => {
    
    return useMutation<EditExternalUserMutation, TError, EditExternalUserMutationVariables, TContext>(
      {
    mutationKey: ['editExternalUser'],
    mutationFn: (variables?: EditExternalUserMutationVariables) => fetchData<EditExternalUserMutation, EditExternalUserMutationVariables>(EditExternalUserDocument, variables)(),
    ...options
  }
    )};

export const EditUserDocument = `
    mutation editUser($input: EditUserInput!) {
  editUser(input: $input) {
    applicationUser {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditUserMutation, TError, EditUserMutationVariables, TContext>) => {
    
    return useMutation<EditUserMutation, TError, EditUserMutationVariables, TContext>(
      {
    mutationKey: ['editUser'],
    mutationFn: (variables?: EditUserMutationVariables) => fetchData<EditUserMutation, EditUserMutationVariables>(EditUserDocument, variables)(),
    ...options
  }
    )};

export const InviteUserDocument = `
    mutation inviteUser($input: InviteUserInput!) {
  inviteUser(input: $input) {
    applicationUser {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useInviteUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InviteUserMutation, TError, InviteUserMutationVariables, TContext>) => {
    
    return useMutation<InviteUserMutation, TError, InviteUserMutationVariables, TContext>(
      {
    mutationKey: ['inviteUser'],
    mutationFn: (variables?: InviteUserMutationVariables) => fetchData<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, variables)(),
    ...options
  }
    )};

export const RemoveUserDocument = `
    mutation removeUser($input: RemoveUserInput!) {
  removeUser(input: $input) {
    applicationUser {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useRemoveUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveUserMutation, TError, RemoveUserMutationVariables, TContext>) => {
    
    return useMutation<RemoveUserMutation, TError, RemoveUserMutationVariables, TContext>(
      {
    mutationKey: ['removeUser'],
    mutationFn: (variables?: RemoveUserMutationVariables) => fetchData<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, variables)(),
    ...options
  }
    )};

export const UnsubscribeFromEmailsDocument = `
    mutation unsubscribeFromEmails($input: UnsubscribeFromEmailsInput!) {
  unsubscribeFromEmails(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useUnsubscribeFromEmailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnsubscribeFromEmailsMutation, TError, UnsubscribeFromEmailsMutationVariables, TContext>) => {
    
    return useMutation<UnsubscribeFromEmailsMutation, TError, UnsubscribeFromEmailsMutationVariables, TContext>(
      {
    mutationKey: ['unsubscribeFromEmails'],
    mutationFn: (variables?: UnsubscribeFromEmailsMutationVariables) => fetchData<UnsubscribeFromEmailsMutation, UnsubscribeFromEmailsMutationVariables>(UnsubscribeFromEmailsDocument, variables)(),
    ...options
  }
    )};

export const GetLoginInfoDocument = `
    query getLoginInfo {
  loginInfo {
    isAuthenticatedWithMagicLink
    isMicrosoftAccountLogin
    hasSignedUp
  }
}
    `;

export const useGetLoginInfoQuery = <
      TData = GetLoginInfoQuery,
      TError = unknown
    >(
      variables?: GetLoginInfoQueryVariables,
      options?: Omit<UseQueryOptions<GetLoginInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLoginInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLoginInfoQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getLoginInfo'] : ['getLoginInfo', variables],
    queryFn: fetchData<GetLoginInfoQuery, GetLoginInfoQueryVariables>(GetLoginInfoDocument, variables),
    ...options
  }
    )};

useGetLoginInfoQuery.document = GetLoginInfoDocument;

useGetLoginInfoQuery.getKey = (variables?: GetLoginInfoQueryVariables) => variables === undefined ? ['getLoginInfo'] : ['getLoginInfo', variables];

export const GetMeDocument = `
    query getMe {
  me {
    id
    firstName
    lastName
    fullName
    email
    language
    optedOutOfWeeklyEmails
    roles {
      name
    }
    builtInRoles
  }
}
    `;

export const useGetMeQuery = <
      TData = GetMeQuery,
      TError = unknown
    >(
      variables?: GetMeQueryVariables,
      options?: Omit<UseQueryOptions<GetMeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getMe'] : ['getMe', variables],
    queryFn: fetchData<GetMeQuery, GetMeQueryVariables>(GetMeDocument, variables),
    ...options
  }
    )};

useGetMeQuery.document = GetMeDocument;

useGetMeQuery.getKey = (variables?: GetMeQueryVariables) => variables === undefined ? ['getMe'] : ['getMe', variables];

export const OrganizationUsersDocument = `
    query organizationUsers($filter: ApplicationUserFilterInput) {
  organizationUsers(where: $filter) {
    id
    firstName
    lastName
    fullName
    business
    title
    email
  }
}
    `;

export const useOrganizationUsersQuery = <
      TData = OrganizationUsersQuery,
      TError = unknown
    >(
      variables?: OrganizationUsersQueryVariables,
      options?: Omit<UseQueryOptions<OrganizationUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrganizationUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrganizationUsersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['organizationUsers'] : ['organizationUsers', variables],
    queryFn: fetchData<OrganizationUsersQuery, OrganizationUsersQueryVariables>(OrganizationUsersDocument, variables),
    ...options
  }
    )};

useOrganizationUsersQuery.document = OrganizationUsersDocument;

useOrganizationUsersQuery.getKey = (variables?: OrganizationUsersQueryVariables) => variables === undefined ? ['organizationUsers'] : ['organizationUsers', variables];

export const GetUserDocument = `
    query getUser($id: String!) {
  user(id: $id) {
    id
    firstName
    lastName
    fullName
    roles {
      name
    }
    title
    business
    builtInRoles
    email
    phoneNumber
  }
}
    `;

export const useGetUserQuery = <
      TData = GetUserQuery,
      TError = unknown
    >(
      variables: GetUserQueryVariables,
      options?: Omit<UseQueryOptions<GetUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserQuery, TError, TData>(
      {
    queryKey: ['getUser', variables],
    queryFn: fetchData<GetUserQuery, GetUserQueryVariables>(GetUserDocument, variables),
    ...options
  }
    )};

useGetUserQuery.document = GetUserDocument;

useGetUserQuery.getKey = (variables: GetUserQueryVariables) => ['getUser', variables];

export const GetUsersDocument = `
    query getUsers($filter: ApplicationUserFilterInput) {
  users(where: $filter) {
    id
    firstName
    lastName
    fullName
    business
    title
    email
  }
}
    `;

export const useGetUsersQuery = <
      TData = GetUsersQuery,
      TError = unknown
    >(
      variables?: GetUsersQueryVariables,
      options?: Omit<UseQueryOptions<GetUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUsersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getUsers'] : ['getUsers', variables],
    queryFn: fetchData<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, variables),
    ...options
  }
    )};

useGetUsersQuery.document = GetUsersDocument;

useGetUsersQuery.getKey = (variables?: GetUsersQueryVariables) => variables === undefined ? ['getUsers'] : ['getUsers', variables];

export const GetUsersFullDocument = `
    query getUsersFull($filter: ApplicationUserFilterInput) {
  users(where: $filter) {
    id
    fullName
    email
    phoneNumber
    business
    title
    roles {
      name
    }
    builtInRoles
  }
}
    `;

export const useGetUsersFullQuery = <
      TData = GetUsersFullQuery,
      TError = unknown
    >(
      variables?: GetUsersFullQueryVariables,
      options?: Omit<UseQueryOptions<GetUsersFullQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUsersFullQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUsersFullQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getUsersFull'] : ['getUsersFull', variables],
    queryFn: fetchData<GetUsersFullQuery, GetUsersFullQueryVariables>(GetUsersFullDocument, variables),
    ...options
  }
    )};

useGetUsersFullQuery.document = GetUsersFullDocument;

useGetUsersFullQuery.getKey = (variables?: GetUsersFullQueryVariables) => variables === undefined ? ['getUsersFull'] : ['getUsersFull', variables];

export const IsEmailsUnsubscribeTokenValidDocument = `
    query isEmailsUnsubscribeTokenValid($input: ValidateUnsubscribeTokenInput!) {
  validateUnsubscribeToken(input: $input) {
    isValid
  }
}
    `;

export const useIsEmailsUnsubscribeTokenValidQuery = <
      TData = IsEmailsUnsubscribeTokenValidQuery,
      TError = unknown
    >(
      variables: IsEmailsUnsubscribeTokenValidQueryVariables,
      options?: Omit<UseQueryOptions<IsEmailsUnsubscribeTokenValidQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<IsEmailsUnsubscribeTokenValidQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<IsEmailsUnsubscribeTokenValidQuery, TError, TData>(
      {
    queryKey: ['isEmailsUnsubscribeTokenValid', variables],
    queryFn: fetchData<IsEmailsUnsubscribeTokenValidQuery, IsEmailsUnsubscribeTokenValidQueryVariables>(IsEmailsUnsubscribeTokenValidDocument, variables),
    ...options
  }
    )};

useIsEmailsUnsubscribeTokenValidQuery.document = IsEmailsUnsubscribeTokenValidDocument;

useIsEmailsUnsubscribeTokenValidQuery.getKey = (variables: IsEmailsUnsubscribeTokenValidQueryVariables) => ['isEmailsUnsubscribeTokenValid', variables];

export const StartWorkflowDocument = `
    mutation startWorkflow($input: StartWorkflowInstanceInput!) {
  startWorkflowInstance(input: $input) {
    workflowInstance {
      id
    }
    errors {
      ... on WorkflowConfigurationError {
        __typename
        message
      }
      ... on WorkflowExecutionFatalError {
        __typename
        message
        workflowInstanceId
      }
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useStartWorkflowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartWorkflowMutation, TError, StartWorkflowMutationVariables, TContext>) => {
    
    return useMutation<StartWorkflowMutation, TError, StartWorkflowMutationVariables, TContext>(
      {
    mutationKey: ['startWorkflow'],
    mutationFn: (variables?: StartWorkflowMutationVariables) => fetchData<StartWorkflowMutation, StartWorkflowMutationVariables>(StartWorkflowDocument, variables)(),
    ...options
  }
    )};

export const AddChildActionDocument = `
    mutation addChildAction($input: AddChildActionInput!) {
  addChildAction(input: $input) {
    workflowActionConfiguration {
      ...WorkflowActionConfigurationFragment
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    ${WorkflowActionConfigurationFragmentFragmentDoc}
${WorkflowActionFieldValueFragmentFragmentDoc}
${WorkflowVariableFragmentFragmentDoc}`;

export const useAddChildActionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddChildActionMutation, TError, AddChildActionMutationVariables, TContext>) => {
    
    return useMutation<AddChildActionMutation, TError, AddChildActionMutationVariables, TContext>(
      {
    mutationKey: ['addChildAction'],
    mutationFn: (variables?: AddChildActionMutationVariables) => fetchData<AddChildActionMutation, AddChildActionMutationVariables>(AddChildActionDocument, variables)(),
    ...options
  }
    )};

export const AddProjectWorkflowDocument = `
    mutation addProjectWorkflow($input: AddProjectWorkflowInput!) {
  addProjectWorkflow(input: $input) {
    workflowDefinition {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddProjectWorkflowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddProjectWorkflowMutation, TError, AddProjectWorkflowMutationVariables, TContext>) => {
    
    return useMutation<AddProjectWorkflowMutation, TError, AddProjectWorkflowMutationVariables, TContext>(
      {
    mutationKey: ['addProjectWorkflow'],
    mutationFn: (variables?: AddProjectWorkflowMutationVariables) => fetchData<AddProjectWorkflowMutation, AddProjectWorkflowMutationVariables>(AddProjectWorkflowDocument, variables)(),
    ...options
  }
    )};

export const AddWorkflowDocument = `
    mutation addWorkflow($input: AddWorkflowDefinitionInput!) {
  addWorkflowDefinition(input: $input) {
    workflowDefinition {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddWorkflowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddWorkflowMutation, TError, AddWorkflowMutationVariables, TContext>) => {
    
    return useMutation<AddWorkflowMutation, TError, AddWorkflowMutationVariables, TContext>(
      {
    mutationKey: ['addWorkflow'],
    mutationFn: (variables?: AddWorkflowMutationVariables) => fetchData<AddWorkflowMutation, AddWorkflowMutationVariables>(AddWorkflowDocument, variables)(),
    ...options
  }
    )};

export const DeleteWorkflowActionDocument = `
    mutation deleteWorkflowAction($input: DeleteWorkflowActionConfigurationInput!) {
  deleteWorkflowActionConfiguration(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteWorkflowActionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteWorkflowActionMutation, TError, DeleteWorkflowActionMutationVariables, TContext>) => {
    
    return useMutation<DeleteWorkflowActionMutation, TError, DeleteWorkflowActionMutationVariables, TContext>(
      {
    mutationKey: ['deleteWorkflowAction'],
    mutationFn: (variables?: DeleteWorkflowActionMutationVariables) => fetchData<DeleteWorkflowActionMutation, DeleteWorkflowActionMutationVariables>(DeleteWorkflowActionDocument, variables)(),
    ...options
  }
    )};

export const StopWorkflowInstanceDocument = `
    mutation stopWorkflowInstance($input: StopWorkflowInstanceInput!) {
  stopWorkflowInstance(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useStopWorkflowInstanceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StopWorkflowInstanceMutation, TError, StopWorkflowInstanceMutationVariables, TContext>) => {
    
    return useMutation<StopWorkflowInstanceMutation, TError, StopWorkflowInstanceMutationVariables, TContext>(
      {
    mutationKey: ['stopWorkflowInstance'],
    mutationFn: (variables?: StopWorkflowInstanceMutationVariables) => fetchData<StopWorkflowInstanceMutation, StopWorkflowInstanceMutationVariables>(StopWorkflowInstanceDocument, variables)(),
    ...options
  }
    )};

export const DeleteWorkflowTemplateDocument = `
    mutation deleteWorkflowTemplate($id: Int!) {
  deleteWorkflowDefinition(input: {id: $id}) {
    workflowDefinition {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteWorkflowTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteWorkflowTemplateMutation, TError, DeleteWorkflowTemplateMutationVariables, TContext>) => {
    
    return useMutation<DeleteWorkflowTemplateMutation, TError, DeleteWorkflowTemplateMutationVariables, TContext>(
      {
    mutationKey: ['deleteWorkflowTemplate'],
    mutationFn: (variables?: DeleteWorkflowTemplateMutationVariables) => fetchData<DeleteWorkflowTemplateMutation, DeleteWorkflowTemplateMutationVariables>(DeleteWorkflowTemplateDocument, variables)(),
    ...options
  }
    )};

export const DuplicateWorkflowDefinitionDocument = `
    mutation duplicateWorkflowDefinition($input: DuplicateWorkflowDefinitionInput!) {
  duplicateWorkflowDefinition(input: $input) {
    workflowDefinition {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDuplicateWorkflowDefinitionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DuplicateWorkflowDefinitionMutation, TError, DuplicateWorkflowDefinitionMutationVariables, TContext>) => {
    
    return useMutation<DuplicateWorkflowDefinitionMutation, TError, DuplicateWorkflowDefinitionMutationVariables, TContext>(
      {
    mutationKey: ['duplicateWorkflowDefinition'],
    mutationFn: (variables?: DuplicateWorkflowDefinitionMutationVariables) => fetchData<DuplicateWorkflowDefinitionMutation, DuplicateWorkflowDefinitionMutationVariables>(DuplicateWorkflowDefinitionDocument, variables)(),
    ...options
  }
    )};

export const EditWorkflowDocument = `
    mutation editWorkflow($input: EditWorkflowDefinitionInput!) {
  editWorkflowDefinition(input: $input) {
    workflowDefinition {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditWorkflowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditWorkflowMutation, TError, EditWorkflowMutationVariables, TContext>) => {
    
    return useMutation<EditWorkflowMutation, TError, EditWorkflowMutationVariables, TContext>(
      {
    mutationKey: ['editWorkflow'],
    mutationFn: (variables?: EditWorkflowMutationVariables) => fetchData<EditWorkflowMutation, EditWorkflowMutationVariables>(EditWorkflowDocument, variables)(),
    ...options
  }
    )};

export const MoveChildActionDocument = `
    mutation moveChildAction($input: MoveChildActionInput!) {
  moveChildAction(input: $input) {
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useMoveChildActionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveChildActionMutation, TError, MoveChildActionMutationVariables, TContext>) => {
    
    return useMutation<MoveChildActionMutation, TError, MoveChildActionMutationVariables, TContext>(
      {
    mutationKey: ['moveChildAction'],
    mutationFn: (variables?: MoveChildActionMutationVariables) => fetchData<MoveChildActionMutation, MoveChildActionMutationVariables>(MoveChildActionDocument, variables)(),
    ...options
  }
    )};

export const UpdateWorkflowActionConfigurationDocument = `
    mutation updateWorkflowActionConfiguration($input: UpdateWorkflowActionConfigurationInput!) {
  updateWorkflowActionConfiguration(input: $input) {
    workflowActionConfiguration {
      ...WorkflowActionConfigurationFragment
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    ${WorkflowActionConfigurationFragmentFragmentDoc}
${WorkflowActionFieldValueFragmentFragmentDoc}
${WorkflowVariableFragmentFragmentDoc}`;

export const useUpdateWorkflowActionConfigurationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWorkflowActionConfigurationMutation, TError, UpdateWorkflowActionConfigurationMutationVariables, TContext>) => {
    
    return useMutation<UpdateWorkflowActionConfigurationMutation, TError, UpdateWorkflowActionConfigurationMutationVariables, TContext>(
      {
    mutationKey: ['updateWorkflowActionConfiguration'],
    mutationFn: (variables?: UpdateWorkflowActionConfigurationMutationVariables) => fetchData<UpdateWorkflowActionConfigurationMutation, UpdateWorkflowActionConfigurationMutationVariables>(UpdateWorkflowActionConfigurationDocument, variables)(),
    ...options
  }
    )};

export const SubmitWorkflowActionDocument = `
    mutation submitWorkflowAction($input: SubmitWorkflowActionInput!) {
  submitWorkflowAction(input: $input) {
    workflowActionConfiguration {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useSubmitWorkflowActionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitWorkflowActionMutation, TError, SubmitWorkflowActionMutationVariables, TContext>) => {
    
    return useMutation<SubmitWorkflowActionMutation, TError, SubmitWorkflowActionMutationVariables, TContext>(
      {
    mutationKey: ['submitWorkflowAction'],
    mutationFn: (variables?: SubmitWorkflowActionMutationVariables) => fetchData<SubmitWorkflowActionMutation, SubmitWorkflowActionMutationVariables>(SubmitWorkflowActionDocument, variables)(),
    ...options
  }
    )};

export const AddWorkflowVariableDocument = `
    mutation addWorkflowVariable($input: AddWorkflowVariableInput!) {
  addWorkflowVariable(input: $input) {
    workflowVariable {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useAddWorkflowVariableMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddWorkflowVariableMutation, TError, AddWorkflowVariableMutationVariables, TContext>) => {
    
    return useMutation<AddWorkflowVariableMutation, TError, AddWorkflowVariableMutationVariables, TContext>(
      {
    mutationKey: ['addWorkflowVariable'],
    mutationFn: (variables?: AddWorkflowVariableMutationVariables) => fetchData<AddWorkflowVariableMutation, AddWorkflowVariableMutationVariables>(AddWorkflowVariableDocument, variables)(),
    ...options
  }
    )};

export const DeleteWorkflowVariableDocument = `
    mutation deleteWorkflowVariable($input: DeleteWorkflowVariableInput!) {
  deleteWorkflowVariable(input: $input) {
    workflowVariable {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useDeleteWorkflowVariableMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteWorkflowVariableMutation, TError, DeleteWorkflowVariableMutationVariables, TContext>) => {
    
    return useMutation<DeleteWorkflowVariableMutation, TError, DeleteWorkflowVariableMutationVariables, TContext>(
      {
    mutationKey: ['deleteWorkflowVariable'],
    mutationFn: (variables?: DeleteWorkflowVariableMutationVariables) => fetchData<DeleteWorkflowVariableMutation, DeleteWorkflowVariableMutationVariables>(DeleteWorkflowVariableDocument, variables)(),
    ...options
  }
    )};

export const EditWorkflowVariableDocument = `
    mutation editWorkflowVariable($input: EditWorkflowVariableInput!) {
  editWorkflowVariable(input: $input) {
    workflowVariable {
      id
    }
    errors {
      ... on Error {
        message
      }
    }
  }
}
    `;

export const useEditWorkflowVariableMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditWorkflowVariableMutation, TError, EditWorkflowVariableMutationVariables, TContext>) => {
    
    return useMutation<EditWorkflowVariableMutation, TError, EditWorkflowVariableMutationVariables, TContext>(
      {
    mutationKey: ['editWorkflowVariable'],
    mutationFn: (variables?: EditWorkflowVariableMutationVariables) => fetchData<EditWorkflowVariableMutation, EditWorkflowVariableMutationVariables>(EditWorkflowVariableDocument, variables)(),
    ...options
  }
    )};

export const ActionsOfWorkflowInstanceDocument = `
    query actionsOfWorkflowInstance($workflowId: Int!) {
  workflowActionConfigurationsOfWorkflow(workflowId: $workflowId) {
    ...WorkflowActionForExecutionFragment
  }
}
    ${WorkflowActionForExecutionFragmentFragmentDoc}
${WorkflowActionFieldValueFragmentFragmentDoc}
${WorkflowVariableFragmentFragmentDoc}`;

export const useActionsOfWorkflowInstanceQuery = <
      TData = ActionsOfWorkflowInstanceQuery,
      TError = unknown
    >(
      variables: ActionsOfWorkflowInstanceQueryVariables,
      options?: Omit<UseQueryOptions<ActionsOfWorkflowInstanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ActionsOfWorkflowInstanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ActionsOfWorkflowInstanceQuery, TError, TData>(
      {
    queryKey: ['actionsOfWorkflowInstance', variables],
    queryFn: fetchData<ActionsOfWorkflowInstanceQuery, ActionsOfWorkflowInstanceQueryVariables>(ActionsOfWorkflowInstanceDocument, variables),
    ...options
  }
    )};

useActionsOfWorkflowInstanceQuery.document = ActionsOfWorkflowInstanceDocument;

useActionsOfWorkflowInstanceQuery.getKey = (variables: ActionsOfWorkflowInstanceQueryVariables) => ['actionsOfWorkflowInstance', variables];

export const WorkflowInstanceDocument = `
    query workflowInstance($projectId: Int!, $workflowId: Int!) {
  workflowInstance(projectId: $projectId, workflowId: $workflowId) {
    ...WorkflowInstanceFragment
  }
}
    ${WorkflowInstanceFragmentFragmentDoc}
${WorkflowActionConfigurationFragmentFragmentDoc}
${WorkflowActionFieldValueFragmentFragmentDoc}
${WorkflowVariableFragmentFragmentDoc}`;

export const useWorkflowInstanceQuery = <
      TData = WorkflowInstanceQuery,
      TError = unknown
    >(
      variables: WorkflowInstanceQueryVariables,
      options?: Omit<UseQueryOptions<WorkflowInstanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WorkflowInstanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WorkflowInstanceQuery, TError, TData>(
      {
    queryKey: ['workflowInstance', variables],
    queryFn: fetchData<WorkflowInstanceQuery, WorkflowInstanceQueryVariables>(WorkflowInstanceDocument, variables),
    ...options
  }
    )};

useWorkflowInstanceQuery.document = WorkflowInstanceDocument;

useWorkflowInstanceQuery.getKey = (variables: WorkflowInstanceQueryVariables) => ['workflowInstance', variables];

export const WorkflowInstancesDocument = `
    query workflowInstances($projectId: Int!, $filter: WorkflowInstanceFilterInput) {
  workflowInstances(projectId: $projectId, where: $filter) {
    id
    name
    workFlowStatus
    createdOn
    stoppedOn
    completedOn
    variables {
      ...WorkflowVariableFragment
    }
  }
}
    ${WorkflowVariableFragmentFragmentDoc}`;

export const useWorkflowInstancesQuery = <
      TData = WorkflowInstancesQuery,
      TError = unknown
    >(
      variables: WorkflowInstancesQueryVariables,
      options?: Omit<UseQueryOptions<WorkflowInstancesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WorkflowInstancesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WorkflowInstancesQuery, TError, TData>(
      {
    queryKey: ['workflowInstances', variables],
    queryFn: fetchData<WorkflowInstancesQuery, WorkflowInstancesQueryVariables>(WorkflowInstancesDocument, variables),
    ...options
  }
    )};

useWorkflowInstancesQuery.document = WorkflowInstancesDocument;

useWorkflowInstancesQuery.getKey = (variables: WorkflowInstancesQueryVariables) => ['workflowInstances', variables];

export const ProjectWorkflowsDocument = `
    query projectWorkflows($filter: WorkflowDefinitionFilterInput, $projectId: Int!) {
  projectWorkflows(where: $filter, projectId: $projectId) {
    ...WorkflowDefinitionFragment
  }
}
    ${WorkflowDefinitionFragmentFragmentDoc}
${WorkflowActionConfigurationFragmentFragmentDoc}
${WorkflowActionFieldValueFragmentFragmentDoc}
${WorkflowVariableFragmentFragmentDoc}`;

export const useProjectWorkflowsQuery = <
      TData = ProjectWorkflowsQuery,
      TError = unknown
    >(
      variables: ProjectWorkflowsQueryVariables,
      options?: Omit<UseQueryOptions<ProjectWorkflowsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectWorkflowsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectWorkflowsQuery, TError, TData>(
      {
    queryKey: ['projectWorkflows', variables],
    queryFn: fetchData<ProjectWorkflowsQuery, ProjectWorkflowsQueryVariables>(ProjectWorkflowsDocument, variables),
    ...options
  }
    )};

useProjectWorkflowsQuery.document = ProjectWorkflowsDocument;

useProjectWorkflowsQuery.getKey = (variables: ProjectWorkflowsQueryVariables) => ['projectWorkflows', variables];

export const WorkflowDocument = `
    query workflow($id: Int!) {
  workflowDefinition(workflowId: $id) {
    ...WorkflowDefinitionFullFragment
  }
}
    ${WorkflowDefinitionFullFragmentFragmentDoc}
${WorkflowDefinitionFragmentFragmentDoc}
${WorkflowActionConfigurationFragmentFragmentDoc}
${WorkflowActionFieldValueFragmentFragmentDoc}
${WorkflowVariableFragmentFragmentDoc}`;

export const useWorkflowQuery = <
      TData = WorkflowQuery,
      TError = unknown
    >(
      variables: WorkflowQueryVariables,
      options?: Omit<UseQueryOptions<WorkflowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WorkflowQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WorkflowQuery, TError, TData>(
      {
    queryKey: ['workflow', variables],
    queryFn: fetchData<WorkflowQuery, WorkflowQueryVariables>(WorkflowDocument, variables),
    ...options
  }
    )};

useWorkflowQuery.document = WorkflowDocument;

useWorkflowQuery.getKey = (variables: WorkflowQueryVariables) => ['workflow', variables];

export const WorkflowActionDefinitionsDocument = `
    query workflowActionDefinitions {
  workflowActionDefinitions {
    ...WorkflowActionDefinitionFragment
  }
}
    ${WorkflowActionDefinitionFragmentFragmentDoc}
${WorkflowActionFieldFragmentFragmentDoc}`;

export const useWorkflowActionDefinitionsQuery = <
      TData = WorkflowActionDefinitionsQuery,
      TError = unknown
    >(
      variables?: WorkflowActionDefinitionsQueryVariables,
      options?: Omit<UseQueryOptions<WorkflowActionDefinitionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WorkflowActionDefinitionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WorkflowActionDefinitionsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['workflowActionDefinitions'] : ['workflowActionDefinitions', variables],
    queryFn: fetchData<WorkflowActionDefinitionsQuery, WorkflowActionDefinitionsQueryVariables>(WorkflowActionDefinitionsDocument, variables),
    ...options
  }
    )};

useWorkflowActionDefinitionsQuery.document = WorkflowActionDefinitionsDocument;

useWorkflowActionDefinitionsQuery.getKey = (variables?: WorkflowActionDefinitionsQueryVariables) => variables === undefined ? ['workflowActionDefinitions'] : ['workflowActionDefinitions', variables];

export const WorkflowTemplateErrorsDocument = `
    query workflowTemplateErrors($workflowId: Int!) {
  workflowTemplateErrors(workflowId: $workflowId) {
    actionId
    fieldId
    message
  }
}
    `;

export const useWorkflowTemplateErrorsQuery = <
      TData = WorkflowTemplateErrorsQuery,
      TError = unknown
    >(
      variables: WorkflowTemplateErrorsQueryVariables,
      options?: Omit<UseQueryOptions<WorkflowTemplateErrorsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WorkflowTemplateErrorsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WorkflowTemplateErrorsQuery, TError, TData>(
      {
    queryKey: ['workflowTemplateErrors', variables],
    queryFn: fetchData<WorkflowTemplateErrorsQuery, WorkflowTemplateErrorsQueryVariables>(WorkflowTemplateErrorsDocument, variables),
    ...options
  }
    )};

useWorkflowTemplateErrorsQuery.document = WorkflowTemplateErrorsDocument;

useWorkflowTemplateErrorsQuery.getKey = (variables: WorkflowTemplateErrorsQueryVariables) => ['workflowTemplateErrors', variables];

export const WorkflowTemplatePermissionsDocument = `
    query workflowTemplatePermissions($templateId: Int!) {
  workflowTemplatePermissions(templateId: $templateId) {
    ...RoleAssignmentFragment
  }
}
    ${RoleAssignmentFragmentFragmentDoc}`;

export const useWorkflowTemplatePermissionsQuery = <
      TData = WorkflowTemplatePermissionsQuery,
      TError = unknown
    >(
      variables: WorkflowTemplatePermissionsQueryVariables,
      options?: Omit<UseQueryOptions<WorkflowTemplatePermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WorkflowTemplatePermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WorkflowTemplatePermissionsQuery, TError, TData>(
      {
    queryKey: ['workflowTemplatePermissions', variables],
    queryFn: fetchData<WorkflowTemplatePermissionsQuery, WorkflowTemplatePermissionsQueryVariables>(WorkflowTemplatePermissionsDocument, variables),
    ...options
  }
    )};

useWorkflowTemplatePermissionsQuery.document = WorkflowTemplatePermissionsDocument;

useWorkflowTemplatePermissionsQuery.getKey = (variables: WorkflowTemplatePermissionsQueryVariables) => ['workflowTemplatePermissions', variables];

export const WorkflowTemplatesDocument = `
    query workflowTemplates($filter: WorkflowDefinitionFilterInput) {
  workflowTemplates(where: $filter) {
    ...WorkflowDefinitionFragment
  }
}
    ${WorkflowDefinitionFragmentFragmentDoc}
${WorkflowActionConfigurationFragmentFragmentDoc}
${WorkflowActionFieldValueFragmentFragmentDoc}
${WorkflowVariableFragmentFragmentDoc}`;

export const useWorkflowTemplatesQuery = <
      TData = WorkflowTemplatesQuery,
      TError = unknown
    >(
      variables?: WorkflowTemplatesQueryVariables,
      options?: Omit<UseQueryOptions<WorkflowTemplatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WorkflowTemplatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WorkflowTemplatesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['workflowTemplates'] : ['workflowTemplates', variables],
    queryFn: fetchData<WorkflowTemplatesQuery, WorkflowTemplatesQueryVariables>(WorkflowTemplatesDocument, variables),
    ...options
  }
    )};

useWorkflowTemplatesQuery.document = WorkflowTemplatesDocument;

useWorkflowTemplatesQuery.getKey = (variables?: WorkflowTemplatesQueryVariables) => variables === undefined ? ['workflowTemplates'] : ['workflowTemplates', variables];
